
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9007"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9007"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a0j6m", function(module, exports) {

$parcel$export(module.exports, "createGallery", function () { return $7488b8aac9c692ba$export$dac8b9bf675ebb55; });
const $7488b8aac9c692ba$export$ff7706047246b98b = ()=>!!window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $7488b8aac9c692ba$export$21bdd81c0b048081 = async ()=>{
    // View Transitions are available on this browser
    if (document.startViewTransition && !$7488b8aac9c692ba$export$ff7706047246b98b()) // add transforms!
    document.startViewTransition(()=>{
    // currentStep = stepNumber
    // showStep(currentStep)
    }).finished.then(()=>{
        // Clean up direction class
        document.documentElement.classList.remove("animate-view");
        return true;
    });
    else return false;
};
const $7488b8aac9c692ba$export$c9eedf6d41f29bd7 = (image, title, attribution)=>{
    // find the nearest dialog...imgvalue 
    const wrapper = image.closest(".gallery");
    const dialog = wrapper.querySelector("dialog");
    const figcaption = dialog.querySelector("figcaption > strong");
    const citation = dialog.querySelector("figcaption > cite");
    const id = image.id;
    if (!dialog) console.warn("No dialog found for gallery image toggle", {
        wrapper: wrapper,
        image: image,
        dialog: dialog
    });
    else {
        const abortSignal = new AbortController();
        // set the image source
        const img = dialog.querySelector("img");
        if (img) {
            //  activateViewTransitions()
            img.classList.toggle("loading", true);
            img.onload = ()=>{
                // set the focus on the image when it loads
                console.warn("image in dialog has loaded");
                img.classList.toggle("loading", false);
            };
            img.src = image.src;
            img.alt = title ?? image.alt ?? "";
            figcaption.textContent = title ?? image.alt ?? "";
            citation.textContent = attribution ? `Copyright 2025, ${attribution}` : false // "Photograph by respective copyright holders""
            ;
            citation.hidden = !attribution || attribution.length === 0;
            // find all other images
            const listItem = image.closest("li");
            const previous = listItem.previousElementSibling;
            const next = listItem.nextElementSibling;
            const previousImage = previous?.querySelector("img");
            const nextImage = next?.querySelector("img");
            const menu = dialog.querySelector("menu");
            const previousImageButton = menu.querySelector(".gallery-image-button-previous");
            const nextImageButton = menu.querySelector(".gallery-image-button-next");
            if (previousImage || nextImage) // show the arrows  
            menu.hidden = false;
            if (previousImageButton) {
                // update the UI with arrows
                if (previousImage) {
                    previousImageButton.hidden = false;
                    previousImageButton.addEventListener("click", ()=>{
                        abortSignal.abort();
                        $7488b8aac9c692ba$export$c9eedf6d41f29bd7(previousImage);
                    }, {
                        signal: abortSignal.signal
                    });
                } else previousImageButton.hidden = true;
            }
            if (nextImageButton) {
                if (nextImage) {
                    nextImageButton.hidden = false;
                    nextImageButton.addEventListener("click", ()=>{
                        abortSignal.abort();
                        $7488b8aac9c692ba$export$c9eedf6d41f29bd7(nextImage);
                    }, {
                        signal: abortSignal.signal
                    });
                } else nextImageButton.hidden = true;
            }
            // allow keyboard events
            window.addEventListener("keydown", (e)=>{
                if (e.key === "ArrowLeft" && previousImage) {
                    abortSignal.abort();
                    $7488b8aac9c692ba$export$c9eedf6d41f29bd7(previousImage);
                }
                if (e.key === "ArrowRight" && nextImage) {
                    abortSignal.abort();
                    $7488b8aac9c692ba$export$c9eedf6d41f29bd7(nextImage);
                }
            }, {
                signal: abortSignal.signal
            });
        //console.warn("dialog opened with image", {image, img,previous, next, previousImage, nextImage, figcaption})
        } else console.warn("No image found in dialog to set source");
        // open the dialog
        dialog.showModal();
        // wait for the dialog to close
        dialog.addEventListener("close", (e)=>{
            // prevent close affecting multiple times
            abortSignal.abort();
            // blank out the loaded image
            img.src = "";
            // set focus on the original image
            image.focus();
            console.warn("dialog closed, focus set on image", image);
        }, {
            signal: abortSignal.signal
        });
    }
};
const $7488b8aac9c692ba$export$dac8b9bf675ebb55 = ()=>{
    const imageToggles = document.querySelectorAll(".gallery-image-toggle");
    //console.warn("createGallery", imageToggles)
    // hijack native toggle event
    imageToggles.forEach((imageToggle)=>{
        imageToggle.addEventListener("click", (event)=>{
            event.preventDefault();
            // find the image associated with the toggle
            const id = imageToggle.value;
            const image = document.getElementById(id);
            const title = image.alt || "Gallery Item";
            const attribution = image.dataset.attribution;
            //console.warn("Gallery:request", image, id, event )
            $7488b8aac9c692ba$export$c9eedf6d41f29bd7(image, title, attribution);
        // ensure that when we close the dialog we
        // also set the focus target onto the original element
        });
    });
};

});

parcelRegister("4nvnS", function(module, exports) {

var $bdMDT = parcelRequire("bdMDT");

var $kXYwo = parcelRequire("kXYwo");

var $jaEHL = parcelRequire("jaEHL");

var $g2KBw = parcelRequire("g2KBw");
function $3301a79d0253e0f9$var$_slicedToArray(r, e) {
    return $bdMDT(r) || $kXYwo(r, e) || $jaEHL(r, e) || $g2KBw();
}
module.exports = $3301a79d0253e0f9$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bdMDT", function(module, exports) {
function $82b6a3f6055b523b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $82b6a3f6055b523b$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kXYwo", function(module, exports) {
function $f43843a972c437fd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $f43843a972c437fd$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jaEHL", function(module, exports) {

var $6a3Qr = parcelRequire("6a3Qr");
function $df4e86a1b9bd40ab$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6a3Qr(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6a3Qr(r, a) : void 0;
    }
}
module.exports = $df4e86a1b9bd40ab$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6a3Qr", function(module, exports) {
function $47c6a8c3c1e5125e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $47c6a8c3c1e5125e$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("g2KBw", function(module, exports) {
function $bae0fbddfde68e0e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $bae0fbddfde68e0e$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("73ILk", function(module, exports) {
function $523b8918cda7c68a$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $523b8918cda7c68a$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gB2Ba", function(module, exports) {

var $ljfoQ = parcelRequire("ljfoQ");
function $c1521e1057130445$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $ljfoQ(o.key), o);
    }
}
function $c1521e1057130445$var$_createClass(e, r, t) {
    return r && $c1521e1057130445$var$_defineProperties(e.prototype, r), t && $c1521e1057130445$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $c1521e1057130445$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ljfoQ", function(module, exports) {

var $2mSIM = parcelRequire("2mSIM");
var $f837516000227db6$var$_typeof = $2mSIM.default;

var $lpQiO = parcelRequire("lpQiO");
function $f837516000227db6$var$toPropertyKey(t) {
    var i = $lpQiO(t, "string");
    return "symbol" == $f837516000227db6$var$_typeof(i) ? i : i + "";
}
module.exports = $f837516000227db6$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2mSIM", function(module, exports) {
function $1b9815576774c0aa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $1b9815576774c0aa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1b9815576774c0aa$var$_typeof(o);
}
module.exports = $1b9815576774c0aa$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lpQiO", function(module, exports) {

var $2mSIM = parcelRequire("2mSIM");
var $f97480f79137f1f8$var$_typeof = $2mSIM.default;
function $f97480f79137f1f8$var$toPrimitive(t, r) {
    if ("object" != $f97480f79137f1f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f97480f79137f1f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $f97480f79137f1f8$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dBrz7", function(module, exports) {
module.exports = $parcel$import("4qjGb").then(()=>parcelRequire('68DOq'));

});

parcelRegister("iuYsy", function(module, exports) {
module.exports = $parcel$import("ixisr").then(()=>parcelRequire('9Vdud'));

});

parcelRegister("5uK7V", function(module, exports) {

$parcel$export(module.exports, "PALETTE", function () { return $400388f00f3e7c03$export$eb89ee75e7d64ec3; });
$parcel$export(module.exports, "VISUALISER_OPTIONS", function () { return $400388f00f3e7c03$export$d01b6dd4c488ef59; });
$parcel$export(module.exports, "getSettings", function () { return $400388f00f3e7c03$export$4a647155031ece; });
parcelRequire("aq50Z");
const $400388f00f3e7c03$export$eb89ee75e7d64ec3 = {
    // Primary colours ------------------------------------------
    // The Royal Society red
    // Pantone® 200
    // c0 m100 y70 k14
    // r211 g18 b69
    // Used throughout the site to indicate important areas of interest 
    // and interactive elements such as navigation, active/hover states, 
    // links and calls to action.
    red: "#d31245",
    plum: "#6F263D",
    // The Royal Society stone
    // Pantone® 7527
    // c4 m4 y12 k8
    // r237 g231 b221
    // Interactive elements such as filter groups and inactive tabs. 
    // Also used for descriptive information on journal cards.
    stone: "#ede7dd",
    // Page background
    stoneLight: "#e8e6df",
    // The Royal Society charcoal
    // 95% black
    // r51 g49 b50
    // #333132
    // Headings, body text and the background colour for selected 
    // additional information areas such as grant opening dates 
    // and event series. Also used as the background for 
    // mobile-specific user interface elements such as "related events" 
    // and "event organisers".#
    // Charcoal has been reserved for use on typography 
    // – it should never be used as a block colour.
    // * Used for journals covering all sciences.
    charcoal: "#333132",
    // Secondary colour palette ------------------------------------
    // Orange
    // Pantone® 144
    // c0 m55 y95 k0
    // r237 g139 b0
    orange: "#ED8B00",
    // Pink
    // Pantone® 219
    // c0 m95 y0 k0
    // r218 g24 b132
    pink: "#DA1884",
    // Purple
    // Pantone® 248
    // c40 m100 y0 k0
    // r165 g24 b144
    // * Used for cross-disciplinary journals.
    purple: "#A51890",
    // Blue
    // Pantone® Process Blue
    // c100 m10 y0 k10
    // r0 g133 b202
    // Used for journals covering physical sciences.
    blue: "#0085CA",
    // Green
    // Pantone® 369
    // c68 m0 y100 k0
    // r100 g167 b11
    // * Used for journals covering biological sciences.
    green: "#64A70B",
    // Warm grey
    // Pantone® 408
    // c0 m10 y10 k50
    // r151 g140 b135
    // Used primarily for the heading area of grant cards. 
    // Also used for icons such as blog date and the footer
    // "back to top" icon.
    // * Used for journals covering the history of science.
    warmGrey: "#978C87",
    // Event schedule headers, content page features 
    // (such as grant application information on grant 
    // content detail pages) and table cells.
    warmGreyLight: "#e0dcdb"
};
const $400388f00f3e7c03$export$d01b6dd4c488ef59 = {
    backgroundColour: "#fff",
    lineColour: $400388f00f3e7c03$export$eb89ee75e7d64ec3.red,
    lineWidth: 3
};
const $400388f00f3e7c03$export$875f3a0d36cc7a9a = "dm";
const $400388f00f3e7c03$export$1d63167810e7f899 = {
    major: [
        0,
        1,
        3
    ],
    minor: [
        0,
        1,
        8
    ],
    major7: [
        0,
        1,
        3,
        4
    ],
    minor7: [
        0,
        1,
        8,
        9
    ],
    dominant7: [
        0,
        1,
        3,
        6
    ],
    minor7flat5: [
        1,
        1,
        2,
        6
    ],
    tritoneSubstitution: [
        4,
        2,
        1,
        3
    ],
    diminishedTriad: [
        0,
        6,
        3
    ],
    diminishedSeventh: [
        0,
        3,
        3,
        3
    ],
    augmented: [
        0,
        4,
        4
    ]
};
const $400388f00f3e7c03$export$de29564508b632b2 = {
    showAllKeys: true,
    showAudioVisualiser: true,
    showNoteVisualiser: true,
    showMouseNotes: true,
    showVoiceOver: true,
    showCountdown: true,
    showKeyboard: true,
    showStats: false,
    showNotes: true,
    notes: 10,
    storage: "photosynthlol",
    monitorIntersections: true,
    recordNotes: true,
    saveNotesInMiniNotation: true,
    useTimer: false,
    useGamepads: true,
    useKeyboard: true,
    loadFromZips: true,
    debug: false
};
const $400388f00f3e7c03$export$91779da6fca5bec4 = Object.keys($400388f00f3e7c03$export$de29564508b632b2);
const $400388f00f3e7c03$export$4a647155031ece = ()=>{
    const searchParams = new URLSearchParams(window.location);
    const SETTINGS = {
        ...$400388f00f3e7c03$export$de29564508b632b2
    };
    for (const [key, value] of searchParams)if ($400388f00f3e7c03$export$91779da6fca5bec4.includes(key)) SETTINGS[key] = value;
    return SETTINGS;
};

});
parcelRegister("aq50Z", function(module, exports) {

$parcel$export(module.exports, "monitorIntersections", function () { return $796038f437572c56$export$9f123fffd1f89b44; });
const $796038f437572c56$var$DEFAULT_OBSERVATION_OPTIONS = {
    // root: document.body,
    root: null,
    rootMargin: '0px',
    threshold: 0,
    pianoQuery: ".piano",
    triggerQuery: "[data-observe]"
};
const $796038f437572c56$export$9f123fffd1f89b44 = (intersectionOptions = $796038f437572c56$var$DEFAULT_OBSERVATION_OPTIONS, onInteraction = null)=>{
    // ensure options contains all possible values
    intersectionOptions = {
        ...$796038f437572c56$var$DEFAULT_OBSERVATION_OPTIONS,
        ...intersectionOptions
    };
    const elementsToObserve = document.querySelectorAll(intersectionOptions.triggerQuery);
    const pianoElement = document.querySelector(intersectionOptions.pianoQuery);
    const intersectionObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const ratio = entry.intersectionRatio;
            const boundingRect = entry.boundingClientRect;
            const intersectionRect = entry.intersectionRect;
            if (ratio === 0) ;
            else if (ratio >= 1) ;
            else boundingRect.top, intersectionRect.top;
            if (entry.isIntersecting) {
                // const inert = entry.target.hasAttribute("data-inert")
                const fullSizeKeyboard = entry.target.hasAttribute("data-full-keyboard");
                // const shortKeyboard = entry.target.hasAttribute("data-short-keyboard")
                // const hideKeyboard = entry.target.hasAttribute("data-hide-keyboard")
                // console.info("intersection", {entry, ratio, boundingRect, intersectionRect, fullSizeKeyboard})  
                const isSticky = entry.target.classList.contains("sticky");
                isSticky;
                fullSizeKeyboard;
                // trigger the associated menu if an id exists
                if (entry.target.id) {
                    const currentMenuItems = document.querySelectorAll(`[aria-current]`);
                    const menuEntries = document.querySelectorAll(`a[href="#${entry.target.id}"]`);
                    currentMenuItems.forEach((menuEntry)=>menuEntry.removeAttribute("aria-current", true));
                    menuEntries.forEach((menuEntry)=>menuEntry.setAttribute("aria-current", true));
                }
                onInteraction && onInteraction(entry, true);
                if (entry.target.classList) entry.target.classList.toggle("in-viewport", true);
                // document.body.classList.toggle("inert", inert)
                pianoElement && pianoElement.classList.toggle("show-full-keyboard", fullSizeKeyboard);
            } else {
                onInteraction && onInteraction(entry, false);
                entry.target.classList.toggle("in-viewport", false);
                entry.target.removeAttribute("aria-current");
            }
        });
    }, intersectionOptions);
    // observe all elements that match that query
    elementsToObserve.forEach((element)=>intersectionObserver.observe(element));
    // console.info("elementsToObserve", {elementsToObserve }) 
    return elementsToObserve;
};

});


parcelRegister("avNAW", function(module, exports) {

$parcel$export(module.exports, "CMD_INITIALISE", function () { return $7a73452159bdc37c$export$d6d948174f44f30e; });
$parcel$export(module.exports, "CMD_START", function () { return $7a73452159bdc37c$export$b6d7488d4cac877d; });
$parcel$export(module.exports, "CMD_STOP", function () { return $7a73452159bdc37c$export$ae0bb7ad9dde4f13; });
$parcel$export(module.exports, "CMD_UPDATE", function () { return $7a73452159bdc37c$export$c47e4720978d2f19; });
$parcel$export(module.exports, "EVENT_READY", function () { return $7a73452159bdc37c$export$d8dac49b4532735a; });
$parcel$export(module.exports, "EVENT_STARTING", function () { return $7a73452159bdc37c$export$94eb30166cc721b3; });
$parcel$export(module.exports, "EVENT_STOPPING", function () { return $7a73452159bdc37c$export$7ffa9f728a168a19; });
$parcel$export(module.exports, "EVENT_TICK", function () { return $7a73452159bdc37c$export$3d63866adcb36c5d; });
const $7a73452159bdc37c$export$d6d948174f44f30e = "init";
const $7a73452159bdc37c$export$b6d7488d4cac877d = "start";
const $7a73452159bdc37c$export$ae0bb7ad9dde4f13 = "stop";
const $7a73452159bdc37c$export$c47e4720978d2f19 = "update";
const $7a73452159bdc37c$export$d8dac49b4532735a = "ready";
const $7a73452159bdc37c$export$94eb30166cc721b3 = "starting";
const $7a73452159bdc37c$export$7ffa9f728a168a19 = "stopping";
const $7a73452159bdc37c$export$3d63866adcb36c5d = "tick";

});

parcelRegister("hyPs1", function(module, exports) {
module.exports = $parcel$import("se3ZA").then(()=>parcelRequire('6XtgI'));

});

parcelRegister("25NTg", function(module, exports) {
module.exports = $parcel$import("hZ2ME").then(()=>parcelRequire('8LykE'));

});

parcelRegister("1PKpj", function(module, exports) {
module.exports = $parcel$import("9NxcV").then(()=>parcelRequire('cdSri'));

});

var $2b61251fa706e285$exports = {};
$parcel$extendImportMap({
    "4qjGb": "webmidi.cjs.min.20d269a7.js",
    "ixisr": "midible.es.071eec44.js",
    "jbhUk": "note-visualiser-worker.bf585dd6.js",
    "b9Bte": "mouse-visualiser-worker.21e5fb01.js",
    "56mx0": "timing.audiocontext.worker.569ee9d4.js",
    "QLqDO": "timing.audioworklet.abce7066.js",
    "kWVsy": "timing.audioworklet-processor.86f4c2f5.js",
    "se3ZA": "timing.audioworklet.1789899b.js",
    "abJQM": "magic-mallet-6262.7490524f.mp3",
    "j77Aa": "magic-spell-cast-sound-effect-224173.d6c87620.mp3",
    "enQih": "shine-magic-sound-4-sounds-190258.1a0bdd52.mp3",
    "eY1iU": "general-midi.1bbe37d4.zip",
    "lA4jq": "manifest.9b25821c.js",
    "hZ2ME": "share-menu.f68cfce4.js",
    "9NxcV": "stats.min.4cfcac62.js"
});

// accessibility
const $95de1c9d486109cf$var$toPrecision = (scale, minimum = 2, precision = 1)=>parseFloat(Math.min(scale, minimum).toFixed(precision));
const $95de1c9d486109cf$export$51a8f1c0de4f8090 = (initialFontSize = 1, onFontSizeChange)=>{
    const buttonFontSizeIncrease = document.getElementById("button-text-size-increase");
    const buttonFontSizeDecrease = document.getElementById("button-text-size-decrease");
    const rootStyles = document.documentElement.style;
    let fontScale = initialFontSize;
    const fontScaleBy = 0.1;
    const setFontScale = (scale)=>{
        if (fontScale !== scale) {
            fontScale = scale;
            rootStyles.setProperty("--font-scale", scale);
            // disable the buttons when their extents are reached?
            buttonFontSizeDecrease.disabled = scale <= 1;
            buttonFontSizeIncrease.disabled = scale >= 2;
            // console.log(rootStyles.getPropertyValue("--font-size-base"))
            onFontSizeChange(scale);
        }
    };
    buttonFontSizeIncrease.addEventListener("click", (e)=>{
        e.preventDefault();
        setFontScale($95de1c9d486109cf$var$toPrecision(fontScale + fontScaleBy, 2));
    });
    buttonFontSizeDecrease.addEventListener("click", (e)=>{
        e.preventDefault();
        setFontScale($95de1c9d486109cf$var$toPrecision(fontScale - fontScaleBy, 2));
    });
};


const $8781acd752900d31$export$ce0e5beb5efeb79 = [
    "default",
    "contrast",
    "monochrome",
    "colourful"
];
const $8781acd752900d31$export$2e49b867b7a0847c = (themeName, onThemeChange)=>{
    // ensure that themeName is a valid theme name
    if (!$8781acd752900d31$export$ce0e5beb5efeb79.includes(themeName)) return false;
    document.documentElement.setAttribute("data-theme", themeName);
    onThemeChange && onThemeChange(themeName);
    return true;
};
const $8781acd752900d31$export$542a581047271686 = (onThemeChange)=>{
    const radioButtons = document.querySelectorAll("input[name='palette']");
    for (const radioButton of radioButtons)radioButton.addEventListener('change', (e)=>{
        if (radioButton.checked) $8781acd752900d31$export$2e49b867b7a0847c(e.target.value, onThemeChange);
    });
};


const $d0a2447e4623647d$export$69e9bdef456a9c46 = (fontName, onFontChange)=>{
    // ensure that fontName is a valid font name
    if (!fontName) return false;
    document.body.setAttribute("data-font", fontName);
    onFontChange && onFontChange(fontName);
    return fontName;
};


// Things that this app can do!
const $63113661c03eac3c$export$830449e67dbe85c8 = 'volumeIncrease';
const $63113661c03eac3c$export$d7c009648ef4529b = 'volumeDecrease';
const $63113661c03eac3c$export$bde8bdbfddc8f27d = 'volumeMute';
const $63113661c03eac3c$export$d8c0e078b0ce9e5c = 'tempoIncrease';
const $63113661c03eac3c$export$d72d3133cdc39d96 = 'tempoDecrease';
const $63113661c03eac3c$export$b16824db080a7d01 = 'tempoReset';
const $63113661c03eac3c$export$be2af54e9cdfd6bf = 'tempoTap';
const $63113661c03eac3c$export$212384c74e1e2d44 = 'playbackToggle';
const $63113661c03eac3c$export$87a956b097ee0a8f = 'playbackStart';
const $63113661c03eac3c$export$4d2b68504638d924 = 'playbackStop';
const $63113661c03eac3c$export$9dae6f82820323cf = 'noteOn';
const $63113661c03eac3c$export$f42c351172ba97da = 'noteOff';
const $63113661c03eac3c$export$a925f15c85079059 = 'pitchBend';


const $f398903761015229$export$9d83d59ca66b5647 = (element, callback)=>{
    // For typing longer numbers
    let numberSequence = "";
    let octaveOffset = 41;
    const midiNoteSequence = [
        "q",
        "2",
        "w",
        "3",
        "e",
        "r",
        "5",
        "t",
        "6",
        "y",
        "7",
        "u",
        "i",
        "9",
        "o",
        "0",
        "p",
        "[",
        "]",
        "\\",
        "a",
        "z",
        "s",
        "x",
        "d",
        "c",
        "f",
        "v",
        "g",
        "b",
        "h",
        "n",
        "j",
        "m",
        "k",
        ",",
        "l",
        ".",
        ";",
        "/",
        "'"
    ];
    const keysPressed = new Map();
    const keyboardMap = new Map();
    midiNoteSequence.forEach((midiNote, index)=>keyboardMap.set(midiNote, index + octaveOffset));
    element.addEventListener('keydown', async (event)=>{
        const isNumber = !isNaN(parseInt(event.key));
        const focussedElement = document.activeElement;
        // Allow Tab to continue to perform its default function
        if (event.key !== 'Tab') event.preventDefault();
        if (keysPressed.has(event.key)) // already pressed so ignore
        return;
        // Contextual hotkeys - if something is focussed then different keys!
        if (focussedElement && focussedElement !== document.documentElement) // not body!
        focussedElement.nodeName;
        let command = undefined;
        let value = -1;
        if (keyboardMap.has(event.key)) {
            const noteNumber = keyboardMap.get(event.key);
            keysPressed.set(event.key, noteNumber);
            console.log("Key down", $63113661c03eac3c$export$9dae6f82820323cf, event.key, noteNumber);
            callback($63113661c03eac3c$export$9dae6f82820323cf, event.key, noteNumber);
            return;
        }
        switch(event.key){
            case 'CapsLock':
                event.preventDefault();
                break;
            case 'Escape':
            case 'Del':
            case 'Delete':
                command = $63113661c03eac3c$export$4d2b68504638d924;
                break;
            case 'Enter':
                command = $63113661c03eac3c$export$212384c74e1e2d44;
                break;
            case 'Space':
                command = $63113661c03eac3c$export$be2af54e9cdfd6bf;
                break;
            case 'QuestionMark':
                event.preventDefault();
                break;
            case '?':
                event.preventDefault();
                break;
            case 'ArrowLeft':
                command = $63113661c03eac3c$export$a925f15c85079059;
                value = 0.2;
                break;
            case 'ArrowRight':
                command = $63113661c03eac3c$export$a925f15c85079059;
                value = -0.2;
                break;
            case 'ArrowUp':
                command = $63113661c03eac3c$export$d8c0e078b0ce9e5c;
                break;
            case 'ArrowDown':
                command = $63113661c03eac3c$export$d72d3133cdc39d96;
                break;
            case ',':
                event.preventDefault();
                break;
            case '.':
                event.preventDefault();
                break;
            case 'a':
                event.preventDefault();
                break;
            case 'b':
                event.preventDefault();
                break;
            case 'c':
                event.preventDefault();
                break;
            case 'd':
                event.preventDefault();
                break;
            case 'e':
                event.preventDefault();
                break;
            case 'f':
                event.preventDefault();
                break;
            case 'g':
                event.preventDefault();
                break;
            case 'h':
                event.preventDefault();
                break;
            case 'i':
                event.preventDefault();
                break;
            case 'j':
                event.preventDefault();
                break;
            case 'k':
                event.preventDefault();
                break;
            case 'l':
                event.preventDefault();
                break;
            case 'm':
                event.preventDefault();
                break;
            case 'n':
                event.preventDefault();
                break;
            case 'o':
                event.preventDefault();
                break;
            case 'p':
                event.preventDefault();
                break;
            case 'q':
                event.preventDefault();
                break;
            case 'r':
                event.preventDefault();
                break;
            case 's':
                event.preventDefault();
                break;
            case 't':
                event.preventDefault();
                break;
            case 'u':
                event.preventDefault();
                break;
            case 'v':
                event.preventDefault();
                break;
            case 'w':
                event.preventDefault();
                break;
            case 'x':
                event.preventDefault();
                break;
            case 'y':
                event.preventDefault();
                break;
            case 'z':
                event.preventDefault();
                break;
            case "F1":
                event.preventDefault();
                break;
            case "F2":
                event.preventDefault();
                break;
            case "F3":
                event.preventDefault();
                break;
            case "F4":
                event.preventDefault();
                break;
            // Select Players only
            case "F5":
                event.preventDefault();
                break;
            case "F6":
                event.preventDefault();
                break;
            case "F7":
                event.preventDefault();
                break;
            case "F8":
                event.preventDefault();
                break;
            // Media Hotkeys
            // Launch Media
            case "LaunchMediaPlayer":
                event.preventDefault();
                break;
            // Previous Track
            case "MediaTrackPrevious":
                event.preventDefault();
                break;
            // Play / Pause Percussion
            case "MediaPlayPause":
                event.preventDefault();
                break;
            // Next Track
            case "MediaTrackNext":
                event.preventDefault();
                break;
            case "F9":
                event.preventDefault();
                break;
            case "F10":
                event.preventDefault();
                break;
            // Play / Pause Percussion
            case "F11":
                event.preventDefault();
                break;
            // Next Track
            case "F12":
                event.preventDefault();
                break;
            case "F13":
                event.preventDefault();
                break;
            case "F14":
                event.preventDefault();
                break;
            case "F15":
                event.preventDefault();
                break;
            case "F16":
                event.preventDefault();
                break;
            case "F17":
                event.preventDefault();
                break;
            case "F18":
                event.preventDefault();
                break;
            case "F19":
                event.preventDefault();
                break;
            // don't hijack tab you numpty!
            // FILTER
            case 'Tab':
                break;
            default:
                // check if it is numerical...
                // or if it is a media key?
                isNumber;
                console.log("Key pressed", {
                    event: event,
                    isNumber: isNumber
                });
        }
        // Check to see if it is a number
        if (isNumber) {
            numberSequence += event.key;
            // now check to see if it is 3 numbers long
            if (numberSequence.length === 3) // reset
            numberSequence = '';
        } else numberSequence = '';
        keysPressed.set(event.key, value);
        callback(command, event.key, value);
    // console.log("key", ui, event)
    });
    // depress notes held
    element.addEventListener('keyup', async (event)=>{
        if (event.key !== 'Tab') event.preventDefault();
        if (keyboardMap.has(event.key)) {
            // note was pressed, so send note off
            const noteNumber = keysPressed.get(event.key);
            console.log("Key up", $63113661c03eac3c$export$f42c351172ba97da, event.key, noteNumber);
            keysPressed.delete(event.key);
            callback($63113661c03eac3c$export$f42c351172ba97da, event.key, noteNumber);
        }
    });
};



var $a0j6m = parcelRequire("a0j6m");
var $ab26ec1106ccdbea$exports = {};



(function(global, factory) {
    factory($ab26ec1106ccdbea$exports, (parcelRequire("4nvnS")), (parcelRequire("73ILk")), (parcelRequire("gB2Ba")));
})($ab26ec1106ccdbea$exports, function(exports1, _slicedToArray, _classCallCheck, _createClass) {
    'use strict';
    var createExtendedExponentialRampToValueAutomationEvent = function createExtendedExponentialRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: 'exponentialRampToValue',
            value: value
        };
    };
    var createExtendedLinearRampToValueAutomationEvent = function createExtendedLinearRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: 'linearRampToValue',
            value: value
        };
    };
    var createSetValueAutomationEvent = function createSetValueAutomationEvent(value, startTime) {
        return {
            startTime: startTime,
            type: 'setValue',
            value: value
        };
    };
    var createSetValueCurveAutomationEvent = function createSetValueCurveAutomationEvent(values, startTime, duration) {
        return {
            duration: duration,
            startTime: startTime,
            type: 'setValueCurve',
            values: values
        };
    };
    var getTargetValueAtTime = function getTargetValueAtTime(time, valueAtStartTime, _ref) {
        var startTime = _ref.startTime, target = _ref.target, timeConstant = _ref.timeConstant;
        return target + (valueAtStartTime - target) * Math.exp((startTime - time) / timeConstant);
    };
    var isExponentialRampToValueAutomationEvent = function isExponentialRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'exponentialRampToValue';
    };
    var isLinearRampToValueAutomationEvent = function isLinearRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'linearRampToValue';
    };
    var isAnyRampToValueAutomationEvent = function isAnyRampToValueAutomationEvent(automationEvent) {
        return isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent);
    };
    var isSetValueAutomationEvent = function isSetValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'setValue';
    };
    var isSetValueCurveAutomationEvent = function isSetValueCurveAutomationEvent(automationEvent) {
        return automationEvent.type === 'setValueCurve';
    };
    var _getValueOfAutomationEventAtIndexAtTime = function getValueOfAutomationEventAtIndexAtTime(automationEvents, index, time, defaultValue) {
        var automationEvent = automationEvents[index];
        return automationEvent === undefined ? defaultValue : isAnyRampToValueAutomationEvent(automationEvent) || isSetValueAutomationEvent(automationEvent) ? automationEvent.value : isSetValueCurveAutomationEvent(automationEvent) ? automationEvent.values[automationEvent.values.length - 1] : getTargetValueAtTime(time, _getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, automationEvent.startTime, defaultValue), automationEvent);
    };
    var getEndTimeAndValueOfPreviousAutomationEvent = function getEndTimeAndValueOfPreviousAutomationEvent(automationEvents, index, currentAutomationEvent, nextAutomationEvent, defaultValue) {
        return currentAutomationEvent === undefined ? [
            nextAutomationEvent.insertTime,
            defaultValue
        ] : isAnyRampToValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.endTime,
            currentAutomationEvent.value
        ] : isSetValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime,
            currentAutomationEvent.value
        ] : isSetValueCurveAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime + currentAutomationEvent.duration,
            currentAutomationEvent.values[currentAutomationEvent.values.length - 1]
        ] : [
            currentAutomationEvent.startTime,
            _getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, currentAutomationEvent.startTime, defaultValue)
        ];
    };
    var isCancelAndHoldAutomationEvent = function isCancelAndHoldAutomationEvent(automationEvent) {
        return automationEvent.type === 'cancelAndHold';
    };
    var isCancelScheduledValuesAutomationEvent = function isCancelScheduledValuesAutomationEvent(automationEvent) {
        return automationEvent.type === 'cancelScheduledValues';
    };
    var getEventTime = function getEventTime(automationEvent) {
        if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) return automationEvent.cancelTime;
        if (isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent)) return automationEvent.endTime;
        return automationEvent.startTime;
    };
    var getExponentialRampValueAtTime = function getExponentialRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        if (valueAtStartTime === value) return value;
        if (0 < valueAtStartTime && 0 < value || valueAtStartTime < 0 && value < 0) return valueAtStartTime * Math.pow(value / valueAtStartTime, (time - startTime) / (endTime - startTime));
        return 0;
    };
    var getLinearRampValueAtTime = function getLinearRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        return valueAtStartTime + (time - startTime) / (endTime - startTime) * (value - valueAtStartTime);
    };
    var interpolateValue = function interpolateValue(values, theoreticIndex) {
        var lowerIndex = Math.floor(theoreticIndex);
        var upperIndex = Math.ceil(theoreticIndex);
        if (lowerIndex === upperIndex) return values[lowerIndex];
        return (1 - (theoreticIndex - lowerIndex)) * values[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * values[upperIndex];
    };
    var getValueCurveValueAtTime = function getValueCurveValueAtTime(time, _ref) {
        var duration = _ref.duration, startTime = _ref.startTime, values = _ref.values;
        var theoreticIndex = (time - startTime) / duration * (values.length - 1);
        return interpolateValue(values, theoreticIndex);
    };
    var isSetTargetAutomationEvent = function isSetTargetAutomationEvent(automationEvent) {
        return automationEvent.type === 'setTarget';
    };
    var AutomationEventList = /*#__PURE__*/ function() {
        function AutomationEventList(defaultValue) {
            _classCallCheck(this, AutomationEventList);
            this._automationEvents = [];
            this._currenTime = 0;
            this._defaultValue = defaultValue;
        }
        return _createClass(AutomationEventList, [
            {
                key: Symbol.iterator,
                value: function value() {
                    return this._automationEvents[Symbol.iterator]();
                }
            },
            {
                key: "add",
                value: function add(automationEvent) {
                    var eventTime = getEventTime(automationEvent);
                    if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) {
                        var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            if (isCancelScheduledValuesAutomationEvent(automationEvent) && isSetValueCurveAutomationEvent(currentAutomationEvent)) return currentAutomationEvent.startTime + currentAutomationEvent.duration >= eventTime;
                            return getEventTime(currentAutomationEvent) >= eventTime;
                        });
                        var removedAutomationEvent = this._automationEvents[index];
                        if (index !== -1) this._automationEvents = this._automationEvents.slice(0, index);
                        if (isCancelAndHoldAutomationEvent(automationEvent)) {
                            var lastAutomationEvent = this._automationEvents[this._automationEvents.length - 1];
                            if (removedAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(removedAutomationEvent)) {
                                if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) throw new Error('The internal list is malformed.');
                                var startTime = lastAutomationEvent === undefined ? removedAutomationEvent.insertTime : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.startTime + lastAutomationEvent.duration : getEventTime(lastAutomationEvent);
                                var startValue = lastAutomationEvent === undefined ? this._defaultValue : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.values[lastAutomationEvent.values.length - 1] : lastAutomationEvent.value;
                                var value = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? getExponentialRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent) : getLinearRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent);
                                var truncatedAutomationEvent = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? createExtendedExponentialRampToValueAutomationEvent(value, eventTime, this._currenTime) : createExtendedLinearRampToValueAutomationEvent(value, eventTime, this._currenTime);
                                this._automationEvents.push(truncatedAutomationEvent);
                            }
                            if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) this._automationEvents.push(createSetValueAutomationEvent(this.getValue(eventTime), eventTime));
                            if (lastAutomationEvent !== undefined && isSetValueCurveAutomationEvent(lastAutomationEvent) && lastAutomationEvent.startTime + lastAutomationEvent.duration > eventTime) {
                                var duration = eventTime - lastAutomationEvent.startTime;
                                var ratio = (lastAutomationEvent.values.length - 1) / lastAutomationEvent.duration;
                                var length = Math.max(2, 1 + Math.ceil(duration * ratio));
                                var fraction = duration / (length - 1) * ratio;
                                var values = lastAutomationEvent.values.slice(0, length);
                                if (fraction < 1) for(var i = 1; i < length; i += 1){
                                    var factor = fraction * i % 1;
                                    values[i] = lastAutomationEvent.values[i - 1] * (1 - factor) + lastAutomationEvent.values[i] * factor;
                                }
                                this._automationEvents[this._automationEvents.length - 1] = createSetValueCurveAutomationEvent(values, lastAutomationEvent.startTime, duration);
                            }
                        }
                    } else {
                        var _index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            return getEventTime(currentAutomationEvent) > eventTime;
                        });
                        var previousAutomationEvent = _index === -1 ? this._automationEvents[this._automationEvents.length - 1] : this._automationEvents[_index - 1];
                        if (previousAutomationEvent !== undefined && isSetValueCurveAutomationEvent(previousAutomationEvent) && getEventTime(previousAutomationEvent) + previousAutomationEvent.duration > eventTime) return false;
                        var persistentAutomationEvent = isExponentialRampToValueAutomationEvent(automationEvent) ? createExtendedExponentialRampToValueAutomationEvent(automationEvent.value, automationEvent.endTime, this._currenTime) : isLinearRampToValueAutomationEvent(automationEvent) ? createExtendedLinearRampToValueAutomationEvent(automationEvent.value, eventTime, this._currenTime) : automationEvent;
                        if (_index === -1) this._automationEvents.push(persistentAutomationEvent);
                        else {
                            if (isSetValueCurveAutomationEvent(automationEvent) && eventTime + automationEvent.duration > getEventTime(this._automationEvents[_index])) return false;
                            this._automationEvents.splice(_index, 0, persistentAutomationEvent);
                        }
                    }
                    return true;
                }
            },
            {
                key: "flush",
                value: function flush(time) {
                    var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                        return getEventTime(currentAutomationEvent) > time;
                    });
                    if (index > 1) {
                        var remainingAutomationEvents = this._automationEvents.slice(index - 1);
                        var firstRemainingAutomationEvent = remainingAutomationEvents[0];
                        if (isSetTargetAutomationEvent(firstRemainingAutomationEvent)) remainingAutomationEvents.unshift(createSetValueAutomationEvent(_getValueOfAutomationEventAtIndexAtTime(this._automationEvents, index - 2, firstRemainingAutomationEvent.startTime, this._defaultValue), firstRemainingAutomationEvent.startTime));
                        this._automationEvents = remainingAutomationEvents;
                    }
                }
            },
            {
                key: "getValue",
                value: function getValue(time) {
                    if (this._automationEvents.length === 0) return this._defaultValue;
                    var indexOfNextEvent = this._automationEvents.findIndex(function(automationEvent) {
                        return getEventTime(automationEvent) > time;
                    });
                    var nextAutomationEvent = this._automationEvents[indexOfNextEvent];
                    var indexOfCurrentEvent = (indexOfNextEvent === -1 ? this._automationEvents.length : indexOfNextEvent) - 1;
                    var currentAutomationEvent = this._automationEvents[indexOfCurrentEvent];
                    if (currentAutomationEvent !== undefined && isSetTargetAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || nextAutomationEvent.insertTime > time)) return getTargetValueAtTime(time, _getValueOfAutomationEventAtIndexAtTime(this._automationEvents, indexOfCurrentEvent - 1, currentAutomationEvent.startTime, this._defaultValue), currentAutomationEvent);
                    if (currentAutomationEvent !== undefined && isSetValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (currentAutomationEvent !== undefined && isSetValueCurveAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || currentAutomationEvent.startTime + currentAutomationEvent.duration > time)) {
                        if (time < currentAutomationEvent.startTime + currentAutomationEvent.duration) return getValueCurveValueAtTime(time, currentAutomationEvent);
                        return currentAutomationEvent.values[currentAutomationEvent.values.length - 1];
                    }
                    if (currentAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (nextAutomationEvent !== undefined && isExponentialRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf2 = _slicedToArray(_getEndTimeAndValueOf, 2), startTime = _getEndTimeAndValueOf2[0], value = _getEndTimeAndValueOf2[1];
                        return getExponentialRampValueAtTime(time, startTime, value, nextAutomationEvent);
                    }
                    if (nextAutomationEvent !== undefined && isLinearRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf3 = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf4 = _slicedToArray(_getEndTimeAndValueOf3, 2), _startTime = _getEndTimeAndValueOf4[0], _value = _getEndTimeAndValueOf4[1];
                        return getLinearRampValueAtTime(time, _startTime, _value, nextAutomationEvent);
                    }
                    return this._defaultValue;
                }
            }
        ]);
    }();
    var createCancelAndHoldAutomationEvent = function createCancelAndHoldAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: 'cancelAndHold'
        };
    };
    var createCancelScheduledValuesAutomationEvent = function createCancelScheduledValuesAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: 'cancelScheduledValues'
        };
    };
    var createExponentialRampToValueAutomationEvent = function createExponentialRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: 'exponentialRampToValue',
            value: value
        };
    };
    var createLinearRampToValueAutomationEvent = function createLinearRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: 'linearRampToValue',
            value: value
        };
    };
    var createSetTargetAutomationEvent = function createSetTargetAutomationEvent(target, startTime, timeConstant) {
        return {
            startTime: startTime,
            target: target,
            timeConstant: timeConstant,
            type: 'setTarget'
        };
    };
    exports1.AutomationEventList = AutomationEventList;
    exports1.createCancelAndHoldAutomationEvent = createCancelAndHoldAutomationEvent;
    exports1.createCancelScheduledValuesAutomationEvent = createCancelScheduledValuesAutomationEvent;
    exports1.createExponentialRampToValueAutomationEvent = createExponentialRampToValueAutomationEvent;
    exports1.createLinearRampToValueAutomationEvent = createLinearRampToValueAutomationEvent;
    exports1.createSetTargetAutomationEvent = createSetTargetAutomationEvent;
    exports1.createSetValueAutomationEvent = createSetValueAutomationEvent;
    exports1.createSetValueCurveAutomationEvent = createSetValueCurveAutomationEvent;
});


const $f6277d111f8e5d11$export$aff31bd5258e9fd4 = ()=>new DOMException('', 'AbortError');


const $b646bcb0a86c631b$export$43d20cccdc976834 = (insertElementInSet)=>{
    return (activeInputs, source, [output, input, eventListener], ignoreDuplicates)=>{
        insertElementInSet(activeInputs[input], [
            source,
            output,
            eventListener
        ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
    };
};


const $12127b780360ed7a$export$7ff07578cebde522 = (audioNodeConnectionsStore)=>{
    return (audioNode, audioNodeRenderer, nativeAudioNode)=>{
        const activeInputs = [];
        for(let i = 0; i < nativeAudioNode.numberOfInputs; i += 1)activeInputs.push(new Set());
        audioNodeConnectionsStore.set(audioNode, {
            activeInputs: activeInputs,
            outputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioNodeRenderer
        });
    };
};


const $2ea332361a1ef3c3$export$25226f7a087f88c3 = (audioParamConnectionsStore)=>{
    return (audioParam, audioParamRenderer)=>{
        audioParamConnectionsStore.set(audioParam, {
            activeInputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioParamRenderer
        });
    };
};


const $063560d8523a7eb5$export$2b500979aea0913f = new WeakSet();
const $063560d8523a7eb5$export$61ca80a8c8c6d728 = new WeakMap();
const $063560d8523a7eb5$export$864a3cfb55580d0c = new WeakMap();
const $063560d8523a7eb5$export$c5d3ff1f46a0185a = new WeakMap();
const $063560d8523a7eb5$export$55484e3055c7a9e2 = new WeakMap();
const $063560d8523a7eb5$export$7d17302229276f06 = new WeakMap();
const $063560d8523a7eb5$export$c998cfefa4fd5136 = new WeakMap();
const $063560d8523a7eb5$export$cf686a6a3e402092 = new WeakMap();
const $063560d8523a7eb5$export$b9bea39f06f96914 = new WeakMap();
const $063560d8523a7eb5$export$16d7878f7e059d67 = new WeakMap();


const $96c3271afebb17a5$var$handler = {
    construct () {
        return $96c3271afebb17a5$var$handler;
    }
};
const $96c3271afebb17a5$export$df064419399503e9 = (constructible)=>{
    try {
        const proxy = new Proxy(constructible, $96c3271afebb17a5$var$handler);
        new proxy(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};


/*
 * This massive regex tries to cover all the following cases.
 *
 * import './path';
 * import defaultImport from './path';
 * import { namedImport } from './path';
 * import { namedImport as renamendImport } from './path';
 * import * as namespaceImport from './path';
 * import defaultImport, { namedImport } from './path';
 * import defaultImport, { namedImport as renamendImport } from './path';
 * import defaultImport, * as namespaceImport from './path';
 */ const $3c17ac4eedebb6c3$var$IMPORT_STATEMENT_REGEX = /^import(?:(?:[\s]+[\w]+|(?:[\s]+[\w]+[\s]*,)?[\s]*\{[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?(?:[\s]*,[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?)*[\s]*}|(?:[\s]+[\w]+[\s]*,)?[\s]*\*[\s]+as[\s]+[\w]+)[\s]+from)?(?:[\s]*)("([^"\\]|\\.)+"|'([^'\\]|\\.)+')(?:[\s]*);?/; // tslint:disable-line:max-line-length
const $3c17ac4eedebb6c3$export$949058cf055dbb57 = (source, url)=>{
    const importStatements = [];
    let sourceWithoutImportStatements = source.replace(/^[\s]+/, '');
    let result = sourceWithoutImportStatements.match($3c17ac4eedebb6c3$var$IMPORT_STATEMENT_REGEX);
    while(result !== null){
        const unresolvedUrl = result[1].slice(1, -1);
        const importStatementWithResolvedUrl = result[0].replace(/([\s]+)?;?$/, '').replace(unresolvedUrl, new URL(unresolvedUrl, url).toString());
        importStatements.push(importStatementWithResolvedUrl);
        sourceWithoutImportStatements = sourceWithoutImportStatements.slice(result[0].length).replace(/^[\s]+/, '');
        result = sourceWithoutImportStatements.match($3c17ac4eedebb6c3$var$IMPORT_STATEMENT_REGEX);
    }
    return [
        importStatements.join(';'),
        sourceWithoutImportStatements
    ];
};


const $ce06fe6462f7561e$var$verifyParameterDescriptors = (parameterDescriptors)=>{
    if (parameterDescriptors !== undefined && !Array.isArray(parameterDescriptors)) throw new TypeError('The parameterDescriptors property of given value for processorCtor is not an array.');
};
const $ce06fe6462f7561e$var$verifyProcessorCtor = (processorCtor)=>{
    if (!(0, $96c3271afebb17a5$export$df064419399503e9)(processorCtor)) throw new TypeError('The given value for processorCtor should be a constructor.');
    if (processorCtor.prototype === null || typeof processorCtor.prototype !== 'object') throw new TypeError('The given value for processorCtor should have a prototype.');
};
const $ce06fe6462f7561e$export$16c6049a33c70efa = (cacheTestResult, createNotSupportedError, evaluateSource, exposeCurrentFrameAndCurrentTime, fetchSource, getNativeContext, getOrCreateBackupOfflineAudioContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, ongoingRequests, resolvedRequests, testAudioWorkletProcessorPostMessageSupport, window)=>{
    let index = 0;
    return (context, moduleURL, options = {
        credentials: 'omit'
    })=>{
        const resolvedRequestsOfContext = resolvedRequests.get(context);
        if (resolvedRequestsOfContext !== undefined && resolvedRequestsOfContext.has(moduleURL)) return Promise.resolve();
        const ongoingRequestsOfContext = ongoingRequests.get(context);
        if (ongoingRequestsOfContext !== undefined) {
            const promiseOfOngoingRequest = ongoingRequestsOfContext.get(moduleURL);
            if (promiseOfOngoingRequest !== undefined) return promiseOfOngoingRequest;
        }
        const nativeContext = getNativeContext(context);
        // Bug #59: Safari does not implement the audioWorklet property.
        const promise = nativeContext.audioWorklet === undefined ? fetchSource(moduleURL).then(([source, absoluteUrl])=>{
            const [importStatements, sourceWithoutImportStatements] = (0, $3c17ac4eedebb6c3$export$949058cf055dbb57)(source, absoluteUrl);
            /*
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * ${ importStatements };
                 * ((a, b) => {
                 *     (a[b] = a[b] || [ ]).push(
                 *         (AudioWorkletProcessor, global, registerProcessor, sampleRate, self, window) => {
                 *             ${ sourceWithoutImportStatements }
                 *         }
                 *     );
                 * })(window, '_AWGS');
                 * ```
                 */ // tslint:disable-next-line:max-line-length
            const wrappedSource = `${importStatements};((a,b)=>{(a[b]=a[b]||[]).push((AudioWorkletProcessor,global,registerProcessor,sampleRate,self,window)=>{${sourceWithoutImportStatements}
})})(window,'_AWGS')`;
            // @todo Evaluating the given source code is a possible security problem.
            return evaluateSource(wrappedSource);
        }).then(()=>{
            const evaluateAudioWorkletGlobalScope = window._AWGS.pop();
            if (evaluateAudioWorkletGlobalScope === undefined) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            throw new SyntaxError();
            exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>evaluateAudioWorkletGlobalScope(class AudioWorkletProcessor {
                }, undefined, (name, processorCtor)=>{
                    if (name.trim() === '') throw createNotSupportedError();
                    const nodeNameToProcessorConstructorMap = (0, $063560d8523a7eb5$export$b9bea39f06f96914).get(nativeContext);
                    if (nodeNameToProcessorConstructorMap !== undefined) {
                        if (nodeNameToProcessorConstructorMap.has(name)) throw createNotSupportedError();
                        $ce06fe6462f7561e$var$verifyProcessorCtor(processorCtor);
                        $ce06fe6462f7561e$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        nodeNameToProcessorConstructorMap.set(name, processorCtor);
                    } else {
                        $ce06fe6462f7561e$var$verifyProcessorCtor(processorCtor);
                        $ce06fe6462f7561e$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        (0, $063560d8523a7eb5$export$b9bea39f06f96914).set(nativeContext, new Map([
                            [
                                name,
                                processorCtor
                            ]
                        ]));
                    }
                }, nativeContext.sampleRate, undefined, undefined));
        }) : Promise.all([
            fetchSource(moduleURL),
            Promise.resolve(cacheTestResult(testAudioWorkletProcessorPostMessageSupport, testAudioWorkletProcessorPostMessageSupport))
        ]).then(([[source, absoluteUrl], isSupportingPostMessage])=>{
            const currentIndex = index + 1;
            index = currentIndex;
            const [importStatements, sourceWithoutImportStatements] = (0, $3c17ac4eedebb6c3$export$949058cf055dbb57)(source, absoluteUrl);
            /*
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * This is the unminified version of the code used below.
                 *
                 * ```js
                 * class extends AudioWorkletProcessor {
                 *
                 *     __buffers = new WeakSet();
                 *
                 *     constructor () {
                 *         super();
                 *
                 *         this.port.postMessage = ((postMessage) => {
                 *             return (message, transferables) => {
                 *                 const filteredTransferables = (transferables)
                 *                     ? transferables.filter((transferable) => !this.__buffers.has(transferable))
                 *                     : transferables;
                 *
                 *                 return postMessage.call(this.port, message, filteredTransferables);
                 *              };
                 *         })(this.port.postMessage);
                 *     }
                 * }
                 * ```
                 */ const patchedAudioWorkletProcessor = isSupportingPostMessage ? 'AudioWorkletProcessor' : 'class extends AudioWorkletProcessor {__b=new WeakSet();constructor(){super();(p=>p.postMessage=(q=>(m,t)=>q.call(p,m,t?t.filter(u=>!this.__b.has(u)):t))(p.postMessage))(this.port)}}';
            /*
                 * Bug #170: Chrome and Edge do call process() with an array with empty channelData for each input if no input is connected.
                 *
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * Bug #190: Safari doesn't throw an error when loading an unparsable module.
                 *
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * `${ importStatements };
                 * ((AudioWorkletProcessor, registerProcessor) => {${ sourceWithoutImportStatements }
                 * })(
                 *     ${ patchedAudioWorkletProcessor },
                 *     (name, processorCtor) => registerProcessor(name, class extends processorCtor {
                 *
                 *         __collectBuffers = (array) => {
                 *             array.forEach((element) => this.__buffers.add(element.buffer));
                 *         };
                 *
                 *         process (inputs, outputs, parameters) {
                 *             inputs.forEach(this.__collectBuffers);
                 *             outputs.forEach(this.__collectBuffers);
                 *             this.__collectBuffers(Object.values(parameters));
                 *
                 *             return super.process(
                 *                 (inputs.map((input) => input.some((channelData) => channelData.length === 0)) ? [ ] : input),
                 *                 outputs,
                 *                 parameters
                 *             );
                 *         }
                 *
                 *     })
                 * );
                 *
                 * registerProcessor(`__sac${currentIndex}`, class extends AudioWorkletProcessor{
                 *
                 *     process () {
                 *         return false;
                 *     }
                 *
                 * })`
                 * ```
                 */ const memberDefinition = isSupportingPostMessage ? '' : '__c = (a) => a.forEach(e=>this.__b.add(e.buffer));';
            const bufferRegistration = isSupportingPostMessage ? '' : 'i.forEach(this.__c);o.forEach(this.__c);this.__c(Object.values(p));';
            const wrappedSource = `${importStatements};((AudioWorkletProcessor,registerProcessor)=>{${sourceWithoutImportStatements}
})(${patchedAudioWorkletProcessor},(n,p)=>registerProcessor(n,class extends p{${memberDefinition}process(i,o,p){${bufferRegistration}return super.process(i.map(j=>j.some(k=>k.length===0)?[]:j),o,p)}}));registerProcessor('__sac${currentIndex}',class extends AudioWorkletProcessor{process(){return !1}})`;
            const blob = new Blob([
                wrappedSource
            ], {
                type: 'application/javascript; charset=utf-8'
            });
            const url = URL.createObjectURL(blob);
            return nativeContext.audioWorklet.addModule(url, options).then(()=>{
                if (isNativeOfflineAudioContext(nativeContext)) return nativeContext;
                // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
                const backupOfflineAudioContext = getOrCreateBackupOfflineAudioContext(nativeContext);
                return backupOfflineAudioContext.audioWorklet.addModule(url, options).then(()=>backupOfflineAudioContext);
            }).then((nativeContextOrBackupOfflineAudioContext)=>{
                if (nativeAudioWorkletNodeConstructor === null) throw new SyntaxError();
                try {
                    // Bug #190: Safari doesn't throw an error when loading an unparsable module.
                    new nativeAudioWorkletNodeConstructor(nativeContextOrBackupOfflineAudioContext, `__sac${currentIndex}`); // tslint:disable-line:no-unused-expression
                } catch  {
                    throw new SyntaxError();
                }
            }).finally(()=>URL.revokeObjectURL(url));
        });
        if (ongoingRequestsOfContext === undefined) ongoingRequests.set(context, new Map([
            [
                moduleURL,
                promise
            ]
        ]));
        else ongoingRequestsOfContext.set(moduleURL, promise);
        promise.then(()=>{
            const updatedResolvedRequestsOfContext = resolvedRequests.get(context);
            if (updatedResolvedRequestsOfContext === undefined) resolvedRequests.set(context, new Set([
                moduleURL
            ]));
            else updatedResolvedRequestsOfContext.add(moduleURL);
        }).finally(()=>{
            const updatedOngoingRequestsOfContext = ongoingRequests.get(context);
            if (updatedOngoingRequestsOfContext !== undefined) updatedOngoingRequestsOfContext.delete(moduleURL);
        });
        return promise;
    };
};


const $a30e5f89486249dd$export$520987e3ff3ffad3 = (map, key)=>{
    const value = map.get(key);
    if (value === undefined) throw new Error('A value with the given key could not be found.');
    return value;
};


const $b040556145ba427c$export$3f1b331b43a0e659 = (set, predicate)=>{
    const matchingElements = Array.from(set).filter(predicate);
    if (matchingElements.length > 1) throw Error('More than one element was found.');
    if (matchingElements.length === 0) throw Error('No element was found.');
    const [matchingElement] = matchingElements;
    set.delete(matchingElement);
    return matchingElement;
};


const $a45841bde2f74cc3$export$26ec3ebc965d6cfd = (passiveInputs, source, output, input)=>{
    const passiveInputConnections = (0, $a30e5f89486249dd$export$520987e3ff3ffad3)(passiveInputs, source);
    const matchingConnection = (0, $b040556145ba427c$export$3f1b331b43a0e659)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};





const $eb1a7cc50e1a0085$export$caac7ea54cb93b25 = (audioNode)=>{
    return (0, $a30e5f89486249dd$export$520987e3ff3ffad3)((0, $063560d8523a7eb5$export$c998cfefa4fd5136), audioNode);
};


const $1dade94fa084012d$export$88a47afdc0e8539c = (audioNode)=>{
    if ((0, $063560d8523a7eb5$export$2b500979aea0913f).has(audioNode)) throw new Error('The AudioNode is already stored.');
    (0, $063560d8523a7eb5$export$2b500979aea0913f).add(audioNode);
    (0, $eb1a7cc50e1a0085$export$caac7ea54cb93b25)(audioNode).forEach((eventListener)=>eventListener(true));
};


const $13907bc2c16ca3ad$export$1293b9fc79a24682 = (audioNode)=>{
    return 'port' in audioNode;
};




const $9fbb9de7ccc2f607$export$7c0830f3a5100dec = (audioNode)=>{
    if (!(0, $063560d8523a7eb5$export$2b500979aea0913f).has(audioNode)) throw new Error('The AudioNode is not stored.');
    (0, $063560d8523a7eb5$export$2b500979aea0913f).delete(audioNode);
    (0, $eb1a7cc50e1a0085$export$caac7ea54cb93b25)(audioNode).forEach((eventListener)=>eventListener(false));
};


const $78897653c3b1c064$export$c74023ca160dc207 = (audioNode, activeInputs)=>{
    if (!(0, $13907bc2c16ca3ad$export$1293b9fc79a24682)(audioNode) && activeInputs.every((connections)=>connections.size === 0)) (0, $9fbb9de7ccc2f607$export$7c0830f3a5100dec)(audioNode);
};


const $4a9ebe5f527c8af2$export$1776cf0d295db1d7 = (addActiveInputConnectionToAudioNode, addPassiveInputConnectionToAudioNode, connectNativeAudioNodeToNativeAudioNode, deleteActiveInputConnectionToAudioNode, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getAudioNodeTailTime, getEventListenersOfAudioNode, getNativeAudioNode, insertElementInSet, isActiveAudioNode, isPartOfACycle, isPassiveAudioNode)=>{
    const tailTimeTimeoutIds = new WeakMap();
    return (source, destination, output, input, isOffline)=>{
        const { activeInputs: activeInputs, passiveInputs: passiveInputs } = getAudioNodeConnections(destination);
        const { outputs: outputs } = getAudioNodeConnections(source);
        const eventListeners = getEventListenersOfAudioNode(source);
        const eventListener = (isActive)=>{
            const nativeDestinationAudioNode = getNativeAudioNode(destination);
            const nativeSourceAudioNode = getNativeAudioNode(source);
            if (isActive) {
                const partialConnection = (0, $a45841bde2f74cc3$export$26ec3ebc965d6cfd)(passiveInputs, source, output, input);
                addActiveInputConnectionToAudioNode(activeInputs, source, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                if (isPassiveAudioNode(destination)) (0, $1dade94fa084012d$export$88a47afdc0e8539c)(destination);
            } else {
                const partialConnection = deleteActiveInputConnectionToAudioNode(activeInputs, source, output, input);
                addPassiveInputConnectionToAudioNode(passiveInputs, input, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                const tailTime = getAudioNodeTailTime(destination);
                if (tailTime === 0) {
                    if (isActiveAudioNode(destination)) (0, $78897653c3b1c064$export$c74023ca160dc207)(destination, activeInputs);
                } else {
                    const tailTimeTimeoutId = tailTimeTimeoutIds.get(destination);
                    if (tailTimeTimeoutId !== undefined) clearTimeout(tailTimeTimeoutId);
                    tailTimeTimeoutIds.set(destination, setTimeout(()=>{
                        if (isActiveAudioNode(destination)) (0, $78897653c3b1c064$export$c74023ca160dc207)(destination, activeInputs);
                    }, tailTime * 1000));
                }
            }
        };
        if (insertElementInSet(outputs, [
            destination,
            output,
            input
        ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output && outputConnection[2] === input, true)) {
            eventListeners.add(eventListener);
            if (isActiveAudioNode(source)) addActiveInputConnectionToAudioNode(activeInputs, source, [
                output,
                input,
                eventListener
            ], true);
            else addPassiveInputConnectionToAudioNode(passiveInputs, input, [
                source,
                output,
                eventListener
            ], true);
            return true;
        }
        return false;
    };
};


const $82c0b56b5effd879$export$67aa4e90be3a506b = (insertElementInSet)=>{
    return (passiveInputs, input, [source, output, eventListener], ignoreDuplicates)=>{
        const passiveInputConnections = passiveInputs.get(source);
        if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
            [
                output,
                input,
                eventListener
            ]
        ]));
        else insertElementInSet(passiveInputConnections, [
            output,
            input,
            eventListener
        ], (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input, ignoreDuplicates);
    };
};


const $dbd295179837d595$export$c6991e18a29704b9 = (createNativeGainNode)=>{
    return (nativeContext, nativeAudioScheduledSourceNode)=>{
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        nativeAudioScheduledSourceNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnect = ()=>{
            nativeAudioScheduledSourceNode.removeEventListener('ended', disconnect);
            nativeAudioScheduledSourceNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        nativeAudioScheduledSourceNode.addEventListener('ended', disconnect);
    };
};


const $d0847042424bd9d5$export$fd0136b1517d036f = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).add(audioWorkletNode);
    };
};


const $5c7bc54ab41e693e$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    fftSize: 2048,
    maxDecibels: -30,
    minDecibels: -100,
    smoothingTimeConstant: 0.8
};
const $5c7bc54ab41e693e$export$569b2da15d7fe153 = (audionNodeConstructor, createAnalyserNodeRenderer, createIndexSizeError, createNativeAnalyserNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class AnalyserNode extends audionNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$5c7bc54ab41e693e$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAnalyserNode = createNativeAnalyserNode(nativeContext, mergedOptions);
            const analyserNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createAnalyserNodeRenderer() : null;
            super(context, false, nativeAnalyserNode, analyserNodeRenderer);
            this._nativeAnalyserNode = nativeAnalyserNode;
        }
        get fftSize() {
            return this._nativeAnalyserNode.fftSize;
        }
        set fftSize(value) {
            this._nativeAnalyserNode.fftSize = value;
        }
        get frequencyBinCount() {
            return this._nativeAnalyserNode.frequencyBinCount;
        }
        get maxDecibels() {
            return this._nativeAnalyserNode.maxDecibels;
        }
        set maxDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const maxDecibels = this._nativeAnalyserNode.maxDecibels;
            this._nativeAnalyserNode.maxDecibels = value;
            if (!(value > this._nativeAnalyserNode.minDecibels)) {
                this._nativeAnalyserNode.maxDecibels = maxDecibels;
                throw createIndexSizeError();
            }
        }
        get minDecibels() {
            return this._nativeAnalyserNode.minDecibels;
        }
        set minDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const minDecibels = this._nativeAnalyserNode.minDecibels;
            this._nativeAnalyserNode.minDecibels = value;
            if (!(this._nativeAnalyserNode.maxDecibels > value)) {
                this._nativeAnalyserNode.minDecibels = minDecibels;
                throw createIndexSizeError();
            }
        }
        get smoothingTimeConstant() {
            return this._nativeAnalyserNode.smoothingTimeConstant;
        }
        set smoothingTimeConstant(value) {
            this._nativeAnalyserNode.smoothingTimeConstant = value;
        }
        getByteFrequencyData(array) {
            this._nativeAnalyserNode.getByteFrequencyData(array);
        }
        getByteTimeDomainData(array) {
            this._nativeAnalyserNode.getByteTimeDomainData(array);
        }
        getFloatFrequencyData(array) {
            this._nativeAnalyserNode.getFloatFrequencyData(array);
        }
        getFloatTimeDomainData(array) {
            this._nativeAnalyserNode.getFloatTimeDomainData(array);
        }
    };
};


const $4f6edb936961edcb$export$4bd7a4bf54ca80bc = (nativeAudioNode, nativeContext)=>{
    return nativeAudioNode.context === nativeContext;
};


const $8dcf092e8be673b7$export$5fe3f5c2d995fe20 = (createNativeAnalyserNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAnalyserNodes = new WeakMap();
        const createAnalyserNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAnalyserNode = getNativeAudioNode(proxy);
            // If the initially used nativeAnalyserNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAnalyserNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeAnalyserNode, nativeOfflineAudioContext);
            if (!nativeAnalyserNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAnalyserNode.channelCount,
                    channelCountMode: nativeAnalyserNode.channelCountMode,
                    channelInterpretation: nativeAnalyserNode.channelInterpretation,
                    fftSize: nativeAnalyserNode.fftSize,
                    maxDecibels: nativeAnalyserNode.maxDecibels,
                    minDecibels: nativeAnalyserNode.minDecibels,
                    smoothingTimeConstant: nativeAnalyserNode.smoothingTimeConstant
                };
                nativeAnalyserNode = createNativeAnalyserNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAnalyserNodes.set(nativeOfflineAudioContext, nativeAnalyserNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAnalyserNode);
            return nativeAnalyserNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAnalyserNode = renderedNativeAnalyserNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAnalyserNode !== undefined) return Promise.resolve(renderedNativeAnalyserNode);
                return createAnalyserNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $12a6e013f8a09c14$export$54e424f510c54ced = (nativeAudioBuffer)=>{
    try {
        nativeAudioBuffer.copyToChannel(new Float32Array(1), 0, -1);
    } catch  {
        return false;
    }
    return true;
};


const $4d0b106e88d3580d$export$926e4aa3eed6ec13 = ()=>new DOMException('', 'IndexSizeError');


const $327fa96f6085d8f9$export$df65309cf6249598 = (audioBuffer)=>{
    audioBuffer.getChannelData = ((getChannelData)=>{
        return (channel)=>{
            try {
                return getChannelData.call(audioBuffer, channel);
            } catch (err) {
                if (err.code === 12) throw (0, $4d0b106e88d3580d$export$926e4aa3eed6ec13)();
                throw err;
            }
        };
    })(audioBuffer.getChannelData);
};


const $15784a30c090bf38$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $15784a30c090bf38$export$c8b88126795b7df2 = (audioBufferStore, cacheTestResult, createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, testNativeAudioBufferConstructorSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    let nativeOfflineAudioContext = null;
    return class AudioBuffer {
        constructor(options){
            if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$15784a30c090bf38$var$DEFAULT_OPTIONS,
                ...options
            };
            if (nativeOfflineAudioContext === null) nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
            /*
             * Bug #99: Firefox does not throw a NotSupportedError when the numberOfChannels is zero. But it only does it when using the
             * factory function. But since Firefox also supports the constructor everything should be fine.
             */ const audioBuffer = nativeAudioBufferConstructor !== null && cacheTestResult(testNativeAudioBufferConstructorSupport, testNativeAudioBufferConstructorSupport) ? new nativeAudioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            }) : nativeOfflineAudioContext.createBuffer(numberOfChannels, length, sampleRate);
            // Bug #99: Safari does not throw an error when the numberOfChannels is zero.
            if (audioBuffer.numberOfChannels === 0) throw createNotSupportedError();
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== 'function') {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $327fa96f6085d8f9$export$df65309cf6249598)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult((0, $12a6e013f8a09c14$export$54e424f510c54ced), ()=>(0, $12a6e013f8a09c14$export$54e424f510c54ced)(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            /*
             * This does violate all good pratices but it is necessary to allow this AudioBuffer to be used with native
             * (Offline)AudioContexts.
             */ return audioBuffer;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === AudioBuffer.prototype || audioBufferStore.has(instance);
        }
    };
};


const $109263ef7a828de3$export$ced6a5c63b103b52 = -340282346638528860000000000000000000000;
const $109263ef7a828de3$export$ab43bedd17d6a167 = -$109263ef7a828de3$export$ced6a5c63b103b52;



const $503abdc94195f7ae$export$e44f0fc8e83fb084 = (audioNode)=>(0, $063560d8523a7eb5$export$2b500979aea0913f).has(audioNode);




const $1d8cf95ce21b401a$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    // Bug #149: Safari does not yet support the detune AudioParam.
    loop: false,
    loopEnd: 0,
    loopStart: 0,
    playbackRate: 1
};
const $1d8cf95ce21b401a$export$6857b764b4428518 = (audioNodeConstructor, createAudioBufferSourceNodeRenderer, createAudioParam, createInvalidStateError, createNativeAudioBufferSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class AudioBufferSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$1d8cf95ce21b401a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const audioBufferSourceNodeRenderer = isOffline ? createAudioBufferSourceNodeRenderer() : null;
            super(context, false, nativeAudioBufferSourceNode, audioBufferSourceNodeRenderer);
            this._audioBufferSourceNodeRenderer = audioBufferSourceNodeRenderer;
            this._isBufferNullified = false;
            this._isBufferSet = mergedOptions.buffer !== null;
            this._nativeAudioBufferSourceNode = nativeAudioBufferSourceNode;
            this._onended = null;
            // Bug #73: Safari does not export the correct values for maxValue and minValue.
            this._playbackRate = createAudioParam(this, isOffline, nativeAudioBufferSourceNode.playbackRate, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeAudioBufferSourceNode.buffer;
        }
        set buffer(value) {
            this._nativeAudioBufferSourceNode.buffer = value;
            // Bug #72: Only Chrome & Edge do not allow to reassign the buffer yet.
            if (value !== null) {
                if (this._isBufferSet) throw createInvalidStateError();
                this._isBufferSet = true;
            }
        }
        get loop() {
            return this._nativeAudioBufferSourceNode.loop;
        }
        set loop(value) {
            this._nativeAudioBufferSourceNode.loop = value;
        }
        get loopEnd() {
            return this._nativeAudioBufferSourceNode.loopEnd;
        }
        set loopEnd(value) {
            this._nativeAudioBufferSourceNode.loopEnd = value;
        }
        get loopStart() {
            return this._nativeAudioBufferSourceNode.loopStart;
        }
        set loopStart(value) {
            this._nativeAudioBufferSourceNode.loopStart = value;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeAudioBufferSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeAudioBufferSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get playbackRate() {
            return this._playbackRate;
        }
        start(when = 0, offset = 0, duration) {
            this._nativeAudioBufferSourceNode.start(when, offset, duration);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.start = duration === undefined ? [
                when,
                offset
            ] : [
                when,
                offset,
                duration
            ];
            if (this.context.state !== 'closed') {
                (0, $1dade94fa084012d$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeAudioBufferSourceNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $503abdc94195f7ae$export$e44f0fc8e83fb084)(this)) (0, $9fbb9de7ccc2f607$export$7c0830f3a5100dec)(this);
                };
                this._nativeAudioBufferSourceNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeAudioBufferSourceNode.stop(when);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.stop = when;
        }
    };
};



const $a0f25202631bec54$export$82721be5d1bb22c5 = (connectAudioParam, createNativeAudioBufferSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioBufferSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createAudioBufferSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeAudioBufferSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeAudioBufferSourceNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeAudioBufferSourceNode, nativeOfflineAudioContext);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeAudioBufferSourceNode.buffer,
                    channelCount: nativeAudioBufferSourceNode.channelCount,
                    channelCountMode: nativeAudioBufferSourceNode.channelCountMode,
                    channelInterpretation: nativeAudioBufferSourceNode.channelInterpretation,
                    // Bug #149: Safari does not yet support the detune AudioParam.
                    loop: nativeAudioBufferSourceNode.loop,
                    loopEnd: nativeAudioBufferSourceNode.loopEnd,
                    loopStart: nativeAudioBufferSourceNode.loopStart,
                    playbackRate: nativeAudioBufferSourceNode.playbackRate.value
                };
                nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeAudioBufferSourceNode.start(...start);
                if (stop !== null) nativeAudioBufferSourceNode.stop(stop);
            }
            renderedNativeAudioBufferSourceNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) // Bug #149: Safari does not yet support the detune AudioParam.
            await renderAutomation(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            else // Bug #149: Safari does not yet support the detune AudioParam.
            await connectAudioParam(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            return nativeAudioBufferSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioBufferSourceNode = renderedNativeAudioBufferSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioBufferSourceNode !== undefined) return Promise.resolve(renderedNativeAudioBufferSourceNode);
                return createAudioBufferSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $c2a6f4b3052b9524$export$b030d1cb39b66ce3 = (audioNode)=>{
    return 'playbackRate' in audioNode;
};



const $272e9de516f14836$export$8bbceb3e2d3b886a = (audioNode)=>{
    return 'frequency' in audioNode && 'gain' in audioNode;
};


const $706095a648ef6e51$export$2b5f11f35c31b1bf = (audioNode)=>{
    return 'offset' in audioNode;
};


const $90cca5ff3fedba8f$export$c124c0514d4f41ab = (audioNode)=>{
    return !('frequency' in audioNode) && 'gain' in audioNode;
};


const $9f8f274ae7e3f99a$export$97bb3ed4238ea897 = (audioNode)=>{
    return 'detune' in audioNode && 'frequency' in audioNode && !('gain' in audioNode);
};


const $6f0927f08729be1f$export$79ba82be14a0b006 = (audioNode)=>{
    return 'pan' in audioNode;
};




const $8c427995665b3ffa$export$6b29eee2af836dfc = (audioNode)=>{
    return (0, $a30e5f89486249dd$export$520987e3ff3ffad3)((0, $063560d8523a7eb5$export$61ca80a8c8c6d728), audioNode);
};




const $8ece18592a1d3a4f$export$1b11f454bf19657 = (audioParam)=>{
    return (0, $a30e5f89486249dd$export$520987e3ff3ffad3)((0, $063560d8523a7eb5$export$c5d3ff1f46a0185a), audioParam);
};




const $b4ff256b0227b048$export$e16f533d410eeca0 = (audioNode, trace)=>{
    const { activeInputs: activeInputs } = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(audioNode);
    activeInputs.forEach((connections)=>connections.forEach(([source])=>{
            if (!trace.includes(audioNode)) $b4ff256b0227b048$export$e16f533d410eeca0(source, [
                ...trace,
                audioNode
            ]);
        }));
    const audioParams = (0, $c2a6f4b3052b9524$export$b030d1cb39b66ce3)(audioNode) ? [
        // Bug #149: Safari does not yet support the detune AudioParam.
        audioNode.playbackRate
    ] : (0, $13907bc2c16ca3ad$export$1293b9fc79a24682)(audioNode) ? Array.from(audioNode.parameters.values()) : (0, $272e9de516f14836$export$8bbceb3e2d3b886a)(audioNode) ? [
        audioNode.Q,
        audioNode.detune,
        audioNode.frequency,
        audioNode.gain
    ] : (0, $706095a648ef6e51$export$2b5f11f35c31b1bf)(audioNode) ? [
        audioNode.offset
    ] : (0, $90cca5ff3fedba8f$export$c124c0514d4f41ab)(audioNode) ? [
        audioNode.gain
    ] : (0, $9f8f274ae7e3f99a$export$97bb3ed4238ea897)(audioNode) ? [
        audioNode.detune,
        audioNode.frequency
    ] : (0, $6f0927f08729be1f$export$79ba82be14a0b006)(audioNode) ? [
        audioNode.pan
    ] : [];
    for (const audioParam of audioParams){
        const audioParamConnections = (0, $8ece18592a1d3a4f$export$1b11f454bf19657)(audioParam);
        if (audioParamConnections !== undefined) audioParamConnections.activeInputs.forEach(([source])=>$b4ff256b0227b048$export$e16f533d410eeca0(source, trace));
    }
    if ((0, $503abdc94195f7ae$export$e44f0fc8e83fb084)(audioNode)) (0, $9fbb9de7ccc2f607$export$7c0830f3a5100dec)(audioNode);
};


const $38dbdfa389791805$export$cbd606bc629ea938 = (context)=>{
    (0, $b4ff256b0227b048$export$e16f533d410eeca0)(context.destination, []);
};


const $9c08ad7d1fee8b6f$export$82d5f0e102842fbe = (latencyHint)=>{
    return latencyHint === undefined || typeof latencyHint === 'number' || typeof latencyHint === 'string' && (latencyHint === 'balanced' || latencyHint === 'interactive' || latencyHint === 'playback');
};


const $11e193d9c959815b$export$c6fe175def53ff71 = (baseAudioContextConstructor, createInvalidStateError, createNotSupportedError, createUnknownError, mediaElementAudioSourceNodeConstructor, mediaStreamAudioDestinationNodeConstructor, mediaStreamAudioSourceNodeConstructor, mediaStreamTrackAudioSourceNodeConstructor, nativeAudioContextConstructor)=>{
    return class AudioContext extends baseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error('Missing the native AudioContext constructor.');
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === 'sampleRate is not in range') throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $9c08ad7d1fee8b6f$export$82d5f0e102842fbe)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === 'running') {
                this._state = 'suspended';
                const revokeState = ()=>{
                    if (this._state === 'suspended') this._state = null;
                    nativeAudioContext.removeEventListener('statechange', revokeState);
                };
                nativeAudioContext.addEventListener('statechange', revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === 'closed') return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === 'suspended') this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $38dbdfa389791805$export$cbd606bc629ea938)(this);
            });
        }
        createMediaElementSource(mediaElement) {
            return new mediaElementAudioSourceNodeConstructor(this, {
                mediaElement: mediaElement
            });
        }
        createMediaStreamDestination() {
            return new mediaStreamAudioDestinationNodeConstructor(this);
        }
        createMediaStreamSource(mediaStream) {
            return new mediaStreamAudioSourceNodeConstructor(this, {
                mediaStream: mediaStream
            });
        }
        createMediaStreamTrackSource(mediaStreamTrack) {
            return new mediaStreamTrackAudioSourceNodeConstructor(this, {
                mediaStreamTrack: mediaStreamTrack
            });
        }
        resume() {
            if (this._state === 'suspended') return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener('statechange', resolvePromise);
                    if (this._nativeAudioContext.state === 'running') resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener('statechange', resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};


const $00d55746043f7ae9$export$cbbb0c3ba3f5dd5b = (audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode)=>{
    return class AudioDestinationNode extends audioNodeConstructor {
        constructor(context, channelCount){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const nativeAudioDestinationNode = createNativeAudioDestinationNode(nativeContext, channelCount, isOffline);
            const audioDestinationNodeRenderer = isOffline ? createAudioDestinationNodeRenderer(renderInputsOfAudioNode) : null;
            super(context, false, nativeAudioDestinationNode, audioDestinationNodeRenderer);
            this._isNodeOfNativeOfflineAudioContext = isOffline;
            this._nativeAudioDestinationNode = nativeAudioDestinationNode;
        }
        get channelCount() {
            return this._nativeAudioDestinationNode.channelCount;
        }
        set channelCount(value) {
            // Bug #52: Chrome, Edge & Safari do not throw an exception at all.
            // Bug #54: Firefox does throw an IndexSizeError.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
            if (value > this._nativeAudioDestinationNode.maxChannelCount) throw createIndexSizeError();
            this._nativeAudioDestinationNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioDestinationNode.channelCountMode;
        }
        set channelCountMode(value) {
            // Bug #53: No browser does throw an exception yet.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            this._nativeAudioDestinationNode.channelCountMode = value;
        }
        get maxChannelCount() {
            return this._nativeAudioDestinationNode.maxChannelCount;
        }
    };
};


const $002b7bffdee189c2$export$d44f3f5d4e42ced2 = (renderInputsOfAudioNode)=>{
    const renderedNativeAudioDestinationNodes = new WeakMap();
    const createAudioDestinationNode = async (proxy, nativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
        renderedNativeAudioDestinationNodes.set(nativeOfflineAudioContext, nativeAudioDestinationNode);
        await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode);
        return nativeAudioDestinationNode;
    };
    return {
        render (proxy, nativeOfflineAudioContext) {
            const renderedNativeAudioDestinationNode = renderedNativeAudioDestinationNodes.get(nativeOfflineAudioContext);
            if (renderedNativeAudioDestinationNode !== undefined) return Promise.resolve(renderedNativeAudioDestinationNode);
            return createAudioDestinationNode(proxy, nativeOfflineAudioContext);
        }
    };
};



const $d58e9c03ca8eb821$export$3e70692c55bd5b52 = (createAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeScriptProcessorNode, createNotSupportedError, getFirstSample, isNativeOfflineAudioContext, overwriteAccessors)=>{
    return (context, nativeContext)=>{
        const nativeListener = nativeContext.listener;
        // Bug #117: Only Chrome & Edge support the new interface already.
        const createFakeAudioParams = ()=>{
            const buffer = new Float32Array(1);
            const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'speakers',
                numberOfInputs: 9
            });
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            let isScriptProcessorNodeCreated = false;
            let lastOrientation = [
                0,
                0,
                -1,
                0,
                1,
                0
            ];
            let lastPosition = [
                0,
                0,
                0
            ];
            const createScriptProcessorNode = ()=>{
                if (isScriptProcessorNodeCreated) return;
                isScriptProcessorNodeCreated = true;
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 9, 0);
                // tslint:disable-next-line:deprecation
                scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
                    const orientation = [
                        getFirstSample(inputBuffer, buffer, 0),
                        getFirstSample(inputBuffer, buffer, 1),
                        getFirstSample(inputBuffer, buffer, 2),
                        getFirstSample(inputBuffer, buffer, 3),
                        getFirstSample(inputBuffer, buffer, 4),
                        getFirstSample(inputBuffer, buffer, 5)
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index])) {
                        nativeListener.setOrientation(...orientation); // tslint:disable-line:deprecation
                        lastOrientation = orientation;
                    }
                    const positon = [
                        getFirstSample(inputBuffer, buffer, 6),
                        getFirstSample(inputBuffer, buffer, 7),
                        getFirstSample(inputBuffer, buffer, 8)
                    ];
                    if (positon.some((value, index)=>value !== lastPosition[index])) {
                        nativeListener.setPosition(...positon); // tslint:disable-line:deprecation
                        lastPosition = positon;
                    }
                };
                channelMergerNode.connect(scriptProcessorNode);
            };
            const createSetOrientation = (index)=>(value)=>{
                    if (value !== lastOrientation[index]) {
                        lastOrientation[index] = value;
                        nativeListener.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
                    }
                };
            const createSetPosition = (index)=>(value)=>{
                    if (value !== lastPosition[index]) {
                        lastPosition[index] = value;
                        nativeListener.setPosition(...lastPosition); // tslint:disable-line:deprecation
                    }
                };
            const createFakeAudioParam = (input, initialValue, setValue)=>{
                const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    offset: initialValue
                });
                constantSourceNode.connect(channelMergerNode, 0, input);
                // @todo This should be stopped when the context is closed.
                constantSourceNode.start();
                Object.defineProperty(constantSourceNode.offset, 'defaultValue', {
                    get () {
                        return initialValue;
                    }
                });
                /*
                 * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and
                 * minValue for GainNodes.
                 */ const audioParam = createAudioParam({
                    context: context
                }, isOffline, constantSourceNode.offset, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
                overwriteAccessors(audioParam, 'value', (get)=>()=>get.call(audioParam), (set)=>(value)=>{
                        try {
                            set.call(audioParam, value);
                        } catch (err) {
                            if (err.code !== 9) throw err;
                        }
                        createScriptProcessorNode();
                        if (isOffline) // Bug #117: Using setOrientation() and setPosition() doesn't work with an OfflineAudioContext.
                        setValue(value);
                    });
                audioParam.cancelAndHoldAtTime = ((cancelAndHoldAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelAndHoldAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelAndHoldAtTime);
                audioParam.cancelScheduledValues = ((cancelScheduledValues)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelScheduledValues.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelScheduledValues);
                audioParam.exponentialRampToValueAtTime = ((exponentialRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = exponentialRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.exponentialRampToValueAtTime);
                audioParam.linearRampToValueAtTime = ((linearRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = linearRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.linearRampToValueAtTime);
                audioParam.setTargetAtTime = ((setTargetAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setTargetAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setTargetAtTime);
                audioParam.setValueAtTime = ((setValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueAtTime);
                audioParam.setValueCurveAtTime = ((setValueCurveAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueCurveAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueCurveAtTime);
                return audioParam;
            };
            return {
                forwardX: createFakeAudioParam(0, 0, createSetOrientation(0)),
                forwardY: createFakeAudioParam(1, 0, createSetOrientation(1)),
                forwardZ: createFakeAudioParam(2, -1, createSetOrientation(2)),
                positionX: createFakeAudioParam(6, 0, createSetPosition(0)),
                positionY: createFakeAudioParam(7, 0, createSetPosition(1)),
                positionZ: createFakeAudioParam(8, 0, createSetPosition(2)),
                upX: createFakeAudioParam(3, 0, createSetOrientation(3)),
                upY: createFakeAudioParam(4, 1, createSetOrientation(4)),
                upZ: createFakeAudioParam(5, 0, createSetOrientation(5))
            };
        };
        const { forwardX: forwardX, forwardY: forwardY, forwardZ: forwardZ, positionX: positionX, positionY: positionY, positionZ: positionZ, upX: upX, upY: upY, upZ: upZ } = nativeListener.forwardX === undefined ? createFakeAudioParams() : nativeListener;
        return {
            get forwardX () {
                return forwardX;
            },
            get forwardY () {
                return forwardY;
            },
            get forwardZ () {
                return forwardZ;
            },
            get positionX () {
                return positionX;
            },
            get positionY () {
                return positionY;
            },
            get positionZ () {
                return positionZ;
            },
            get upX () {
                return upX;
            },
            get upY () {
                return upY;
            },
            get upZ () {
                return upZ;
            }
        };
    };
};



const $abb453140d998e25$export$85cd8e93eb858e81 = (audioNodeOrAudioParam)=>{
    return 'context' in audioNodeOrAudioParam;
};



const $ac48105bedc212b3$export$419d66ef3a96a878 = (outputConnection)=>{
    return (0, $abb453140d998e25$export$85cd8e93eb858e81)(outputConnection[0]);
};


const $e6ab5bfca0b63cf7$export$64505511c8abc942 = (set, element, predicate, ignoreDuplicates)=>{
    for (const lmnt of set)if (predicate(lmnt)) {
        if (ignoreDuplicates) return false;
        throw Error('The set contains at least one similar element.');
    }
    set.add(element);
    return true;
};


const $7bd68fdf2442b76e$export$3dfe9f7f712d42df = (activeInputs, source, [output, eventListener], ignoreDuplicates)=>{
    (0, $e6ab5bfca0b63cf7$export$64505511c8abc942)(activeInputs, [
        source,
        output,
        eventListener
    ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
};



const $2f5d0440a4f3e168$export$2a7c0e6916aa50e4 = (passiveInputs, [source, output, eventListener], ignoreDuplicates)=>{
    const passiveInputConnections = passiveInputs.get(source);
    if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
        [
            output,
            eventListener
        ]
    ]));
    else (0, $e6ab5bfca0b63cf7$export$64505511c8abc942)(passiveInputConnections, [
        output,
        eventListener
    ], (passiveInputConnection)=>passiveInputConnection[0] === output, ignoreDuplicates);
};


const $077e12d27999c158$export$ac2aef07f705aa48 = (nativeAudioNodeOrNativeAudioNodeFaker)=>{
    return 'inputs' in nativeAudioNodeOrNativeAudioNodeFaker;
};


const $2167468b26f40e2e$export$b92162b3199b4461 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $077e12d27999c158$export$ac2aef07f705aa48)(nativeDestinationAudioNode)) {
        const fakeNativeDestinationAudioNode = nativeDestinationAudioNode.inputs[input];
        nativeSourceAudioNode.connect(fakeNativeDestinationAudioNode, output, 0);
        return [
            fakeNativeDestinationAudioNode,
            output,
            0
        ];
    }
    nativeSourceAudioNode.connect(nativeDestinationAudioNode, output, input);
    return [
        nativeDestinationAudioNode,
        output,
        input
    ];
};


const $086d1c35fad7691a$export$6cc4c86d6b87a4b8 = (activeInputConnections, source, output)=>{
    for (const activeInputConnection of activeInputConnections)if (activeInputConnection[0] === source && activeInputConnection[1] === output) {
        activeInputConnections.delete(activeInputConnection);
        return activeInputConnection;
    }
    return null;
};



const $f14cf830bb5b4591$export$dc5a8616367736a9 = (activeInputs, source, output)=>{
    return (0, $b040556145ba427c$export$3f1b331b43a0e659)(activeInputs, (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
};



const $8d9851b3ce841ff0$export$b5a32c2e2eac4137 = (audioNode, eventListener)=>{
    const eventListeners = (0, $eb1a7cc50e1a0085$export$caac7ea54cb93b25)(audioNode);
    if (!eventListeners.delete(eventListener)) throw new Error('Missing the expected event listener.');
};





const $6231a6993a4748a9$export$368aa16ce008e2f4 = (passiveInputs, source, output)=>{
    const passiveInputConnections = (0, $a30e5f89486249dd$export$520987e3ff3ffad3)(passiveInputs, source);
    const matchingConnection = (0, $b040556145ba427c$export$3f1b331b43a0e659)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};



const $f65544ff5369b765$export$a19b495df4b88921 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $077e12d27999c158$export$ac2aef07f705aa48)(nativeDestinationAudioNode)) nativeSourceAudioNode.disconnect(nativeDestinationAudioNode.inputs[input], output, 0);
    else nativeSourceAudioNode.disconnect(nativeDestinationAudioNode, output, input);
};







const $a25444b65385088d$export$e719c0d45ea16d08 = (audioNode)=>{
    return (0, $a30e5f89486249dd$export$520987e3ff3ffad3)((0, $063560d8523a7eb5$export$864a3cfb55580d0c), audioNode);
};




const $44fe7bee8da5f8b6$export$fad3d843b2a56ffb = (audioParam)=>{
    return (0, $a30e5f89486249dd$export$520987e3ff3ffad3)((0, $063560d8523a7eb5$export$55484e3055c7a9e2), audioParam);
};





const $0f23cc3dee4d6a7f$export$8658a39a04a404d5 = (audioNode)=>{
    return (0, $063560d8523a7eb5$export$cf686a6a3e402092).has(audioNode);
};



const $b765ea918e2b8359$export$79a7cb9fa56970e = (audioNode)=>{
    return !(0, $063560d8523a7eb5$export$2b500979aea0913f).has(audioNode);
};




const $351f08ffebfa3c12$export$f938a299860627 = (nativeAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return new Promise((resolve)=>{
        /*
         * This bug existed in Safari up until v14.0.2. Since AudioWorklets were not supported in Safari until v14.1 the presence of the
         * constructor for an AudioWorkletNode can be used here to skip the test.
         */ if (nativeAudioWorkletNodeConstructor !== null) resolve(true);
        else {
            const analyzer = nativeAudioContext.createScriptProcessor(256, 1, 1); // tslint:disable-line deprecation
            const dummy = nativeAudioContext.createGain();
            // Bug #95: Safari does not play one sample buffers.
            const ones = nativeAudioContext.createBuffer(1, 2, 44100);
            const channelData = ones.getChannelData(0);
            channelData[0] = 1;
            channelData[1] = 1;
            const source = nativeAudioContext.createBufferSource();
            source.buffer = ones;
            source.loop = true;
            source.connect(analyzer).connect(nativeAudioContext.destination);
            source.connect(dummy);
            source.disconnect(dummy);
            // tslint:disable-next-line:deprecation
            analyzer.onaudioprocess = (event)=>{
                const chnnlDt = event.inputBuffer.getChannelData(0); // tslint:disable-line deprecation
                if (Array.prototype.some.call(chnnlDt, (sample)=>sample === 1)) resolve(true);
                else resolve(false);
                source.stop();
                analyzer.onaudioprocess = null; // tslint:disable-line:deprecation
                source.disconnect(analyzer);
                analyzer.disconnect(nativeAudioContext.destination);
            };
            source.start();
        }
    });
};


const $fa15ebb04ca0fc27$export$f8092aa3a6fcf50f = (cycles, visitor)=>{
    const counts = new Map();
    for (const cycle of cycles)for (const audioNode of cycle){
        const count = counts.get(audioNode);
        counts.set(audioNode, count === undefined ? 1 : count + 1);
    }
    counts.forEach((count, audioNode)=>visitor(audioNode, count));
};


const $db699c2c2928ff4a$export$d647358384f164e0 = (nativeAudioNodeOrAudioParam)=>{
    return 'context' in nativeAudioNodeOrAudioParam;
};


const $576051a2e9e747fc$export$d4ca24d0078a887f = (nativeAudioNode)=>{
    const connections = new Map();
    nativeAudioNode.connect = ((connect)=>{
        // tslint:disable-next-line:invalid-void no-inferrable-types
        return (destination, output = 0, input = 0)=>{
            const returnValue = (0, $db699c2c2928ff4a$export$d647358384f164e0)(destination) ? connect(destination, output, input) : connect(destination, output);
            // Save the new connection only if the calls to connect above didn't throw an error.
            const connectionsToDestination = connections.get(destination);
            if (connectionsToDestination === undefined) connections.set(destination, [
                {
                    input: input,
                    output: output
                }
            ]);
            else if (connectionsToDestination.every((connection)=>connection.input !== input || connection.output !== output)) connectionsToDestination.push({
                input: input,
                output: output
            });
            return returnValue;
        };
    })(nativeAudioNode.connect.bind(nativeAudioNode));
    nativeAudioNode.disconnect = ((disconnect)=>{
        return (destinationOrOutput, output, input)=>{
            disconnect.apply(nativeAudioNode);
            if (destinationOrOutput === undefined) connections.clear();
            else if (typeof destinationOrOutput === 'number') for (const [destination, connectionsToDestination] of connections){
                const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== destinationOrOutput);
                if (filteredConnections.length === 0) connections.delete(destination);
                else connections.set(destination, filteredConnections);
            }
            else if (connections.has(destinationOrOutput)) {
                if (output === undefined) connections.delete(destinationOrOutput);
                else {
                    const connectionsToDestination = connections.get(destinationOrOutput);
                    if (connectionsToDestination !== undefined) {
                        const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== output && (connection.input !== input || input === undefined));
                        if (filteredConnections.length === 0) connections.delete(destinationOrOutput);
                        else connections.set(destinationOrOutput, filteredConnections);
                    }
                }
            }
            for (const [destination, connectionsToDestination] of connections)connectionsToDestination.forEach((connection)=>{
                if ((0, $db699c2c2928ff4a$export$d647358384f164e0)(destination)) nativeAudioNode.connect(destination, connection.output, connection.input);
                else nativeAudioNode.connect(destination, connection.output);
            });
        };
    })(nativeAudioNode.disconnect);
};


const $f7091401ab9fe646$var$addConnectionToAudioParamOfAudioContext = (source, destination, output, isOffline)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $8ece18592a1d3a4f$export$1b11f454bf19657)(destination);
    const { outputs: outputs } = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(source);
    const eventListeners = (0, $eb1a7cc50e1a0085$export$caac7ea54cb93b25)(source);
    const eventListener = (isActive)=>{
        const nativeAudioNode = (0, $a25444b65385088d$export$e719c0d45ea16d08)(source);
        const nativeAudioParam = (0, $44fe7bee8da5f8b6$export$fad3d843b2a56ffb)(destination);
        if (isActive) {
            const partialConnection = (0, $6231a6993a4748a9$export$368aa16ce008e2f4)(passiveInputs, source, output);
            (0, $7bd68fdf2442b76e$export$3dfe9f7f712d42df)(activeInputs, source, partialConnection, false);
            if (!isOffline && !(0, $0f23cc3dee4d6a7f$export$8658a39a04a404d5)(source)) nativeAudioNode.connect(nativeAudioParam, output);
        } else {
            const partialConnection = (0, $f14cf830bb5b4591$export$dc5a8616367736a9)(activeInputs, source, output);
            (0, $2f5d0440a4f3e168$export$2a7c0e6916aa50e4)(passiveInputs, partialConnection, false);
            if (!isOffline && !(0, $0f23cc3dee4d6a7f$export$8658a39a04a404d5)(source)) nativeAudioNode.disconnect(nativeAudioParam, output);
        }
    };
    if ((0, $e6ab5bfca0b63cf7$export$64505511c8abc942)(outputs, [
        destination,
        output
    ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output, true)) {
        eventListeners.add(eventListener);
        if ((0, $503abdc94195f7ae$export$e44f0fc8e83fb084)(source)) (0, $7bd68fdf2442b76e$export$3dfe9f7f712d42df)(activeInputs, source, [
            output,
            eventListener
        ], true);
        else (0, $2f5d0440a4f3e168$export$2a7c0e6916aa50e4)(passiveInputs, [
            source,
            output,
            eventListener
        ], true);
        return true;
    }
    return false;
};
const $f7091401ab9fe646$var$deleteInputConnectionOfAudioNode = (source, destination, output, input)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(destination);
    const activeInputConnection = (0, $086d1c35fad7691a$export$6cc4c86d6b87a4b8)(activeInputs[input], source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $a45841bde2f74cc3$export$26ec3ebc965d6cfd)(passiveInputs, source, output, input);
        return [
            passiveInputConnection[2],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $f7091401ab9fe646$var$deleteInputConnectionOfAudioParam = (source, destination, output)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $8ece18592a1d3a4f$export$1b11f454bf19657)(destination);
    const activeInputConnection = (0, $086d1c35fad7691a$export$6cc4c86d6b87a4b8)(activeInputs, source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $6231a6993a4748a9$export$368aa16ce008e2f4)(passiveInputs, source, output);
        return [
            passiveInputConnection[1],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $f7091401ab9fe646$var$deleteInputsOfAudioNode = (source, isOffline, destination, output, input)=>{
    const [listener, isActive] = $f7091401ab9fe646$var$deleteInputConnectionOfAudioNode(source, destination, output, input);
    if (listener !== null) {
        (0, $8d9851b3ce841ff0$export$b5a32c2e2eac4137)(source, listener);
        if (isActive && !isOffline && !(0, $0f23cc3dee4d6a7f$export$8658a39a04a404d5)(source)) (0, $f65544ff5369b765$export$a19b495df4b88921)((0, $a25444b65385088d$export$e719c0d45ea16d08)(source), (0, $a25444b65385088d$export$e719c0d45ea16d08)(destination), output, input);
    }
    if ((0, $503abdc94195f7ae$export$e44f0fc8e83fb084)(destination)) {
        const { activeInputs: activeInputs } = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(destination);
        (0, $78897653c3b1c064$export$c74023ca160dc207)(destination, activeInputs);
    }
};
const $f7091401ab9fe646$var$deleteInputsOfAudioParam = (source, isOffline, destination, output)=>{
    const [listener, isActive] = $f7091401ab9fe646$var$deleteInputConnectionOfAudioParam(source, destination, output);
    if (listener !== null) {
        (0, $8d9851b3ce841ff0$export$b5a32c2e2eac4137)(source, listener);
        if (isActive && !isOffline && !(0, $0f23cc3dee4d6a7f$export$8658a39a04a404d5)(source)) (0, $a25444b65385088d$export$e719c0d45ea16d08)(source).disconnect((0, $44fe7bee8da5f8b6$export$fad3d843b2a56ffb)(destination), output);
    }
};
const $f7091401ab9fe646$var$deleteAnyConnection = (source, isOffline)=>{
    const audioNodeConnectionsOfSource = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs){
        if ((0, $ac48105bedc212b3$export$419d66ef3a96a878)(outputConnection)) $f7091401ab9fe646$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $f7091401ab9fe646$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
    }
    audioNodeConnectionsOfSource.outputs.clear();
    return destinations;
};
const $f7091401ab9fe646$var$deleteConnectionAtOutput = (source, isOffline, output)=>{
    const audioNodeConnectionsOfSource = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs)if (outputConnection[1] === output) {
        if ((0, $ac48105bedc212b3$export$419d66ef3a96a878)(outputConnection)) $f7091401ab9fe646$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $f7091401ab9fe646$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
    }
    return destinations;
};
const $f7091401ab9fe646$var$deleteConnectionToDestination = (source, isOffline, destination, output, input)=>{
    const audioNodeConnectionsOfSource = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(source);
    return Array.from(audioNodeConnectionsOfSource.outputs).filter((outputConnection)=>outputConnection[0] === destination && (output === undefined || outputConnection[1] === output) && (input === undefined || outputConnection[2] === input)).map((outputConnection)=>{
        if ((0, $ac48105bedc212b3$export$419d66ef3a96a878)(outputConnection)) $f7091401ab9fe646$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $f7091401ab9fe646$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
        return outputConnection[0];
    });
};
const $f7091401ab9fe646$export$20e3fa4f981cb01d = (addAudioNodeConnections, addConnectionToAudioNode, cacheTestResult, createIncrementCycleCounter, createIndexSizeError, createInvalidAccessError, createNotSupportedError, decrementCycleCounter, detectCycles, eventTargetConstructor, getNativeContext, isNativeAudioContext, isNativeAudioNode, isNativeAudioParam, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return class AudioNode extends eventTargetConstructor {
        constructor(context, isActive, nativeAudioNode, audioNodeRenderer){
            super(nativeAudioNode);
            this._context = context;
            this._nativeAudioNode = nativeAudioNode;
            const nativeContext = getNativeContext(context);
            // Bug #12: Safari does not support to disconnect a specific destination.
            if (isNativeAudioContext(nativeContext) && true !== cacheTestResult((0, $351f08ffebfa3c12$export$f938a299860627), ()=>{
                return (0, $351f08ffebfa3c12$export$f938a299860627)(nativeContext, nativeAudioWorkletNodeConstructor);
            })) (0, $576051a2e9e747fc$export$d4ca24d0078a887f)(nativeAudioNode);
            (0, $063560d8523a7eb5$export$864a3cfb55580d0c).set(this, nativeAudioNode);
            (0, $063560d8523a7eb5$export$c998cfefa4fd5136).set(this, new Set());
            if (context.state !== 'closed' && isActive) (0, $1dade94fa084012d$export$88a47afdc0e8539c)(this);
            addAudioNodeConnections(this, audioNodeRenderer, nativeAudioNode);
        }
        get channelCount() {
            return this._nativeAudioNode.channelCount;
        }
        set channelCount(value) {
            this._nativeAudioNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioNode.channelCountMode;
        }
        set channelCountMode(value) {
            this._nativeAudioNode.channelCountMode = value;
        }
        get channelInterpretation() {
            return this._nativeAudioNode.channelInterpretation;
        }
        set channelInterpretation(value) {
            this._nativeAudioNode.channelInterpretation = value;
        }
        get context() {
            return this._context;
        }
        get numberOfInputs() {
            return this._nativeAudioNode.numberOfInputs;
        }
        get numberOfOutputs() {
            return this._nativeAudioNode.numberOfOutputs;
        }
        // tslint:disable-next-line:invalid-void
        connect(destination, output = 0, input = 0) {
            // Bug #174: Safari does expose a wrong numberOfOutputs for MediaStreamAudioDestinationNodes.
            if (output < 0 || output >= this._nativeAudioNode.numberOfOutputs) throw createIndexSizeError();
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (isNativeAudioNode(destination) || isNativeAudioParam(destination)) throw createInvalidAccessError();
            if ((0, $abb453140d998e25$export$85cd8e93eb858e81)(destination)) {
                const nativeDestinationAudioNode = (0, $a25444b65385088d$export$e719c0d45ea16d08)(destination);
                try {
                    const connection = (0, $2167468b26f40e2e$export$b92162b3199b4461)(this._nativeAudioNode, nativeDestinationAudioNode, output, input);
                    const isPassive = (0, $b765ea918e2b8359$export$79a7cb9fa56970e)(this);
                    if (isOffline || isPassive) this._nativeAudioNode.disconnect(...connection);
                    if (this.context.state !== 'closed' && !isPassive && (0, $b765ea918e2b8359$export$79a7cb9fa56970e)(destination)) (0, $1dade94fa084012d$export$88a47afdc0e8539c)(destination);
                } catch (err) {
                    // Bug #41: Safari does not throw the correct exception so far.
                    if (err.code === 12) throw createInvalidAccessError();
                    throw err;
                }
                const isNewConnectionToAudioNode = addConnectionToAudioNode(this, destination, output, input, isOffline);
                // Bug #164: Only Firefox detects cycles so far.
                if (isNewConnectionToAudioNode) {
                    const cycles = detectCycles([
                        this
                    ], destination);
                    (0, $fa15ebb04ca0fc27$export$f8092aa3a6fcf50f)(cycles, createIncrementCycleCounter(isOffline));
                }
                return destination;
            }
            const nativeAudioParam = (0, $44fe7bee8da5f8b6$export$fad3d843b2a56ffb)(destination);
            /*
             * Bug #73, #147 & #153: Safari does not support to connect an input signal to the playbackRate AudioParam of an
             * AudioBufferSourceNode. This can't be easily detected and that's why the outdated name property is used here to identify
             * Safari. In addition to that the maxValue property is used to only detect the affected versions below v14.0.2.
             */ if (nativeAudioParam.name === 'playbackRate' && nativeAudioParam.maxValue === 1024) throw createNotSupportedError();
            try {
                this._nativeAudioNode.connect(nativeAudioParam, output);
                if (isOffline || (0, $b765ea918e2b8359$export$79a7cb9fa56970e)(this)) this._nativeAudioNode.disconnect(nativeAudioParam, output);
            } catch (err) {
                // Bug #58: Safari doesn't throw an InvalidAccessError yet.
                if (err.code === 12) throw createInvalidAccessError();
                throw err;
            }
            const isNewConnectionToAudioParam = $f7091401ab9fe646$var$addConnectionToAudioParamOfAudioContext(this, destination, output, isOffline);
            // Bug #164: Only Firefox detects cycles so far.
            if (isNewConnectionToAudioParam) {
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $fa15ebb04ca0fc27$export$f8092aa3a6fcf50f)(cycles, createIncrementCycleCounter(isOffline));
            }
        }
        disconnect(destinationOrOutput, output, input) {
            let destinations;
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (destinationOrOutput === undefined) destinations = $f7091401ab9fe646$var$deleteAnyConnection(this, isOffline);
            else if (typeof destinationOrOutput === 'number') {
                if (destinationOrOutput < 0 || destinationOrOutput >= this.numberOfOutputs) throw createIndexSizeError();
                destinations = $f7091401ab9fe646$var$deleteConnectionAtOutput(this, isOffline, destinationOrOutput);
            } else {
                if (output !== undefined && (output < 0 || output >= this.numberOfOutputs)) throw createIndexSizeError();
                if ((0, $abb453140d998e25$export$85cd8e93eb858e81)(destinationOrOutput) && input !== undefined && (input < 0 || input >= destinationOrOutput.numberOfInputs)) throw createIndexSizeError();
                destinations = $f7091401ab9fe646$var$deleteConnectionToDestination(this, isOffline, destinationOrOutput, output, input);
                if (destinations.length === 0) throw createInvalidAccessError();
            }
            // Bug #164: Only Firefox detects cycles so far.
            for (const destination of destinations){
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $fa15ebb04ca0fc27$export$f8092aa3a6fcf50f)(cycles, decrementCycleCounter);
            }
        }
    };
};



const $10cae184a6e8a9ae$export$25d3edb077748cfc = (addAudioParamConnections, audioParamAudioNodeStore, audioParamStore, createAudioParamRenderer, createCancelAndHoldAutomationEvent, createCancelScheduledValuesAutomationEvent, createExponentialRampToValueAutomationEvent, createLinearRampToValueAutomationEvent, createSetTargetAutomationEvent, createSetValueAutomationEvent, createSetValueCurveAutomationEvent, nativeAudioContextConstructor, setValueAtTimeUntilPossible)=>{
    return (audioNode, isAudioParamOfOfflineAudioContext, nativeAudioParam, maxValue = null, minValue = null)=>{
        // Bug #196 Only Safari sets the defaultValue to the initial value.
        const defaultValue = nativeAudioParam.value;
        const automationEventList = new (0, $ab26ec1106ccdbea$exports.AutomationEventList)(defaultValue);
        const audioParamRenderer = isAudioParamOfOfflineAudioContext ? createAudioParamRenderer(automationEventList) : null;
        const audioParam = {
            get defaultValue () {
                return defaultValue;
            },
            get maxValue () {
                return maxValue === null ? nativeAudioParam.maxValue : maxValue;
            },
            get minValue () {
                return minValue === null ? nativeAudioParam.minValue : minValue;
            },
            get value () {
                return nativeAudioParam.value;
            },
            set value (value){
                nativeAudioParam.value = value;
                // Bug #98: Firefox & Safari do not yet treat the value setter like a call to setValueAtTime().
                audioParam.setValueAtTime(value, audioNode.context.currentTime);
            },
            cancelAndHoldAtTime (cancelTime) {
                // Bug #28: Firefox & Safari do not yet implement cancelAndHoldAtTime().
                if (typeof nativeAudioParam.cancelAndHoldAtTime === 'function') {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    nativeAudioParam.cancelAndHoldAtTime(cancelTime);
                } else {
                    const previousLastEvent = Array.from(automationEventList).pop();
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    const currentLastEvent = Array.from(automationEventList).pop();
                    nativeAudioParam.cancelScheduledValues(cancelTime);
                    if (previousLastEvent !== currentLastEvent && currentLastEvent !== undefined) {
                        if (currentLastEvent.type === 'exponentialRampToValue') nativeAudioParam.exponentialRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === 'linearRampToValue') nativeAudioParam.linearRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === 'setValue') nativeAudioParam.setValueAtTime(currentLastEvent.value, currentLastEvent.startTime);
                        else if (currentLastEvent.type === 'setValueCurve') nativeAudioParam.setValueCurveAtTime(currentLastEvent.values, currentLastEvent.startTime, currentLastEvent.duration);
                    }
                }
                return audioParam;
            },
            cancelScheduledValues (cancelTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createCancelScheduledValuesAutomationEvent(cancelTime));
                nativeAudioParam.cancelScheduledValues(cancelTime);
                return audioParam;
            },
            exponentialRampToValueAtTime (value1, endTime) {
                // Bug #45: Safari does not throw an error yet.
                if (value1 === 0) throw new RangeError();
                // Bug #187: Safari does not throw an error yet.
                if (!Number.isFinite(endTime) || endTime < 0) throw new RangeError();
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #194: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createExponentialRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.exponentialRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            linearRampToValueAtTime (value1, endTime) {
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #195: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createLinearRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.linearRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            setTargetAtTime (target, startTime, timeConstant) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetTargetAutomationEvent(target, startTime, timeConstant));
                nativeAudioParam.setTargetAtTime(target, startTime, timeConstant);
                return audioParam;
            },
            setValueAtTime (value1, startTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetValueAutomationEvent(value1, startTime));
                nativeAudioParam.setValueAtTime(value1, startTime);
                return audioParam;
            },
            setValueCurveAtTime (values, startTime, duration) {
                // Bug 183: Safari only accepts a Float32Array.
                const convertedValues = values instanceof Float32Array ? values : new Float32Array(values);
                /*
                 * Bug #152: Safari does not correctly interpolate the values of the curve.
                 * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the
                 * existence of the webkitAudioContext is used as a workaround here.
                 */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') {
                    const endTime = startTime + duration;
                    const sampleRate = audioNode.context.sampleRate;
                    const firstSample = Math.ceil(startTime * sampleRate);
                    const lastSample = Math.floor(endTime * sampleRate);
                    const numberOfInterpolatedValues = lastSample - firstSample;
                    const interpolatedValues = new Float32Array(numberOfInterpolatedValues);
                    for(let i = 0; i < numberOfInterpolatedValues; i += 1){
                        const theoreticIndex = (convertedValues.length - 1) / duration * ((firstSample + i) / sampleRate - startTime);
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        interpolatedValues[i] = lowerIndex === upperIndex ? convertedValues[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * convertedValues[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * convertedValues[upperIndex];
                    }
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(interpolatedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(interpolatedValues, startTime, duration);
                    const timeOfLastSample = lastSample / sampleRate;
                    if (timeOfLastSample < endTime) setValueAtTimeUntilPossible(audioParam, interpolatedValues[interpolatedValues.length - 1], timeOfLastSample);
                    setValueAtTimeUntilPossible(audioParam, convertedValues[convertedValues.length - 1], endTime);
                } else {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(convertedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(convertedValues, startTime, duration);
                }
                return audioParam;
            }
        };
        audioParamStore.set(audioParam, nativeAudioParam);
        audioParamAudioNodeStore.set(audioParam, audioNode);
        addAudioParamConnections(audioParam, audioParamRenderer);
        return audioParam;
    };
};


const $b8c9a078b765371e$export$8858f507eb103ac6 = (automationEventList)=>{
    return {
        replay (audioParam) {
            for (const automationEvent of automationEventList){
                if (automationEvent.type === 'exponentialRampToValue') {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.exponentialRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === 'linearRampToValue') {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.linearRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === 'setTarget') {
                    const { startTime: startTime, target: target, timeConstant: timeConstant } = automationEvent;
                    audioParam.setTargetAtTime(target, startTime, timeConstant);
                } else if (automationEvent.type === 'setValue') {
                    const { startTime: startTime, value: value } = automationEvent;
                    audioParam.setValueAtTime(value, startTime);
                } else if (automationEvent.type === 'setValueCurve') {
                    const { duration: duration, startTime: startTime, values: values } = automationEvent;
                    audioParam.setValueCurveAtTime(values, startTime, duration);
                } else throw new Error("Can't apply an unknown automation.");
            }
        }
    };
};



class $ab3dc1f1bca26f43$export$5da0cf80a3ca75d6 {
    constructor(parameters){
        this._map = new Map(parameters);
    }
    get size() {
        return this._map.size;
    }
    entries() {
        return this._map.entries();
    }
    forEach(callback, thisArg = null) {
        return this._map.forEach((value, key)=>callback.call(thisArg, value, key, this));
    }
    get(name) {
        return this._map.get(name);
    }
    has(name) {
        return this._map.has(name);
    }
    keys() {
        return this._map.keys();
    }
    values() {
        return this._map.values();
    }
}


const $720c5487527456e2$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    // Bug #61: The channelCountMode should be 'max' according to the spec but is set to 'explicit' to achieve consistent behavior.
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    numberOfInputs: 1,
    numberOfOutputs: 1,
    parameterData: {},
    processorOptions: {}
};
const $720c5487527456e2$export$48302d37fa2cf062 = (addUnrenderedAudioWorkletNode, audioNodeConstructor, createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, getAudioNodeConnections, getBackupOfflineAudioContext, getNativeContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, sanitizeAudioWorkletNodeOptions, setActiveAudioWorkletNodeInputs, testAudioWorkletNodeOptionsClonability, wrapEventListener)=>{
    return class AudioWorkletNode extends audioNodeConstructor {
        constructor(context, name, options){
            var _a;
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = sanitizeAudioWorkletNodeOptions({
                ...$720c5487527456e2$var$DEFAULT_OPTIONS,
                ...options
            });
            // Bug #191: Safari doesn't throw an error if the options aren't clonable.
            testAudioWorkletNodeOptionsClonability(mergedOptions);
            const nodeNameToProcessorConstructorMap = (0, $063560d8523a7eb5$export$b9bea39f06f96914).get(nativeContext);
            const processorConstructor = nodeNameToProcessorConstructorMap === null || nodeNameToProcessorConstructorMap === void 0 ? void 0 : nodeNameToProcessorConstructorMap.get(name);
            // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
            const nativeContextOrBackupOfflineAudioContext = isOffline || nativeContext.state !== 'closed' ? nativeContext : (_a = getBackupOfflineAudioContext(nativeContext)) !== null && _a !== void 0 ? _a : nativeContext;
            const nativeAudioWorkletNode = createNativeAudioWorkletNode(nativeContextOrBackupOfflineAudioContext, isOffline ? null : context.baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, mergedOptions);
            const audioWorkletNodeRenderer = isOffline ? createAudioWorkletNodeRenderer(name, mergedOptions, processorConstructor) : null;
            /*
             * @todo Add a mechanism to switch an AudioWorkletNode to passive once the process() function of the AudioWorkletProcessor
             * returns false.
             */ super(context, true, nativeAudioWorkletNode, audioWorkletNodeRenderer);
            const parameters = [];
            nativeAudioWorkletNode.parameters.forEach((nativeAudioParam, nm)=>{
                const audioParam = createAudioParam(this, isOffline, nativeAudioParam);
                parameters.push([
                    nm,
                    audioParam
                ]);
            });
            this._nativeAudioWorkletNode = nativeAudioWorkletNode;
            this._onprocessorerror = null;
            this._parameters = new (0, $ab3dc1f1bca26f43$export$5da0cf80a3ca75d6)(parameters);
            /*
             * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to
             * the destination.
             */ if (isOffline) addUnrenderedAudioWorkletNode(nativeContext, this);
            const { activeInputs: activeInputs } = getAudioNodeConnections(this);
            setActiveAudioWorkletNodeInputs(nativeAudioWorkletNode, activeInputs);
        }
        get onprocessorerror() {
            return this._onprocessorerror;
        }
        set onprocessorerror(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeAudioWorkletNode.onprocessorerror = wrappedListener;
            const nativeOnProcessorError = this._nativeAudioWorkletNode.onprocessorerror;
            this._onprocessorerror = nativeOnProcessorError !== null && nativeOnProcessorError === wrappedListener ? value : nativeOnProcessorError;
        }
        get parameters() {
            if (this._parameters === null) // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            return this._nativeAudioWorkletNode.parameters;
            return this._parameters;
        }
        get port() {
            return this._nativeAudioWorkletNode.port;
        }
    };
};


function $73892a6a2256b990$export$e3c6e435bf217093(audioBuffer, // @todo There is currently no way to define something like { [ key: number | string ]: Float32Array }
parent, key, channelNumber, bufferOffset) {
    if (typeof audioBuffer.copyFromChannel === 'function') {
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = new Float32Array(128);
        audioBuffer.copyFromChannel(parent[key], channelNumber, bufferOffset);
    // Bug #5: Safari does not support copyFromChannel().
    } else {
        const channelData = audioBuffer.getChannelData(channelNumber);
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = channelData.slice(bufferOffset, bufferOffset + 128);
        else {
            const slicedInput = new Float32Array(channelData.buffer, bufferOffset * Float32Array.BYTES_PER_ELEMENT, 128);
            parent[key].set(slicedInput);
        }
    }
}


const $13ff1980ed86128e$export$6bb6d131144bd753 = (audioBuffer, parent, key, channelNumber, bufferOffset)=>{
    if (typeof audioBuffer.copyToChannel === 'function') // The byteLength will be 0 when the ArrayBuffer was transferred.
    {
        if (parent[key].byteLength !== 0) audioBuffer.copyToChannel(parent[key], channelNumber, bufferOffset);
    } else // The byteLength will be 0 when the ArrayBuffer was transferred.
    if (parent[key].byteLength !== 0) audioBuffer.getChannelData(channelNumber).set(parent[key], bufferOffset);
};


const $bd65332d5b5b21dd$export$495a31436d188d6d = (x, y)=>{
    const arrays = [];
    for(let i = 0; i < x; i += 1){
        const array = [];
        const length = typeof y === 'number' ? y : y[i];
        for(let j = 0; j < length; j += 1)array.push(new Float32Array(128));
        arrays.push(array);
    }
    return arrays;
};






const $95aabeff91a3d171$export$d948bbdb8f0d97d7 = (nativeOfflineAudioContext, proxy)=>{
    const nodeToProcessorMap = (0, $a30e5f89486249dd$export$520987e3ff3ffad3)((0, $063560d8523a7eb5$export$16d7878f7e059d67), nativeOfflineAudioContext);
    const nativeAudioWorkletNode = (0, $a25444b65385088d$export$e719c0d45ea16d08)(proxy);
    return (0, $a30e5f89486249dd$export$520987e3ff3ffad3)(nodeToProcessorMap, nativeAudioWorkletNode);
};



const $750258ff33a5082b$var$processBuffer = async (proxy, renderedBuffer, nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime)=>{
    // Ceil the length to the next full render quantum.
    // Bug #17: Safari does not yet expose the length.
    const length = renderedBuffer === null ? Math.ceil(proxy.context.length / 128) * 128 : renderedBuffer.length;
    const numberOfInputChannels = options.channelCount * options.numberOfInputs;
    const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
    const processedBuffer = numberOfOutputChannels === 0 ? null : nativeOfflineAudioContext.createBuffer(numberOfOutputChannels, length, nativeOfflineAudioContext.sampleRate);
    if (processorConstructor === undefined) throw new Error('Missing the processor constructor.');
    const audioNodeConnections = (0, $8c427995665b3ffa$export$6b29eee2af836dfc)(proxy);
    const audioWorkletProcessor = await (0, $95aabeff91a3d171$export$d948bbdb8f0d97d7)(nativeOfflineAudioContext, proxy);
    const inputs = (0, $bd65332d5b5b21dd$export$495a31436d188d6d)(options.numberOfInputs, options.channelCount);
    const outputs = (0, $bd65332d5b5b21dd$export$495a31436d188d6d)(options.numberOfOutputs, outputChannelCount);
    const parameters = Array.from(proxy.parameters.keys()).reduce((prmtrs, name)=>({
            ...prmtrs,
            [name]: new Float32Array(128)
        }), {});
    for(let i = 0; i < length; i += 128){
        if (options.numberOfInputs > 0 && renderedBuffer !== null) {
            for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $73892a6a2256b990$export$e3c6e435bf217093)(renderedBuffer, inputs[j], k, k, i);
        }
        if (processorConstructor.parameterDescriptors !== undefined && renderedBuffer !== null) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
            (0, $73892a6a2256b990$export$e3c6e435bf217093)(renderedBuffer, parameters, name, numberOfInputChannels + index, i);
        });
        for(let j = 0; j < options.numberOfInputs; j += 1){
            for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
            if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
        }
        try {
            const potentiallyEmptyInputs = inputs.map((input, index)=>{
                if (audioNodeConnections.activeInputs[index].size === 0) return [];
                return input;
            });
            const activeSourceFlag = exposeCurrentFrameAndCurrentTime(i / nativeOfflineAudioContext.sampleRate, nativeOfflineAudioContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
            if (processedBuffer !== null) for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $13ff1980ed86128e$export$6bb6d131144bd753)(processedBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                outputChannelSplitterNodeOutput += outputChannelCount[j];
            }
            if (!activeSourceFlag) break;
        } catch (error) {
            proxy.dispatchEvent(new ErrorEvent('processorerror', {
                colno: error.colno,
                filename: error.filename,
                lineno: error.lineno,
                message: error.message
            }));
            break;
        }
    }
    return processedBuffer;
};
const $750258ff33a5082b$export$3a898af5d2b29a5b = (connectAudioParam, connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, deleteUnrenderedAudioWorkletNode, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getNativeAudioNode, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (name, options, processorConstructor)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let processedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioWorkletNode = getNativeAudioNode(proxy);
            let nativeOutputNodes = null;
            const nativeAudioWorkletNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeAudioWorkletNode, nativeOfflineAudioContext);
            const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
            // Bug #61: Only Chrome, Edge & Firefox have an implementation of the AudioWorkletNode yet.
            if (nativeAudioWorkletNodeConstructor === null) {
                const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
                const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, {
                    channelCount: Math.max(1, numberOfOutputChannels),
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    numberOfOutputs: Math.max(1, numberOfOutputChannels)
                });
                const outputChannelMergerNodes = [];
                for(let i = 0; i < proxy.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeOfflineAudioContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'speakers',
                    numberOfInputs: outputChannelCount[i]
                }));
                const outputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    channelCount: options.channelCount,
                    channelCountMode: options.channelCountMode,
                    channelInterpretation: options.channelInterpretation,
                    gain: 1
                });
                outputGainNode.connect = connectMultipleOutputs.bind(null, outputChannelMergerNodes);
                outputGainNode.disconnect = disconnectMultipleOutputs.bind(null, outputChannelMergerNodes);
                nativeOutputNodes = [
                    outputChannelSplitterNode,
                    outputChannelMergerNodes,
                    outputGainNode
                ];
            } else if (!nativeAudioWorkletNodeIsOwnedByContext) nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeOfflineAudioContext, name);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeOutputNodes === null ? nativeAudioWorkletNode : nativeOutputNodes[2]);
            if (nativeOutputNodes !== null) {
                if (processedBufferPromise === null) {
                    if (processorConstructor === undefined) throw new Error('Missing the processor constructor.');
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    // Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    const numberOfInputChannels = proxy.channelCount * proxy.numberOfInputs;
                    const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
                    const numberOfChannels = numberOfInputChannels + numberOfParameters;
                    const renderBuffer = async ()=>{
                        const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(numberOfChannels, // Ceil the length to the next full render quantum.
                        // Bug #17: Safari does not yet expose the length.
                        Math.ceil(proxy.context.length / 128) * 128, nativeOfflineAudioContext.sampleRate);
                        const gainNodes = [];
                        const inputChannelSplitterNodes = [];
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes.push(createNativeGainNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: options.channelCountMode,
                                channelInterpretation: options.channelInterpretation,
                                gain: 1
                            }));
                            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                numberOfOutputs: options.channelCount
                            }));
                        }
                        const constantSourceNodes = await Promise.all(Array.from(proxy.parameters.values()).map(async (audioParam)=>{
                            const constantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                offset: audioParam.value
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, constantSourceNode.offset);
                            return constantSourceNode;
                        }));
                        const inputChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                            channelCount: 1,
                            channelCountMode: 'explicit',
                            channelInterpretation: 'speakers',
                            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
                        });
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes[i].connect(inputChannelSplitterNodes[i]);
                            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
                        }
                        for (const [index, constantSourceNode] of constantSourceNodes.entries()){
                            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
                            constantSourceNode.start(0);
                        }
                        inputChannelMergerNode.connect(partialOfflineAudioContext.destination);
                        await Promise.all(gainNodes.map((gainNode)=>renderInputsOfAudioNode(proxy, partialOfflineAudioContext, gainNode)));
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    };
                    processedBufferPromise = $750258ff33a5082b$var$processBuffer(proxy, numberOfChannels === 0 ? null : await renderBuffer(), nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime);
                }
                const processedBuffer = await processedBufferPromise;
                const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                    buffer: null,
                    channelCount: 2,
                    channelCountMode: 'max',
                    channelInterpretation: 'speakers',
                    loop: false,
                    loopEnd: 0,
                    loopStart: 0,
                    playbackRate: 1
                });
                const [outputChannelSplitterNode, outputChannelMergerNodes, outputGainNode] = nativeOutputNodes;
                if (processedBuffer !== null) {
                    audioBufferSourceNode.buffer = processedBuffer;
                    audioBufferSourceNode.start(0);
                }
                audioBufferSourceNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < proxy.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
                return outputGainNode;
            }
            if (!nativeAudioWorkletNodeIsOwnedByContext) for (const [nm, audioParam] of proxy.parameters.entries())await renderAutomation(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            else for (const [nm, audioParam] of proxy.parameters.entries())await connectAudioParam(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioWorkletNode);
            return nativeAudioWorkletNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                deleteUnrenderedAudioWorkletNode(nativeOfflineAudioContext, proxy);
                const renderedNativeAudioWorkletNodeOrGainNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioWorkletNodeOrGainNode !== undefined) return Promise.resolve(renderedNativeAudioWorkletNodeOrGainNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $43a0fa9c89e73420$export$7824d6f4713e1e35 = (addAudioWorkletModule, analyserNodeConstructor, audioBufferConstructor, audioBufferSourceNodeConstructor, biquadFilterNodeConstructor, channelMergerNodeConstructor, channelSplitterNodeConstructor, constantSourceNodeConstructor, convolverNodeConstructor, decodeAudioData, delayNodeConstructor, dynamicsCompressorNodeConstructor, gainNodeConstructor, iIRFilterNodeConstructor, minimalBaseAudioContextConstructor, oscillatorNodeConstructor, pannerNodeConstructor, periodicWaveConstructor, stereoPannerNodeConstructor, waveShaperNodeConstructor)=>{
    return class BaseAudioContext extends minimalBaseAudioContextConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext, numberOfChannels);
            this._nativeContext = _nativeContext;
            this._audioWorklet = addAudioWorkletModule === undefined ? undefined : {
                addModule: (moduleURL, options)=>{
                    return addAudioWorkletModule(this, moduleURL, options);
                }
            };
        }
        get audioWorklet() {
            return this._audioWorklet;
        }
        createAnalyser() {
            return new analyserNodeConstructor(this);
        }
        createBiquadFilter() {
            return new biquadFilterNodeConstructor(this);
        }
        createBuffer(numberOfChannels, length, sampleRate) {
            return new audioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            });
        }
        createBufferSource() {
            return new audioBufferSourceNodeConstructor(this);
        }
        createChannelMerger(numberOfInputs = 6) {
            return new channelMergerNodeConstructor(this, {
                numberOfInputs: numberOfInputs
            });
        }
        createChannelSplitter(numberOfOutputs = 6) {
            return new channelSplitterNodeConstructor(this, {
                numberOfOutputs: numberOfOutputs
            });
        }
        createConstantSource() {
            return new constantSourceNodeConstructor(this);
        }
        createConvolver() {
            return new convolverNodeConstructor(this);
        }
        createDelay(maxDelayTime = 1) {
            return new delayNodeConstructor(this, {
                maxDelayTime: maxDelayTime
            });
        }
        createDynamicsCompressor() {
            return new dynamicsCompressorNodeConstructor(this);
        }
        createGain() {
            return new gainNodeConstructor(this);
        }
        createIIRFilter(feedforward, feedback) {
            return new iIRFilterNodeConstructor(this, {
                feedback: feedback,
                feedforward: feedforward
            });
        }
        createOscillator() {
            return new oscillatorNodeConstructor(this);
        }
        createPanner() {
            return new pannerNodeConstructor(this);
        }
        createPeriodicWave(real, imag, constraints = {
            disableNormalization: false
        }) {
            return new periodicWaveConstructor(this, {
                ...constraints,
                imag: imag,
                real: real
            });
        }
        createStereoPanner() {
            return new stereoPannerNodeConstructor(this);
        }
        createWaveShaper() {
            return new waveShaperNodeConstructor(this);
        }
        decodeAudioData(audioData, successCallback, errorCallback) {
            return decodeAudioData(this._nativeContext, audioData).then((audioBuffer)=>{
                if (typeof successCallback === 'function') successCallback(audioBuffer);
                return audioBuffer;
            }, (err)=>{
                if (typeof errorCallback === 'function') errorCallback(err);
                throw err;
            });
        }
    };
};



const $36a4a36f22d1d20a$var$DEFAULT_OPTIONS = {
    Q: 1,
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    detune: 0,
    frequency: 350,
    gain: 0,
    type: 'lowpass'
};
const $36a4a36f22d1d20a$export$aa421daabad177b5 = (audioNodeConstructor, createAudioParam, createBiquadFilterNodeRenderer, createInvalidAccessError, createNativeBiquadFilterNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class BiquadFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$36a4a36f22d1d20a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const biquadFilterNodeRenderer = isOffline ? createBiquadFilterNodeRenderer() : null;
            super(context, false, nativeBiquadFilterNode, biquadFilterNodeRenderer);
            // Bug #80: Safari does not export the correct values for maxValue and minValue.
            this._Q = createAudioParam(this, isOffline, nativeBiquadFilterNode.Q, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            // Bug #78: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeBiquadFilterNode.detune, 1200 * Math.log2((0, $109263ef7a828de3$export$ab43bedd17d6a167)), -1200 * Math.log2((0, $109263ef7a828de3$export$ab43bedd17d6a167)));
            // Bug #77: Firefox & Safari do not export the correct value for minValue.
            this._frequency = createAudioParam(this, isOffline, nativeBiquadFilterNode.frequency, context.sampleRate / 2, 0);
            // Bug #79: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeBiquadFilterNode.gain, 40 * Math.log10((0, $109263ef7a828de3$export$ab43bedd17d6a167)), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            this._nativeBiquadFilterNode = nativeBiquadFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get gain() {
            return this._gain;
        }
        get Q() {
            return this._Q;
        }
        get type() {
            return this._nativeBiquadFilterNode.type;
        }
        set type(value) {
            this._nativeBiquadFilterNode.type = value;
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            // Bug #189: Safari does throw an InvalidStateError.
            try {
                this._nativeBiquadFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
            } catch (err) {
                if (err.code === 11) throw createInvalidAccessError();
                throw err;
            }
            // Bug #68: Safari does not throw an error if the parameters differ in their length.
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
        }
    };
};



const $ce516b52d946e959$export$1532cc6682032d84 = (connectAudioParam, createNativeBiquadFilterNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeBiquadFilterNodes = new WeakMap();
        const createBiquadFilterNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeBiquadFilterNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeBiquadFilterNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeBiquadFilterNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeBiquadFilterNode, nativeOfflineAudioContext);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                const options = {
                    Q: nativeBiquadFilterNode.Q.value,
                    channelCount: nativeBiquadFilterNode.channelCount,
                    channelCountMode: nativeBiquadFilterNode.channelCountMode,
                    channelInterpretation: nativeBiquadFilterNode.channelInterpretation,
                    detune: nativeBiquadFilterNode.detune.value,
                    frequency: nativeBiquadFilterNode.frequency.value,
                    gain: nativeBiquadFilterNode.gain.value,
                    type: nativeBiquadFilterNode.type
                };
                nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeBiquadFilterNodes.set(nativeOfflineAudioContext, nativeBiquadFilterNode);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeBiquadFilterNode);
            return nativeBiquadFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeBiquadFilterNode = renderedNativeBiquadFilterNodes.get(nativeOfflineAudioContext);
                if (renderedNativeBiquadFilterNode !== undefined) return Promise.resolve(renderedNativeBiquadFilterNode);
                return createBiquadFilterNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $af3e1769cc80141b$export$e72d622686b5f6c7 = (ongoingTests, testResults)=>{
    return (tester, test)=>{
        const cachedTestResult = testResults.get(tester);
        if (cachedTestResult !== undefined) return cachedTestResult;
        const ongoingTest = ongoingTests.get(tester);
        if (ongoingTest !== undefined) return ongoingTest;
        try {
            const synchronousTestResult = test();
            if (synchronousTestResult instanceof Promise) {
                ongoingTests.set(tester, synchronousTestResult);
                return synchronousTestResult.catch(()=>false).then((finalTestResult)=>{
                    ongoingTests.delete(tester);
                    testResults.set(tester, finalTestResult);
                    return finalTestResult;
                });
            }
            testResults.set(tester, synchronousTestResult);
            return synchronousTestResult;
        } catch  {
            testResults.set(tester, false);
            return false;
        }
    };
};


const $b6e468c80b067009$var$DEFAULT_OPTIONS = {
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    numberOfInputs: 6
};
const $b6e468c80b067009$export$a65a5a400135d27 = (audioNodeConstructor, createChannelMergerNodeRenderer, createNativeChannelMergerNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class ChannelMergerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$b6e468c80b067009$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeChannelMergerNode = createNativeChannelMergerNode(nativeContext, mergedOptions);
            const channelMergerNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelMergerNodeRenderer() : null;
            super(context, false, nativeChannelMergerNode, channelMergerNodeRenderer);
        }
    };
};



const $9c2b7ff5228068f2$export$79056cbe2b10cae5 = (createNativeChannelMergerNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfInputs: nativeAudioNode.numberOfInputs
                };
                nativeAudioNode = createNativeChannelMergerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $21176c212530cf3a$var$DEFAULT_OPTIONS = {
    channelCount: 6,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete',
    numberOfOutputs: 6
};
const $21176c212530cf3a$export$ce9d996cafa605b = (audioNodeConstructor, createChannelSplitterNodeRenderer, createNativeChannelSplitterNode, getNativeContext, isNativeOfflineAudioContext, sanitizeChannelSplitterOptions)=>{
    return class ChannelSplitterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizeChannelSplitterOptions({
                ...$21176c212530cf3a$var$DEFAULT_OPTIONS,
                ...options
            });
            const nativeChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, mergedOptions);
            const channelSplitterNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelSplitterNodeRenderer() : null;
            super(context, false, nativeChannelSplitterNode, channelSplitterNodeRenderer);
        }
    };
};



const $195c18eec70c40c3$export$d815cad16abde9c3 = (createNativeChannelSplitterNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfOutputs: nativeAudioNode.numberOfOutputs
                };
                nativeAudioNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $bc0c5c6dd5333aa6$export$1e69fdca2ad79f10 = (renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};



const $fc80e8768a3bf27d$export$5f708e50316bf1a = (createIndexSizeError)=>{
    return (outputAudioNodes, destination, output = 0, input = 0)=>{
        const outputAudioNode = outputAudioNodes[output];
        if (outputAudioNode === undefined) throw createIndexSizeError();
        if ((0, $db699c2c2928ff4a$export$d647358384f164e0)(destination)) return outputAudioNode.connect(destination, 0, input);
        return outputAudioNode.connect(destination, 0);
    };
};


const $edb3001c457f5d46$export$e82b2b63ea82dc82 = (createNativeAudioBufferSourceNode)=>{
    return (nativeContext, nativeAudioNode)=>{
        const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: 'max',
            channelInterpretation: 'speakers',
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const nativeAudioBuffer = nativeContext.createBuffer(1, 2, 44100);
        nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
        nativeAudioBufferSourceNode.loop = true;
        nativeAudioBufferSourceNode.connect(nativeAudioNode);
        nativeAudioBufferSourceNode.start();
        return ()=>{
            nativeAudioBufferSourceNode.stop();
            nativeAudioBufferSourceNode.disconnect(nativeAudioNode);
        };
    };
};






const $33d67bcca502b0be$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    offset: 1
};
const $33d67bcca502b0be$export$a02a9a6200996500 = (audioNodeConstructor, createAudioParam, createConstantSourceNodeRendererFactory, createNativeConstantSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class ConstantSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$33d67bcca502b0be$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConstantSourceNode = createNativeConstantSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const constantSourceNodeRenderer = isOffline ? createConstantSourceNodeRendererFactory() : null;
            super(context, false, nativeConstantSourceNode, constantSourceNodeRenderer);
            this._constantSourceNodeRenderer = constantSourceNodeRenderer;
            this._nativeConstantSourceNode = nativeConstantSourceNode;
            /*
             * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and minValue
             * for GainNodes.
             */ this._offset = createAudioParam(this, isOffline, nativeConstantSourceNode.offset, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            this._onended = null;
        }
        get offset() {
            return this._offset;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeConstantSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeConstantSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        start(when = 0) {
            this._nativeConstantSourceNode.start(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.start = when;
            if (this.context.state !== 'closed') {
                (0, $1dade94fa084012d$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeConstantSourceNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $503abdc94195f7ae$export$e44f0fc8e83fb084)(this)) (0, $9fbb9de7ccc2f607$export$7c0830f3a5100dec)(this);
                };
                this._nativeConstantSourceNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeConstantSourceNode.stop(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.stop = when;
        }
    };
};



const $759e2b050fe8a44a$export$bc541a3c87b45a7d = (connectAudioParam, createNativeConstantSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConstantSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createConstantSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConstantSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeConstantSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeConstantSourceNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeConstantSourceNode, nativeOfflineAudioContext);
            if (!nativeConstantSourceNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeConstantSourceNode.channelCount,
                    channelCountMode: nativeConstantSourceNode.channelCountMode,
                    channelInterpretation: nativeConstantSourceNode.channelInterpretation,
                    offset: nativeConstantSourceNode.offset.value
                };
                nativeConstantSourceNode = createNativeConstantSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeConstantSourceNode.start(start);
                if (stop !== null) nativeConstantSourceNode.stop(stop);
            }
            renderedNativeConstantSourceNodes.set(nativeOfflineAudioContext, nativeConstantSourceNode);
            if (!nativeConstantSourceNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConstantSourceNode);
            return nativeConstantSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConstantSourceNode = renderedNativeConstantSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConstantSourceNode !== undefined) return Promise.resolve(renderedNativeConstantSourceNode);
                return createConstantSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $0a226f4b1123cd32$export$540e228106d2c471 = (unit32Array)=>{
    return (value)=>{
        unit32Array[0] = value;
        return unit32Array[0];
    };
};


const $5bc4231d0341670e$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    disableNormalization: false
};
const $5bc4231d0341670e$export$4894173a4b4ee485 = (audioNodeConstructor, createConvolverNodeRenderer, createNativeConvolverNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class ConvolverNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$5bc4231d0341670e$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConvolverNode = createNativeConvolverNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const convolverNodeRenderer = isOffline ? createConvolverNodeRenderer() : null;
            super(context, false, nativeConvolverNode, convolverNodeRenderer);
            this._isBufferNullified = false;
            this._nativeConvolverNode = nativeConvolverNode;
            if (mergedOptions.buffer !== null) setAudioNodeTailTime(this, mergedOptions.buffer.duration);
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeConvolverNode.buffer;
        }
        set buffer(value) {
            this._nativeConvolverNode.buffer = value;
            // Bug #115: Safari does not allow to set the buffer to null.
            if (value === null && this._nativeConvolverNode.buffer !== null) {
                const nativeContext = this._nativeConvolverNode.context;
                this._nativeConvolverNode.buffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
                this._isBufferNullified = true;
                setAudioNodeTailTime(this, 0);
            } else {
                this._isBufferNullified = false;
                setAudioNodeTailTime(this, this._nativeConvolverNode.buffer === null ? 0 : this._nativeConvolverNode.buffer.duration);
            }
        }
        get normalize() {
            return this._nativeConvolverNode.normalize;
        }
        set normalize(value) {
            this._nativeConvolverNode.normalize = value;
        }
    };
};




const $e49830cde0da43f3$export$5b278ccdb1a6393 = (createNativeConvolverNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConvolverNodes = new WeakMap();
        const createConvolverNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConvolverNode = getNativeAudioNode(proxy);
            // If the initially used nativeConvolverNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeConvolverNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeConvolverNode, nativeOfflineAudioContext);
            if (!nativeConvolverNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeConvolverNode.buffer,
                    channelCount: nativeConvolverNode.channelCount,
                    channelCountMode: nativeConvolverNode.channelCountMode,
                    channelInterpretation: nativeConvolverNode.channelInterpretation,
                    disableNormalization: !nativeConvolverNode.normalize
                };
                nativeConvolverNode = createNativeConvolverNode(nativeOfflineAudioContext, options);
            }
            renderedNativeConvolverNodes.set(nativeOfflineAudioContext, nativeConvolverNode);
            if ((0, $077e12d27999c158$export$ac2aef07f705aa48)(nativeConvolverNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode);
            return nativeConvolverNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConvolverNode = renderedNativeConvolverNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConvolverNode !== undefined) return Promise.resolve(renderedNativeConvolverNode);
                return createConvolverNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $b94b99e9ef151b5d$export$ab44e304a31eb0ae = (createNotSupportedError, nativeOfflineAudioContextConstructor)=>{
    return (numberOfChannels, length, sampleRate)=>{
        if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
        try {
            return new nativeOfflineAudioContextConstructor(numberOfChannels, length, sampleRate);
        } catch (err) {
            // Bug #143, #144 & #146: Safari throws a SyntaxError when numberOfChannels, length or sampleRate are invalid.
            if (err.name === 'SyntaxError') throw createNotSupportedError();
            throw err;
        }
    };
};


const $91ae39be37a09214$export$fc1a599a84ca01a8 = ()=>new DOMException('', 'DataCloneError');


const $d8c883e2f4806733$export$2d33e41548107ad3 = (arrayBuffer)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    return new Promise((resolve)=>{
        const closeAndResolve = ()=>{
            port2.onmessage = null;
            port1.close();
            port2.close();
            resolve();
        };
        port2.onmessage = ()=>closeAndResolve();
        try {
            port1.postMessage(arrayBuffer, [
                arrayBuffer
            ]);
        } catch  {
        // Ignore errors.
        } finally{
            closeAndResolve();
        }
    });
};



const $1fa33cee60a8fbee$export$d83e4a6039bccfb = (audioBufferStore, cacheTestResult, createDataCloneError, createEncodingError, detachedArrayBuffers, getNativeContext, isNativeContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, testPromiseSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (anyContext, audioData)=>{
        const nativeContext = isNativeContext(anyContext) ? anyContext : getNativeContext(anyContext);
        // Bug #43: Only Chrome and Edge do throw a DataCloneError.
        if (detachedArrayBuffers.has(audioData)) {
            const err = createDataCloneError();
            return Promise.reject(err);
        }
        // The audioData parameter maybe of a type which can't be added to a WeakSet.
        try {
            detachedArrayBuffers.add(audioData);
        } catch  {
        // Ignore errors.
        }
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult(testPromiseSupport, ()=>testPromiseSupport(nativeContext))) return nativeContext.decodeAudioData(audioData).then((audioBuffer)=>{
            // Bug #133: Safari does neuter the ArrayBuffer.
            (0, $d8c883e2f4806733$export$2d33e41548107ad3)(audioData).catch(()=>{
            // Ignore errors.
            });
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
        // Bug #21: Safari does not return a Promise yet.
        return new Promise((resolve, reject)=>{
            const complete = async ()=>{
                // Bug #133: Safari does neuter the ArrayBuffer.
                try {
                    await (0, $d8c883e2f4806733$export$2d33e41548107ad3)(audioData);
                } catch  {
                // Ignore errors.
                }
            };
            const fail = (err)=>{
                reject(err);
                complete();
            };
            // Bug #26: Safari throws a synchronous error.
            try {
                // Bug #1: Safari requires a successCallback.
                nativeContext.decodeAudioData(audioData, (audioBuffer)=>{
                    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
                    // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
                    if (typeof audioBuffer.copyFromChannel !== 'function') {
                        wrapAudioBufferCopyChannelMethods(audioBuffer);
                        (0, $327fa96f6085d8f9$export$df65309cf6249598)(audioBuffer);
                    }
                    audioBufferStore.add(audioBuffer);
                    complete().then(()=>resolve(audioBuffer));
                }, (err)=>{
                    // Bug #4: Safari returns null instead of an error.
                    if (err === null) fail(createEncodingError());
                    else fail(err);
                });
            } catch (err) {
                fail(err);
            }
        });
    };
};



const $98964fb918f30d92$export$93f58f9268fde9f6 = (connectNativeAudioNodeToNativeAudioNode, cycleCounters, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, getNativeContext, isActiveAudioNode, isNativeOfflineAudioContext)=>{
    return (audioNode, count)=>{
        const cycleCounter = cycleCounters.get(audioNode);
        if (cycleCounter === undefined) throw new Error('Missing the expected cycle count.');
        const nativeContext = getNativeContext(audioNode.context);
        const isOffline = isNativeOfflineAudioContext(nativeContext);
        if (cycleCounter === count) {
            cycleCounters.delete(audioNode);
            if (!isOffline && isActiveAudioNode(audioNode)) {
                const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                const { outputs: outputs } = getAudioNodeConnections(audioNode);
                for (const output of outputs)if ((0, $ac48105bedc212b3$export$419d66ef3a96a878)(output)) {
                    const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                    connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                } else {
                    const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                    nativeSourceAudioNode.connect(nativeDestinationAudioParam, output[1]);
                }
            }
        } else cycleCounters.set(audioNode, cycleCounter - count);
    };
};


const $0f2ec2fb49743844$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    delayTime: 0,
    maxDelayTime: 1
};
const $0f2ec2fb49743844$export$b89a0215c1c607e3 = (audioNodeConstructor, createAudioParam, createDelayNodeRenderer, createNativeDelayNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DelayNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$0f2ec2fb49743844$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDelayNode = createNativeDelayNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const delayNodeRenderer = isOffline ? createDelayNodeRenderer(mergedOptions.maxDelayTime) : null;
            super(context, false, nativeDelayNode, delayNodeRenderer);
            this._delayTime = createAudioParam(this, isOffline, nativeDelayNode.delayTime);
            setAudioNodeTailTime(this, mergedOptions.maxDelayTime);
        }
        get delayTime() {
            return this._delayTime;
        }
    };
};



const $1c495b946a181301$export$d03c2308083a28e5 = (connectAudioParam, createNativeDelayNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return (maxDelayTime)=>{
        const renderedNativeDelayNodes = new WeakMap();
        const createDelayNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDelayNode = getNativeAudioNode(proxy);
            // If the initially used nativeDelayNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeDelayNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeDelayNode, nativeOfflineAudioContext);
            if (!nativeDelayNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeDelayNode.channelCount,
                    channelCountMode: nativeDelayNode.channelCountMode,
                    channelInterpretation: nativeDelayNode.channelInterpretation,
                    delayTime: nativeDelayNode.delayTime.value,
                    maxDelayTime: maxDelayTime
                };
                nativeDelayNode = createNativeDelayNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDelayNodes.set(nativeOfflineAudioContext, nativeDelayNode);
            if (!nativeDelayNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDelayNode);
            return nativeDelayNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDelayNode = renderedNativeDelayNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDelayNode !== undefined) return Promise.resolve(renderedNativeDelayNode);
                return createDelayNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $85c84ce05513d4a0$export$1f7c0152b9e322ae = (pickElementFromSet)=>{
    return (activeInputs, source, output, input)=>{
        return pickElementFromSet(activeInputs[input], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
    };
};


const $d38b548213acb987$export$92df121abbf21dca = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).delete(audioWorkletNode);
    };
};



const $757f7fc5e9da4694$export$c283d436eafbd9b2 = (audioNode)=>{
    return 'delayTime' in audioNode;
};


const $38a9fb4c6f21e90a$export$b4f8d2824d9887dc = (audioParamAudioNodeStore, getAudioNodeConnections, getValueForKey)=>{
    return function detectCycles(chain, nextLink) {
        const audioNode = (0, $abb453140d998e25$export$85cd8e93eb858e81)(nextLink) ? nextLink : getValueForKey(audioParamAudioNodeStore, nextLink);
        if ((0, $757f7fc5e9da4694$export$c283d436eafbd9b2)(audioNode)) return [];
        if (chain[0] === audioNode) return [
            chain
        ];
        if (chain.includes(audioNode)) return [];
        const { outputs: outputs } = getAudioNodeConnections(audioNode);
        return Array.from(outputs).map((outputConnection)=>detectCycles([
                ...chain,
                audioNode
            ], outputConnection[0])).reduce((mergedCycles, nestedCycles)=>mergedCycles.concat(nestedCycles), []);
    };
};



const $d5650f4917318555$var$getOutputAudioNodeAtIndex = (createIndexSizeError, outputAudioNodes, output)=>{
    const outputAudioNode = outputAudioNodes[output];
    if (outputAudioNode === undefined) throw createIndexSizeError();
    return outputAudioNode;
};
const $d5650f4917318555$export$78a992fad11cd00e = (createIndexSizeError)=>{
    return (outputAudioNodes, destinationOrOutput, output, input = 0)=>{
        if (destinationOrOutput === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect());
        if (typeof destinationOrOutput === 'number') return $d5650f4917318555$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, destinationOrOutput).disconnect();
        if ((0, $db699c2c2928ff4a$export$d647358384f164e0)(destinationOrOutput)) {
            if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
            if (input === undefined) return $d5650f4917318555$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
            return $d5650f4917318555$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0, input);
        }
        if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
        return $d5650f4917318555$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
    };
};


const $318a8077a10d6784$var$DEFAULT_OPTIONS = {
    attack: 0.003,
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    knee: 30,
    ratio: 12,
    release: 0.25,
    threshold: -24
};
const $318a8077a10d6784$export$60ec6725c2d45fc8 = (audioNodeConstructor, createAudioParam, createDynamicsCompressorNodeRenderer, createNativeDynamicsCompressorNode, createNotSupportedError, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DynamicsCompressorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$318a8077a10d6784$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const dynamicsCompressorNodeRenderer = isOffline ? createDynamicsCompressorNodeRenderer() : null;
            super(context, false, nativeDynamicsCompressorNode, dynamicsCompressorNodeRenderer);
            this._attack = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.attack);
            this._knee = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.knee);
            this._nativeDynamicsCompressorNode = nativeDynamicsCompressorNode;
            this._ratio = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.ratio);
            this._release = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.release);
            this._threshold = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.threshold);
            setAudioNodeTailTime(this, 0.006);
        }
        get attack() {
            return this._attack;
        }
        // Bug #108: Safari allows a channelCount of three and above which is why the getter and setter needs to be overwritten here.
        get channelCount() {
            return this._nativeDynamicsCompressorNode.channelCount;
        }
        set channelCount(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCount;
            this._nativeDynamicsCompressorNode.channelCount = value;
            if (value > 2) {
                this._nativeDynamicsCompressorNode.channelCount = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        /*
         * Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max' yet which is why the getter and setter needs to be
         * overwritten here.
         */ get channelCountMode() {
            return this._nativeDynamicsCompressorNode.channelCountMode;
        }
        set channelCountMode(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCountMode;
            this._nativeDynamicsCompressorNode.channelCountMode = value;
            if (value === 'max') {
                this._nativeDynamicsCompressorNode.channelCountMode = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        get knee() {
            return this._knee;
        }
        get ratio() {
            return this._ratio;
        }
        get reduction() {
            // Bug #111: Safari returns an AudioParam instead of a number.
            if (typeof this._nativeDynamicsCompressorNode.reduction.value === 'number') return this._nativeDynamicsCompressorNode.reduction.value;
            return this._nativeDynamicsCompressorNode.reduction;
        }
        get release() {
            return this._release;
        }
        get threshold() {
            return this._threshold;
        }
    };
};



const $b8141f8bf6a9223d$export$1b1e82cc3f0a2c8 = (connectAudioParam, createNativeDynamicsCompressorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeDynamicsCompressorNodes = new WeakMap();
        const createDynamicsCompressorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDynamicsCompressorNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeDynamicsCompressorNode was not constructed on the same OfflineAudioContext it needs to be
             * created again.
             */ const nativeDynamicsCompressorNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeDynamicsCompressorNode, nativeOfflineAudioContext);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                const options = {
                    attack: nativeDynamicsCompressorNode.attack.value,
                    channelCount: nativeDynamicsCompressorNode.channelCount,
                    channelCountMode: nativeDynamicsCompressorNode.channelCountMode,
                    channelInterpretation: nativeDynamicsCompressorNode.channelInterpretation,
                    knee: nativeDynamicsCompressorNode.knee.value,
                    ratio: nativeDynamicsCompressorNode.ratio.value,
                    release: nativeDynamicsCompressorNode.release.value,
                    threshold: nativeDynamicsCompressorNode.threshold.value
                };
                nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDynamicsCompressorNodes.set(nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await renderAutomation(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await renderAutomation(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await renderAutomation(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await renderAutomation(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await connectAudioParam(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await connectAudioParam(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await connectAudioParam(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await connectAudioParam(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            return nativeDynamicsCompressorNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDynamicsCompressorNode = renderedNativeDynamicsCompressorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDynamicsCompressorNode !== undefined) return Promise.resolve(renderedNativeDynamicsCompressorNode);
                return createDynamicsCompressorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $5d38f2b111b4df64$export$6372d3d9069bc778 = ()=>new DOMException('', 'EncodingError');


const $93ab3e52560a3d1a$export$43b563d089dd1d8 = (window)=>{
    return (source)=>new Promise((resolve, reject)=>{
            if (window === null) {
                // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                reject(new SyntaxError());
                return;
            }
            const head = window.document.head;
            if (head === null) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            reject(new SyntaxError());
            else {
                const script = window.document.createElement('script');
                // @todo Safari doesn't like URLs with a type of 'application/javascript; charset=utf-8'.
                const blob = new Blob([
                    source
                ], {
                    type: 'application/javascript'
                });
                const url = URL.createObjectURL(blob);
                const originalOnErrorHandler = window.onerror;
                const removeErrorEventListenerAndRevokeUrl = ()=>{
                    window.onerror = originalOnErrorHandler;
                    URL.revokeObjectURL(url);
                };
                window.onerror = (message, src, lineno, colno, error)=>{
                    // @todo Edge thinks the source is the one of the html document.
                    if (src === url || src === window.location.href && lineno === 1 && colno === 1) {
                        removeErrorEventListenerAndRevokeUrl();
                        reject(error);
                        return false;
                    }
                    if (originalOnErrorHandler !== null) return originalOnErrorHandler(message, src, lineno, colno, error);
                };
                script.onerror = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                    reject(new SyntaxError());
                };
                script.onload = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    resolve();
                };
                script.src = url;
                script.type = 'module';
                head.appendChild(script);
            }
        });
};


const $f77562cca85f27c5$export$a512af3fc2ab91f2 = (wrapEventListener)=>{
    return class EventTarget {
        constructor(_nativeEventTarget){
            this._nativeEventTarget = _nativeEventTarget;
            this._listeners = new WeakMap();
        }
        addEventListener(type, listener, options) {
            if (listener !== null) {
                let wrappedEventListener = this._listeners.get(listener);
                if (wrappedEventListener === undefined) {
                    wrappedEventListener = wrapEventListener(this, listener);
                    if (typeof listener === 'function') this._listeners.set(listener, wrappedEventListener);
                }
                this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
            }
        }
        dispatchEvent(event) {
            return this._nativeEventTarget.dispatchEvent(event);
        }
        removeEventListener(type, listener, options) {
            const wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);
            this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
        }
    };
};


const $4d36b7de4be93f4e$export$c43b8ab5e8913cbb = (window)=>{
    return (currentTime, sampleRate, fn)=>{
        Object.defineProperties(window, {
            currentFrame: {
                configurable: true,
                get () {
                    return Math.round(currentTime * sampleRate);
                }
            },
            currentTime: {
                configurable: true,
                get () {
                    return currentTime;
                }
            }
        });
        try {
            return fn();
        } finally{
            if (window !== null) {
                delete window.currentFrame;
                delete window.currentTime;
            }
        }
    };
};


const $4421c430ef9ef0be$export$c7282a393375a8ca = (createAbortError)=>{
    return async (url)=>{
        try {
            const response = await fetch(url);
            if (response.ok) return [
                await response.text(),
                response.url
            ];
        } catch  {
        // Ignore errors.
        } // tslint:disable-line:no-empty
        throw createAbortError();
    };
};



const $a7d03eaa13cb4139$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    gain: 1
};
const $a7d03eaa13cb4139$export$7b37b693b55bf5d7 = (audioNodeConstructor, createAudioParam, createGainNodeRenderer, createNativeGainNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class GainNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$a7d03eaa13cb4139$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeGainNode = createNativeGainNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const gainNodeRenderer = isOffline ? createGainNodeRenderer() : null;
            super(context, false, nativeGainNode, gainNodeRenderer);
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeGainNode.gain, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
        }
        get gain() {
            return this._gain;
        }
    };
};



const $b8c579544df95d54$export$7312404e5bea9cd = (connectAudioParam, createNativeGainNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeGainNodes = new WeakMap();
        const createGainNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = getNativeAudioNode(proxy);
            // If the initially used nativeGainNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeGainNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeGainNode, nativeOfflineAudioContext);
            if (!nativeGainNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeGainNode.channelCount,
                    channelCountMode: nativeGainNode.channelCountMode,
                    channelInterpretation: nativeGainNode.channelInterpretation,
                    gain: nativeGainNode.gain.value
                };
                nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, options);
            }
            renderedNativeGainNodes.set(nativeOfflineAudioContext, nativeGainNode);
            if (!nativeGainNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeGainNode);
            return nativeGainNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNode = renderedNativeGainNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNode !== undefined) return Promise.resolve(renderedNativeGainNode);
                return createGainNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $3494284d53c386ba$export$8b01844840684f8d = (activeAudioWorkletNodeInputsStore, getValueForKey)=>{
    return (nativeAudioWorkletNode)=>getValueForKey(activeAudioWorkletNodeInputsStore, nativeAudioWorkletNode);
};


const $7905bd1efa914bd5$export$97bb1acefff8970e = (getAudioNodeConnections)=>{
    return (audioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        if (audioNodeConnections.renderer === null) throw new Error('Missing the renderer of the given AudioNode in the audio graph.');
        return audioNodeConnections.renderer;
    };
};


const $72b6e297b7c98cbb$export$4abc3abd061bc2cc = (audioNodeTailTimeStore)=>{
    return (audioNode)=>{
        var _a;
        return (_a = audioNodeTailTimeStore.get(audioNode)) !== null && _a !== void 0 ? _a : 0;
    };
};


const $0da9d58f0d78ecd1$export$1653dd3e76bcb1b0 = (getAudioParamConnections)=>{
    return (audioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        if (audioParamConnections.renderer === null) throw new Error('Missing the renderer of the given AudioParam in the audio graph.');
        return audioParamConnections.renderer;
    };
};


const $025a53012dff4874$export$afecf147821b5609 = (backupOfflineAudioContextStore)=>{
    return (nativeContext)=>{
        return backupOfflineAudioContextStore.get(nativeContext);
    };
};


const $d3386d35bc2b7a66$export$5a1c4cd5830ea09b = ()=>new DOMException('', 'InvalidStateError');


const $c493805cef303fde$export$797a319a8065fb37 = (contextStore)=>{
    return (context)=>{
        const nativeContext = contextStore.get(context);
        if (nativeContext === undefined) throw (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b)();
        return nativeContext;
    };
};


const $8546f1058c7ad9ca$export$70df0ae42e1340c8 = (backupOfflineAudioContextStore, nativeOfflineAudioContextConstructor)=>{
    return (nativeContext)=>{
        let backupOfflineAudioContext = backupOfflineAudioContextStore.get(nativeContext);
        if (backupOfflineAudioContext !== undefined) return backupOfflineAudioContext;
        if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        backupOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        backupOfflineAudioContextStore.set(nativeContext, backupOfflineAudioContext);
        return backupOfflineAudioContext;
    };
};


const $7f98b199b5686bd0$export$43ef7eb1ae3d2f40 = (unrenderedAudioWorkletNodeStore)=>{
    return (nativeContext)=>{
        const unrenderedAudioWorkletNodes = unrenderedAudioWorkletNodeStore.get(nativeContext);
        if (unrenderedAudioWorkletNodes === undefined) throw new Error('The context has no set of AudioWorkletNodes.');
        return unrenderedAudioWorkletNodes;
    };
};


const $d5b9a4487fd5e996$export$254c536c2ca9b917 = ()=>new DOMException('', 'InvalidAccessError');


const $577a7df77a71625d$export$8170ec2d1debbbdd = (nativeIIRFilterNode)=>{
    nativeIIRFilterNode.getFrequencyResponse = ((getFrequencyResponse)=>{
        return (frequencyHz, magResponse, phaseResponse)=>{
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw (0, $d5b9a4487fd5e996$export$254c536c2ca9b917)();
            return getFrequencyResponse.call(nativeIIRFilterNode, frequencyHz, magResponse, phaseResponse);
        };
    })(nativeIIRFilterNode.getFrequencyResponse);
};


const $9017795a9f3f416c$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers'
};
const $9017795a9f3f416c$export$a22f1eb785a05608 = (audioNodeConstructor, createNativeIIRFilterNode, createIIRFilterNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class IIRFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = {
                ...$9017795a9f3f416c$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeIIRFilterNode = createNativeIIRFilterNode(nativeContext, isOffline ? null : context.baseLatency, mergedOptions);
            const iirFilterNodeRenderer = isOffline ? createIIRFilterNodeRenderer(mergedOptions.feedback, mergedOptions.feedforward) : null;
            super(context, false, nativeIIRFilterNode, iirFilterNodeRenderer);
            // Bug #23 & #24: FirefoxDeveloper does not throw an InvalidAccessError.
            // @todo Write a test which allows other browsers to remain unpatched.
            (0, $577a7df77a71625d$export$8170ec2d1debbbdd)(nativeIIRFilterNode);
            this._nativeIIRFilterNode = nativeIIRFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            return this._nativeIIRFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
        }
    };
};


// This implementation as shamelessly inspired by source code of
// tslint:disable-next-line:max-line-length
// {@link https://chromium.googlesource.com/chromium/src.git/+/master/third_party/WebKit/Source/platform/audio/IIRFilter.cpp|Chromium's IIRFilter}.
const $cb3893968b11ac5e$export$7fa1177e7d2178dd = (feedback, feedbackLength, feedforward, feedforwardLength, minLength, xBuffer, yBuffer, bufferIndex, bufferLength, input, output)=>{
    const inputLength = input.length;
    let i = bufferIndex;
    for(let j = 0; j < inputLength; j += 1){
        let y = feedforward[0] * input[j];
        for(let k = 1; k < minLength; k += 1){
            const x = i - k & bufferLength - 1; // tslint:disable-line:no-bitwise
            y += feedforward[k] * xBuffer[x];
            y -= feedback[k] * yBuffer[x];
        }
        for(let k = minLength; k < feedforwardLength; k += 1)y += feedforward[k] * xBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        for(let k = minLength; k < feedbackLength; k += 1)y -= feedback[k] * yBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        xBuffer[i] = input[j];
        yBuffer[i] = y;
        i = i + 1 & bufferLength - 1; // tslint:disable-line:no-bitwise
        output[j] = y;
    }
    return i;
};



const $5f9674e3cd03078f$var$filterFullBuffer = (renderedBuffer, nativeOfflineAudioContext, feedback, feedforward)=>{
    const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
    const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
    const feedbackLength = convertedFeedback.length;
    const feedforwardLength = convertedFeedforward.length;
    const minLength = Math.min(feedbackLength, feedforwardLength);
    if (convertedFeedback[0] !== 1) {
        for(let i = 0; i < feedbackLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
        for(let i = 1; i < feedforwardLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
    }
    const bufferLength = 32;
    const xBuffer = new Float32Array(bufferLength);
    const yBuffer = new Float32Array(bufferLength);
    const filteredBuffer = nativeOfflineAudioContext.createBuffer(renderedBuffer.numberOfChannels, renderedBuffer.length, renderedBuffer.sampleRate);
    const numberOfChannels = renderedBuffer.numberOfChannels;
    for(let i = 0; i < numberOfChannels; i += 1){
        const input = renderedBuffer.getChannelData(i);
        const output = filteredBuffer.getChannelData(i);
        xBuffer.fill(0);
        yBuffer.fill(0);
        (0, $cb3893968b11ac5e$export$7fa1177e7d2178dd)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffer, yBuffer, 0, bufferLength, input, output);
    }
    return filteredBuffer;
};
const $5f9674e3cd03078f$export$329316f0ca6cf17e = (createNativeAudioBufferSourceNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (feedback, feedforward)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let filteredBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = null;
            let nativeIIRFilterNode = getNativeAudioNode(proxy);
            // If the initially used nativeIIRFilterNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeIIRFilterNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeIIRFilterNode, nativeOfflineAudioContext);
            // Bug #9: Safari does not support IIRFilterNodes.
            if (nativeOfflineAudioContext.createIIRFilter === undefined) nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                buffer: null,
                channelCount: 2,
                channelCountMode: 'max',
                channelInterpretation: 'speakers',
                loop: false,
                loopEnd: 0,
                loopStart: 0,
                playbackRate: 1
            });
            else if (!nativeIIRFilterNodeIsOwnedByContext) // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
            nativeIIRFilterNode = nativeOfflineAudioContext.createIIRFilter(feedforward, feedback);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode === null ? nativeIIRFilterNode : nativeAudioBufferSourceNode);
            if (nativeAudioBufferSourceNode !== null) {
                if (filteredBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(// Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    proxy.context.destination.channelCount, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    filteredBufferPromise = (async ()=>{
                        await renderInputsOfAudioNode(proxy, partialOfflineAudioContext, partialOfflineAudioContext.destination);
                        const renderedBuffer = await renderNativeOfflineAudioContext(partialOfflineAudioContext);
                        return $5f9674e3cd03078f$var$filterFullBuffer(renderedBuffer, nativeOfflineAudioContext, feedback, feedforward);
                    })();
                }
                const filteredBuffer = await filteredBufferPromise;
                nativeAudioBufferSourceNode.buffer = filteredBuffer;
                nativeAudioBufferSourceNode.start(0);
                return nativeAudioBufferSourceNode;
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeIIRFilterNode);
            return nativeIIRFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};



const $379675dcab724dbd$export$e306a463e9286bbd = (cycleCounters, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, isActiveAudioNode)=>{
    return (isOffline)=>{
        return (audioNode, count)=>{
            const cycleCounter = cycleCounters.get(audioNode);
            if (cycleCounter === undefined) {
                if (!isOffline && isActiveAudioNode(audioNode)) {
                    const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                    const { outputs: outputs } = getAudioNodeConnections(audioNode);
                    for (const output of outputs)if ((0, $ac48105bedc212b3$export$419d66ef3a96a878)(output)) {
                        const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                        disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                    } else {
                        const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                        nativeSourceAudioNode.disconnect(nativeDestinationAudioParam, output[1]);
                    }
                }
                cycleCounters.set(audioNode, count);
            } else cycleCounters.set(audioNode, cycleCounter + count);
        };
    };
};





const $3fb13afb989780c8$export$7030a6f3318876b = (contextStore, isNativeAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeAudioContext(nativeContext) || isNativeAudioContext(anything);
    };
};


const $72567d9c778a8250$export$150a35c855945f9d = (audioNodeStore, isNativeAudioNode)=>{
    return (anything)=>audioNodeStore.has(anything) || isNativeAudioNode(anything);
};


const $11df81699cdc985f$export$41505fc8888255a0 = (audioParamStore, isNativeAudioParam)=>{
    return (anything)=>audioParamStore.has(anything) || isNativeAudioParam(anything);
};


const $66bba1c5d93e8abe$export$845691ce8ebc2907 = (contextStore, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeOfflineAudioContext(nativeContext) || isNativeOfflineAudioContext(anything);
    };
};


const $27e5f4b8882b02ee$export$5d44272df169092e = (nativeAudioContextConstructor)=>{
    return (anything)=>{
        return nativeAudioContextConstructor !== null && anything instanceof nativeAudioContextConstructor;
    };
};


const $4e598b45f53fc947$export$96f2bb6e8a5795ea = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioNode === 'function' && anything instanceof window.AudioNode;
    };
};


const $e02daab6a7e4bfbe$export$7c3a44537acaf24e = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioParam === 'function' && anything instanceof window.AudioParam;
    };
};


const $3c161e75d4bd155d$export$a7c969701e5471d0 = (isNativeAudioContext, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        return isNativeAudioContext(anything) || isNativeOfflineAudioContext(anything);
    };
};


const $8288725d93323f74$export$722bd4bab77df75a = (nativeOfflineAudioContextConstructor)=>{
    return (anything)=>{
        return nativeOfflineAudioContextConstructor !== null && anything instanceof nativeOfflineAudioContextConstructor;
    };
};


const $1906dbddefaf3bd4$export$2e9a7e6b17a9abae = (window)=>window !== null && window.isSecureContext;


const $9be8ead70a901adf$export$a245ecb43f54c4de = async (cacheTestResult, testAudioBufferCopyChannelMethodsSubarraySupport, testAudioContextCloseMethodSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextOptionsSupport, testAudioNodeConnectMethodSupport, testAudioWorkletProcessorNoOutputsSupport, testChannelMergerNodeChannelCountSupport, testConstantSourceNodeAccurateSchedulingSupport, testConvolverNodeBufferReassignabilitySupport, testConvolverNodeChannelCountSupport, testDomExceptionContrucorSupport, testIsSecureContextSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testStereoPannerNodeDefaultValueSupport, testTransferablesSupport)=>{
    if (cacheTestResult(testAudioBufferCopyChannelMethodsSubarraySupport, testAudioBufferCopyChannelMethodsSubarraySupport) && cacheTestResult(testAudioContextCloseMethodSupport, testAudioContextCloseMethodSupport) && cacheTestResult(testAudioContextOptionsSupport, testAudioContextOptionsSupport) && cacheTestResult(testAudioNodeConnectMethodSupport, testAudioNodeConnectMethodSupport) && cacheTestResult(testChannelMergerNodeChannelCountSupport, testChannelMergerNodeChannelCountSupport) && cacheTestResult(testConstantSourceNodeAccurateSchedulingSupport, testConstantSourceNodeAccurateSchedulingSupport) && cacheTestResult(testConvolverNodeBufferReassignabilitySupport, testConvolverNodeBufferReassignabilitySupport) && cacheTestResult(testConvolverNodeChannelCountSupport, testConvolverNodeChannelCountSupport) && cacheTestResult(testDomExceptionContrucorSupport, testDomExceptionContrucorSupport) && cacheTestResult(testIsSecureContextSupport, testIsSecureContextSupport) && cacheTestResult(testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport)) {
        const results = await Promise.all([
            cacheTestResult(testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport),
            cacheTestResult(testAudioWorkletProcessorNoOutputsSupport, testAudioWorkletProcessorNoOutputsSupport),
            cacheTestResult(testStereoPannerNodeDefaultValueSupport, testStereoPannerNodeDefaultValueSupport),
            cacheTestResult(testTransferablesSupport, testTransferablesSupport)
        ]);
        return results.every((result)=>result);
    }
    return false;
};


const $079115c0ef941b11$export$d24d3af0853fd021 = (audioNodeConstructor, createNativeMediaElementAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaElementAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaElementAudioSourceNode = createNativeMediaElementAudioSourceNode(nativeContext, options);
            // Bug #171: Safari allows to create a MediaElementAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw TypeError();
            super(context, true, nativeMediaElementAudioSourceNode, null);
            this._nativeMediaElementAudioSourceNode = nativeMediaElementAudioSourceNode;
        }
        get mediaElement() {
            return this._nativeMediaElementAudioSourceNode.mediaElement;
        }
    };
};


const $89475f3ad216aff8$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers'
};
const $89475f3ad216aff8$export$5d3ee2470cd2874 = (audioNodeConstructor, createNativeMediaStreamAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioDestinationNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            // Bug #173: Safari allows to create a MediaStreamAudioDestinationNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            const mergedOptions = {
                ...$89475f3ad216aff8$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeMediaStreamAudioDestinationNode = createNativeMediaStreamAudioDestinationNode(nativeContext, mergedOptions);
            super(context, false, nativeMediaStreamAudioDestinationNode, null);
            this._nativeMediaStreamAudioDestinationNode = nativeMediaStreamAudioDestinationNode;
        }
        get stream() {
            return this._nativeMediaStreamAudioDestinationNode.stream;
        }
    };
};


const $97b84ffec3eb7e83$export$a42e10687df73a9d = (audioNodeConstructor, createNativeMediaStreamAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamAudioSourceNode = createNativeMediaStreamAudioSourceNode(nativeContext, options);
            // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            super(context, true, nativeMediaStreamAudioSourceNode, null);
            this._nativeMediaStreamAudioSourceNode = nativeMediaStreamAudioSourceNode;
        }
        get mediaStream() {
            return this._nativeMediaStreamAudioSourceNode.mediaStream;
        }
    };
};


const $58a5ef1f9d17e13b$export$24f27d34fdf823bc = (audioNodeConstructor, createNativeMediaStreamTrackAudioSourceNode, getNativeContext)=>{
    return class MediaStreamTrackAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamTrackAudioSourceNode = createNativeMediaStreamTrackAudioSourceNode(nativeContext, options);
            super(context, true, nativeMediaStreamTrackAudioSourceNode, null);
        }
    };
};




const $6b0a830f2ea9ee6f$export$8a5e66f668b2e9e8 = (createInvalidStateError, createNotSupportedError, createUnknownError, minimalBaseAudioContextConstructor, nativeAudioContextConstructor)=>{
    return class MinimalAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error('Missing the native AudioContext constructor.');
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === 'sampleRate is not in range') throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $9c08ad7d1fee8b6f$export$82d5f0e102842fbe)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === 'running') {
                this._state = 'suspended';
                const revokeState = ()=>{
                    if (this._state === 'suspended') this._state = null;
                    nativeAudioContext.removeEventListener('statechange', revokeState);
                };
                nativeAudioContext.addEventListener('statechange', revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === 'closed') return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === 'suspended') this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $38dbdfa389791805$export$cbd606bc629ea938)(this);
            });
        }
        resume() {
            if (this._state === 'suspended') return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener('statechange', resolvePromise);
                    if (this._nativeAudioContext.state === 'running') resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener('statechange', resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};



const $12328baab9a3bae7$export$3f49d9c870ba2692 = (audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener)=>{
    return class MinimalBaseAudioContext extends eventTargetConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext);
            this._nativeContext = _nativeContext;
            (0, $063560d8523a7eb5$export$7d17302229276f06).set(this, _nativeContext);
            if (isNativeOfflineAudioContext(_nativeContext)) unrenderedAudioWorkletNodeStore.set(_nativeContext, new Set());
            this._destination = new audioDestinationNodeConstructor(this, numberOfChannels);
            this._listener = createAudioListener(this, _nativeContext);
            this._onstatechange = null;
        }
        get currentTime() {
            return this._nativeContext.currentTime;
        }
        get destination() {
            return this._destination;
        }
        get listener() {
            return this._listener;
        }
        get onstatechange() {
            return this._onstatechange;
        }
        set onstatechange(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeContext.onstatechange = wrappedListener;
            const nativeOnStateChange = this._nativeContext.onstatechange;
            this._onstatechange = nativeOnStateChange !== null && nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
        }
        get sampleRate() {
            return this._nativeContext.sampleRate;
        }
        get state() {
            return this._nativeContext.state;
        }
    };
};



const $790c2f9ab3e8ea25$export$9ec44223b1284cd4 = (nativeContext)=>{
    // This 12 numbers represent the 48 bytes of an empty WAVE file with a single sample.
    const uint32Array = new Uint32Array([
        1179011410,
        40,
        1163280727,
        544501094,
        16,
        131073,
        44100,
        176400,
        1048580,
        1635017060,
        4,
        0
    ]);
    try {
        // Bug #1: Safari requires a successCallback.
        const promise = nativeContext.decodeAudioData(uint32Array.buffer, ()=>{
        // Ignore the success callback.
        });
        if (promise === undefined) return false;
        promise.catch(()=>{
        // Ignore rejected errors.
        });
        return true;
    } catch  {
    // Ignore errors.
    }
    return false;
};


const $d3a2c4ee8588a6de$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $d3a2c4ee8588a6de$export$3d487af37fe7f521 = (cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, minimalBaseAudioContextConstructor, startRendering)=>{
    return class MinimalOfflineAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options){
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$d3a2c4ee8588a6de$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $790c2f9ab3e8ea25$export$9ec44223b1284cd4), ()=>(0, $790c2f9ab3e8ea25$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener('statechange', (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === 'running') {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === 'running') return Promise.reject(createInvalidStateError());
            this._state = 'running';
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $38dbdfa389791805$export$cbd606bc629ea938)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};


const $2109969fcb7bbded$export$9f33b5a0b80f2717 = (insertElementInSet, isNativeAudioNode)=>{
    return (nativeAudioNode, whenConnected, whenDisconnected)=>{
        const connections = new Set();
        nativeAudioNode.connect = ((connect)=>{
            // tslint:disable-next-line:invalid-void no-inferrable-types
            return (destination, output = 0, input = 0)=>{
                const wasDisconnected = connections.size === 0;
                if (isNativeAudioNode(destination)) {
                    // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    connect.call(nativeAudioNode, destination, output, input);
                    insertElementInSet(connections, [
                        destination,
                        output,
                        input
                    ], (connection)=>connection[0] === destination && connection[1] === output && connection[2] === input, true);
                    if (wasDisconnected) whenConnected();
                    return destination;
                }
                connect.call(nativeAudioNode, destination, output);
                insertElementInSet(connections, [
                    destination,
                    output
                ], (connection)=>connection[0] === destination && connection[1] === output, true);
                if (wasDisconnected) whenConnected();
                return;
            };
        })(nativeAudioNode.connect);
        nativeAudioNode.disconnect = ((disconnect)=>{
            return (destinationOrOutput, output, input)=>{
                const wasConnected = connections.size > 0;
                if (destinationOrOutput === undefined) {
                    disconnect.apply(nativeAudioNode);
                    connections.clear();
                } else if (typeof destinationOrOutput === 'number') {
                    // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput);
                    for (const connection of connections)if (connection[1] === destinationOrOutput) connections.delete(connection);
                } else {
                    if (isNativeAudioNode(destinationOrOutput)) // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output, input);
                    else // @todo TypeScript cannot infer the overloaded signature with 2 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output);
                    for (const connection of connections)if (connection[0] === destinationOrOutput && (output === undefined || connection[1] === output) && (input === undefined || connection[2] === input)) connections.delete(connection);
                }
                const isDisconnected = connections.size === 0;
                if (wasConnected && isDisconnected) whenDisconnected();
            };
        })(nativeAudioNode.disconnect);
        return nativeAudioNode;
    };
};


const $ae24732efd4b40e6$export$26855c8d5a8f5839 = (nativeAudioNode, options, option)=>{
    const value = options[option];
    if (value !== undefined && value !== nativeAudioNode[option]) nativeAudioNode[option] = value;
};



const $b801f4d60b36d5b1$export$a741a487b656b6ff = (nativeAudioNode, options)=>{
    (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAudioNode, options, 'channelCount');
    (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAudioNode, options, 'channelCountMode');
    (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAudioNode, options, 'channelInterpretation');
};


const $b60b8bc18debf104$export$1cb15f891b4f5e5e = (nativeAnalyserNode)=>{
    return typeof nativeAnalyserNode.getFloatTimeDomainData === 'function';
};


const $a99b796678f8c3c3$export$df32660d042dab2e = (nativeAnalyserNode)=>{
    nativeAnalyserNode.getFloatTimeDomainData = (array)=>{
        const byteTimeDomainData = new Uint8Array(array.length);
        nativeAnalyserNode.getByteTimeDomainData(byteTimeDomainData);
        const length = Math.max(byteTimeDomainData.length, nativeAnalyserNode.fftSize);
        for(let i = 0; i < length; i += 1)array[i] = (byteTimeDomainData[i] - 128) * 0.0078125;
        return array;
    };
};


const $320337e4f695847d$export$36e704ad7c903a26 = (cacheTestResult, createIndexSizeError)=>{
    return (nativeContext, options)=>{
        const nativeAnalyserNode = nativeContext.createAnalyser();
        // Bug #37: Firefox does not create an AnalyserNode with the default properties.
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeAnalyserNode, options);
        // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
        if (!(options.maxDecibels > options.minDecibels)) throw createIndexSizeError();
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'fftSize');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'maxDecibels');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'minDecibels');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'smoothingTimeConstant');
        // Bug #36: Safari does not support getFloatTimeDomainData() yet.
        if (!cacheTestResult((0, $b60b8bc18debf104$export$1cb15f891b4f5e5e), ()=>(0, $b60b8bc18debf104$export$1cb15f891b4f5e5e)(nativeAnalyserNode))) (0, $a99b796678f8c3c3$export$df32660d042dab2e)(nativeAnalyserNode);
        return nativeAnalyserNode;
    };
};


const $8b8fb3c3b191f477$export$1ddb6a79e564be96 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('AudioBuffer')) return window.AudioBuffer;
    return null;
};


const $693812907b556ae9$export$4778de978774ec4f = (nativeAudioNode, options, audioParam)=>{
    const value = options[audioParam];
    if (value !== undefined && value !== nativeAudioNode[audioParam].value) nativeAudioNode[audioParam].value = value;
};





const $fc0150107fcb98b6$export$6b4321a414ed55c5 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        let isScheduled = false;
        return (when = 0, offset = 0, duration)=>{
            if (isScheduled) throw (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b)();
            start.call(nativeAudioBufferSourceNode, when, offset, duration);
            isScheduled = true;
        };
    })(nativeAudioBufferSourceNode.start);
};


const $3eae80472e147373$export$987b3a4087e6578c = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            if (typeof duration === 'number' && duration < 0 || offset < 0 || when < 0) throw new RangeError("The parameters can't be negative.");
            // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
            start.call(nativeAudioScheduledSourceNode, when, offset, duration);
        };
    })(nativeAudioScheduledSourceNode.start);
};


const $a8862ad76a9ef05e$export$7adf5b1e83aad45 = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        return (when = 0)=>{
            if (when < 0) throw new RangeError("The parameter can't be negative.");
            stop.call(nativeAudioScheduledSourceNode, when);
        };
    })(nativeAudioScheduledSourceNode.stop);
};


const $455e7c248d85054a$export$4f48c993f264b207 = (addSilentConnection, cacheTestResult, testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, testAudioBufferSourceNodeStartMethodOffsetClampingSupport, testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioBufferSourceNodeStartMethodOffsetClampling, wrapAudioBufferSourceNodeStopMethodNullifiedBuffer, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeAudioBufferSourceNode, options);
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeAudioBufferSourceNode, options, 'playbackRate');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'buffer');
        // Bug #149: Safari does not yet support the detune AudioParam.
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'loop');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'loopEnd');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'loopStart');
        // Bug #69: Safari does allow calls to start() of an already scheduled AudioBufferSourceNode.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, ()=>testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport(nativeContext))) (0, $fc0150107fcb98b6$export$6b4321a414ed55c5)(nativeAudioBufferSourceNode);
        // Bug #154 & #155: Safari does not handle offsets which are equal to or greater than the duration of the buffer.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodOffsetClampingSupport, ()=>testAudioBufferSourceNodeStartMethodOffsetClampingSupport(nativeContext))) wrapAudioBufferSourceNodeStartMethodOffsetClampling(nativeAudioBufferSourceNode);
        // Bug #162: Safari does throw an error when stop() is called on an AudioBufferSourceNode which has no buffer assigned to it.
        if (!cacheTestResult(testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, ()=>testAudioBufferSourceNodeStopMethodNullifiedBufferSupport(nativeContext))) wrapAudioBufferSourceNodeStopMethodNullifiedBuffer(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $3eae80472e147373$export$987b3a4087e6578c)(nativeAudioBufferSourceNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $a8862ad76a9ef05e$export$7adf5b1e83aad45)(nativeAudioBufferSourceNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeAudioBufferSourceNode);
        return nativeAudioBufferSourceNode;
    };
};


const $b174c3cd8dc2c9e6$export$3a22fc4046f7b4ec = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('AudioContext')) return window.AudioContext;
    return window.hasOwnProperty('webkitAudioContext') ? window.webkitAudioContext : null;
};


const $7d5d63ea08d09167$export$d3097038f258fce = (createNativeGainNode, overwriteAccessors)=>{
    return (nativeContext, channelCount, isNodeOfNativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeContext.destination;
        // Bug #132: Safari does not have the correct channelCount.
        if (nativeAudioDestinationNode.channelCount !== channelCount) try {
            nativeAudioDestinationNode.channelCount = channelCount;
        } catch  {
        // Bug #169: Safari throws an error on each attempt to change the channelCount.
        }
        // Bug #83: Safari does not have the correct channelCountMode.
        if (isNodeOfNativeOfflineAudioContext && nativeAudioDestinationNode.channelCountMode !== 'explicit') nativeAudioDestinationNode.channelCountMode = 'explicit';
        // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
        if (nativeAudioDestinationNode.maxChannelCount === 0) Object.defineProperty(nativeAudioDestinationNode, 'maxChannelCount', {
            value: channelCount
        });
        // Bug #168: No browser does yet have an AudioDestinationNode with an output.
        const gainNode = createNativeGainNode(nativeContext, {
            channelCount: channelCount,
            channelCountMode: nativeAudioDestinationNode.channelCountMode,
            channelInterpretation: nativeAudioDestinationNode.channelInterpretation,
            gain: 1
        });
        overwriteAccessors(gainNode, 'channelCount', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                try {
                    nativeAudioDestinationNode.channelCount = value;
                } catch (err) {
                    // Bug #169: Safari throws an error on each attempt to change the channelCount.
                    if (value > nativeAudioDestinationNode.maxChannelCount) throw err;
                }
            });
        overwriteAccessors(gainNode, 'channelCountMode', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelCountMode = value;
            });
        overwriteAccessors(gainNode, 'channelInterpretation', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelInterpretation = value;
            });
        Object.defineProperty(gainNode, 'maxChannelCount', {
            get: ()=>nativeAudioDestinationNode.maxChannelCount
        });
        // @todo This should be disconnected when the context is closed.
        gainNode.connect(nativeAudioDestinationNode);
        return gainNode;
    };
};


const $9acbfdce1428f919$export$b0ef4818c07d1453 = (window)=>{
    if (window === null) return null;
    return window.hasOwnProperty('AudioWorkletNode') ? window.AudioWorkletNode : null;
};


const $6517c70090412813$export$8bad4bda0c154746 = (audioWorkletNodeOptions)=>{
    const { port1: port1 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
    }
};


const $bf228dd5f9198c20$export$a6399b47836cd044 = (createInvalidStateError, createNativeAudioWorkletNodeFaker, createNativeGainNode, createNotSupportedError, monitorConnections)=>{
    return (nativeContext, baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, options)=>{
        if (nativeAudioWorkletNodeConstructor !== null) try {
            const nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeContext, name, options);
            const patchedEventListeners = new Map();
            let onprocessorerror = null;
            Object.defineProperties(nativeAudioWorkletNode, {
                /*
                     * Bug #61: Overwriting the property accessors for channelCount and channelCountMode is necessary as long as some
                     * browsers have no native implementation to achieve a consistent behavior.
                     */ channelCount: {
                    get: ()=>options.channelCount,
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                channelCountMode: {
                    get: ()=>'explicit',
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                // Bug #156: Chrome and Edge do not yet fire an ErrorEvent.
                onprocessorerror: {
                    get: ()=>onprocessorerror,
                    set: (value)=>{
                        if (typeof onprocessorerror === 'function') nativeAudioWorkletNode.removeEventListener('processorerror', onprocessorerror);
                        onprocessorerror = typeof value === 'function' ? value : null;
                        if (typeof onprocessorerror === 'function') nativeAudioWorkletNode.addEventListener('processorerror', onprocessorerror);
                    }
                }
            });
            nativeAudioWorkletNode.addEventListener = ((addEventListener)=>{
                return (...args)=>{
                    if (args[0] === 'processorerror') {
                        const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;
                        if (unpatchedEventListener !== null) {
                            const patchedEventListener = patchedEventListeners.get(args[1]);
                            if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                            else {
                                args[1] = (event)=>{
                                    // Bug #178: Chrome and Edge do fire an event of type error.
                                    if (event.type === 'error') {
                                        Object.defineProperties(event, {
                                            type: {
                                                value: 'processorerror'
                                            }
                                        });
                                        unpatchedEventListener(event);
                                    } else unpatchedEventListener(new ErrorEvent(args[0], {
                                        ...event
                                    }));
                                };
                                patchedEventListeners.set(unpatchedEventListener, args[1]);
                            }
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    addEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
                    return addEventListener.call(nativeAudioWorkletNode, ...args);
                };
            })(nativeAudioWorkletNode.addEventListener);
            nativeAudioWorkletNode.removeEventListener = ((removeEventListener)=>{
                return (...args)=>{
                    if (args[0] === 'processorerror') {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) {
                            patchedEventListeners.delete(args[1]);
                            args[1] = patchedEventListener;
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    removeEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
                    return removeEventListener.call(nativeAudioWorkletNode, args[0], args[1], args[2]);
                };
            })(nativeAudioWorkletNode.removeEventListener);
            /*
                 * Bug #86: Chrome and Edge do not invoke the process() function if the corresponding AudioWorkletNode is unconnected but
                 * has an output.
                 */ if (options.numberOfOutputs !== 0) {
                const nativeGainNode = createNativeGainNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    gain: 0
                });
                nativeAudioWorkletNode.connect(nativeGainNode).connect(nativeContext.destination);
                const whenConnected = ()=>nativeGainNode.disconnect();
                const whenDisconnected = ()=>nativeGainNode.connect(nativeContext.destination);
                // @todo Disconnect the connection when the process() function of the AudioWorkletNode returns false.
                return monitorConnections(nativeAudioWorkletNode, whenConnected, whenDisconnected);
            }
            return nativeAudioWorkletNode;
        } catch (err) {
            // Bug #60: Chrome & Edge throw an InvalidStateError instead of a NotSupportedError.
            if (err.code === 11) throw createNotSupportedError();
            throw err;
        }
        // Bug #61: Only Chrome & Edge have an implementation of the AudioWorkletNode yet.
        if (processorConstructor === undefined) throw createNotSupportedError();
        (0, $6517c70090412813$export$8bad4bda0c154746)(options);
        return createNativeAudioWorkletNodeFaker(nativeContext, baseLatency, processorConstructor, options);
    };
};



const $35d5b49b56b5e999$export$c3c4ba87244c2bf4 = (baseLatency, sampleRate)=>{
    if (baseLatency === null) return 512;
    return Math.max(512, Math.min(16384, Math.pow(2, Math.round(Math.log2(baseLatency * sampleRate)))));
};





const $07818de13046c792$export$45f6aa3433a4eb0 = (audioWorkletNodeOptions)=>{
    return new Promise((resolve, reject)=>{
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>{
            port1.close();
            port2.close();
            resolve(data);
        };
        port1.onmessageerror = ({ data: data })=>{
            port1.close();
            port2.close();
            reject(data);
        };
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port2.postMessage(audioWorkletNodeOptions);
    });
};


const $b62b5aa2415b2cf0$export$62410a657c3adf1d = async (processorConstructor, audioWorkletNodeOptions)=>{
    const clonedAudioWorkletNodeOptions = await (0, $07818de13046c792$export$45f6aa3433a4eb0)(audioWorkletNodeOptions);
    return new processorConstructor(clonedAudioWorkletNodeOptions);
};


const $8883960b9b7c3064$export$5200a42feb14a7b7 = (nativeContext, nativeAudioWorkletNode, processorConstructor, audioWorkletNodeOptions)=>{
    let nodeToProcessorMap = (0, $063560d8523a7eb5$export$16d7878f7e059d67).get(nativeContext);
    if (nodeToProcessorMap === undefined) {
        nodeToProcessorMap = new WeakMap();
        (0, $063560d8523a7eb5$export$16d7878f7e059d67).set(nativeContext, nodeToProcessorMap);
    }
    const audioWorkletProcessorPromise = (0, $b62b5aa2415b2cf0$export$62410a657c3adf1d)(processorConstructor, audioWorkletNodeOptions);
    nodeToProcessorMap.set(nativeAudioWorkletNode, audioWorkletProcessorPromise);
    return audioWorkletProcessorPromise;
};




const $2e8d1870505b948b$export$ea40f9f600f0adcb = (connectMultipleOutputs, createIndexSizeError, createInvalidStateError, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, createNativeScriptProcessorNode, createNotSupportedError, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getActiveAudioWorkletNodeInputs, monitorConnections)=>{
    return (nativeContext, baseLatency, processorConstructor, options)=>{
        if (options.numberOfInputs === 0 && options.numberOfOutputs === 0) throw createNotSupportedError();
        const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
        // @todo Check if any of the channelCount values is greater than the implementation's maximum number of channels.
        if (outputChannelCount.some((channelCount)=>channelCount < 1)) throw createNotSupportedError();
        if (outputChannelCount.length !== options.numberOfOutputs) throw createIndexSizeError();
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (options.channelCountMode !== 'explicit') throw createNotSupportedError();
        const numberOfInputChannels = options.channelCount * options.numberOfInputs;
        const numberOfOutputChannels = outputChannelCount.reduce((sum, value1)=>sum + value1, 0);
        const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (numberOfInputChannels + numberOfParameters > 6 || numberOfOutputChannels > 6) throw createNotSupportedError();
        const messageChannel = new MessageChannel();
        const gainNodes = [];
        const inputChannelSplitterNodes = [];
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes.push(createNativeGainNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: options.channelCountMode,
                channelInterpretation: options.channelInterpretation,
                gain: 1
            }));
            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                numberOfOutputs: options.channelCount
            }));
        }
        const constantSourceNodes = [];
        if (processorConstructor.parameterDescriptors !== undefined) for (const { defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, name: name } of processorConstructor.parameterDescriptors){
            const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                offset: options.parameterData[name] !== undefined ? options.parameterData[name] : defaultValue === undefined ? 0 : defaultValue
            });
            Object.defineProperties(constantSourceNode.offset, {
                defaultValue: {
                    get: ()=>defaultValue === undefined ? 0 : defaultValue
                },
                maxValue: {
                    get: ()=>maxValue === undefined ? (0, $109263ef7a828de3$export$ab43bedd17d6a167) : maxValue
                },
                minValue: {
                    get: ()=>minValue === undefined ? (0, $109263ef7a828de3$export$ced6a5c63b103b52) : minValue
                }
            });
            constantSourceNodes.push(constantSourceNode);
        }
        const inputChannelMergerNode = createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'speakers',
            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
        });
        const bufferSize = (0, $35d5b49b56b5e999$export$c3c4ba87244c2bf4)(baseLatency, nativeContext.sampleRate);
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, numberOfInputChannels + numberOfParameters, // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        Math.max(1, numberOfOutputChannels));
        const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: Math.max(1, numberOfOutputChannels),
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            numberOfOutputs: Math.max(1, numberOfOutputChannels)
        });
        const outputChannelMergerNodes = [];
        for(let i = 0; i < options.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'speakers',
            numberOfInputs: outputChannelCount[i]
        }));
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes[i].connect(inputChannelSplitterNodes[i]);
            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
        }
        const parameterMap = new (0, $ab3dc1f1bca26f43$export$5da0cf80a3ca75d6)(processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.map(({ name: name }, index)=>{
            const constantSourceNode = constantSourceNodes[index];
            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
            constantSourceNode.start(0);
            return [
                name,
                constantSourceNode.offset
            ];
        }));
        inputChannelMergerNode.connect(scriptProcessorNode);
        let channelInterpretation = options.channelInterpretation;
        let onprocessorerror = null;
        // Bug #87: Expose at least one output to make this node connectable.
        const outputAudioNodes = options.numberOfOutputs === 0 ? [
            scriptProcessorNode
        ] : outputChannelMergerNodes;
        const nativeAudioWorkletNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return options.channelCount;
            },
            set channelCount (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelCountMode () {
                return options.channelCountMode;
            },
            set channelCountMode (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelInterpretation () {
                return channelInterpretation;
            },
            set channelInterpretation (value){
                for (const gainNode of gainNodes)gainNode.channelInterpretation = value;
                channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return gainNodes;
            },
            get numberOfInputs () {
                return options.numberOfInputs;
            },
            get numberOfOutputs () {
                return options.numberOfOutputs;
            },
            get onprocessorerror () {
                return onprocessorerror;
            },
            set onprocessorerror (value){
                if (typeof onprocessorerror === 'function') nativeAudioWorkletNodeFaker.removeEventListener('processorerror', onprocessorerror);
                onprocessorerror = typeof value === 'function' ? value : null;
                if (typeof onprocessorerror === 'function') nativeAudioWorkletNodeFaker.addEventListener('processorerror', onprocessorerror);
            },
            get parameters () {
                return parameterMap;
            },
            get port () {
                return messageChannel.port2;
            },
            addEventListener (...args) {
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            connect: connectMultipleOutputs.bind(null, outputAudioNodes),
            disconnect: disconnectMultipleOutputs.bind(null, outputAudioNodes),
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        const patchedEventListeners = new Map();
        messageChannel.port1.addEventListener = ((addEventListener)=>{
            return (...args)=>{
                if (args[0] === 'message') {
                    const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;
                    if (unpatchedEventListener !== null) {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                        else {
                            args[1] = (event)=>{
                                exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>unpatchedEventListener(event));
                            };
                            patchedEventListeners.set(unpatchedEventListener, args[1]);
                        }
                    }
                }
                return addEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.addEventListener);
        messageChannel.port1.removeEventListener = ((removeEventListener)=>{
            return (...args)=>{
                if (args[0] === 'message') {
                    const patchedEventListener = patchedEventListeners.get(args[1]);
                    if (patchedEventListener !== undefined) {
                        patchedEventListeners.delete(args[1]);
                        args[1] = patchedEventListener;
                    }
                }
                return removeEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.removeEventListener);
        let onmessage = null;
        Object.defineProperty(messageChannel.port1, 'onmessage', {
            get: ()=>onmessage,
            set: (value1)=>{
                if (typeof onmessage === 'function') messageChannel.port1.removeEventListener('message', onmessage);
                onmessage = typeof value1 === 'function' ? value1 : null;
                if (typeof onmessage === 'function') {
                    messageChannel.port1.addEventListener('message', onmessage);
                    messageChannel.port1.start();
                }
            }
        });
        processorConstructor.prototype.port = messageChannel.port1;
        let audioWorkletProcessor = null;
        const audioWorkletProcessorPromise = (0, $8883960b9b7c3064$export$5200a42feb14a7b7)(nativeContext, nativeAudioWorkletNodeFaker, processorConstructor, options);
        audioWorkletProcessorPromise.then((dWrkltPrcssr)=>audioWorkletProcessor = dWrkltPrcssr);
        const inputs = (0, $bd65332d5b5b21dd$export$495a31436d188d6d)(options.numberOfInputs, options.channelCount);
        const outputs = (0, $bd65332d5b5b21dd$export$495a31436d188d6d)(options.numberOfOutputs, outputChannelCount);
        const parameters = processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.reduce((prmtrs, { name: name })=>({
                ...prmtrs,
                [name]: new Float32Array(128)
            }), {});
        let isActive = true;
        const disconnectOutputsGraph = ()=>{
            if (options.numberOfOutputs > 0) scriptProcessorNode.disconnect(outputChannelSplitterNode);
            for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                const outputChannelMergerNode = outputChannelMergerNodes[i];
                for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.disconnect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                outputChannelSplitterNodeOutput += outputChannelCount[i];
            }
        };
        const activeInputIndexes = new Map();
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer, outputBuffer: outputBuffer })=>{
            if (audioWorkletProcessor !== null) {
                const activeInputs = getActiveAudioWorkletNodeInputs(nativeAudioWorkletNodeFaker);
                for(let i = 0; i < bufferSize; i += 128){
                    for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $73892a6a2256b990$export$e3c6e435bf217093)(inputBuffer, inputs[j], k, k, i);
                    if (processorConstructor.parameterDescriptors !== undefined) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
                        (0, $73892a6a2256b990$export$e3c6e435bf217093)(inputBuffer, parameters, name, numberOfInputChannels + index, i);
                    });
                    for(let j = 0; j < options.numberOfInputs; j += 1){
                        for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
                        if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
                    }
                    try {
                        const potentiallyEmptyInputs = inputs.map((input, index)=>{
                            const activeInput = activeInputs[index];
                            if (activeInput.size > 0) {
                                activeInputIndexes.set(index, bufferSize / 128);
                                return input;
                            }
                            const count = activeInputIndexes.get(index);
                            if (count === undefined) return [];
                            if (input.every((channelData)=>channelData.every((sample)=>sample === 0))) {
                                if (count === 1) activeInputIndexes.delete(index);
                                else activeInputIndexes.set(index, count - 1);
                            }
                            return input;
                        });
                        const activeSourceFlag = exposeCurrentFrameAndCurrentTime(nativeContext.currentTime + i / nativeContext.sampleRate, nativeContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
                        isActive = activeSourceFlag;
                        for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                            for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $13ff1980ed86128e$export$6bb6d131144bd753)(outputBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                            outputChannelSplitterNodeOutput += outputChannelCount[j];
                        }
                    } catch (error) {
                        isActive = false;
                        nativeAudioWorkletNodeFaker.dispatchEvent(new ErrorEvent('processorerror', {
                            colno: error.colno,
                            filename: error.filename,
                            lineno: error.lineno,
                            message: error.message
                        }));
                    }
                    if (!isActive) {
                        for(let j = 0; j < options.numberOfInputs; j += 1){
                            gainNodes[j].disconnect(inputChannelSplitterNodes[j]);
                            for(let k = 0; k < options.channelCount; k += 1)inputChannelSplitterNodes[i].disconnect(inputChannelMergerNode, k, j * options.channelCount + k);
                        }
                        if (processorConstructor.parameterDescriptors !== undefined) {
                            const length = processorConstructor.parameterDescriptors.length;
                            for(let j = 0; j < length; j += 1){
                                const constantSourceNode = constantSourceNodes[j];
                                constantSourceNode.disconnect(inputChannelMergerNode, 0, numberOfInputChannels + j);
                                constantSourceNode.stop();
                            }
                        }
                        inputChannelMergerNode.disconnect(scriptProcessorNode);
                        scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                        if (isConnected) disconnectOutputsGraph();
                        else disconnectFakeGraph();
                        break;
                    }
                }
            }
        };
        let isConnected = false;
        // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        const connectFakeGraph = ()=>scriptProcessorNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnectFakeGraph = ()=>{
            scriptProcessorNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        const whenConnected = ()=>{
            if (isActive) {
                disconnectFakeGraph();
                if (options.numberOfOutputs > 0) scriptProcessorNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
            }
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            if (isActive) {
                connectFakeGraph();
                disconnectOutputsGraph();
            }
            isConnected = false;
        };
        connectFakeGraph();
        return monitorConnections(nativeAudioWorkletNodeFaker, whenConnected, whenDisconnected);
    };
};





const $4c7d1977ac981af8$export$97e69c8dbd260f85 = (nativeContext, options)=>{
    const nativeBiquadFilterNode = nativeContext.createBiquadFilter();
    (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeBiquadFilterNode, options);
    (0, $693812907b556ae9$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'Q');
    (0, $693812907b556ae9$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'detune');
    (0, $693812907b556ae9$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'frequency');
    (0, $693812907b556ae9$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'gain');
    (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeBiquadFilterNode, options, 'type');
    return nativeBiquadFilterNode;
};



const $7e677dc375016540$export$99fe194415d94151 = (nativeAudioContextConstructor, wrapChannelMergerNode)=>{
    return (nativeContext, options)=>{
        const nativeChannelMergerNode = nativeContext.createChannelMerger(options.numberOfInputs);
        /*
         * Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') wrapChannelMergerNode(nativeContext, nativeChannelMergerNode);
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeChannelMergerNode, options);
        return nativeChannelMergerNode;
    };
};




const $5ff68dd2474e6634$export$62f6b3ab91fa4589 = (channelSplitterNode)=>{
    const channelCount = channelSplitterNode.numberOfOutputs;
    // Bug #97: Safari does not throw an error when attempting to change the channelCount to something other than its initial value.
    Object.defineProperty(channelSplitterNode, 'channelCount', {
        get: ()=>channelCount,
        set: (value)=>{
            if (value !== channelCount) throw (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b)();
        }
    });
    // Bug #30: Safari does not throw an error when attempting to change the channelCountMode to something other than explicit.
    Object.defineProperty(channelSplitterNode, 'channelCountMode', {
        get: ()=>'explicit',
        set: (value)=>{
            if (value !== 'explicit') throw (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b)();
        }
    });
    // Bug #32: Safari does not throw an error when attempting to change the channelInterpretation to something other than discrete.
    Object.defineProperty(channelSplitterNode, 'channelInterpretation', {
        get: ()=>'discrete',
        set: (value)=>{
            if (value !== 'discrete') throw (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b)();
        }
    });
};


const $eb6e154d4211f7ae$export$17649533bf213707 = (nativeContext, options)=>{
    const nativeChannelSplitterNode = nativeContext.createChannelSplitter(options.numberOfOutputs);
    // Bug #96: Safari does not have the correct channelCount.
    // Bug #29: Safari does not have the correct channelCountMode.
    // Bug #31: Safari does not have the correct channelInterpretation.
    (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeChannelSplitterNode, options);
    // Bug #29, #30, #31, #32, #96 & #97: Only Chrome, Edge & Firefox partially support the spec yet.
    (0, $5ff68dd2474e6634$export$62f6b3ab91fa4589)(nativeChannelSplitterNode);
    return nativeChannelSplitterNode;
};






const $27cb740f471b1f49$export$2dd44f7bb3dd8089 = (addSilentConnection, cacheTestResult, createNativeConstantSourceNodeFaker, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport)=>{
    return (nativeContext, options)=>{
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeContext.createConstantSource === undefined) return createNativeConstantSourceNodeFaker(nativeContext, options);
        const nativeConstantSourceNode = nativeContext.createConstantSource();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeConstantSourceNode, options);
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeConstantSourceNode, options, 'offset');
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $3eae80472e147373$export$987b3a4087e6578c)(nativeConstantSourceNode);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $a8862ad76a9ef05e$export$7adf5b1e83aad45)(nativeConstantSourceNode);
        // Bug #175: Safari will not fire an ended event if the ConstantSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeConstantSourceNode);
        return nativeConstantSourceNode;
    };
};


const $900bfd37a2c1e10d$export$19c8a106f82dff14 = (original, interceptor)=>{
    original.connect = interceptor.connect.bind(interceptor);
    original.disconnect = interceptor.disconnect.bind(interceptor);
    return original;
};


const $fa4d351520187cd9$export$360749cf3d02285a = (addSilentConnection, createNativeAudioBufferSourceNode, createNativeGainNode, monitorConnections)=>{
    return (nativeContext, { offset: offset, ...audioNodeOptions })=>{
        const audioBuffer = nativeContext.createBuffer(1, 2, 44100);
        const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: 'max',
            channelInterpretation: 'speakers',
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const gainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: offset
        });
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        const channelData = audioBuffer.getChannelData(0);
        // Bug #95: Safari does not play or loop one sample buffers.
        channelData[0] = 1;
        channelData[1] = 1;
        audioBufferSourceNode.buffer = audioBuffer;
        audioBufferSourceNode.loop = true;
        const nativeConstantSourceNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return gainNode.channelCount;
            },
            set channelCount (value){
                gainNode.channelCount = value;
            },
            get channelCountMode () {
                return gainNode.channelCountMode;
            },
            set channelCountMode (value){
                gainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return gainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                gainNode.channelInterpretation = value;
            },
            get context () {
                return gainNode.context;
            },
            get inputs () {
                return [];
            },
            get numberOfInputs () {
                return audioBufferSourceNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return gainNode.numberOfOutputs;
            },
            get offset () {
                return gainNode.gain;
            },
            get onended () {
                return audioBufferSourceNode.onended;
            },
            set onended (value){
                audioBufferSourceNode.onended = value;
            },
            addEventListener (...args) {
                return audioBufferSourceNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return audioBufferSourceNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return audioBufferSourceNode.removeEventListener(args[0], args[1], args[2]);
            },
            start (when = 0) {
                audioBufferSourceNode.start.call(audioBufferSourceNode, when);
            },
            stop (when = 0) {
                audioBufferSourceNode.stop.call(audioBufferSourceNode, when);
            }
        };
        const whenConnected = ()=>audioBufferSourceNode.connect(gainNode);
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(gainNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, audioBufferSourceNode);
        return monitorConnections((0, $900bfd37a2c1e10d$export$19c8a106f82dff14)(nativeConstantSourceNodeFaker, gainNode), whenConnected, whenDisconnected);
    };
};




const $f8c85b2d5c748d5a$export$afdcf89d13ff62e = (createNotSupportedError, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeConvolverNode = nativeContext.createConvolver();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeConvolverNode, options);
        // The normalize property needs to be set before setting the buffer.
        if (options.disableNormalization === nativeConvolverNode.normalize) nativeConvolverNode.normalize = !options.disableNormalization;
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeConvolverNode, options, 'buffer');
        // Bug #113: Safari does allow to set the channelCount to a value larger than 2.
        if (options.channelCount > 2) throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, 'channelCount', (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value > 2) throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        // Bug #114: Safari allows to set the channelCountMode to 'max'.
        if (options.channelCountMode === 'max') throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, 'channelCountMode', (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value === 'max') throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        return nativeConvolverNode;
    };
};




const $044670cab61f9ad3$export$f7dd6d407a2109ef = (nativeContext, options)=>{
    const nativeDelayNode = nativeContext.createDelay(options.maxDelayTime);
    (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeDelayNode, options);
    (0, $693812907b556ae9$export$4778de978774ec4f)(nativeDelayNode, options, 'delayTime');
    return nativeDelayNode;
};




const $2ab5f70826dc282d$export$f19d90a0cd4a2ecc = (createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const nativeDynamicsCompressorNode = nativeContext.createDynamicsCompressor();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeDynamicsCompressorNode, options);
        // Bug #108: Safari allows a channelCount of three and above.
        if (options.channelCount > 2) throw createNotSupportedError();
        // Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max'.
        if (options.channelCountMode === 'max') throw createNotSupportedError();
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'attack');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'knee');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'ratio');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'release');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'threshold');
        return nativeDynamicsCompressorNode;
    };
};




const $3965703d51935300$export$7cf909169b9c4d6f = (nativeContext, options)=>{
    const nativeGainNode = nativeContext.createGain();
    (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeGainNode, options);
    (0, $693812907b556ae9$export$4778de978774ec4f)(nativeGainNode, options, 'gain');
    return nativeGainNode;
};



const $b2bc07259451fc8c$export$3c1aed24ed6efd9d = (createNativeIIRFilterNodeFaker)=>{
    return (nativeContext, baseLatency, options)=>{
        // Bug #9: Safari does not support IIRFilterNodes.
        if (nativeContext.createIIRFilter === undefined) return createNativeIIRFilterNodeFaker(nativeContext, baseLatency, options);
        // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
        const nativeIIRFilterNode = nativeContext.createIIRFilter(options.feedforward, options.feedback);
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeIIRFilterNode, options);
        return nativeIIRFilterNode;
    };
};





function $de8dfc2add5cb231$var$divide(a, b) {
    const denominator = b[0] * b[0] + b[1] * b[1];
    return [
        (a[0] * b[0] + a[1] * b[1]) / denominator,
        (a[1] * b[0] - a[0] * b[1]) / denominator
    ];
}
function $de8dfc2add5cb231$var$multiply(a, b) {
    return [
        a[0] * b[0] - a[1] * b[1],
        a[0] * b[1] + a[1] * b[0]
    ];
}
function $de8dfc2add5cb231$var$evaluatePolynomial(coefficient, z) {
    let result = [
        0,
        0
    ];
    for(let i = coefficient.length - 1; i >= 0; i -= 1){
        result = $de8dfc2add5cb231$var$multiply(result, z);
        result[0] += coefficient[i];
    }
    return result;
}
const $de8dfc2add5cb231$export$49dca6a724f463b = (createInvalidAccessError, createInvalidStateError, createNativeScriptProcessorNode, createNotSupportedError)=>{
    return (nativeContext, baseLatency, { channelCount: channelCount, channelCountMode: channelCountMode, channelInterpretation: channelInterpretation, feedback: feedback, feedforward: feedforward })=>{
        const bufferSize = (0, $35d5b49b56b5e999$export$c3c4ba87244c2bf4)(baseLatency, nativeContext.sampleRate);
        const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
        const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
        const feedbackLength = convertedFeedback.length;
        const feedforwardLength = convertedFeedforward.length;
        const minLength = Math.min(feedbackLength, feedforwardLength);
        if (feedbackLength === 0 || feedbackLength > 20) throw createNotSupportedError();
        if (convertedFeedback[0] === 0) throw createInvalidStateError();
        if (feedforwardLength === 0 || feedforwardLength > 20) throw createNotSupportedError();
        if (convertedFeedforward[0] === 0) throw createInvalidStateError();
        if (convertedFeedback[0] !== 1) {
            for(let i = 0; i < feedforwardLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
            for(let i = 1; i < feedbackLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
        }
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, channelCount, channelCount);
        scriptProcessorNode.channelCount = channelCount;
        scriptProcessorNode.channelCountMode = channelCountMode;
        scriptProcessorNode.channelInterpretation = channelInterpretation;
        const bufferLength = 32;
        const bufferIndexes = [];
        const xBuffers = [];
        const yBuffers = [];
        for(let i = 0; i < channelCount; i += 1){
            bufferIndexes.push(0);
            const xBuffer = new Float32Array(bufferLength);
            const yBuffer = new Float32Array(bufferLength);
            xBuffer.fill(0);
            yBuffer.fill(0);
            xBuffers.push(xBuffer);
            yBuffers.push(yBuffer);
        }
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = (event)=>{
            const inputBuffer = event.inputBuffer;
            const outputBuffer = event.outputBuffer;
            const numberOfChannels = inputBuffer.numberOfChannels;
            for(let i = 0; i < numberOfChannels; i += 1){
                const input = inputBuffer.getChannelData(i);
                const output = outputBuffer.getChannelData(i);
                bufferIndexes[i] = (0, $cb3893968b11ac5e$export$7fa1177e7d2178dd)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffers[i], yBuffers[i], bufferIndexes[i], bufferLength, input, output);
            }
        };
        const nyquist = nativeContext.sampleRate / 2;
        const nativeIIRFilterNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return scriptProcessorNode.channelCount;
            },
            set channelCount (value){
                scriptProcessorNode.channelCount = value;
            },
            get channelCountMode () {
                return scriptProcessorNode.channelCountMode;
            },
            set channelCountMode (value){
                scriptProcessorNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return scriptProcessorNode.channelInterpretation;
            },
            set channelInterpretation (value){
                scriptProcessorNode.channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return [
                    scriptProcessorNode
                ];
            },
            get numberOfInputs () {
                return scriptProcessorNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return scriptProcessorNode.numberOfOutputs;
            },
            addEventListener (...args) {
                // @todo Dissallow adding an audioprocess listener.
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            getFrequencyResponse (frequencyHz, magResponse, phaseResponse) {
                if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
                const length = frequencyHz.length;
                for(let i = 0; i < length; i += 1){
                    const omega = -Math.PI * (frequencyHz[i] / nyquist);
                    const z = [
                        Math.cos(omega),
                        Math.sin(omega)
                    ];
                    const numerator = $de8dfc2add5cb231$var$evaluatePolynomial(convertedFeedforward, z);
                    const denominator = $de8dfc2add5cb231$var$evaluatePolynomial(convertedFeedback, z);
                    const response = $de8dfc2add5cb231$var$divide(numerator, denominator);
                    magResponse[i] = Math.sqrt(response[0] * response[0] + response[1] * response[1]);
                    phaseResponse[i] = Math.atan2(response[1], response[0]);
                }
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        return (0, $900bfd37a2c1e10d$export$19c8a106f82dff14)(nativeIIRFilterNodeFaker, scriptProcessorNode);
    };
};


const $52cabc1aa66bc20e$export$2b1682bf41b4d16b = (nativeAudioContext, options)=>{
    return nativeAudioContext.createMediaElementSource(options.mediaElement);
};



const $7f6a69fc18439af4$export$acb51039efa3405d = (nativeAudioContext, options)=>{
    const nativeMediaStreamAudioDestinationNode = nativeAudioContext.createMediaStreamDestination();
    (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeMediaStreamAudioDestinationNode, options);
    // Bug #174: Safari does expose a wrong numberOfOutputs.
    if (nativeMediaStreamAudioDestinationNode.numberOfOutputs === 1) Object.defineProperty(nativeMediaStreamAudioDestinationNode, 'numberOfOutputs', {
        get: ()=>0
    });
    return nativeMediaStreamAudioDestinationNode;
};


const $bef6c01fc83a8f84$export$ad3e497ef44fc577 = (nativeAudioContext, { mediaStream: mediaStream })=>{
    const audioStreamTracks = mediaStream.getAudioTracks();
    /*
     * Bug #151: Safari does not use the audio track as input anymore if it gets removed from the mediaStream after construction.
     * Bug #159: Safari picks the first audio track if the MediaStream has more than one audio track.
     */ audioStreamTracks.sort((a, b)=>a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
    const filteredAudioStreamTracks = audioStreamTracks.slice(0, 1);
    const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(new MediaStream(filteredAudioStreamTracks));
    /*
     * Bug #151 & #159: The given mediaStream gets reconstructed before it gets passed to the native node which is why the accessor needs
     * to be overwritten as it would otherwise expose the reconstructed version.
     */ Object.defineProperty(nativeMediaStreamAudioSourceNode, 'mediaStream', {
        value: mediaStream
    });
    return nativeMediaStreamAudioSourceNode;
};


const $572b286451ff8a1d$export$87e46bc6eb8ed6ac = (createInvalidStateError, isNativeOfflineAudioContext)=>{
    return (nativeAudioContext, { mediaStreamTrack: mediaStreamTrack })=>{
        // Bug #121: Only Firefox does yet support the MediaStreamTrackAudioSourceNode.
        if (typeof nativeAudioContext.createMediaStreamTrackSource === 'function') return nativeAudioContext.createMediaStreamTrackSource(mediaStreamTrack);
        const mediaStream = new MediaStream([
            mediaStreamTrack
        ]);
        const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(mediaStream);
        // Bug #120: Firefox does not throw an error if the mediaStream has no audio track.
        if (mediaStreamTrack.kind !== 'audio') throw createInvalidStateError();
        // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
        if (isNativeOfflineAudioContext(nativeAudioContext)) throw new TypeError();
        return nativeMediaStreamAudioSourceNode;
    };
};


const $b808050287dcf7fe$export$e628a2a5fd5b78b9 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('OfflineAudioContext')) return window.OfflineAudioContext;
    return window.hasOwnProperty('webkitOfflineAudioContext') ? window.webkitOfflineAudioContext : null;
};







const $9d9c4636eb90f334$export$a40e02c218ae01d3 = (addSilentConnection, cacheTestResult, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeOscillatorNode = nativeContext.createOscillator();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeOscillatorNode, options);
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeOscillatorNode, options, 'detune');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeOscillatorNode, options, 'frequency');
        if (options.periodicWave !== undefined) nativeOscillatorNode.setPeriodicWave(options.periodicWave);
        else (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeOscillatorNode, options, 'type');
        // Bug #44: Only Chrome & Edge throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $3eae80472e147373$export$987b3a4087e6578c)(nativeOscillatorNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeOscillatorNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $a8862ad76a9ef05e$export$7adf5b1e83aad45)(nativeOscillatorNode);
        // Bug #175: Safari will not fire an ended event if the OscillatorNode is unconnected.
        addSilentConnection(nativeContext, nativeOscillatorNode);
        return nativeOscillatorNode;
    };
};





const $bcbbd7243a1d01e6$export$8e3c89af72a58833 = (createNativePannerNodeFaker)=>{
    return (nativeContext, options)=>{
        const nativePannerNode = nativeContext.createPanner();
        // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
        if (nativePannerNode.orientationX === undefined) return createNativePannerNodeFaker(nativeContext, options);
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativePannerNode, options);
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativePannerNode, options, 'orientationX');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativePannerNode, options, 'orientationY');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativePannerNode, options, 'orientationZ');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativePannerNode, options, 'positionX');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativePannerNode, options, 'positionY');
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativePannerNode, options, 'positionZ');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'coneInnerAngle');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'coneOuterAngle');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'coneOuterGain');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'distanceModel');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'maxDistance');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'panningModel');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'refDistance');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativePannerNode, options, 'rolloffFactor');
        return nativePannerNode;
    };
};




const $bf1f8e186f9f5924$export$f04468477689c1b4 = (connectNativeAudioNodeToNativeAudioNode, createInvalidStateError, createNativeChannelMergerNode, createNativeGainNode, createNativeScriptProcessorNode, createNativeWaveShaperNode, createNotSupportedError, disconnectNativeAudioNodeFromNativeAudioNode, getFirstSample, monitorConnections)=>{
    return (nativeContext, { coneInnerAngle: coneInnerAngle, coneOuterAngle: coneOuterAngle, coneOuterGain: coneOuterGain, distanceModel: distanceModel, maxDistance: maxDistance, orientationX: orientationX, orientationY: orientationY, orientationZ: orientationZ, panningModel: panningModel, positionX: positionX, positionY: positionY, positionZ: positionZ, refDistance: refDistance, rolloffFactor: rolloffFactor, ...audioNodeOptions })=>{
        const pannerNode = nativeContext.createPanner();
        // Bug #125: Safari does not throw an error yet.
        if (audioNodeOptions.channelCount > 2) throw createNotSupportedError();
        // Bug #126: Safari does not throw an error yet.
        if (audioNodeOptions.channelCountMode === 'max') throw createNotSupportedError();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(pannerNode, audioNodeOptions);
        const SINGLE_CHANNEL_OPTIONS = {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete'
        };
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            channelInterpretation: 'speakers',
            numberOfInputs: 6
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const orientationXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 1
        });
        const orientationYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const orientationZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 6, 1);
        const waveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            curve: new Float32Array([
                1,
                1
            ]),
            oversample: 'none'
        });
        let lastOrientation = [
            orientationX,
            orientationY,
            orientationZ
        ];
        let lastPosition = [
            positionX,
            positionY,
            positionZ
        ];
        const buffer = new Float32Array(1);
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
            const orientation = [
                getFirstSample(inputBuffer, buffer, 0),
                getFirstSample(inputBuffer, buffer, 1),
                getFirstSample(inputBuffer, buffer, 2)
            ];
            if (orientation.some((value1, index)=>value1 !== lastOrientation[index])) {
                pannerNode.setOrientation(...orientation); // tslint:disable-line:deprecation
                lastOrientation = orientation;
            }
            const positon = [
                getFirstSample(inputBuffer, buffer, 3),
                getFirstSample(inputBuffer, buffer, 4),
                getFirstSample(inputBuffer, buffer, 5)
            ];
            if (positon.some((value1, index)=>value1 !== lastPosition[index])) {
                pannerNode.setPosition(...positon); // tslint:disable-line:deprecation
                lastPosition = positon;
            }
        };
        Object.defineProperty(orientationYGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(orientationZGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionXGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionYGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionZGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        const nativePannerNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return pannerNode.channelCount;
            },
            set channelCount (value){
                // Bug #125: Safari does not throw an error yet.
                if (value > 2) throw createNotSupportedError();
                inputGainNode.channelCount = value;
                pannerNode.channelCount = value;
            },
            get channelCountMode () {
                return pannerNode.channelCountMode;
            },
            set channelCountMode (value){
                // Bug #126: Safari does not throw an error yet.
                if (value === 'max') throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
                pannerNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return pannerNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                pannerNode.channelInterpretation = value;
            },
            get coneInnerAngle () {
                return pannerNode.coneInnerAngle;
            },
            set coneInnerAngle (value){
                pannerNode.coneInnerAngle = value;
            },
            get coneOuterAngle () {
                return pannerNode.coneOuterAngle;
            },
            set coneOuterAngle (value){
                pannerNode.coneOuterAngle = value;
            },
            get coneOuterGain () {
                return pannerNode.coneOuterGain;
            },
            set coneOuterGain (value){
                // Bug #127: Safari does not throw an InvalidStateError yet.
                if (value < 0 || value > 1) throw createInvalidStateError();
                pannerNode.coneOuterGain = value;
            },
            get context () {
                return pannerNode.context;
            },
            get distanceModel () {
                return pannerNode.distanceModel;
            },
            set distanceModel (value){
                pannerNode.distanceModel = value;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get maxDistance () {
                return pannerNode.maxDistance;
            },
            set maxDistance (value){
                // Bug #128: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.maxDistance = value;
            },
            get numberOfInputs () {
                return pannerNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return pannerNode.numberOfOutputs;
            },
            get orientationX () {
                return orientationXGainNode.gain;
            },
            get orientationY () {
                return orientationYGainNode.gain;
            },
            get orientationZ () {
                return orientationZGainNode.gain;
            },
            get panningModel () {
                return pannerNode.panningModel;
            },
            set panningModel (value){
                pannerNode.panningModel = value;
            },
            get positionX () {
                return positionXGainNode.gain;
            },
            get positionY () {
                return positionYGainNode.gain;
            },
            get positionZ () {
                return positionZGainNode.gain;
            },
            get refDistance () {
                return pannerNode.refDistance;
            },
            set refDistance (value){
                // Bug #129: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.refDistance = value;
            },
            get rolloffFactor () {
                return pannerNode.rolloffFactor;
            },
            set rolloffFactor (value){
                // Bug #130: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.rolloffFactor = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (coneInnerAngle !== nativePannerNodeFaker.coneInnerAngle) nativePannerNodeFaker.coneInnerAngle = coneInnerAngle;
        if (coneOuterAngle !== nativePannerNodeFaker.coneOuterAngle) nativePannerNodeFaker.coneOuterAngle = coneOuterAngle;
        if (coneOuterGain !== nativePannerNodeFaker.coneOuterGain) nativePannerNodeFaker.coneOuterGain = coneOuterGain;
        if (distanceModel !== nativePannerNodeFaker.distanceModel) nativePannerNodeFaker.distanceModel = distanceModel;
        if (maxDistance !== nativePannerNodeFaker.maxDistance) nativePannerNodeFaker.maxDistance = maxDistance;
        if (orientationX !== nativePannerNodeFaker.orientationX.value) nativePannerNodeFaker.orientationX.value = orientationX;
        if (orientationY !== nativePannerNodeFaker.orientationY.value) nativePannerNodeFaker.orientationY.value = orientationY;
        if (orientationZ !== nativePannerNodeFaker.orientationZ.value) nativePannerNodeFaker.orientationZ.value = orientationZ;
        if (panningModel !== nativePannerNodeFaker.panningModel) nativePannerNodeFaker.panningModel = panningModel;
        if (positionX !== nativePannerNodeFaker.positionX.value) nativePannerNodeFaker.positionX.value = positionX;
        if (positionY !== nativePannerNodeFaker.positionY.value) nativePannerNodeFaker.positionY.value = positionY;
        if (positionZ !== nativePannerNodeFaker.positionZ.value) nativePannerNodeFaker.positionZ.value = positionZ;
        if (refDistance !== nativePannerNodeFaker.refDistance) nativePannerNodeFaker.refDistance = refDistance;
        if (rolloffFactor !== nativePannerNodeFaker.rolloffFactor) nativePannerNodeFaker.rolloffFactor = rolloffFactor;
        if (lastOrientation[0] !== 1 || lastOrientation[1] !== 0 || lastOrientation[2] !== 0) pannerNode.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
        if (lastPosition[0] !== 0 || lastPosition[1] !== 0 || lastPosition[2] !== 0) pannerNode.setPosition(...lastPosition); // tslint:disable-line:deprecation
        const whenConnected = ()=>{
            inputGainNode.connect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            connectNativeAudioNodeToNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.connect(orientationXGainNode).connect(channelMergerNode, 0, 0);
            waveShaperNode.connect(orientationYGainNode).connect(channelMergerNode, 0, 1);
            waveShaperNode.connect(orientationZGainNode).connect(channelMergerNode, 0, 2);
            waveShaperNode.connect(positionXGainNode).connect(channelMergerNode, 0, 3);
            waveShaperNode.connect(positionYGainNode).connect(channelMergerNode, 0, 4);
            waveShaperNode.connect(positionZGainNode).connect(channelMergerNode, 0, 5);
            channelMergerNode.connect(scriptProcessorNode).connect(nativeContext.destination);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            disconnectNativeAudioNodeFromNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.disconnect(orientationXGainNode);
            orientationXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationYGainNode);
            orientationYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationZGainNode);
            orientationZGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionXGainNode);
            positionXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionYGainNode);
            positionYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionZGainNode);
            positionZGainNode.disconnect(channelMergerNode);
            channelMergerNode.disconnect(scriptProcessorNode);
            scriptProcessorNode.disconnect(nativeContext.destination);
        };
        return monitorConnections((0, $900bfd37a2c1e10d$export$19c8a106f82dff14)(nativePannerNodeFaker, pannerNode), whenConnected, whenDisconnected);
    };
};


const $6d8ee1bebc39d00d$export$3f519524c23feca0 = (createIndexSizeError)=>{
    return (nativeContext, { disableNormalization: disableNormalization, imag: imag, real: real })=>{
        // Bug #180: Safari does not allow to use ordinary arrays.
        const convertedImag = imag instanceof Float32Array ? imag : new Float32Array(imag);
        const convertedReal = real instanceof Float32Array ? real : new Float32Array(real);
        const nativePeriodicWave = nativeContext.createPeriodicWave(convertedReal, convertedImag, {
            disableNormalization: disableNormalization
        });
        // Bug #181: Safari does not throw an IndexSizeError so far if the given arrays have less than two values.
        if (Array.from(imag).length < 2) throw createIndexSizeError();
        return nativePeriodicWave;
    };
};


const $ce98e9e38de0c041$export$9f784f497a6d6acb = (nativeContext, bufferSize, numberOfInputChannels, numberOfOutputChannels)=>{
    return nativeContext.createScriptProcessor(bufferSize, numberOfInputChannels, numberOfOutputChannels); // tslint:disable-line deprecation
};




const $2bfde3b6c5ad3b93$export$247580dcf7d2f2c4 = (createNativeStereoPannerNodeFaker, createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const channelCountMode = options.channelCountMode;
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ if (channelCountMode === 'clamped-max') throw createNotSupportedError();
        // Bug #105: Safari does not support the StereoPannerNode.
        if (nativeContext.createStereoPanner === undefined) return createNativeStereoPannerNodeFaker(nativeContext, options);
        const nativeStereoPannerNode = nativeContext.createStereoPanner();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeStereoPannerNode, options);
        (0, $693812907b556ae9$export$4778de978774ec4f)(nativeStereoPannerNode, options, 'pan');
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ Object.defineProperty(nativeStereoPannerNode, 'channelCountMode', {
            get: ()=>channelCountMode,
            set: (value)=>{
                if (value !== channelCountMode) throw createNotSupportedError();
            }
        });
        return nativeStereoPannerNode;
    };
};



const $bfb8b52e9bdf9d42$export$5fe2a787c06b2d34 = (createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeGainNode, createNativeWaveShaperNode, createNotSupportedError, monitorConnections)=>{
    // The curve has a size of 14bit plus 1 value to have an exact representation for zero. This value has been determined experimentally.
    const CURVE_SIZE = 16385;
    const DC_CURVE = new Float32Array([
        1,
        1
    ]);
    const HALF_PI = Math.PI / 2;
    const SINGLE_CHANNEL_OPTIONS = {
        channelCount: 1,
        channelCountMode: 'explicit',
        channelInterpretation: 'discrete'
    };
    const SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS = {
        ...SINGLE_CHANNEL_OPTIONS,
        oversample: 'none'
    };
    const buildInternalGraphForMono = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightWaveShaperCurve = new Float32Array(CURVE_SIZE);
        for(let i = 0; i < CURVE_SIZE; i += 1){
            const x = i / (CURVE_SIZE - 1) * HALF_PI;
            leftWaveShaperCurve[i] = Math.cos(x);
            rightWaveShaperCurve[i] = Math.sin(x);
        }
        const leftGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(leftGainNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.connect(rightGainNode);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.connect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.connect(leftGainNode.gain);
                rightWaveShaperNode.connect(rightGainNode.gain);
                leftGainNode.connect(channelMergerNode, 0, 0);
                rightGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(leftGainNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.disconnect(rightGainNode);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.disconnect(leftGainNode.gain);
                rightWaveShaperNode.disconnect(rightGainNode.gain);
                leftGainNode.disconnect(channelMergerNode, 0, 0);
                rightGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraphForStereo = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const leftInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const centerIndex = Math.floor(CURVE_SIZE / 2);
        for(let i = 0; i < CURVE_SIZE; i += 1)if (i > centerIndex) {
            const x = (i - centerIndex) / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            leftInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
            rightInputForLeftOutputWaveShaperCurve[i] = 0;
            rightInputForRightOutputWaveShaperCurve[i] = 1;
        } else {
            const x = i / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = 1;
            leftInputForRightOutputWaveShaperCurve[i] = 0;
            rightInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            rightInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
        }
        const channelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: 2,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            numberOfOutputs: 2
        });
        const leftInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForLeftOutputWaveShaperCurve
        });
        const leftInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForRightOutputWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForLeftOutputWaveShaperCurve
        });
        const rightInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForRightOutputWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(channelSplitterNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.connect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.connect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.connect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.connect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.connect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.connect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.connect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.connect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(channelSplitterNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.disconnect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.disconnect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.disconnect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.disconnect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.disconnect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.disconnect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.disconnect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.disconnect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraph = (nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode)=>{
        if (channelCount === 1) return buildInternalGraphForMono(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        if (channelCount === 2) return buildInternalGraphForStereo(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        throw createNotSupportedError();
    };
    return (nativeContext, { channelCount: channelCount, channelCountMode: channelCountMode, pan: pan, ...audioNodeOptions })=>{
        if (channelCountMode === 'max') throw createNotSupportedError();
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: 1,
            channelCountMode: channelCountMode,
            numberOfInputs: 2
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: channelCount,
            channelCountMode: channelCountMode,
            gain: 1
        });
        const panGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: pan
        });
        let { connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode);
        Object.defineProperty(panGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(panGainNode.gain, 'maxValue', {
            get: ()=>1
        });
        Object.defineProperty(panGainNode.gain, 'minValue', {
            get: ()=>-1
        });
        const nativeStereoPannerNodeFakerFactory = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return inputGainNode.channelCount;
            },
            set channelCount (value){
                if (inputGainNode.channelCount !== value) {
                    if (isConnected) disconnectGraph();
                    ({ connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, value, inputGainNode, panGainNode, channelMergerNode));
                    if (isConnected) connectGraph();
                }
                inputGainNode.channelCount = value;
            },
            get channelCountMode () {
                return inputGainNode.channelCountMode;
            },
            set channelCountMode (value){
                if (value === 'clamped-max' || value === 'max') throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return inputGainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
            },
            get context () {
                return inputGainNode.context;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return inputGainNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return inputGainNode.numberOfOutputs;
            },
            get pan () {
                return panGainNode.gain;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        let isConnected = false;
        const whenConnected = ()=>{
            connectGraph();
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            disconnectGraph();
            isConnected = false;
        };
        return monitorConnections((0, $900bfd37a2c1e10d$export$19c8a106f82dff14)(nativeStereoPannerNodeFakerFactory, channelMergerNode), whenConnected, whenDisconnected);
    };
};




const $2f2c2819a28b32b4$export$75168c4c8ce320c4 = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeWaveShaperNodeFaker, isDCCurve, monitorConnections, nativeAudioContextConstructor, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeWaveShaperNode = nativeContext.createWaveShaper();
        /*
         * Bug #119: Safari does not correctly map the values.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here. Testing for the automationRate property is necessary because this workaround
         * isn't necessary anymore since v14.0.2 of Safari.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext' && nativeContext.createGain().gain.automationRate === undefined) return createNativeWaveShaperNodeFaker(nativeContext, options);
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(nativeWaveShaperNode, options);
        const curve = options.curve === null || options.curve instanceof Float32Array ? options.curve : new Float32Array(options.curve);
        // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
        if (curve !== null && curve.length < 2) throw createInvalidStateError();
        // Only values of type Float32Array can be assigned to the curve property.
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeWaveShaperNode, {
            curve: curve
        }, 'curve');
        (0, $ae24732efd4b40e6$export$26855c8d5a8f5839)(nativeWaveShaperNode, options, 'oversample');
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        overwriteAccessors(nativeWaveShaperNode, 'curve', (get)=>()=>get.call(nativeWaveShaperNode), (set)=>(value)=>{
                set.call(nativeWaveShaperNode, value);
                if (isConnected) {
                    if (isDCCurve(value) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
                    else if (!isDCCurve(value) && disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
                return value;
            });
        const whenConnected = ()=>{
            isConnected = true;
            if (isDCCurve(nativeWaveShaperNode.curve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
        };
        const whenDisconnected = ()=>{
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections(nativeWaveShaperNode, whenConnected, whenDisconnected);
    };
};




const $d7a2d82fb19eb7a0$export$f5f0b26abc22907e = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeGainNode, isDCCurve, monitorConnections)=>{
    return (nativeContext, { curve: curve, oversample: oversample, ...audioNodeOptions })=>{
        const negativeWaveShaperNode = nativeContext.createWaveShaper();
        const positiveWaveShaperNode = nativeContext.createWaveShaper();
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(negativeWaveShaperNode, audioNodeOptions);
        (0, $b801f4d60b36d5b1$export$a741a487b656b6ff)(positiveWaveShaperNode, audioNodeOptions);
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const invertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        const outputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const revertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        let unmodifiedCurve = null;
        const nativeWaveShaperNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return negativeWaveShaperNode.channelCount;
            },
            set channelCount (value){
                inputGainNode.channelCount = value;
                invertGainNode.channelCount = value;
                negativeWaveShaperNode.channelCount = value;
                outputGainNode.channelCount = value;
                positiveWaveShaperNode.channelCount = value;
                revertGainNode.channelCount = value;
            },
            get channelCountMode () {
                return negativeWaveShaperNode.channelCountMode;
            },
            set channelCountMode (value){
                inputGainNode.channelCountMode = value;
                invertGainNode.channelCountMode = value;
                negativeWaveShaperNode.channelCountMode = value;
                outputGainNode.channelCountMode = value;
                positiveWaveShaperNode.channelCountMode = value;
                revertGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return negativeWaveShaperNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                invertGainNode.channelInterpretation = value;
                negativeWaveShaperNode.channelInterpretation = value;
                outputGainNode.channelInterpretation = value;
                positiveWaveShaperNode.channelInterpretation = value;
                revertGainNode.channelInterpretation = value;
            },
            get context () {
                return negativeWaveShaperNode.context;
            },
            get curve () {
                return unmodifiedCurve;
            },
            set curve (value){
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                if (value !== null && value.length < 2) throw createInvalidStateError();
                if (value === null) {
                    negativeWaveShaperNode.curve = value;
                    positiveWaveShaperNode.curve = value;
                } else {
                    const curveLength = value.length;
                    const negativeCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    const positiveCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    negativeCurve[0] = value[0];
                    positiveCurve[0] = -value[curveLength - 1];
                    const length = Math.ceil((curveLength + 1) / 2);
                    const centerIndex = (curveLength + 1) / 2 - 1;
                    for(let i = 1; i < length; i += 1){
                        const theoreticIndex = i / length * centerIndex;
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        negativeCurve[i] = lowerIndex === upperIndex ? value[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * value[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * value[upperIndex];
                        positiveCurve[i] = lowerIndex === upperIndex ? -value[curveLength - 1 - lowerIndex] : -((1 - (theoreticIndex - lowerIndex)) * value[curveLength - 1 - lowerIndex]) - (1 - (upperIndex - theoreticIndex)) * value[curveLength - 1 - upperIndex];
                    }
                    negativeCurve[length] = curveLength % 2 === 1 ? value[length - 1] : (value[length - 2] + value[length - 1]) / 2;
                    negativeWaveShaperNode.curve = negativeCurve;
                    positiveWaveShaperNode.curve = positiveCurve;
                }
                unmodifiedCurve = value;
                if (isConnected) {
                    if (isDCCurve(unmodifiedCurve) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
                    else if (disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return negativeWaveShaperNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return negativeWaveShaperNode.numberOfOutputs;
            },
            get oversample () {
                return negativeWaveShaperNode.oversample;
            },
            set oversample (value){
                negativeWaveShaperNode.oversample = value;
                positiveWaveShaperNode.oversample = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (curve !== null) // Only values of type Float32Array can be assigned to the curve property.
        nativeWaveShaperNodeFaker.curve = curve instanceof Float32Array ? curve : new Float32Array(curve);
        if (oversample !== nativeWaveShaperNodeFaker.oversample) nativeWaveShaperNodeFaker.oversample = oversample;
        const whenConnected = ()=>{
            inputGainNode.connect(negativeWaveShaperNode).connect(outputGainNode);
            inputGainNode.connect(invertGainNode).connect(positiveWaveShaperNode).connect(revertGainNode).connect(outputGainNode);
            isConnected = true;
            if (isDCCurve(unmodifiedCurve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(negativeWaveShaperNode);
            negativeWaveShaperNode.disconnect(outputGainNode);
            inputGainNode.disconnect(invertGainNode);
            invertGainNode.disconnect(positiveWaveShaperNode);
            positiveWaveShaperNode.disconnect(revertGainNode);
            revertGainNode.disconnect(outputGainNode);
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections((0, $900bfd37a2c1e10d$export$19c8a106f82dff14)(nativeWaveShaperNodeFaker, outputGainNode), whenConnected, whenDisconnected);
    };
};


const $04b2e9cba31dc468$export$dbebdb13622d486c = ()=>new DOMException('', 'NotSupportedError');




const $b0e850ac703cdca5$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $b0e850ac703cdca5$export$a9b5caf52b398870 = (baseAudioContextConstructor, cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, startRendering)=>{
    return class OfflineAudioContext extends baseAudioContextConstructor {
        constructor(a, b, c){
            let options;
            if (typeof a === 'number' && b !== undefined && c !== undefined) options = {
                length: b,
                numberOfChannels: a,
                sampleRate: c
            };
            else if (typeof a === 'object') options = a;
            else throw new Error('The given parameters are not valid.');
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$b0e850ac703cdca5$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $790c2f9ab3e8ea25$export$9ec44223b1284cd4), ()=>(0, $790c2f9ab3e8ea25$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener('statechange', (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === 'running') {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === 'running') return Promise.reject(createInvalidStateError());
            this._state = 'running';
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $38dbdfa389791805$export$cbd606bc629ea938)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};





const $02857985c06e48d0$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    detune: 0,
    frequency: 440,
    periodicWave: undefined,
    type: 'sine'
};
const $02857985c06e48d0$export$c1c3584074b042b3 = (audioNodeConstructor, createAudioParam, createNativeOscillatorNode, createOscillatorNodeRenderer, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class OscillatorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$02857985c06e48d0$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOscillatorNode = createNativeOscillatorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const oscillatorNodeRenderer = isOffline ? createOscillatorNodeRenderer() : null;
            const nyquist = context.sampleRate / 2;
            super(context, false, nativeOscillatorNode, oscillatorNodeRenderer);
            // Bug #81: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeOscillatorNode.detune, 153600, -153600);
            // Bug #76: Safari does not export the correct values for maxValue and minValue.
            this._frequency = createAudioParam(this, isOffline, nativeOscillatorNode.frequency, nyquist, -nyquist);
            this._nativeOscillatorNode = nativeOscillatorNode;
            this._onended = null;
            this._oscillatorNodeRenderer = oscillatorNodeRenderer;
            if (this._oscillatorNodeRenderer !== null && mergedOptions.periodicWave !== undefined) this._oscillatorNodeRenderer.periodicWave = mergedOptions.periodicWave;
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeOscillatorNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeOscillatorNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get type() {
            return this._nativeOscillatorNode.type;
        }
        set type(value) {
            this._nativeOscillatorNode.type = value;
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = null;
        }
        setPeriodicWave(periodicWave) {
            this._nativeOscillatorNode.setPeriodicWave(periodicWave);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = periodicWave;
        }
        start(when = 0) {
            this._nativeOscillatorNode.start(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.start = when;
            if (this.context.state !== 'closed') {
                (0, $1dade94fa084012d$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeOscillatorNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $503abdc94195f7ae$export$e44f0fc8e83fb084)(this)) (0, $9fbb9de7ccc2f607$export$7c0830f3a5100dec)(this);
                };
                this._nativeOscillatorNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeOscillatorNode.stop(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.stop = when;
        }
    };
};



const $abe65c5b4b23c0ab$export$99143538b3590be5 = (connectAudioParam, createNativeOscillatorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeOscillatorNodes = new WeakMap();
        let periodicWave = null;
        let start = null;
        let stop = null;
        const createOscillatorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeOscillatorNode = getNativeAudioNode(proxy);
            // If the initially used nativeOscillatorNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeOscillatorNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeOscillatorNode, nativeOfflineAudioContext);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeOscillatorNode.channelCount,
                    channelCountMode: nativeOscillatorNode.channelCountMode,
                    channelInterpretation: nativeOscillatorNode.channelInterpretation,
                    detune: nativeOscillatorNode.detune.value,
                    frequency: nativeOscillatorNode.frequency.value,
                    periodicWave: periodicWave === null ? undefined : periodicWave,
                    type: nativeOscillatorNode.type
                };
                nativeOscillatorNode = createNativeOscillatorNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeOscillatorNode.start(start);
                if (stop !== null) nativeOscillatorNode.stop(stop);
            }
            renderedNativeOscillatorNodes.set(nativeOfflineAudioContext, nativeOscillatorNode);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeOscillatorNode);
            return nativeOscillatorNode;
        };
        return {
            set periodicWave (value){
                periodicWave = value;
            },
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeOscillatorNode = renderedNativeOscillatorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeOscillatorNode !== undefined) return Promise.resolve(renderedNativeOscillatorNode);
                return createOscillatorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};



const $f2c10d2f8c2b6ea3$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    coneInnerAngle: 360,
    coneOuterAngle: 360,
    coneOuterGain: 0,
    distanceModel: 'inverse',
    maxDistance: 10000,
    orientationX: 1,
    orientationY: 0,
    orientationZ: 0,
    panningModel: 'equalpower',
    positionX: 0,
    positionY: 0,
    positionZ: 0,
    refDistance: 1,
    rolloffFactor: 1
};
const $f2c10d2f8c2b6ea3$export$91b046021cf98bac = (audioNodeConstructor, createAudioParam, createNativePannerNode, createPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class PannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$f2c10d2f8c2b6ea3$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativePannerNode = createNativePannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const pannerNodeRenderer = isOffline ? createPannerNodeRenderer() : null;
            super(context, false, nativePannerNode, pannerNodeRenderer);
            this._nativePannerNode = nativePannerNode;
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._orientationX = createAudioParam(this, isOffline, nativePannerNode.orientationX, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            this._orientationY = createAudioParam(this, isOffline, nativePannerNode.orientationY, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            this._orientationZ = createAudioParam(this, isOffline, nativePannerNode.orientationZ, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            this._positionX = createAudioParam(this, isOffline, nativePannerNode.positionX, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            this._positionY = createAudioParam(this, isOffline, nativePannerNode.positionY, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            this._positionZ = createAudioParam(this, isOffline, nativePannerNode.positionZ, (0, $109263ef7a828de3$export$ab43bedd17d6a167), (0, $109263ef7a828de3$export$ced6a5c63b103b52));
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get coneInnerAngle() {
            return this._nativePannerNode.coneInnerAngle;
        }
        set coneInnerAngle(value) {
            this._nativePannerNode.coneInnerAngle = value;
        }
        get coneOuterAngle() {
            return this._nativePannerNode.coneOuterAngle;
        }
        set coneOuterAngle(value) {
            this._nativePannerNode.coneOuterAngle = value;
        }
        get coneOuterGain() {
            return this._nativePannerNode.coneOuterGain;
        }
        set coneOuterGain(value) {
            this._nativePannerNode.coneOuterGain = value;
        }
        get distanceModel() {
            return this._nativePannerNode.distanceModel;
        }
        set distanceModel(value) {
            this._nativePannerNode.distanceModel = value;
        }
        get maxDistance() {
            return this._nativePannerNode.maxDistance;
        }
        set maxDistance(value) {
            this._nativePannerNode.maxDistance = value;
        }
        get orientationX() {
            return this._orientationX;
        }
        get orientationY() {
            return this._orientationY;
        }
        get orientationZ() {
            return this._orientationZ;
        }
        get panningModel() {
            return this._nativePannerNode.panningModel;
        }
        set panningModel(value) {
            this._nativePannerNode.panningModel = value;
        }
        get positionX() {
            return this._positionX;
        }
        get positionY() {
            return this._positionY;
        }
        get positionZ() {
            return this._positionZ;
        }
        get refDistance() {
            return this._nativePannerNode.refDistance;
        }
        set refDistance(value) {
            this._nativePannerNode.refDistance = value;
        }
        get rolloffFactor() {
            return this._nativePannerNode.rolloffFactor;
        }
        set rolloffFactor(value) {
            this._nativePannerNode.rolloffFactor = value;
        }
    };
};




const $bca6f8bc10c68bcf$export$ccd091498494025 = (connectAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeGainNode, createNativePannerNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        let renderedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = null;
            let nativePannerNode = getNativeAudioNode(proxy);
            const commonAudioNodeOptions = {
                channelCount: nativePannerNode.channelCount,
                channelCountMode: nativePannerNode.channelCountMode,
                channelInterpretation: nativePannerNode.channelInterpretation
            };
            const commonNativePannerNodeOptions = {
                ...commonAudioNodeOptions,
                coneInnerAngle: nativePannerNode.coneInnerAngle,
                coneOuterAngle: nativePannerNode.coneOuterAngle,
                coneOuterGain: nativePannerNode.coneOuterGain,
                distanceModel: nativePannerNode.distanceModel,
                maxDistance: nativePannerNode.maxDistance,
                panningModel: nativePannerNode.panningModel,
                refDistance: nativePannerNode.refDistance,
                rolloffFactor: nativePannerNode.rolloffFactor
            };
            // If the initially used nativePannerNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativePannerNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativePannerNode, nativeOfflineAudioContext);
            // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
            if ('bufferSize' in nativePannerNode) nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                ...commonAudioNodeOptions,
                gain: 1
            });
            else if (!nativePannerNodeIsOwnedByContext) {
                const options = {
                    ...commonNativePannerNodeOptions,
                    orientationX: nativePannerNode.orientationX.value,
                    orientationY: nativePannerNode.orientationY.value,
                    orientationZ: nativePannerNode.orientationZ.value,
                    positionX: nativePannerNode.positionX.value,
                    positionY: nativePannerNode.positionY.value,
                    positionZ: nativePannerNode.positionZ.value
                };
                nativePannerNode = createNativePannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeGainNode === null ? nativePannerNode : nativeGainNode);
            if (nativeGainNode !== null) {
                if (renderedBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(6, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    const nativeChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                        channelCount: 1,
                        channelCountMode: 'explicit',
                        channelInterpretation: 'speakers',
                        numberOfInputs: 6
                    });
                    nativeChannelMergerNode.connect(partialOfflineAudioContext.destination);
                    renderedBufferPromise = (async ()=>{
                        const nativeConstantSourceNodes = await Promise.all([
                            proxy.orientationX,
                            proxy.orientationY,
                            proxy.orientationZ,
                            proxy.positionX,
                            proxy.positionY,
                            proxy.positionZ
                        ].map(async (audioParam, index)=>{
                            const nativeConstantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                offset: index === 0 ? 1 : 0
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, nativeConstantSourceNode.offset);
                            return nativeConstantSourceNode;
                        }));
                        for(let i = 0; i < 6; i += 1){
                            nativeConstantSourceNodes[i].connect(nativeChannelMergerNode, 0, i);
                            nativeConstantSourceNodes[i].start(0);
                        }
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    })();
                }
                const renderedBuffer = await renderedBufferPromise;
                const inputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, inputGainNode);
                const channelDatas = [];
                for(let i = 0; i < renderedBuffer.numberOfChannels; i += 1)channelDatas.push(renderedBuffer.getChannelData(i));
                let lastOrientation = [
                    channelDatas[0][0],
                    channelDatas[1][0],
                    channelDatas[2][0]
                ];
                let lastPosition = [
                    channelDatas[3][0],
                    channelDatas[4][0],
                    channelDatas[5][0]
                ];
                let gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                let partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                    ...commonNativePannerNodeOptions,
                    orientationX: lastOrientation[0],
                    orientationY: lastOrientation[1],
                    orientationZ: lastOrientation[2],
                    positionX: lastPosition[0],
                    positionY: lastPosition[1],
                    positionZ: lastPosition[2]
                });
                inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                partialPannerNode.connect(nativeGainNode);
                for(let i = 128; i < renderedBuffer.length; i += 128){
                    const orientation = [
                        channelDatas[0][i],
                        channelDatas[1][i],
                        channelDatas[2][i]
                    ];
                    const positon = [
                        channelDatas[3][i],
                        channelDatas[4][i],
                        channelDatas[5][i]
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index]) || positon.some((value, index)=>value !== lastPosition[index])) {
                        lastOrientation = orientation;
                        lastPosition = positon;
                        const currentTime = i / nativeOfflineAudioContext.sampleRate;
                        gateGainNode.gain.setValueAtTime(0, currentTime);
                        gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                            ...commonAudioNodeOptions,
                            gain: 0
                        });
                        partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                            ...commonNativePannerNodeOptions,
                            orientationX: lastOrientation[0],
                            orientationY: lastOrientation[1],
                            orientationZ: lastOrientation[2],
                            positionX: lastPosition[0],
                            positionY: lastPosition[1],
                            positionZ: lastPosition[2]
                        });
                        gateGainNode.gain.setValueAtTime(1, currentTime);
                        inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                        partialPannerNode.connect(nativeGainNode);
                    }
                }
                return nativeGainNode;
            }
            if (!nativePannerNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            }
            if ((0, $077e12d27999c158$export$ac2aef07f705aa48)(nativePannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode);
            return nativePannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNodeOrNativePannerNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNodeOrNativePannerNode !== undefined) return Promise.resolve(renderedNativeGainNodeOrNativePannerNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $bcdb4c40b77d698f$var$DEFAULT_OPTIONS = {
    disableNormalization: false
};
const $bcdb4c40b77d698f$export$10e47cfa48a5069d = (createNativePeriodicWave, getNativeContext, periodicWaveStore, sanitizePeriodicWaveOptions)=>{
    return class PeriodicWave {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizePeriodicWaveOptions({
                ...$bcdb4c40b77d698f$var$DEFAULT_OPTIONS,
                ...options
            });
            const periodicWave = createNativePeriodicWave(nativeContext, mergedOptions);
            periodicWaveStore.add(periodicWave);
            // This does violate all good pratices but it is used here to simplify the handling of periodic waves.
            return periodicWave;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === PeriodicWave.prototype || periodicWaveStore.has(instance);
        }
    };
};


const $6020b9f8edefa15e$export$889eef7d338963f6 = (getAudioParamRenderer, renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        const audioParamRenderer = getAudioParamRenderer(audioParam);
        audioParamRenderer.replay(nativeAudioParam);
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};


const $6043bc772a73bc2b$export$cff0938ddf51f6f4 = (getAudioNodeConnections, getAudioNodeRenderer, isPartOfACycle)=>{
    return async (audioNode, nativeOfflineAudioContext, nativeAudioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        await Promise.all(audioNodeConnections.activeInputs.map((connections, input)=>Array.from(connections).map(async ([source, output])=>{
                const audioNodeRenderer = getAudioNodeRenderer(source);
                const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
                const destination = audioNode.context.destination;
                if (!isPartOfACycle(source) && (audioNode !== destination || !isPartOfACycle(audioNode))) renderedNativeAudioNode.connect(nativeAudioNode, output, input);
            })).reduce((allRenderingPromises, renderingPromises)=>[
                ...allRenderingPromises,
                ...renderingPromises
            ], []));
    };
};


const $dbeef96128f81fb2$export$82cd58acb1062198 = (getAudioNodeRenderer, getAudioParamConnections, isPartOfACycle)=>{
    return async (audioParam, nativeOfflineAudioContext, nativeAudioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        await Promise.all(Array.from(audioParamConnections.activeInputs).map(async ([source, output])=>{
            const audioNodeRenderer = getAudioNodeRenderer(source);
            const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
            if (!isPartOfACycle(source)) renderedNativeAudioNode.connect(nativeAudioParam, output);
        }));
    };
};



const $0b946b5c2554feb1$export$feb8d4a8e403af48 = (cacheTestResult, createNativeGainNode, createNativeScriptProcessorNode, testOfflineAudioContextCurrentTimeSupport)=>{
    return (nativeOfflineAudioContext)=>{
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult((0, $790c2f9ab3e8ea25$export$9ec44223b1284cd4), ()=>(0, $790c2f9ab3e8ea25$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) // Bug #158: Chrome and Edge do not advance currentTime if it is not accessed while rendering the audio.
        return Promise.resolve(cacheTestResult(testOfflineAudioContextCurrentTimeSupport, testOfflineAudioContextCurrentTimeSupport)).then((isOfflineAudioContextCurrentTimeSupported)=>{
            if (!isOfflineAudioContextCurrentTimeSupported) {
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeOfflineAudioContext, 512, 0, 1);
                nativeOfflineAudioContext.oncomplete = ()=>{
                    scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                    scriptProcessorNode.disconnect();
                };
                scriptProcessorNode.onaudioprocess = ()=>nativeOfflineAudioContext.currentTime; // tslint:disable-line:deprecation
                scriptProcessorNode.connect(nativeOfflineAudioContext.destination);
            }
            return nativeOfflineAudioContext.startRendering();
        });
        return new Promise((resolve)=>{
            // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
            const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                gain: 0
            });
            nativeOfflineAudioContext.oncomplete = (event)=>{
                gainNode.disconnect();
                resolve(event.renderedBuffer);
            };
            gainNode.connect(nativeOfflineAudioContext.destination);
            nativeOfflineAudioContext.startRendering();
        });
    };
};


const $120326ce44350082$export$17328c9508de4388 = (activeAudioWorkletNodeInputsStore)=>{
    return (nativeAudioWorkletNode, activeInputs)=>{
        activeAudioWorkletNodeInputsStore.set(nativeAudioWorkletNode, activeInputs);
    };
};


const $9e1693c764da0c5c$export$c5e78cc8035d00aa = (audioNodeTailTimeStore)=>{
    return (audioNode, tailTime)=>audioNodeTailTimeStore.set(audioNode, tailTime);
};



const $a166304a81a24a83$export$a04cd80dfb1b8309 = (audioBufferStore, cacheTestResult, getAudioNodeRenderer, getUnrenderedAudioWorkletNodes, renderNativeOfflineAudioContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (destination, nativeOfflineAudioContext)=>getAudioNodeRenderer(destination).render(destination, nativeOfflineAudioContext)/*
         * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to the
         * destination.
         */ .then(()=>Promise.all(Array.from(getUnrenderedAudioWorkletNodes(nativeOfflineAudioContext)).map((audioWorkletNode)=>getAudioNodeRenderer(audioWorkletNode).render(audioWorkletNode, nativeOfflineAudioContext)))).then(()=>renderNativeOfflineAudioContext(nativeOfflineAudioContext)).then((audioBuffer)=>{
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== 'function') {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $327fa96f6085d8f9$export$df65309cf6249598)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
};


const $666d48b9edf5c35d$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    /*
     * Bug #105: The channelCountMode should be 'clamped-max' according to the spec but is set to 'explicit' to achieve consistent
     * behavior.
     */ channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    pan: 0
};
const $666d48b9edf5c35d$export$9b005b0c35721c84 = (audioNodeConstructor, createAudioParam, createNativeStereoPannerNode, createStereoPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext)=>{
    return class StereoPannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$666d48b9edf5c35d$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeStereoPannerNode = createNativeStereoPannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const stereoPannerNodeRenderer = isOffline ? createStereoPannerNodeRenderer() : null;
            super(context, false, nativeStereoPannerNode, stereoPannerNodeRenderer);
            this._pan = createAudioParam(this, isOffline, nativeStereoPannerNode.pan);
        }
        get pan() {
            return this._pan;
        }
    };
};




const $cf1c501560a0f777$export$3ba9002bd6b539cf = (connectAudioParam, createNativeStereoPannerNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeStereoPannerNodes = new WeakMap();
        const createStereoPannerNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeStereoPannerNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeStereoPannerNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeStereoPannerNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeStereoPannerNode, nativeOfflineAudioContext);
            if (!nativeStereoPannerNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeStereoPannerNode.channelCount,
                    channelCountMode: nativeStereoPannerNode.channelCountMode,
                    channelInterpretation: nativeStereoPannerNode.channelInterpretation,
                    pan: nativeStereoPannerNode.pan.value
                };
                nativeStereoPannerNode = createNativeStereoPannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeStereoPannerNodes.set(nativeOfflineAudioContext, nativeStereoPannerNode);
            if (!nativeStereoPannerNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            if ((0, $077e12d27999c158$export$ac2aef07f705aa48)(nativeStereoPannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode);
            return nativeStereoPannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeStereoPannerNode = renderedNativeStereoPannerNodes.get(nativeOfflineAudioContext);
                if (renderedNativeStereoPannerNode !== undefined) return Promise.resolve(renderedNativeStereoPannerNode);
                return createStereoPannerNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


// Bug #33: Safari exposes an AudioBuffer but it can't be used as a constructor.
const $f4396aa7947e4289$export$5bddcff46df9c642 = (nativeAudioBufferConstructor)=>{
    return ()=>{
        if (nativeAudioBufferConstructor === null) return false;
        try {
            new nativeAudioBufferConstructor({
                length: 1,
                sampleRate: 44100
            }); // tslint:disable-line:no-unused-expression
        } catch  {
            return false;
        }
        return true;
    };
};


/*
 * Firefox up to version 67 didn't fully support the copyFromChannel() and copyToChannel() methods. Therefore testing one of those methods
 * is enough to know if the other one is supported as well.
 */ const $c3e8d82c55ddf4a2$export$1995b5466f5c2709 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeAudioBuffer = nativeOfflineAudioContext.createBuffer(1, 1, 44100);
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        if (nativeAudioBuffer.copyToChannel === undefined) return true;
        const source = new Float32Array(2);
        try {
            nativeAudioBuffer.copyFromChannel(source, 0, 0);
        } catch  {
            return false;
        }
        return true;
    };
};


const $e67fe62fc3ca8164$export$34981ee6aafdf532 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        // Try to check the prototype before constructing the AudioContext.
        if (nativeAudioContextConstructor.prototype !== undefined && nativeAudioContextConstructor.prototype.close !== undefined) return true;
        const audioContext = new nativeAudioContextConstructor();
        const isAudioContextClosable = audioContext.close !== undefined;
        try {
            audioContext.close();
        } catch  {
        // Ignore errors.
        }
        return isAudioContextClosable;
    };
};


/**
 * Edge up to version 14, Firefox up to version 52, Safari up to version 9 and maybe other browsers
 * did not refuse to decode invalid parameters with a TypeError.
 */ const $c36096dba3865ac7$export$622ba23aa6b35822 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            let isPending = true;
            const resolvePromise = (err)=>{
                if (isPending) {
                    isPending = false;
                    offlineAudioContext.startRendering();
                    resolve(err instanceof TypeError);
                }
            };
            let promise;
            // Bug #26: Safari throws a synchronous error.
            try {
                promise = offlineAudioContext// Bug #1: Safari requires a successCallback.
                .decodeAudioData(null, ()=>{
                // Ignore the success callback.
                }, resolvePromise);
            } catch (err) {
                resolvePromise(err);
            }
            // Bug #21: Safari does not support promises yet.
            if (promise !== undefined) // Bug #6: Chrome, Edge and Firefox do not call the errorCallback.
            promise.catch(resolvePromise);
        });
    };
};


const $a91715fa5046b1a4$export$2f44088abd2df2e = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        let audioContext;
        try {
            audioContext = new nativeAudioContextConstructor({
                latencyHint: 'balanced'
            });
        } catch  {
            return false;
        }
        audioContext.close();
        return true;
    };
};


// Safari up to version 12.0 (but not v12.1) didn't return the destination in case it was an AudioNode.
const $983026835cd4816a$export$f77a3bce7e4efd81 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeGainNode = nativeOfflineAudioContext.createGain();
        const isSupported = nativeGainNode.connect(nativeGainNode) === nativeGainNode;
        nativeGainNode.disconnect(nativeGainNode);
        return isSupported;
    };
};


/**
 * Chrome version 66 and 67 did not call the process() function of an AudioWorkletProcessor if it had no outputs. AudioWorklet support was
 * enabled by default in version 66.
 */ const $f253df1213fbfab8$export$ce5ba80a98dc0ba7 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'let c,p;class A extends AudioWorkletProcessor{constructor(){super();this.port.onmessage=(e)=>{p=e.data;p.onmessage=()=>{p.postMessage(c);p.close()};this.port.postMessage(0)}}process(){c=1}}registerProcessor("a",A)'
        ], {
            type: 'application/javascript; charset=utf-8'
        });
        const messageChannel = new MessageChannel();
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isCallingProcess = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            await new Promise((resolve)=>{
                audioWorkletNode.port.onmessage = ()=>resolve();
                audioWorkletNode.port.postMessage(messageChannel.port2, [
                    messageChannel.port2
                ]);
            });
            audioWorkletNode.port.onmessage = ()=>isCallingProcess = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            isCallingProcess = await new Promise((resolve)=>{
                messageChannel.port1.onmessage = ({ data: data })=>resolve(data === 1);
                messageChannel.port1.postMessage(0);
            });
        } catch  {
        // Ignore errors.
        } finally{
            messageChannel.port1.close();
            URL.revokeObjectURL(url);
        }
        return isCallingProcess;
    };
};


// Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
const $f589bc975e60193c$export$19b2cf184a7cfba8 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'
        ], {
            type: 'application/javascript; charset=utf-8'
        });
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isEmittingMessageEvents = false;
        let isEmittingProcessorErrorEvents = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            audioWorkletNode.port.onmessage = ()=>isEmittingMessageEvents = true;
            audioWorkletNode.onprocessorerror = ()=>isEmittingProcessorErrorEvents = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            // Bug #197: Safari does not deliver the messages before the promise returned by startRendering() resolves.
            await new Promise((resolve)=>setTimeout(resolve));
        } catch  {
        // Ignore errors.
        } finally{
            URL.revokeObjectURL(url);
        }
        return isEmittingMessageEvents && !isEmittingProcessorErrorEvents;
    };
};


/**
 * Firefox up to version 69 did not throw an error when setting a different channelCount or channelCountMode.
 */ const $fed83104d448f843$export$a04037cfe0b977fa = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeChannelMergerNode = offlineAudioContext.createChannelMerger();
        /**
         * Bug #15: Safari does not return the default properties. It still needs to be patched. This test is supposed to test the support
         * in other browsers.
         */ if (nativeChannelMergerNode.channelCountMode === 'max') return true;
        try {
            nativeChannelMergerNode.channelCount = 2;
        } catch  {
            return true;
        }
        return false;
    };
};


const $a3245851525d5fbf$export$63ae3ec177f0ed66 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return true;
        const nativeConstantSourceNode = nativeOfflineAudioContext.createConstantSource();
        /*
         * @todo This is using bug #75 to detect bug #70. That works because both bugs were unique to
         * the implementation of Firefox right now, but it could probably be done in a better way.
         */ return nativeConstantSourceNode.offset.maxValue !== Number.POSITIVE_INFINITY;
    };
};


// Opera up to version 57 did not allow to reassign the buffer of a ConvolverNode.
const $2f4fe0305ef7af2f$export$b6f3c4027f959b95 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        try {
            nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        } catch  {
            return false;
        }
        return true;
    };
};


// Chrome up to version v80, Edge up to version v80 and Opera up to version v67 did not allow to set the channelCount property of a ConvolverNode to 1. They also did not allow to set the channelCountMode to 'explicit'.
const $6f4b71f217612aeb$export$d1bddb88e5c21d26 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        try {
            nativeConvolverNode.channelCount = 1;
        } catch  {
            return false;
        }
        return true;
    };
};


const $197c2ac4e9bc0425$export$41669e689e17d4f0 = (window)=>{
    return ()=>window !== null && window.hasOwnProperty('isSecureContext');
};


// Firefox up to version 68 did not throw an error when creating a MediaStreamAudioSourceNode with a mediaStream that had no audio track.
const $3500b38276420784$export$416bb3b14425e126 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        const audioContext = new nativeAudioContextConstructor();
        try {
            audioContext.createMediaStreamSource(new MediaStream());
            return false;
        } catch (err) {
            return true;
        } finally{
            audioContext.close();
        }
    };
};


const $bd137f4ed4ae506e$export$6db7e9dd49157213 = (createNativeGainNode, nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
        const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            nativeOfflineAudioContext.oncomplete = ()=>{
                gainNode.disconnect();
                resolve(nativeOfflineAudioContext.currentTime !== 0);
            };
            nativeOfflineAudioContext.startRendering();
        });
    };
};


/**
 * Firefox up to version 62 did not kick off the processing of the StereoPannerNode if the value of pan was zero.
 */ const $f870c0bf15000a6f$export$5ea70af76c7a03fc = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        /*
         * Bug #105: Safari does not support the StereoPannerNode. Therefore the returned value should normally be false but the faker does
         * support the tested behaviour.
         */ if (nativeOfflineAudioContext.createStereoPanner === undefined) return Promise.resolve(true);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return Promise.resolve(true);
        const constantSourceNode = nativeOfflineAudioContext.createConstantSource();
        const stereoPanner = nativeOfflineAudioContext.createStereoPanner();
        constantSourceNode.channelCount = 1;
        constantSourceNode.offset.value = 1;
        stereoPanner.channelCount = 1;
        constantSourceNode.start();
        constantSourceNode.connect(stereoPanner).connect(nativeOfflineAudioContext.destination);
        return nativeOfflineAudioContext.startRendering().then((buffer)=>buffer.getChannelData(0)[0] !== 1);
    };
};


const $8a5f1f3d40884e74$export$988fb803bae63f80 = ()=>new DOMException('', 'UnknownError');


const $7d36aa63ccfd8c9c$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    curve: null,
    oversample: 'none'
};
const $7d36aa63ccfd8c9c$export$3a30e911e17b1cf5 = (audioNodeConstructor, createInvalidStateError, createNativeWaveShaperNode, createWaveShaperNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class WaveShaperNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$7d36aa63ccfd8c9c$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeWaveShaperNode = createNativeWaveShaperNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const waveShaperNodeRenderer = isOffline ? createWaveShaperNodeRenderer() : null;
            // @todo Add a mechanism to only switch a WaveShaperNode to active while it is connected.
            super(context, true, nativeWaveShaperNode, waveShaperNodeRenderer);
            this._isCurveNullified = false;
            this._nativeWaveShaperNode = nativeWaveShaperNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get curve() {
            if (this._isCurveNullified) return null;
            return this._nativeWaveShaperNode.curve;
        }
        set curve(value) {
            // Bug #103: Safari does not allow to set the curve to null.
            if (value === null) {
                this._isCurveNullified = true;
                this._nativeWaveShaperNode.curve = new Float32Array([
                    0,
                    0
                ]);
            } else {
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
                if (value.length < 2) throw createInvalidStateError();
                this._isCurveNullified = false;
                this._nativeWaveShaperNode.curve = value;
            }
        }
        get oversample() {
            return this._nativeWaveShaperNode.oversample;
        }
        set oversample(value) {
            this._nativeWaveShaperNode.oversample = value;
        }
    };
};




const $5adc61e34c426c5f$export$9709a48a5037d121 = (createNativeWaveShaperNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeWaveShaperNodes = new WeakMap();
        const createWaveShaperNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeWaveShaperNode = getNativeAudioNode(proxy);
            // If the initially used nativeWaveShaperNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeWaveShaperNodeIsOwnedByContext = (0, $4f6edb936961edcb$export$4bd7a4bf54ca80bc)(nativeWaveShaperNode, nativeOfflineAudioContext);
            if (!nativeWaveShaperNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeWaveShaperNode.channelCount,
                    channelCountMode: nativeWaveShaperNode.channelCountMode,
                    channelInterpretation: nativeWaveShaperNode.channelInterpretation,
                    curve: nativeWaveShaperNode.curve,
                    oversample: nativeWaveShaperNode.oversample
                };
                nativeWaveShaperNode = createNativeWaveShaperNode(nativeOfflineAudioContext, options);
            }
            renderedNativeWaveShaperNodes.set(nativeOfflineAudioContext, nativeWaveShaperNode);
            if ((0, $077e12d27999c158$export$ac2aef07f705aa48)(nativeWaveShaperNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode);
            return nativeWaveShaperNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeWaveShaperNode = renderedNativeWaveShaperNodes.get(nativeOfflineAudioContext);
                if (renderedNativeWaveShaperNode !== undefined) return Promise.resolve(renderedNativeWaveShaperNode);
                return createWaveShaperNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $c88f24e5b3fefd1f$export$ba255020126e276e = ()=>typeof window === 'undefined' ? null : window;


const $5f8cc07022a7dc56$export$dbf1ce6ba2b4bc6a = (convertNumberToUnsignedLong, createIndexSizeError)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const destinationLength = destination.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < destinationLength; i += 1)destination[i] = channelData[i + bufferOffset];
        };
        audioBuffer.copyToChannel = (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const sourceLength = source.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < sourceLength; i += 1)channelData[i + bufferOffset] = source[i];
        };
    };
};


const $75c0502605549efa$export$bff9a41e76b37a6e = (convertNumberToUnsignedLong)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = ((copyFromChannel)=>{
            return (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyFromChannel.call(audioBuffer, destination, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyFromChannel);
        audioBuffer.copyToChannel = ((copyToChannel)=>{
            return (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyToChannel.call(audioBuffer, source, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyToChannel);
    };
};


const $9e3ed7199324f30a$export$3c1722ed0f0ed532 = (overwriteAccessors)=>{
    return (nativeAudioBufferSourceNode, nativeContext)=>{
        const nullifiedBuffer = nativeContext.createBuffer(1, 1, 44100);
        if (nativeAudioBufferSourceNode.buffer === null) nativeAudioBufferSourceNode.buffer = nullifiedBuffer;
        overwriteAccessors(nativeAudioBufferSourceNode, 'buffer', (get)=>()=>{
                const value = get.call(nativeAudioBufferSourceNode);
                return value === nullifiedBuffer ? null : value;
            }, (set)=>(value)=>{
                return set.call(nativeAudioBufferSourceNode, value === null ? nullifiedBuffer : value);
            });
    };
};


const $72925d67d3b2202d$export$162785cfa8a63221 = (createInvalidStateError, monitorConnections)=>{
    return (nativeContext, channelMergerNode)=>{
        // Bug #15: Safari does not return the default properties.
        channelMergerNode.channelCount = 1;
        channelMergerNode.channelCountMode = 'explicit';
        // Bug #16: Safari does not throw an error when setting a different channelCount or channelCountMode.
        Object.defineProperty(channelMergerNode, 'channelCount', {
            get: ()=>1,
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        Object.defineProperty(channelMergerNode, 'channelCountMode', {
            get: ()=>'explicit',
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        // Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
        const audioBufferSourceNode = nativeContext.createBufferSource();
        const whenConnected = ()=>{
            const length = channelMergerNode.numberOfInputs;
            for(let i = 0; i < length; i += 1)audioBufferSourceNode.connect(channelMergerNode, 0, i);
        };
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(channelMergerNode);
        monitorConnections(channelMergerNode, whenConnected, whenDisconnected);
    };
};








const $97988ab397cf266d$export$4ec0c13c358eb2b5 = (audioBuffer, buffer, channelNumber)=>{
    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
    if (audioBuffer.copyFromChannel === undefined) return audioBuffer.getChannelData(channelNumber)[0];
    audioBuffer.copyFromChannel(buffer, channelNumber);
    return buffer[0];
};







const $98792b855212607a$export$b32eba1f356dc699 = (curve)=>{
    if (curve === null) return false;
    const length = curve.length;
    if (length % 2 !== 0) return curve[Math.floor(length / 2)] !== 0;
    return curve[length / 2 - 1] + curve[length / 2] !== 0;
};




const $46c85403dfb52f0e$export$f25ed0e1b53c5d37 = (object, property, createGetter, createSetter)=>{
    let prototype = object;
    while(!prototype.hasOwnProperty(property))prototype = Object.getPrototypeOf(prototype);
    const { get: get, set: set } = Object.getOwnPropertyDescriptor(prototype, property);
    Object.defineProperty(object, property, {
        get: createGetter(get),
        set: createSetter(set)
    });
};



const $60bb84eaa0062d6c$export$9a47aefcb4b02450 = (options)=>{
    return {
        ...options,
        outputChannelCount: options.outputChannelCount !== undefined ? options.outputChannelCount : options.numberOfInputs === 1 && options.numberOfOutputs === 1 ? /*
                   * Bug #61: This should be the computedNumberOfChannels, but unfortunately that is almost impossible to fake. That's why
                   * the channelCountMode is required to be 'explicit' as long as there is not a native implementation in every browser. That
                   * makes sure the computedNumberOfChannels is equivilant to the channelCount which makes it much easier to compute.
                   */ [
            options.channelCount
        ] : Array.from({
            length: options.numberOfOutputs
        }, ()=>1)
    };
};


const $9359fe94645a15be$export$6edb0bde597f2c9a = (options)=>{
    return {
        ...options,
        channelCount: options.numberOfOutputs
    };
};


const $5f31e98c1dcc9805$export$833c872c8eda5015 = (options)=>{
    const { imag: imag, real: real } = options;
    if (imag === undefined) {
        if (real === undefined) return {
            ...options,
            imag: [
                0,
                0
            ],
            real: [
                0,
                0
            ]
        };
        return {
            ...options,
            imag: Array.from(real, ()=>0),
            real: real
        };
    }
    if (real === undefined) return {
        ...options,
        imag: imag,
        real: Array.from(imag, ()=>0)
    };
    return {
        ...options,
        imag: imag,
        real: real
    };
};


const $440ef96c706c04e4$export$652ab3e522965552 = (audioParam, value, startTime)=>{
    try {
        audioParam.setValueAtTime(value, startTime);
    } catch (err) {
        if (err.code !== 9) throw err;
        $440ef96c706c04e4$export$652ab3e522965552(audioParam, value, startTime + 1e-7);
    }
};



const $afb242c72c255251$export$3211ed65c5b8326b = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.start();
    } catch  {
        return true;
    }
    return false;
};


const $5e33ae28019f460b$export$74929efb99360b7a = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    try {
        nativeAudioBufferSourceNode.start(0, 1);
    } catch  {
        return false;
    }
    return true;
};


const $58a02af0bb373801$export$c29f4eec5460fc70 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.stop();
    } catch  {
        return false;
    }
    return true;
};


const $e3ec52da21f65de4$export$9be334adb9176c59 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.start(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};


const $1c24db9ea4c2ab6a$export$a7f1019c14a08879 = (nativeContext)=>{
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    nativeAudioBufferSourceNode.start();
    nativeAudioBufferSourceNode.stop();
    try {
        nativeAudioBufferSourceNode.stop();
        return true;
    } catch  {
        return false;
    }
};


const $3293f15c79e15817$export$67a72517a9facc5 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.stop(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};


const $7a5435b9aad5e7c5$export$a40748749fc273c5 = (audioWorkletNodeOptions)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
        port2.close();
    }
};


/*
 * Bug #122: Edge up to version v18 did not allow to construct a DOMException'. It also had a couple more bugs but since this is easy to
 * test it's used here as a placeholder.
 *
 * Bug #27: Edge up to version v18 did reject an invalid arrayBuffer passed to decodeAudioData() with a DOMException.
 *
 * Bug #50: Edge up to version v18 did not allow to create AudioNodes on a closed context.
 *
 * Bug #57: Edge up to version v18 did not throw an error when assigning the type of an OscillatorNode to 'custom'.
 *
 * Bug #63: Edge up to version v18 did not expose the mediaElement property of a MediaElementAudioSourceNode.
 *
 * Bug #64: Edge up to version v18 did not support the MediaStreamAudioDestinationNode.
 *
 * Bug #71: Edge up to version v18 did not allow to set the buffer of an AudioBufferSourceNode to null.
 *
 * Bug #93: Edge up to version v18 did set the sampleRate of an AudioContext to zero when it was closed.
 *
 * Bug #101: Edge up to version v18 refused to execute decodeAudioData() on a closed context.
 *
 * Bug #106: Edge up to version v18 did not expose the maxValue and minValue properties of the pan AudioParam of a StereoPannerNode.
 *
 * Bug #110: Edge up to version v18 did not expose the maxValue and minValue properties of the attack, knee, ratio, release and threshold AudioParams of a DynamicsCompressorNode.
 *
 * Bug #123: Edge up to version v18 did not support HRTF as the panningModel for a PannerNode.
 *
 * Bug #145: Edge up to version v18 did throw an IndexSizeError when an OfflineAudioContext was created with a sampleRate of zero.
 *
 * Bug #161: Edge up to version v18 did not expose the maxValue and minValue properties of the delayTime AudioParam of a DelayNode.
 */ const $142bc72578879373$export$1310f0b96d9d8115 = ()=>{
    try {
        new DOMException(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};



// Safari at version 11 did not support transferables.
const $d94cd1a35a36191a$export$4f6e0d4bb1ead9ce = ()=>new Promise((resolve)=>{
        const arrayBuffer = new ArrayBuffer(0);
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>resolve(data !== null);
        port2.postMessage(arrayBuffer, [
            arrayBuffer
        ]);
    });


const $5a1e9b5ab7a1c99f$export$c3eb87c85305df2 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            const buffer = nativeAudioBufferSourceNode.buffer;
            // Bug #154: Safari does not clamp the offset if it is equal to or greater than the duration of the buffer.
            const clampedOffset = buffer === null ? offset : Math.min(buffer.duration, offset);
            // Bug #155: Safari does not handle the offset correctly if it would cause the buffer to be not be played at all.
            if (buffer !== null && clampedOffset > buffer.duration - 0.5 / nativeAudioBufferSourceNode.context.sampleRate) start.call(nativeAudioBufferSourceNode, when, 0, 0);
            else start.call(nativeAudioBufferSourceNode, when, clampedOffset, duration);
        };
    })(nativeAudioBufferSourceNode.start);
};



const $ca5dca3e6ca0fcd2$export$587074127be31245 = (nativeAudioScheduledSourceNode, nativeContext)=>{
    const nativeGainNode = nativeContext.createGain();
    nativeAudioScheduledSourceNode.connect(nativeGainNode);
    const disconnectGainNode = ((disconnect)=>{
        return ()=>{
            // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
            disconnect.call(nativeAudioScheduledSourceNode, nativeGainNode);
            nativeAudioScheduledSourceNode.removeEventListener('ended', disconnectGainNode);
        };
    })(nativeAudioScheduledSourceNode.disconnect);
    nativeAudioScheduledSourceNode.addEventListener('ended', disconnectGainNode);
    (0, $900bfd37a2c1e10d$export$19c8a106f82dff14)(nativeAudioScheduledSourceNode, nativeGainNode);
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        let isStopped = false;
        return (when = 0)=>{
            if (isStopped) try {
                stop.call(nativeAudioScheduledSourceNode, when);
            } catch  {
                nativeGainNode.gain.setValueAtTime(0, when);
            }
            else {
                stop.call(nativeAudioScheduledSourceNode, when);
                isStopped = true;
            }
        };
    })(nativeAudioScheduledSourceNode.stop);
};


const $434a1efbbe1460a6$export$63f14ca2e716ed28 = (target, eventListener)=>{
    return (event)=>{
        const descriptor = {
            value: target
        };
        Object.defineProperties(event, {
            currentTarget: descriptor,
            target: descriptor
        });
        if (typeof eventListener === 'function') return eventListener.call(target, event);
        return eventListener.handleEvent.call(target, event);
    };
};








































































































































































// @todo This is currently named IWorkletOptions and not IAudioWorkletOptions because it defines the options of a generic Worklet.




























































































































































































































































































































































































































































































































































































































































































































































































































const $dd284deb2f465d95$var$addActiveInputConnectionToAudioNode = (0, $b646bcb0a86c631b$export$43d20cccdc976834)((0, $e6ab5bfca0b63cf7$export$64505511c8abc942));
const $dd284deb2f465d95$var$addPassiveInputConnectionToAudioNode = (0, $82c0b56b5effd879$export$67aa4e90be3a506b)((0, $e6ab5bfca0b63cf7$export$64505511c8abc942));
const $dd284deb2f465d95$var$deleteActiveInputConnectionToAudioNode = (0, $85c84ce05513d4a0$export$1f7c0152b9e322ae)((0, $b040556145ba427c$export$3f1b331b43a0e659));
const $dd284deb2f465d95$var$audioNodeTailTimeStore = new WeakMap();
const $dd284deb2f465d95$var$getAudioNodeTailTime = (0, $72b6e297b7c98cbb$export$4abc3abd061bc2cc)($dd284deb2f465d95$var$audioNodeTailTimeStore);
const $dd284deb2f465d95$var$cacheTestResult = (0, $af3e1769cc80141b$export$e72d622686b5f6c7)(new Map(), new WeakMap());
const $dd284deb2f465d95$var$window = (0, $c88f24e5b3fefd1f$export$ba255020126e276e)();
const $dd284deb2f465d95$var$createNativeAnalyserNode = (0, $320337e4f695847d$export$36e704ad7c903a26)($dd284deb2f465d95$var$cacheTestResult, (0, $4d0b106e88d3580d$export$926e4aa3eed6ec13));
const $dd284deb2f465d95$var$getAudioNodeRenderer = (0, $7905bd1efa914bd5$export$97bb1acefff8970e)((0, $8c427995665b3ffa$export$6b29eee2af836dfc));
const $dd284deb2f465d95$var$renderInputsOfAudioNode = (0, $6043bc772a73bc2b$export$cff0938ddf51f6f4)((0, $8c427995665b3ffa$export$6b29eee2af836dfc), $dd284deb2f465d95$var$getAudioNodeRenderer, (0, $0f23cc3dee4d6a7f$export$8658a39a04a404d5));
const $dd284deb2f465d95$var$createAnalyserNodeRenderer = (0, $8dcf092e8be673b7$export$5fe3f5c2d995fe20)($dd284deb2f465d95$var$createNativeAnalyserNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$var$getNativeContext = (0, $c493805cef303fde$export$797a319a8065fb37)((0, $063560d8523a7eb5$export$7d17302229276f06));
const $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor = (0, $b808050287dcf7fe$export$e628a2a5fd5b78b9)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$isNativeOfflineAudioContext = (0, $8288725d93323f74$export$722bd4bab77df75a)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor);
const $dd284deb2f465d95$var$audioParamAudioNodeStore = new WeakMap();
const $dd284deb2f465d95$var$eventTargetConstructor = (0, $f77562cca85f27c5$export$a512af3fc2ab91f2)((0, $434a1efbbe1460a6$export$63f14ca2e716ed28));
const $dd284deb2f465d95$var$nativeAudioContextConstructor = (0, $b174c3cd8dc2c9e6$export$3a22fc4046f7b4ec)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$isNativeAudioContext = (0, $27e5f4b8882b02ee$export$5d44272df169092e)($dd284deb2f465d95$var$nativeAudioContextConstructor);
const $dd284deb2f465d95$var$isNativeAudioNode = (0, $4e598b45f53fc947$export$96f2bb6e8a5795ea)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$isNativeAudioParam = (0, $e02daab6a7e4bfbe$export$7c3a44537acaf24e)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$nativeAudioWorkletNodeConstructor = (0, $9acbfdce1428f919$export$b0ef4818c07d1453)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$audioNodeConstructor = (0, $f7091401ab9fe646$export$20e3fa4f981cb01d)((0, $12127b780360ed7a$export$7ff07578cebde522)((0, $063560d8523a7eb5$export$61ca80a8c8c6d728)), (0, $4a9ebe5f527c8af2$export$1776cf0d295db1d7)($dd284deb2f465d95$var$addActiveInputConnectionToAudioNode, $dd284deb2f465d95$var$addPassiveInputConnectionToAudioNode, (0, $2167468b26f40e2e$export$b92162b3199b4461), $dd284deb2f465d95$var$deleteActiveInputConnectionToAudioNode, (0, $f65544ff5369b765$export$a19b495df4b88921), (0, $8c427995665b3ffa$export$6b29eee2af836dfc), $dd284deb2f465d95$var$getAudioNodeTailTime, (0, $eb1a7cc50e1a0085$export$caac7ea54cb93b25), (0, $a25444b65385088d$export$e719c0d45ea16d08), (0, $e6ab5bfca0b63cf7$export$64505511c8abc942), (0, $503abdc94195f7ae$export$e44f0fc8e83fb084), (0, $0f23cc3dee4d6a7f$export$8658a39a04a404d5), (0, $b765ea918e2b8359$export$79a7cb9fa56970e)), $dd284deb2f465d95$var$cacheTestResult, (0, $379675dcab724dbd$export$e306a463e9286bbd)((0, $063560d8523a7eb5$export$cf686a6a3e402092), (0, $f65544ff5369b765$export$a19b495df4b88921), (0, $8c427995665b3ffa$export$6b29eee2af836dfc), (0, $a25444b65385088d$export$e719c0d45ea16d08), (0, $44fe7bee8da5f8b6$export$fad3d843b2a56ffb), (0, $503abdc94195f7ae$export$e44f0fc8e83fb084)), (0, $4d0b106e88d3580d$export$926e4aa3eed6ec13), (0, $d5b9a4487fd5e996$export$254c536c2ca9b917), (0, $04b2e9cba31dc468$export$dbebdb13622d486c), (0, $98964fb918f30d92$export$93f58f9268fde9f6)((0, $2167468b26f40e2e$export$b92162b3199b4461), (0, $063560d8523a7eb5$export$cf686a6a3e402092), (0, $8c427995665b3ffa$export$6b29eee2af836dfc), (0, $a25444b65385088d$export$e719c0d45ea16d08), (0, $44fe7bee8da5f8b6$export$fad3d843b2a56ffb), $dd284deb2f465d95$var$getNativeContext, (0, $503abdc94195f7ae$export$e44f0fc8e83fb084), $dd284deb2f465d95$var$isNativeOfflineAudioContext), (0, $38a9fb4c6f21e90a$export$b4f8d2824d9887dc)($dd284deb2f465d95$var$audioParamAudioNodeStore, (0, $8c427995665b3ffa$export$6b29eee2af836dfc), (0, $a30e5f89486249dd$export$520987e3ff3ffad3)), $dd284deb2f465d95$var$eventTargetConstructor, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeAudioContext, $dd284deb2f465d95$var$isNativeAudioNode, $dd284deb2f465d95$var$isNativeAudioParam, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$nativeAudioWorkletNodeConstructor);
const $dd284deb2f465d95$export$ed204192bbbabcef = (0, $5c7bc54ab41e693e$export$569b2da15d7fe153)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAnalyserNodeRenderer, (0, $4d0b106e88d3580d$export$926e4aa3eed6ec13), $dd284deb2f465d95$var$createNativeAnalyserNode, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$var$audioBufferStore = new WeakSet();
const $dd284deb2f465d95$var$nativeAudioBufferConstructor = (0, $8b8fb3c3b191f477$export$1ddb6a79e564be96)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$convertNumberToUnsignedLong = (0, $0a226f4b1123cd32$export$540e228106d2c471)(new Uint32Array(1));
const $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethods = (0, $5f8cc07022a7dc56$export$dbf1ce6ba2b4bc6a)($dd284deb2f465d95$var$convertNumberToUnsignedLong, (0, $4d0b106e88d3580d$export$926e4aa3eed6ec13));
const $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethodsOutOfBounds = (0, $75c0502605549efa$export$bff9a41e76b37a6e)($dd284deb2f465d95$var$convertNumberToUnsignedLong);
const $dd284deb2f465d95$export$2dbca7d91f7769d7 = (0, $15784a30c090bf38$export$c8b88126795b7df2)($dd284deb2f465d95$var$audioBufferStore, $dd284deb2f465d95$var$cacheTestResult, (0, $04b2e9cba31dc468$export$dbebdb13622d486c), $dd284deb2f465d95$var$nativeAudioBufferConstructor, $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor, (0, $f4396aa7947e4289$export$5bddcff46df9c642)($dd284deb2f465d95$var$nativeAudioBufferConstructor), $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethods, $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $dd284deb2f465d95$var$addSilentConnection = (0, $dbd295179837d595$export$c6991e18a29704b9)((0, $3965703d51935300$export$7cf909169b9c4d6f));
const $dd284deb2f465d95$var$renderInputsOfAudioParam = (0, $dbeef96128f81fb2$export$82cd58acb1062198)($dd284deb2f465d95$var$getAudioNodeRenderer, (0, $8ece18592a1d3a4f$export$1b11f454bf19657), (0, $0f23cc3dee4d6a7f$export$8658a39a04a404d5));
const $dd284deb2f465d95$var$connectAudioParam = (0, $bc0c5c6dd5333aa6$export$1e69fdca2ad79f10)($dd284deb2f465d95$var$renderInputsOfAudioParam);
const $dd284deb2f465d95$var$createNativeAudioBufferSourceNode = (0, $455e7c248d85054a$export$4f48c993f264b207)($dd284deb2f465d95$var$addSilentConnection, $dd284deb2f465d95$var$cacheTestResult, (0, $afb242c72c255251$export$3211ed65c5b8326b), (0, $5e33ae28019f460b$export$74929efb99360b7a), (0, $58a02af0bb373801$export$c29f4eec5460fc70), (0, $e3ec52da21f65de4$export$9be334adb9176c59), (0, $1c24db9ea4c2ab6a$export$a7f1019c14a08879), (0, $3293f15c79e15817$export$67a72517a9facc5), (0, $5a1e9b5ab7a1c99f$export$c3eb87c85305df2), (0, $9e3ed7199324f30a$export$3c1722ed0f0ed532)((0, $46c85403dfb52f0e$export$f25ed0e1b53c5d37)), (0, $ca5dca3e6ca0fcd2$export$587074127be31245));
const $dd284deb2f465d95$var$renderAutomation = (0, $6020b9f8edefa15e$export$889eef7d338963f6)((0, $0da9d58f0d78ecd1$export$1653dd3e76bcb1b0)((0, $8ece18592a1d3a4f$export$1b11f454bf19657)), $dd284deb2f465d95$var$renderInputsOfAudioParam);
const $dd284deb2f465d95$var$createAudioBufferSourceNodeRenderer = (0, $a0f25202631bec54$export$82721be5d1bb22c5)($dd284deb2f465d95$var$connectAudioParam, $dd284deb2f465d95$var$createNativeAudioBufferSourceNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$var$createAudioParam = (0, $10cae184a6e8a9ae$export$25d3edb077748cfc)((0, $2ea332361a1ef3c3$export$25226f7a087f88c3)((0, $063560d8523a7eb5$export$c5d3ff1f46a0185a)), $dd284deb2f465d95$var$audioParamAudioNodeStore, (0, $063560d8523a7eb5$export$55484e3055c7a9e2), (0, $b8c9a078b765371e$export$8858f507eb103ac6), (0, $ab26ec1106ccdbea$exports.createCancelAndHoldAutomationEvent), (0, $ab26ec1106ccdbea$exports.createCancelScheduledValuesAutomationEvent), (0, $ab26ec1106ccdbea$exports.createExponentialRampToValueAutomationEvent), (0, $ab26ec1106ccdbea$exports.createLinearRampToValueAutomationEvent), (0, $ab26ec1106ccdbea$exports.createSetTargetAutomationEvent), (0, $ab26ec1106ccdbea$exports.createSetValueAutomationEvent), (0, $ab26ec1106ccdbea$exports.createSetValueCurveAutomationEvent), $dd284deb2f465d95$var$nativeAudioContextConstructor, (0, $440ef96c706c04e4$export$652ab3e522965552));
const $dd284deb2f465d95$export$c1b1480edd16e065 = (0, $1d8cf95ce21b401a$export$6857b764b4428518)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioBufferSourceNodeRenderer, $dd284deb2f465d95$var$createAudioParam, (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeAudioBufferSourceNode, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, (0, $434a1efbbe1460a6$export$63f14ca2e716ed28));
const $dd284deb2f465d95$var$audioDestinationNodeConstructor = (0, $00d55746043f7ae9$export$cbbb0c3ba3f5dd5b)($dd284deb2f465d95$var$audioNodeConstructor, (0, $002b7bffdee189c2$export$d44f3f5d4e42ced2), (0, $4d0b106e88d3580d$export$926e4aa3eed6ec13), (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), (0, $7d5d63ea08d09167$export$d3097038f258fce)((0, $3965703d51935300$export$7cf909169b9c4d6f), (0, $46c85403dfb52f0e$export$f25ed0e1b53c5d37)), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$var$createBiquadFilterNodeRenderer = (0, $ce516b52d946e959$export$1532cc6682032d84)($dd284deb2f465d95$var$connectAudioParam, (0, $4c7d1977ac981af8$export$97e69c8dbd260f85), (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$var$setAudioNodeTailTime = (0, $9e1693c764da0c5c$export$c5e78cc8035d00aa)($dd284deb2f465d95$var$audioNodeTailTimeStore);
const $dd284deb2f465d95$export$f068340fbfd684eb = (0, $36a4a36f22d1d20a$export$aa421daabad177b5)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createBiquadFilterNodeRenderer, (0, $d5b9a4487fd5e996$export$254c536c2ca9b917), (0, $4c7d1977ac981af8$export$97e69c8dbd260f85), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$setAudioNodeTailTime);
const $dd284deb2f465d95$var$monitorConnections = (0, $2109969fcb7bbded$export$9f33b5a0b80f2717)((0, $e6ab5bfca0b63cf7$export$64505511c8abc942), $dd284deb2f465d95$var$isNativeAudioNode);
const $dd284deb2f465d95$var$wrapChannelMergerNode = (0, $72925d67d3b2202d$export$162785cfa8a63221)((0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$monitorConnections);
const $dd284deb2f465d95$var$createNativeChannelMergerNode = (0, $7e677dc375016540$export$99fe194415d94151)($dd284deb2f465d95$var$nativeAudioContextConstructor, $dd284deb2f465d95$var$wrapChannelMergerNode);
const $dd284deb2f465d95$var$createChannelMergerNodeRenderer = (0, $9c2b7ff5228068f2$export$79056cbe2b10cae5)($dd284deb2f465d95$var$createNativeChannelMergerNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$7488bfd772ec10fc = (0, $b6e468c80b067009$export$a65a5a400135d27)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createChannelMergerNodeRenderer, $dd284deb2f465d95$var$createNativeChannelMergerNode, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$var$createChannelSplitterNodeRenderer = (0, $195c18eec70c40c3$export$d815cad16abde9c3)((0, $eb6e154d4211f7ae$export$17649533bf213707), (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$6f860927b3cf75c1 = (0, $21176c212530cf3a$export$ce9d996cafa605b)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createChannelSplitterNodeRenderer, (0, $eb6e154d4211f7ae$export$17649533bf213707), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, (0, $9359fe94645a15be$export$6edb0bde597f2c9a));
const $dd284deb2f465d95$var$createNativeConstantSourceNodeFaker = (0, $fa4d351520187cd9$export$360749cf3d02285a)($dd284deb2f465d95$var$addSilentConnection, $dd284deb2f465d95$var$createNativeAudioBufferSourceNode, (0, $3965703d51935300$export$7cf909169b9c4d6f), $dd284deb2f465d95$var$monitorConnections);
const $dd284deb2f465d95$var$createNativeConstantSourceNode = (0, $27cb740f471b1f49$export$2dd44f7bb3dd8089)($dd284deb2f465d95$var$addSilentConnection, $dd284deb2f465d95$var$cacheTestResult, $dd284deb2f465d95$var$createNativeConstantSourceNodeFaker, (0, $e3ec52da21f65de4$export$9be334adb9176c59), (0, $3293f15c79e15817$export$67a72517a9facc5));
const $dd284deb2f465d95$var$createConstantSourceNodeRenderer = (0, $759e2b050fe8a44a$export$bc541a3c87b45a7d)($dd284deb2f465d95$var$connectAudioParam, $dd284deb2f465d95$var$createNativeConstantSourceNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$d394f3dc072b3480 = (0, $33d67bcca502b0be$export$a02a9a6200996500)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createConstantSourceNodeRenderer, $dd284deb2f465d95$var$createNativeConstantSourceNode, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, (0, $434a1efbbe1460a6$export$63f14ca2e716ed28));
const $dd284deb2f465d95$var$createNativeConvolverNode = (0, $f8c85b2d5c748d5a$export$afdcf89d13ff62e)((0, $04b2e9cba31dc468$export$dbebdb13622d486c), (0, $46c85403dfb52f0e$export$f25ed0e1b53c5d37));
const $dd284deb2f465d95$var$createConvolverNodeRenderer = (0, $e49830cde0da43f3$export$5b278ccdb1a6393)($dd284deb2f465d95$var$createNativeConvolverNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$20cfee6cb9c5d644 = (0, $5bc4231d0341670e$export$4894173a4b4ee485)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createConvolverNodeRenderer, $dd284deb2f465d95$var$createNativeConvolverNode, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$setAudioNodeTailTime);
const $dd284deb2f465d95$var$createDelayNodeRenderer = (0, $1c495b946a181301$export$d03c2308083a28e5)($dd284deb2f465d95$var$connectAudioParam, (0, $044670cab61f9ad3$export$f7dd6d407a2109ef), (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$ce8664483cc583db = (0, $0f2ec2fb49743844$export$b89a0215c1c607e3)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createDelayNodeRenderer, (0, $044670cab61f9ad3$export$f7dd6d407a2109ef), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$setAudioNodeTailTime);
const $dd284deb2f465d95$var$createNativeDynamicsCompressorNode = (0, $2ab5f70826dc282d$export$f19d90a0cd4a2ecc)((0, $04b2e9cba31dc468$export$dbebdb13622d486c));
const $dd284deb2f465d95$var$createDynamicsCompressorNodeRenderer = (0, $b8141f8bf6a9223d$export$1b1e82cc3f0a2c8)($dd284deb2f465d95$var$connectAudioParam, $dd284deb2f465d95$var$createNativeDynamicsCompressorNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$c74a663d797d02ba = (0, $318a8077a10d6784$export$60ec6725c2d45fc8)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createDynamicsCompressorNodeRenderer, $dd284deb2f465d95$var$createNativeDynamicsCompressorNode, (0, $04b2e9cba31dc468$export$dbebdb13622d486c), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$setAudioNodeTailTime);
const $dd284deb2f465d95$var$createGainNodeRenderer = (0, $b8c579544df95d54$export$7312404e5bea9cd)($dd284deb2f465d95$var$connectAudioParam, (0, $3965703d51935300$export$7cf909169b9c4d6f), (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$db147ea22bd7e3ce = (0, $a7d03eaa13cb4139$export$7b37b693b55bf5d7)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createGainNodeRenderer, (0, $3965703d51935300$export$7cf909169b9c4d6f), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$var$createNativeIIRFilterNodeFaker = (0, $de8dfc2add5cb231$export$49dca6a724f463b)((0, $d5b9a4487fd5e996$export$254c536c2ca9b917), (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), (0, $ce98e9e38de0c041$export$9f784f497a6d6acb), (0, $04b2e9cba31dc468$export$dbebdb13622d486c));
const $dd284deb2f465d95$var$renderNativeOfflineAudioContext = (0, $0b946b5c2554feb1$export$feb8d4a8e403af48)($dd284deb2f465d95$var$cacheTestResult, (0, $3965703d51935300$export$7cf909169b9c4d6f), (0, $ce98e9e38de0c041$export$9f784f497a6d6acb), (0, $bd137f4ed4ae506e$export$6db7e9dd49157213)((0, $3965703d51935300$export$7cf909169b9c4d6f), $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor));
const $dd284deb2f465d95$var$createIIRFilterNodeRenderer = (0, $5f9674e3cd03078f$export$329316f0ca6cf17e)($dd284deb2f465d95$var$createNativeAudioBufferSourceNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor, $dd284deb2f465d95$var$renderInputsOfAudioNode, $dd284deb2f465d95$var$renderNativeOfflineAudioContext);
const $dd284deb2f465d95$var$createNativeIIRFilterNode = (0, $b2bc07259451fc8c$export$3c1aed24ed6efd9d)($dd284deb2f465d95$var$createNativeIIRFilterNodeFaker);
const $dd284deb2f465d95$export$81c00f34825a7708 = (0, $9017795a9f3f416c$export$a22f1eb785a05608)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createNativeIIRFilterNode, $dd284deb2f465d95$var$createIIRFilterNodeRenderer, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$setAudioNodeTailTime);
const $dd284deb2f465d95$var$createAudioListener = (0, $d58e9c03ca8eb821$export$3e70692c55bd5b52)($dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createNativeChannelMergerNode, $dd284deb2f465d95$var$createNativeConstantSourceNode, (0, $ce98e9e38de0c041$export$9f784f497a6d6acb), (0, $04b2e9cba31dc468$export$dbebdb13622d486c), (0, $97988ab397cf266d$export$4ec0c13c358eb2b5), $dd284deb2f465d95$var$isNativeOfflineAudioContext, (0, $46c85403dfb52f0e$export$f25ed0e1b53c5d37));
const $dd284deb2f465d95$var$unrenderedAudioWorkletNodeStore = new WeakMap();
const $dd284deb2f465d95$var$minimalBaseAudioContextConstructor = (0, $12328baab9a3bae7$export$3f49d9c870ba2692)($dd284deb2f465d95$var$audioDestinationNodeConstructor, $dd284deb2f465d95$var$createAudioListener, $dd284deb2f465d95$var$eventTargetConstructor, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$unrenderedAudioWorkletNodeStore, (0, $434a1efbbe1460a6$export$63f14ca2e716ed28));
const $dd284deb2f465d95$var$createNativeOscillatorNode = (0, $9d9c4636eb90f334$export$a40e02c218ae01d3)($dd284deb2f465d95$var$addSilentConnection, $dd284deb2f465d95$var$cacheTestResult, (0, $e3ec52da21f65de4$export$9be334adb9176c59), (0, $1c24db9ea4c2ab6a$export$a7f1019c14a08879), (0, $3293f15c79e15817$export$67a72517a9facc5), (0, $ca5dca3e6ca0fcd2$export$587074127be31245));
const $dd284deb2f465d95$var$createOscillatorNodeRenderer = (0, $abe65c5b4b23c0ab$export$99143538b3590be5)($dd284deb2f465d95$var$connectAudioParam, $dd284deb2f465d95$var$createNativeOscillatorNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$f44e83cdc55961f2 = (0, $02857985c06e48d0$export$c1c3584074b042b3)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createNativeOscillatorNode, $dd284deb2f465d95$var$createOscillatorNodeRenderer, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, (0, $434a1efbbe1460a6$export$63f14ca2e716ed28));
const $dd284deb2f465d95$var$createConnectedNativeAudioBufferSourceNode = (0, $edb3001c457f5d46$export$e82b2b63ea82dc82)($dd284deb2f465d95$var$createNativeAudioBufferSourceNode);
const $dd284deb2f465d95$var$createNativeWaveShaperNodeFaker = (0, $d7a2d82fb19eb7a0$export$f5f0b26abc22907e)($dd284deb2f465d95$var$createConnectedNativeAudioBufferSourceNode, (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), (0, $3965703d51935300$export$7cf909169b9c4d6f), (0, $98792b855212607a$export$b32eba1f356dc699), $dd284deb2f465d95$var$monitorConnections);
const $dd284deb2f465d95$var$createNativeWaveShaperNode = (0, $2f2c2819a28b32b4$export$75168c4c8ce320c4)($dd284deb2f465d95$var$createConnectedNativeAudioBufferSourceNode, (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeWaveShaperNodeFaker, (0, $98792b855212607a$export$b32eba1f356dc699), $dd284deb2f465d95$var$monitorConnections, $dd284deb2f465d95$var$nativeAudioContextConstructor, (0, $46c85403dfb52f0e$export$f25ed0e1b53c5d37));
const $dd284deb2f465d95$var$createNativePannerNodeFaker = (0, $bf1f8e186f9f5924$export$f04468477689c1b4)((0, $2167468b26f40e2e$export$b92162b3199b4461), (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeChannelMergerNode, (0, $3965703d51935300$export$7cf909169b9c4d6f), (0, $ce98e9e38de0c041$export$9f784f497a6d6acb), $dd284deb2f465d95$var$createNativeWaveShaperNode, (0, $04b2e9cba31dc468$export$dbebdb13622d486c), (0, $f65544ff5369b765$export$a19b495df4b88921), (0, $97988ab397cf266d$export$4ec0c13c358eb2b5), $dd284deb2f465d95$var$monitorConnections);
const $dd284deb2f465d95$var$createNativePannerNode = (0, $bcbbd7243a1d01e6$export$8e3c89af72a58833)($dd284deb2f465d95$var$createNativePannerNodeFaker);
const $dd284deb2f465d95$var$createPannerNodeRenderer = (0, $bca6f8bc10c68bcf$export$ccd091498494025)($dd284deb2f465d95$var$connectAudioParam, $dd284deb2f465d95$var$createNativeChannelMergerNode, $dd284deb2f465d95$var$createNativeConstantSourceNode, (0, $3965703d51935300$export$7cf909169b9c4d6f), $dd284deb2f465d95$var$createNativePannerNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor, $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode, $dd284deb2f465d95$var$renderNativeOfflineAudioContext);
const $dd284deb2f465d95$export$dafa2f26c98332af = (0, $f2c10d2f8c2b6ea3$export$91b046021cf98bac)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createNativePannerNode, $dd284deb2f465d95$var$createPannerNodeRenderer, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$setAudioNodeTailTime);
const $dd284deb2f465d95$var$createNativePeriodicWave = (0, $6d8ee1bebc39d00d$export$3f519524c23feca0)((0, $4d0b106e88d3580d$export$926e4aa3eed6ec13));
const $dd284deb2f465d95$export$6b71e63ac9d62aa3 = (0, $bcdb4c40b77d698f$export$10e47cfa48a5069d)($dd284deb2f465d95$var$createNativePeriodicWave, $dd284deb2f465d95$var$getNativeContext, new WeakSet(), (0, $5f31e98c1dcc9805$export$833c872c8eda5015));
const $dd284deb2f465d95$var$nativeStereoPannerNodeFakerFactory = (0, $bfb8b52e9bdf9d42$export$5fe2a787c06b2d34)($dd284deb2f465d95$var$createNativeChannelMergerNode, (0, $eb6e154d4211f7ae$export$17649533bf213707), (0, $3965703d51935300$export$7cf909169b9c4d6f), $dd284deb2f465d95$var$createNativeWaveShaperNode, (0, $04b2e9cba31dc468$export$dbebdb13622d486c), $dd284deb2f465d95$var$monitorConnections);
const $dd284deb2f465d95$var$createNativeStereoPannerNode = (0, $2bfde3b6c5ad3b93$export$247580dcf7d2f2c4)($dd284deb2f465d95$var$nativeStereoPannerNodeFakerFactory, (0, $04b2e9cba31dc468$export$dbebdb13622d486c));
const $dd284deb2f465d95$var$createStereoPannerNodeRenderer = (0, $cf1c501560a0f777$export$3ba9002bd6b539cf)($dd284deb2f465d95$var$connectAudioParam, $dd284deb2f465d95$var$createNativeStereoPannerNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$4ee0e4c1628c69a6 = (0, $666d48b9edf5c35d$export$9b005b0c35721c84)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createNativeStereoPannerNode, $dd284deb2f465d95$var$createStereoPannerNodeRenderer, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$var$createWaveShaperNodeRenderer = (0, $5adc61e34c426c5f$export$9709a48a5037d121)($dd284deb2f465d95$var$createNativeWaveShaperNode, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$renderInputsOfAudioNode);
const $dd284deb2f465d95$export$400071720810ca26 = (0, $7d36aa63ccfd8c9c$export$3a30e911e17b1cf5)($dd284deb2f465d95$var$audioNodeConstructor, (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeWaveShaperNode, $dd284deb2f465d95$var$createWaveShaperNodeRenderer, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$setAudioNodeTailTime);
const $dd284deb2f465d95$var$isSecureContext = (0, $1906dbddefaf3bd4$export$2e9a7e6b17a9abae)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$exposeCurrentFrameAndCurrentTime = (0, $4d36b7de4be93f4e$export$c43b8ab5e8913cbb)($dd284deb2f465d95$var$window);
const $dd284deb2f465d95$var$backupOfflineAudioContextStore = new WeakMap();
const $dd284deb2f465d95$var$getOrCreateBackupOfflineAudioContext = (0, $8546f1058c7ad9ca$export$70df0ae42e1340c8)($dd284deb2f465d95$var$backupOfflineAudioContextStore, $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor);
const $dd284deb2f465d95$export$f820757b6d3df312 = $dd284deb2f465d95$var$isSecureContext ? (0, $ce06fe6462f7561e$export$16c6049a33c70efa)($dd284deb2f465d95$var$cacheTestResult, (0, $04b2e9cba31dc468$export$dbebdb13622d486c), (0, $93ab3e52560a3d1a$export$43b563d089dd1d8)($dd284deb2f465d95$var$window), $dd284deb2f465d95$var$exposeCurrentFrameAndCurrentTime, (0, $4421c430ef9ef0be$export$c7282a393375a8ca)((0, $f6277d111f8e5d11$export$aff31bd5258e9fd4)), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$getOrCreateBackupOfflineAudioContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$nativeAudioWorkletNodeConstructor, new WeakMap(), new WeakMap(), (0, $f589bc975e60193c$export$19b2cf184a7cfba8)($dd284deb2f465d95$var$nativeAudioWorkletNodeConstructor, $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), // @todo window is guaranteed to be defined because isSecureContext checks that as well.
$dd284deb2f465d95$var$window) : undefined;
const $dd284deb2f465d95$var$isNativeContext = (0, $3c161e75d4bd155d$export$a7c969701e5471d0)($dd284deb2f465d95$var$isNativeAudioContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$export$1fbfb80f24dc90ea = (0, $1fa33cee60a8fbee$export$d83e4a6039bccfb)($dd284deb2f465d95$var$audioBufferStore, $dd284deb2f465d95$var$cacheTestResult, (0, $91ae39be37a09214$export$fc1a599a84ca01a8), (0, $5d38f2b111b4df64$export$6372d3d9069bc778), new WeakSet(), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeContext, (0, $12a6e013f8a09c14$export$54e424f510c54ced), (0, $790c2f9ab3e8ea25$export$9ec44223b1284cd4), $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethods, $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $dd284deb2f465d95$var$baseAudioContextConstructor = (0, $43a0fa9c89e73420$export$7824d6f4713e1e35)($dd284deb2f465d95$export$f820757b6d3df312, $dd284deb2f465d95$export$ed204192bbbabcef, $dd284deb2f465d95$export$2dbca7d91f7769d7, $dd284deb2f465d95$export$c1b1480edd16e065, $dd284deb2f465d95$export$f068340fbfd684eb, $dd284deb2f465d95$export$7488bfd772ec10fc, $dd284deb2f465d95$export$6f860927b3cf75c1, $dd284deb2f465d95$export$d394f3dc072b3480, $dd284deb2f465d95$export$20cfee6cb9c5d644, $dd284deb2f465d95$export$1fbfb80f24dc90ea, $dd284deb2f465d95$export$ce8664483cc583db, $dd284deb2f465d95$export$c74a663d797d02ba, $dd284deb2f465d95$export$db147ea22bd7e3ce, $dd284deb2f465d95$export$81c00f34825a7708, $dd284deb2f465d95$var$minimalBaseAudioContextConstructor, $dd284deb2f465d95$export$f44e83cdc55961f2, $dd284deb2f465d95$export$dafa2f26c98332af, $dd284deb2f465d95$export$6b71e63ac9d62aa3, $dd284deb2f465d95$export$4ee0e4c1628c69a6, $dd284deb2f465d95$export$400071720810ca26);
const $dd284deb2f465d95$export$cbdfd9619c90296e = (0, $079115c0ef941b11$export$d24d3af0853fd021)($dd284deb2f465d95$var$audioNodeConstructor, (0, $52cabc1aa66bc20e$export$2b1682bf41b4d16b), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$export$3ebbc22363b821ba = (0, $89475f3ad216aff8$export$5d3ee2470cd2874)($dd284deb2f465d95$var$audioNodeConstructor, (0, $7f6a69fc18439af4$export$acb51039efa3405d), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$export$57f554392102e4c0 = (0, $97b84ffec3eb7e83$export$a42e10687df73a9d)($dd284deb2f465d95$var$audioNodeConstructor, (0, $bef6c01fc83a8f84$export$ad3e497ef44fc577), $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$var$createNativeMediaStreamTrackAudioSourceNode = (0, $572b286451ff8a1d$export$87e46bc6eb8ed6ac)((0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$export$b6c8ffccaed2d826 = (0, $58a5ef1f9d17e13b$export$24f27d34fdf823bc)($dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createNativeMediaStreamTrackAudioSourceNode, $dd284deb2f465d95$var$getNativeContext);
const $dd284deb2f465d95$export$fcbc63750ec2a81f = (0, $11e193d9c959815b$export$c6fe175def53ff71)($dd284deb2f465d95$var$baseAudioContextConstructor, (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), (0, $04b2e9cba31dc468$export$dbebdb13622d486c), (0, $8a5f1f3d40884e74$export$988fb803bae63f80), $dd284deb2f465d95$export$cbdfd9619c90296e, $dd284deb2f465d95$export$3ebbc22363b821ba, $dd284deb2f465d95$export$57f554392102e4c0, $dd284deb2f465d95$export$b6c8ffccaed2d826, $dd284deb2f465d95$var$nativeAudioContextConstructor);
const $dd284deb2f465d95$var$getUnrenderedAudioWorkletNodes = (0, $7f98b199b5686bd0$export$43ef7eb1ae3d2f40)($dd284deb2f465d95$var$unrenderedAudioWorkletNodeStore);
const $dd284deb2f465d95$var$addUnrenderedAudioWorkletNode = (0, $d0847042424bd9d5$export$fd0136b1517d036f)($dd284deb2f465d95$var$getUnrenderedAudioWorkletNodes);
const $dd284deb2f465d95$var$connectMultipleOutputs = (0, $fc80e8768a3bf27d$export$5f708e50316bf1a)((0, $4d0b106e88d3580d$export$926e4aa3eed6ec13));
const $dd284deb2f465d95$var$deleteUnrenderedAudioWorkletNode = (0, $d38b548213acb987$export$92df121abbf21dca)($dd284deb2f465d95$var$getUnrenderedAudioWorkletNodes);
const $dd284deb2f465d95$var$disconnectMultipleOutputs = (0, $d5650f4917318555$export$78a992fad11cd00e)((0, $4d0b106e88d3580d$export$926e4aa3eed6ec13));
const $dd284deb2f465d95$var$activeAudioWorkletNodeInputsStore = new WeakMap();
const $dd284deb2f465d95$var$getActiveAudioWorkletNodeInputs = (0, $3494284d53c386ba$export$8b01844840684f8d)($dd284deb2f465d95$var$activeAudioWorkletNodeInputsStore, (0, $a30e5f89486249dd$export$520987e3ff3ffad3));
const $dd284deb2f465d95$var$createNativeAudioWorkletNodeFaker = (0, $2e8d1870505b948b$export$ea40f9f600f0adcb)($dd284deb2f465d95$var$connectMultipleOutputs, (0, $4d0b106e88d3580d$export$926e4aa3eed6ec13), (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeChannelMergerNode, (0, $eb6e154d4211f7ae$export$17649533bf213707), $dd284deb2f465d95$var$createNativeConstantSourceNode, (0, $3965703d51935300$export$7cf909169b9c4d6f), (0, $ce98e9e38de0c041$export$9f784f497a6d6acb), (0, $04b2e9cba31dc468$export$dbebdb13622d486c), $dd284deb2f465d95$var$disconnectMultipleOutputs, $dd284deb2f465d95$var$exposeCurrentFrameAndCurrentTime, $dd284deb2f465d95$var$getActiveAudioWorkletNodeInputs, $dd284deb2f465d95$var$monitorConnections);
const $dd284deb2f465d95$var$createNativeAudioWorkletNode = (0, $bf228dd5f9198c20$export$a6399b47836cd044)((0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeAudioWorkletNodeFaker, (0, $3965703d51935300$export$7cf909169b9c4d6f), (0, $04b2e9cba31dc468$export$dbebdb13622d486c), $dd284deb2f465d95$var$monitorConnections);
const $dd284deb2f465d95$var$createAudioWorkletNodeRenderer = (0, $750258ff33a5082b$export$3a898af5d2b29a5b)($dd284deb2f465d95$var$connectAudioParam, $dd284deb2f465d95$var$connectMultipleOutputs, $dd284deb2f465d95$var$createNativeAudioBufferSourceNode, $dd284deb2f465d95$var$createNativeChannelMergerNode, (0, $eb6e154d4211f7ae$export$17649533bf213707), $dd284deb2f465d95$var$createNativeConstantSourceNode, (0, $3965703d51935300$export$7cf909169b9c4d6f), $dd284deb2f465d95$var$deleteUnrenderedAudioWorkletNode, $dd284deb2f465d95$var$disconnectMultipleOutputs, $dd284deb2f465d95$var$exposeCurrentFrameAndCurrentTime, (0, $a25444b65385088d$export$e719c0d45ea16d08), $dd284deb2f465d95$var$nativeAudioWorkletNodeConstructor, $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor, $dd284deb2f465d95$var$renderAutomation, $dd284deb2f465d95$var$renderInputsOfAudioNode, $dd284deb2f465d95$var$renderNativeOfflineAudioContext);
const $dd284deb2f465d95$var$getBackupOfflineAudioContext = (0, $025a53012dff4874$export$afecf147821b5609)($dd284deb2f465d95$var$backupOfflineAudioContextStore);
const $dd284deb2f465d95$var$setActiveAudioWorkletNodeInputs = (0, $120326ce44350082$export$17328c9508de4388)($dd284deb2f465d95$var$activeAudioWorkletNodeInputsStore);
// The AudioWorkletNode constructor is only available in a SecureContext.
const $dd284deb2f465d95$export$bc6715221481535 = $dd284deb2f465d95$var$isSecureContext ? (0, $720c5487527456e2$export$48302d37fa2cf062)($dd284deb2f465d95$var$addUnrenderedAudioWorkletNode, $dd284deb2f465d95$var$audioNodeConstructor, $dd284deb2f465d95$var$createAudioParam, $dd284deb2f465d95$var$createAudioWorkletNodeRenderer, $dd284deb2f465d95$var$createNativeAudioWorkletNode, (0, $8c427995665b3ffa$export$6b29eee2af836dfc), $dd284deb2f465d95$var$getBackupOfflineAudioContext, $dd284deb2f465d95$var$getNativeContext, $dd284deb2f465d95$var$isNativeOfflineAudioContext, $dd284deb2f465d95$var$nativeAudioWorkletNodeConstructor, (0, $60bb84eaa0062d6c$export$9a47aefcb4b02450), $dd284deb2f465d95$var$setActiveAudioWorkletNodeInputs, (0, $7a5435b9aad5e7c5$export$a40748749fc273c5), (0, $434a1efbbe1460a6$export$63f14ca2e716ed28)) : undefined;
const $dd284deb2f465d95$export$898a44341df73d6e = (0, $6b0a830f2ea9ee6f$export$8a5e66f668b2e9e8)((0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), (0, $04b2e9cba31dc468$export$dbebdb13622d486c), (0, $8a5f1f3d40884e74$export$988fb803bae63f80), $dd284deb2f465d95$var$minimalBaseAudioContextConstructor, $dd284deb2f465d95$var$nativeAudioContextConstructor);
const $dd284deb2f465d95$var$createNativeOfflineAudioContext = (0, $b94b99e9ef151b5d$export$ab44e304a31eb0ae)((0, $04b2e9cba31dc468$export$dbebdb13622d486c), $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor);
const $dd284deb2f465d95$var$startRendering = (0, $a166304a81a24a83$export$a04cd80dfb1b8309)($dd284deb2f465d95$var$audioBufferStore, $dd284deb2f465d95$var$cacheTestResult, $dd284deb2f465d95$var$getAudioNodeRenderer, $dd284deb2f465d95$var$getUnrenderedAudioWorkletNodes, $dd284deb2f465d95$var$renderNativeOfflineAudioContext, (0, $12a6e013f8a09c14$export$54e424f510c54ced), $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethods, $dd284deb2f465d95$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $dd284deb2f465d95$export$a6f995d32126fe2e = (0, $d3a2c4ee8588a6de$export$3d487af37fe7f521)($dd284deb2f465d95$var$cacheTestResult, (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeOfflineAudioContext, $dd284deb2f465d95$var$minimalBaseAudioContextConstructor, $dd284deb2f465d95$var$startRendering);
const $dd284deb2f465d95$export$5ab5c649a10df7db = (0, $b0e850ac703cdca5$export$a9b5caf52b398870)($dd284deb2f465d95$var$baseAudioContextConstructor, $dd284deb2f465d95$var$cacheTestResult, (0, $d3386d35bc2b7a66$export$5a1c4cd5830ea09b), $dd284deb2f465d95$var$createNativeOfflineAudioContext, $dd284deb2f465d95$var$startRendering);
const $dd284deb2f465d95$export$e55e427bf52f793d = (0, $3fb13afb989780c8$export$7030a6f3318876b)((0, $063560d8523a7eb5$export$7d17302229276f06), $dd284deb2f465d95$var$isNativeAudioContext);
const $dd284deb2f465d95$export$61ea8ea4691b9a32 = (0, $72567d9c778a8250$export$150a35c855945f9d)((0, $063560d8523a7eb5$export$864a3cfb55580d0c), $dd284deb2f465d95$var$isNativeAudioNode);
const $dd284deb2f465d95$export$254dcc24b342c8c2 = (0, $11df81699cdc985f$export$41505fc8888255a0)((0, $063560d8523a7eb5$export$55484e3055c7a9e2), $dd284deb2f465d95$var$isNativeAudioParam);
const $dd284deb2f465d95$export$e78994f7990ad5d3 = (0, $66bba1c5d93e8abe$export$845691ce8ebc2907)((0, $063560d8523a7eb5$export$7d17302229276f06), $dd284deb2f465d95$var$isNativeOfflineAudioContext);
const $dd284deb2f465d95$export$48c17662a6902497 = ()=>(0, $9be8ead70a901adf$export$a245ecb43f54c4de)($dd284deb2f465d95$var$cacheTestResult, (0, $c3e8d82c55ddf4a2$export$1995b5466f5c2709)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $e67fe62fc3ca8164$export$34981ee6aafdf532)($dd284deb2f465d95$var$nativeAudioContextConstructor), (0, $c36096dba3865ac7$export$622ba23aa6b35822)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $a91715fa5046b1a4$export$2f44088abd2df2e)($dd284deb2f465d95$var$nativeAudioContextConstructor), (0, $983026835cd4816a$export$f77a3bce7e4efd81)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $f253df1213fbfab8$export$ce5ba80a98dc0ba7)($dd284deb2f465d95$var$nativeAudioWorkletNodeConstructor, $dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $fed83104d448f843$export$a04037cfe0b977fa)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $a3245851525d5fbf$export$63ae3ec177f0ed66)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $2f4fe0305ef7af2f$export$b6f3c4027f959b95)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $6f4b71f217612aeb$export$d1bddb88e5c21d26)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $142bc72578879373$export$1310f0b96d9d8115), (0, $197c2ac4e9bc0425$export$41669e689e17d4f0)($dd284deb2f465d95$var$window), (0, $3500b38276420784$export$416bb3b14425e126)($dd284deb2f465d95$var$nativeAudioContextConstructor), (0, $f870c0bf15000a6f$export$5ea70af76c7a03fc)($dd284deb2f465d95$var$nativeOfflineAudioContextConstructor), (0, $d94cd1a35a36191a$export$4f6e0d4bb1ead9ce));


/**
 * Most scales, except the blues scale, have seven steps, 
 * while pentatonic scales have five steps.
 * there are different scales with custom tunings
 * out there but these are the classics
 * 
 * Dorian sounds brighter than Aeolian, 
 * but Phrygian and especially Locrian 
 * have a much darker sound 
 */ const $96f413b39c3d1f22$var$rotateArray = (a, n)=>{
    n = n % a.length;
    return a.slice(n, a.length).concat(a.slice(0, n));
};
const $96f413b39c3d1f22$export$eea29b9d2a589f3f = 'Ionian';
const $96f413b39c3d1f22$export$7553314f3dda4d80 = 'Dorian';
const $96f413b39c3d1f22$export$253a602a5c00bc = 'Phrygian';
const $96f413b39c3d1f22$export$c3ab3c7f6284107e = 'Lydian' // Harmonic Minor
;
const $96f413b39c3d1f22$export$9c8a499c95acb5dc = 'Mixolydian' // Melodic Minor
;
const $96f413b39c3d1f22$export$552fc2a6e5af96bb = 'Aeolian';
const $96f413b39c3d1f22$export$9da03196452327a1 = 'Locrian';
const $96f413b39c3d1f22$export$d70b64e2bb71bb4e = [
    $96f413b39c3d1f22$export$eea29b9d2a589f3f,
    $96f413b39c3d1f22$export$7553314f3dda4d80,
    $96f413b39c3d1f22$export$253a602a5c00bc,
    $96f413b39c3d1f22$export$c3ab3c7f6284107e,
    $96f413b39c3d1f22$export$9c8a499c95acb5dc,
    $96f413b39c3d1f22$export$552fc2a6e5af96bb,
    $96f413b39c3d1f22$export$9da03196452327a1 // * Start from seventh degree
];
const $96f413b39c3d1f22$export$6a4d1dd9fd40a1d0 = (mode)=>isNaN(parseInt(mode)) ? $96f413b39c3d1f22$export$d70b64e2bb71bb4e.indexOf(mode) : mode % $96f413b39c3d1f22$export$d70b64e2bb71bb4e.length;
const $96f413b39c3d1f22$export$73ad9fe2ff31b7b6 = (mode)=>isNaN(parseInt(mode)) ? mode : $96f413b39c3d1f22$export$d70b64e2bb71bb4e[mode % $96f413b39c3d1f22$export$d70b64e2bb71bb4e.length];
// Shifted intervals...
// To go from any specific note to any other specific note
const $96f413b39c3d1f22$var$TRANSPOSE_INTERVAL = {
    downOctave: -12,
    minorSecond: 1,
    majorSecond: 2,
    minorThird: 3,
    majorThird: 4,
    perfectFourth: 5,
    diminishedFifth: 6,
    perfectFifth: 7,
    minorSixth: 8,
    majorSixth: 9,
    minorSeventh: 10,
    majorSeventh: 11,
    perfectOctave: 12,
    upOctave: 12
};
const $96f413b39c3d1f22$export$11a614999be145f9 = [
    0,
    4,
    3
];
const $96f413b39c3d1f22$export$47ab18dfff75fa45 = [
    0,
    3,
    4
];
const $96f413b39c3d1f22$export$3a58a8a194b1d8c6 = [
    0,
    3,
    3
];
const $96f413b39c3d1f22$export$e179b19912ca2307 = [
    0,
    2,
    5
];
const $96f413b39c3d1f22$export$a341915e3ed074e5 = [
    0,
    5,
    2
];
const $96f413b39c3d1f22$export$e634fd595a3b06a5 = [
    0,
    3,
    4
];
const $96f413b39c3d1f22$export$2cc3e9820f7dbae5 = [
    0,
    3,
    4
];
const $96f413b39c3d1f22$export$c336e71dd18df9c4 = [
    0,
    3,
    4
];
const $96f413b39c3d1f22$export$6301d3b01a38f754 = [
    0,
    3,
    4
];
const $96f413b39c3d1f22$export$21350cd6b5f14e1e = [
    0,
    3,
    4
];
const $96f413b39c3d1f22$export$30ce297b5730a3e = [
    0,
    3,
    4
];
const $96f413b39c3d1f22$export$7bcb398e5a0fecf4 = [
    0,
    2,
    3,
    5
];
const $96f413b39c3d1f22$export$d36802239aa3005d = [
    0,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5
];
const $96f413b39c3d1f22$export$985838d816625ca9 = [
    $96f413b39c3d1f22$export$11a614999be145f9,
    $96f413b39c3d1f22$export$47ab18dfff75fa45,
    $96f413b39c3d1f22$export$3a58a8a194b1d8c6,
    // DORIAN_CHORD_INTERVALS,
    $96f413b39c3d1f22$export$d36802239aa3005d
];
const $96f413b39c3d1f22$export$23934e34e39daf40 = (notes, scaleFormula = MAJOR_SCALE, offset = 0, mode = 0, cutOff = true, accumulate = false)=>{
    const quantityOfNotes = notes.length;
    const quantityInScale = scaleFormula.length;
    let accumulator = offset // : 0
    ;
    let output = [];
    for(let index = 0; index < quantityInScale; ++index){
        const noteIndex = scaleFormula[(index + mode) % quantityInScale];
        if (accumulate) {
            // if noteIndex is 0 and index !== 0 add 12?
            if (noteIndex === 0 && index !== 0) {
                // this will be a note repetition so we transpose
                accumulator -= 12;
                accumulator += noteIndex;
                console.log("transpose", offset, accumulator, offset - accumulator);
            } else accumulator += noteIndex;
        } else accumulator = noteIndex;
        if (cutOff && accumulator > quantityOfNotes) ;
        else output[index] = notes[accumulator % quantityOfNotes];
    }
    return output;
};
const $96f413b39c3d1f22$export$7a8d537a00aa0876 = (notes, offset = 0, mode = 0)=>$96f413b39c3d1f22$export$23934e34e39daf40(notes, $96f413b39c3d1f22$export$11a614999be145f9, offset, mode, true, true);
const $96f413b39c3d1f22$export$6b86be061ac2dfd6 = (notes, offset = 0, mode = 0)=>$96f413b39c3d1f22$export$23934e34e39daf40(notes, $96f413b39c3d1f22$export$47ab18dfff75fa45, offset, mode, true, true);
const $96f413b39c3d1f22$export$3e070e48e768ef6f = (notes, offset = 0, mode = 0)=>$96f413b39c3d1f22$export$23934e34e39daf40(notes, $96f413b39c3d1f22$export$3a58a8a194b1d8c6, offset, mode, true, true);
const $96f413b39c3d1f22$export$a6f744ead6b37562 = (notes, offset = 0, mode = 0)=>$96f413b39c3d1f22$export$23934e34e39daf40(notes, $96f413b39c3d1f22$export$d36802239aa3005d, offset, mode, false, true);
const $96f413b39c3d1f22$export$800c04f251d75d81 = (chord, inversion = 0)=>{
    return $96f413b39c3d1f22$var$rotateArray(chord, inversion);
};


const $b5907fdf43994cd6$export$7789d9e7785a9b7e = (notes = [], noteOnCallback = null, noteOffCallback = null, onAvailableNoteChange = null)=>{
    const controller = new AbortController();
    const canvas = document.getElementById("wallpaper");
    if (!canvas) return false;
    // const ctx = canvas.getContext('2d')
    const activeNotes = new Map();
    let availableNote;
    const passive = false;
    /**
     * 
     * @param {PointerEvent|MouseEvent|TouchEvent} e 
     * @returns {Number}
     */ const convertPositionToNote = (e)=>{
        const x = e.clientX - canvas.offsetLeft;
        const y = e.clientY - canvas.offsetTop;
        const canvasWidth = e.target.clientWidth;
        const canvasHeight = e.target.clientHeight;
        const percentageX = x / canvasWidth;
        const percentageY = y / canvasHeight;
        // set frequency based on the mouse position
        // from Octave 3->7
        const octave = 3 + Math.round(percentageX * 4);
        const note = Math.round(percentageY * 12 + octave * 12);
        return notes[note % notes.length];
    };
    /**
     * Mouse Down or Touch Started
     * @param {PointerEvent|MouseEvent|TouchEvent} e 
     */ const onInteractionBegin = (e)=>{
        // If the user makes simultaneous touches, the browser will fire a
        // separate touchstart event for each touch point. Thus if there are
        // three simultaneous touches, the first touchstart event will have
        // targetTouches length of one, the second event will have a length
        // of two, and so on.
        e.preventDefault();
        const id = e.pointerId ?? 0;
        // check for multi-touch!
        const note = convertPositionToNote(e);
        noteOnCallback(note, 1, id);
        activeNotes.set(id, note);
        canvas.classList.toggle("interacting", true);
    // console.info(id, "mouse down", {e})
    };
    /**
     * user has moused out whilst the note was playing, so we turned 
     * it off, but now we want to continue playing it!
     * 
     * @param {PointerEvent|MouseEvent|TouchEvent} e 
     * @returns 
     */ const onInteractionContinue = (e)=>{
        // if (activeNotes.size === 0){
        //     return
        // }
        e.preventDefault();
    // activeNotes.forEach(id =>{
    //     const note = activeNotes.get(id)
    //     noteOnCallback( note, 1,id )
    //   console.info(id, "mouse continue", {e})
    // })
    };
    /**
     * 
     * @param {PointerEvent|MouseEvent|TouchEvent} e 
     * @returns 
     */ const onInteractionMoving = (e)=>{
        const id = e.pointerId ?? 0;
        // console.info("MOUSE MOVE", id, e, {activeNotes})
        if (activeNotes.size === 0) {
            const previousNote = availableNote;
            availableNote = convertPositionToNote(e);
            onAvailableNoteChange && onAvailableNoteChange(availableNote, previousNote, id);
            return;
        }
        // Note: if the user makes more than one "simultaneous" touches, most browsers
        // fire at least one touchmove event and some will fire several touch moves.
        // Consequently, an application might want to "ignore" some touch moves.
        e.preventDefault();
        // check to see if we are already playing
        const activeNote = activeNotes.get(id);
        const note = convertPositionToNote(e);
        if (activeNote && activeNote.noteNumber === note.noteNumber) return;
        noteOffCallback && noteOffCallback(activeNote, 1, id);
        activeNotes.set(id, note);
        noteOnCallback && noteOnCallback(note, 1, id);
    // console.info( id, "mouse move", { e, activeNotes })
    };
    /**
     * Touch / Mouse interaction has completed
     * (either mouse up or touch end)
     * @param {PointerEvent|MouseEvent|TouchEvent} e 
     */ const onInteractionEnd = (e)=>{
        e.preventDefault();
        const id = e.pointerId ?? 0;
        const activeNote = activeNotes.get(id);
        if (activeNote) {
            const note = convertPositionToNote(e);
            noteOffCallback(note, 1, id);
            activeNotes.delete(id);
        // console.info( id, "mouse up", {e, note, activeNotes})
        }
        canvas.classList.toggle("interacting", false);
    };
    // start tracking pointer moves
    // canvas.onmousemove = function(event) {
    canvas.onpointermove = function(event) {
        // moving the slider: listen on the thumb, as all pointer events are retargeted to it
        onInteractionMoving(event);
    };
    canvas.onpointerdown = function(event) {
        // retarget all pointer events (until pointerup) to thumb
        canvas.setPointerCapture(event.pointerId);
        onInteractionBegin(event);
    };
    // on pointer up finish tracking pointer moves
    canvas.onpointerup = function(event) {
        onInteractionEnd(event);
    // canvas.onpointerup = null
    // ...also process the "drag end" if needed
    };
    // Clean up and kill all objects
    return ()=>{
        canvas.onpointermove = null;
        canvas.onpointerdown = null;
        canvas.onpointerup = null;
        controller.abort();
    };
};




const $4de8aad6661668d1$export$7fa132cd7a5ed62d = "\uD83D\uDE10";
const $4de8aad6661668d1$export$5f5931fe1cb6e7db = "\uD83D\uDE11";
const $4de8aad6661668d1$export$c08f6b6e7fade075 = "\uD83D\uDE09";
const $4de8aad6661668d1$export$d57e753270ff4ccb = "\uD83E\uDEE4";
const $4de8aad6661668d1$export$a33ee7da1d967ea1 = "\uD83D\uDE44";
const $4de8aad6661668d1$export$5d2546af0fd930c7 = "\uD83D\uDE42";
const $4de8aad6661668d1$export$c215eb9913eef23c = "\uD83D\uDE0A";
const $4de8aad6661668d1$export$4a537437f97bcf15 = "\uD83D\uDE00";
const $4de8aad6661668d1$export$17e61be0c49992fc = "\uD83D\uDE03";
const $4de8aad6661668d1$export$bfa99287474ea52f = "\uD83D\uDE06";
const $4de8aad6661668d1$export$fc2e4584ee15ed76 = "\uD83D\uDE01";
const $4de8aad6661668d1$export$870711ba581e25ca = "\uD83D\uDE2F";
const $4de8aad6661668d1$export$171ce61c7cc07277 = "\uD83D\uDE2E";
const $4de8aad6661668d1$export$3f2dc24d384c385 = "\uD83D\uDE29";
const $4de8aad6661668d1$export$d952e14b5d9b8b69 = "\uD83D\uDE32";
const $4de8aad6661668d1$export$a3a208488ea3303 = "\uD83D\uDE2C";
const $4de8aad6661668d1$export$1c0b863302fba821 = "\uD83E\uDD2A";
const $4de8aad6661668d1$export$96fd33c52eb5af96 = "\uD83D\uDE17";
const $4de8aad6661668d1$export$55bf1f7a54495546 = "\uD83D\uDE19";
const $4de8aad6661668d1$export$b2a4f37ea6877959 = "\uD83D\uDE18";
const $4de8aad6661668d1$export$308f7b10d9127d1d = "\uD83D\uDE0F";
const $4de8aad6661668d1$export$69b32d42581a3188 = "\uD83D\uDE12";
const $4de8aad6661668d1$export$27bfc75042312206 = "\uD83E\uDD28";
const $4de8aad6661668d1$export$74d3f7f6031cfcaf = "\uD83D\uDE15";
const $4de8aad6661668d1$export$b719685466400081 = "\uD83D\uDE16";
const $4de8aad6661668d1$export$6fcbe77e4f344170 = "\uD83D\uDE1F";
const $4de8aad6661668d1$export$a50a964daa78f45f = "\u2639\uFE0F";
const $4de8aad6661668d1$export$e694ab2beecaede8 = "\uD83D\uDE14";
const $4de8aad6661668d1$export$6563db05f453b0b9 = "\uD83D\uDE1E";
const $4de8aad6661668d1$export$77730455fff7d32b = "\uD83D\uDE20";
const $4de8aad6661668d1$export$2ffebdb1fc763871 = "\uD83D\uDE35\u200D\uD83D\uDCAB";
const $4de8aad6661668d1$export$2181b19db5f0ce3c = "\uD83E\uDEE8";
const $4de8aad6661668d1$export$bf866857ce7629b0 = "\uD83D\uDE42\u200D\u2194\uFE0F";
const $4de8aad6661668d1$export$db9df5b7a981b4ef = "\uD83D\uDE42\u200D\u2195\uFE0F";
const $4de8aad6661668d1$export$1d6c1a3ec49437d = "\uD83D\uDE2D";
const $4de8aad6661668d1$export$14026e079fa843a9 = "\uD83E\uDD70";
const $4de8aad6661668d1$export$73c384dc05623114 = "\uD83D\uDE0D";
const $4de8aad6661668d1$export$a55a254c5b191ed5 = "\uD83E\uDD29";
const $4de8aad6661668d1$export$89fc98068d421b49 = "\uD83E\uDD73";
const $4de8aad6661668d1$export$abfdc545e1034c54 = "\uD83D\uDE43";
const $4de8aad6661668d1$export$1de8e5f6f0d7dd18 = "\uD83E\uDD72";
const $4de8aad6661668d1$export$81048a17ec382bcd = "\uD83E\uDD79";
const $4de8aad6661668d1$export$ffaab22e7b3e7c14 = "\uD83D\uDE0B";
const $4de8aad6661668d1$export$928e8dd9f33d2426 = "\uD83D\uDE1B";
const $4de8aad6661668d1$export$23c81c793d95ad11 = "\uD83D\uDE1C";
const $4de8aad6661668d1$export$fc3fd3d7a8c75ca6 = "\uD83D\uDE1D";
const $4de8aad6661668d1$export$52470923e5fe050 = "\uD83D\uDE07";
const $4de8aad6661668d1$export$230c664d95715696 = "\uD83E\uDEE1";
const $4de8aad6661668d1$export$5132dbdd0e4c5ed3 = "\uD83E\uDD14";
const $4de8aad6661668d1$export$22c3d85e13c80ef6 = "\uD83E\uDD2B";
const $4de8aad6661668d1$export$871aeaacb5ddb182 = "\uD83E\uDEE2";
const $4de8aad6661668d1$export$11114b20159c60d9 = "\uD83E\uDD2D";
const $4de8aad6661668d1$export$f8c2834d0e1630af = "\uD83E\uDD71";
const $4de8aad6661668d1$export$aa11831c126af90c = "\uD83E\uDD17";
const $4de8aad6661668d1$export$a2361eb5d0946819 = "\uD83E\uDEE3";
const $4de8aad6661668d1$export$f987741278f3a5ca = "\uD83D\uDE31";
const $4de8aad6661668d1$export$baf7d4ae1338dff0 = "\uD83E\uDDD0";
const $4de8aad6661668d1$export$eadb8cf0677069aa = "\uD83D\uDE2E\u200D\uD83D\uDCA8";
const $4de8aad6661668d1$export$f8ef5126f7519c67 = "\uD83D\uDE24";
const $4de8aad6661668d1$export$f1bb2c7ed01d66fd = "\uD83E\uDD2C";
const $4de8aad6661668d1$export$aca5fbb7f9bdef4f = "\uD83E\uDD7A";
const $4de8aad6661668d1$export$79a44946a11204cd = "\uD83D\uDE30";
const $4de8aad6661668d1$export$c774cb96f72ce473 = "\uD83D\uDE28";
const $4de8aad6661668d1$export$39547d84dde94caf = "\uD83D\uDE27";
const $4de8aad6661668d1$export$72e67ab361fff772 = "\uD83D\uDE32";
const $4de8aad6661668d1$export$b95ca0be4dd148fd = "\uD83D\uDE33";
const $4de8aad6661668d1$export$7a99e3b52b12f29c = "\uD83E\uDD2F";
const $4de8aad6661668d1$export$f9bad99d18130862 = "\uD83D\uDE13";
const $4de8aad6661668d1$export$474a57764641c1de = "\uD83D\uDE23";
const $4de8aad6661668d1$export$a9833dee7b862aed = "\uD83D\uDE2B";
const $4de8aad6661668d1$export$56f8237960b8bef0 = "\uD83D\uDE35";
const $4de8aad6661668d1$export$94cd1adfc2530563 = "\uD83E\uDEE5";
const $4de8aad6661668d1$export$aa00daebfd2db953 = "\uD83D\uDE34";
const $4de8aad6661668d1$export$a8b73060a6dbe702 = "\uD83D\uDE2A";
const $4de8aad6661668d1$export$f011e72ce2f9ab38 = "\uD83E\uDD24";
const $4de8aad6661668d1$export$afb8f46e2cda43a3 = "\uD83C\uDF1B";
const $4de8aad6661668d1$export$4af83e36fdc44320 = "\uD83C\uDF1C";
const $4de8aad6661668d1$export$6265b2b35dc2ce40 = "\uD83C\uDF1A";
const $4de8aad6661668d1$export$229f684c96689f66 = "\uD83C\uDF1D";
const $4de8aad6661668d1$export$fc816f11d4b4c38a = "\uD83C\uDF1E";
const $4de8aad6661668d1$export$4917bb672fa12df3 = "\uD83E\uDEE0";
const $4de8aad6661668d1$export$c59873d5d66772af = "\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0E";
const $4de8aad6661668d1$export$85849cb5fc7ac85b = "\uD83E\uDD74";
const $4de8aad6661668d1$export$a84d3a190051d447 = "\uD83E\uDD75";
const $4de8aad6661668d1$export$805013eb487f1e29 = "\uD83E\uDD76";
const $4de8aad6661668d1$export$5a68bd5ac2f90644 = "\uD83E\uDD22";
const $4de8aad6661668d1$export$b2e82a7a38eb611d = "\uD83E\uDD2E";
const $4de8aad6661668d1$export$1e675eb80873ab6e = "\uD83E\uDD27";
const $4de8aad6661668d1$export$7b27dfaca8d49e26 = "\uD83E\uDD12";
const $4de8aad6661668d1$export$fc152b202d643c55 = "\uD83E\uDD15";
const $4de8aad6661668d1$export$e0f2681512119e2e = "\uD83D\uDE37";
const $4de8aad6661668d1$export$bd5e5ac621280318 = "\uD83E\uDD20";
const $4de8aad6661668d1$export$8ec5bf1101a8c4bd = "\uD83E\uDD11";
const $4de8aad6661668d1$export$15ff7c5f2fd85ebd = "\uD83D\uDE0E";
const $4de8aad6661668d1$export$2f1e16e6a7a2bada = "\uD83E\uDD13";
const $4de8aad6661668d1$export$c1ef079e727003db = "\uD83E\uDD78";
const $4de8aad6661668d1$export$8f74ea9f3a1650eb = "\uD83E\uDD25";
const $4de8aad6661668d1$export$c09a232f4dc63972 = "\uD83E\uDD21";
const $4de8aad6661668d1$export$38e07adf7ab17d90 = "\uD83D\uDC7B";
const $4de8aad6661668d1$export$2c96b59f2e904aa4 = "\uD83D\uDCA9";
const $4de8aad6661668d1$export$ec2bcc99921bb770 = "\uD83D\uDC7D";
const $4de8aad6661668d1$export$671b7ca8802041bb = "\uD83E\uDD16";
const $4de8aad6661668d1$export$1d7ddc36d624a2a6 = "\uD83D\uDCA4";
const $4de8aad6661668d1$export$cd909ba89390c1fa = "\uD83D\uDD73\uFE0E";
const $4de8aad6661668d1$export$a5b6417bd9792cac = "\uD83C\uDF89";
const $4de8aad6661668d1$export$c6f909b5ca73c104 = "\uD83C\uDF8A";
const $4de8aad6661668d1$export$f2940ff183c5283c = "\uD83D\uDE48";
const $4de8aad6661668d1$export$5c5a6b2e4af33fb7 = "\uD83D\uDE49";
const $4de8aad6661668d1$export$d340ce2d98f29726 = "\uD83D\uDE4A";
const $4de8aad6661668d1$export$7fa2df243d1df831 = "\uD83D\uDE3A";
const $4de8aad6661668d1$export$8b7eed79f6adc51e = "\uD83D\uDE38";
const $4de8aad6661668d1$export$9de16aee5e81aa6b = "\uD83D\uDE39";
const $4de8aad6661668d1$export$9d2866ef8c810ccb = "\uD83D\uDE3B";
const $4de8aad6661668d1$export$6393373588f7c5f7 = "\uD83D\uDE3C";
const $4de8aad6661668d1$export$acc0f102f315e1ac = "\uD83D\uDE3D";
const $4de8aad6661668d1$export$750208e3d9d6c611 = "\uD83D\uDE40";
const $4de8aad6661668d1$export$3d849c302a70e188 = "\uD83D\uDE3F";
const $4de8aad6661668d1$export$76c79fb120c706aa = "\uD83D\uDE3E";
const $4de8aad6661668d1$export$4d360050690f05bf = "\u2764\uFE0E";
const $4de8aad6661668d1$export$6e1520aa3594d89b = "\uD83E\uDDE1";
const $4de8aad6661668d1$export$240dc38cedd3e18b = "\uD83D\uDC9B";
const $4de8aad6661668d1$export$a3d5f614fec373e = "\uD83D\uDC9A";
const $4de8aad6661668d1$export$328152662e6ad1d = "\uD83D\uDC99";
const $4de8aad6661668d1$export$356ae9efae09dbb7 = "\uD83D\uDC9C";
const $4de8aad6661668d1$export$466191acfcc188a4 = "\uD83E\uDD0E";
const $4de8aad6661668d1$export$50bf8ee24beae6b4 = "\uD83D\uDDA4";
const $4de8aad6661668d1$export$bb96e3ad3242ee54 = "\uD83E\uDD0D";
const $4de8aad6661668d1$export$7e2471ad348c1684 = "\u2665\uFE0E";
const $4de8aad6661668d1$export$62dfd1132ee85baf = [
    // Happiest
    $4de8aad6661668d1$export$a55a254c5b191ed5,
    $4de8aad6661668d1$export$14026e079fa843a9,
    $4de8aad6661668d1$export$73c384dc05623114,
    $4de8aad6661668d1$export$89fc98068d421b49,
    $4de8aad6661668d1$export$fc2e4584ee15ed76,
    $4de8aad6661668d1$export$17e61be0c49992fc,
    $4de8aad6661668d1$export$bfa99287474ea52f,
    $4de8aad6661668d1$export$4a537437f97bcf15,
    $4de8aad6661668d1$export$c215eb9913eef23c,
    $4de8aad6661668d1$export$5d2546af0fd930c7,
    $4de8aad6661668d1$export$7fa132cd7a5ed62d,
    $4de8aad6661668d1$export$5f5931fe1cb6e7db,
    $4de8aad6661668d1$export$74d3f7f6031cfcaf,
    $4de8aad6661668d1$export$6fcbe77e4f344170,
    $4de8aad6661668d1$export$a50a964daa78f45f,
    $4de8aad6661668d1$export$b719685466400081,
    $4de8aad6661668d1$export$e694ab2beecaede8,
    $4de8aad6661668d1$export$6563db05f453b0b9,
    $4de8aad6661668d1$export$474a57764641c1de,
    $4de8aad6661668d1$export$a9833dee7b862aed,
    $4de8aad6661668d1$export$3f2dc24d384c385,
    $4de8aad6661668d1$export$1d6c1a3ec49437d
];
const $4de8aad6661668d1$export$9e56eae8c43b7d08 = [
    $4de8aad6661668d1$export$7fa132cd7a5ed62d,
    $4de8aad6661668d1$export$81048a17ec382bcd,
    $4de8aad6661668d1$export$308f7b10d9127d1d,
    $4de8aad6661668d1$export$55bf1f7a54495546,
    $4de8aad6661668d1$export$c215eb9913eef23c,
    $4de8aad6661668d1$export$72e67ab361fff772,
    $4de8aad6661668d1$export$928e8dd9f33d2426 // Start from seventh degree
];
const $4de8aad6661668d1$export$a6e73a069c6c602b = {
    [(0, $96f413b39c3d1f22$export$eea29b9d2a589f3f)]: $4de8aad6661668d1$export$9e56eae8c43b7d08[0],
    [(0, $96f413b39c3d1f22$export$7553314f3dda4d80)]: $4de8aad6661668d1$export$9e56eae8c43b7d08[1],
    [(0, $96f413b39c3d1f22$export$253a602a5c00bc)]: $4de8aad6661668d1$export$9e56eae8c43b7d08[2],
    [(0, $96f413b39c3d1f22$export$c3ab3c7f6284107e)]: $4de8aad6661668d1$export$9e56eae8c43b7d08[3],
    [(0, $96f413b39c3d1f22$export$9c8a499c95acb5dc)]: $4de8aad6661668d1$export$9e56eae8c43b7d08[4],
    [(0, $96f413b39c3d1f22$export$552fc2a6e5af96bb)]: $4de8aad6661668d1$export$9e56eae8c43b7d08[5],
    [(0, $96f413b39c3d1f22$export$9da03196452327a1)]: $4de8aad6661668d1$export$9e56eae8c43b7d08[6] // Start from seventh degree
};
const $4de8aad6661668d1$export$4c1bb52195d1efed = [
    $4de8aad6661668d1$export$7fa132cd7a5ed62d,
    $4de8aad6661668d1$export$aca5fbb7f9bdef4f,
    $4de8aad6661668d1$export$74d3f7f6031cfcaf,
    $4de8aad6661668d1$export$b95ca0be4dd148fd,
    $4de8aad6661668d1$export$b719685466400081,
    $4de8aad6661668d1$export$f987741278f3a5ca,
    $4de8aad6661668d1$export$a3a208488ea3303 // Start from seventh degree
];
const $4de8aad6661668d1$export$36bb143d7246eba3 = {
    [(0, $96f413b39c3d1f22$export$eea29b9d2a589f3f)]: $4de8aad6661668d1$export$4c1bb52195d1efed[0],
    [(0, $96f413b39c3d1f22$export$7553314f3dda4d80)]: $4de8aad6661668d1$export$4c1bb52195d1efed[1],
    [(0, $96f413b39c3d1f22$export$253a602a5c00bc)]: $4de8aad6661668d1$export$4c1bb52195d1efed[2],
    [(0, $96f413b39c3d1f22$export$c3ab3c7f6284107e)]: $4de8aad6661668d1$export$4c1bb52195d1efed[3],
    [(0, $96f413b39c3d1f22$export$9c8a499c95acb5dc)]: $4de8aad6661668d1$export$4c1bb52195d1efed[4],
    [(0, $96f413b39c3d1f22$export$552fc2a6e5af96bb)]: $4de8aad6661668d1$export$4c1bb52195d1efed[5],
    [(0, $96f413b39c3d1f22$export$9da03196452327a1)]: $4de8aad6661668d1$export$4c1bb52195d1efed[6] // Start from seventh degree
};
const $4de8aad6661668d1$export$4d99af9fe2d5a299 = (scale, mode)=>{
    switch(scale){
        case "Minor":
        case 1:
            return $4de8aad6661668d1$export$4c1bb52195d1efed[mode % $4de8aad6661668d1$export$4c1bb52195d1efed.length];
        case "Major":
        case 0:
        default:
            return $4de8aad6661668d1$export$9e56eae8c43b7d08[mode % $4de8aad6661668d1$export$9e56eae8c43b7d08.length];
    }
};



const $cc1d0ccf700154db$export$582afac2cd0d1cc9 = 1;
class $cc1d0ccf700154db$export$2e2bcd8739ae039 {
    activeId = new Map();
    activeNotes = new Map();
    activeElement = new Map();
    glide = false;
    #rollingIndex = 0;
    #maxTouchEvents = 10;
    #mouseDown = false;
    #rotateFixedPointer = false;
    constructor(pitchBend = true, rotateFixedPointer = false){
        this.glide = pitchBend;
        this.#rotateFixedPointer = rotateFixedPointer;
    }
    get isMouseDown() {
        return this.#mouseDown;
    }
    get isTouching() {
        return this.activeNotes.size > 0;
    }
    /**
     * 
     * @param {Number} maxTouches 
     * @returns 
     */ getNextAvailableIndex(maxTouches) {
        if (!this.#rotateFixedPointer) return $cc1d0ccf700154db$export$582afac2cd0d1cc9;
        else {
            let id = ($cc1d0ccf700154db$export$582afac2cd0d1cc9 + this.#rollingIndex) % maxTouches;
            // loop through all digits starting from default to find which is "free"
            for(let i = 0; i < maxTouches; i++){
                id = (id + i) % maxTouches;
                if (this.activeId.has(id)) continue;
                else // escape with this none-active one
                return id;
            }
            // not good - all instruments are engaged!
            return id;
        }
    }
    getIdFromEvent(event) {
        // if this element already has handled an interaction
        // resuse the id previously cached
        if (this.activeElement.has(event.target)) return this.activeElement.get(event.target);
        // update index immediately!
        // switch (event.pointerType) {
        //     case "mouse":
        // }
        switch(event.pointerType){
            case "touch":
                // each touch id is different
                return event.pointerId;
            default:
                //case "mouse":
                //case "pen":
                return this.getNextAvailableIndex(this.#maxTouchEvents);
        }
    }
    /**
	 * Add interactivity to the keyboard and wire these
	 * to the noteOn and noteOff functions provided
	 * @param {Function} noteOn - method to call to play a note
	 * @param {Function} noteOff - method to call to stop the playing note
	 * @param {Boolean} passive - use passive listeners 
	 */ addInteractivity(buttonElements, noteOn, noteOff, passive = true) {
        if (!buttonElements) throw Error("No keys provided to add interactivity to");
        const controller = new AbortController();
        buttonElements.forEach((button, i)=>{
            // can come from a touch a mouse click or a keyboard enter press
            const onInteractionStarting = (event)=>{
                // Keypresses other than Enter and Space should not trigger a command
                if (event instanceof KeyboardEvent && event.key !== "Enter" && event.key !== " ") return;
                if (!passive && event.preventDefault) event.preventDefault();
                // roll around of 
                this.#rollingIndex = (this.#rollingIndex + 1) % this.#maxTouchEvents;
                switch(event.pointerType){
                    case "mouse":
                        this.#mouseDown = true;
                }
                const pressure = event.pressure ?? event.webkitForce ?? 1;
                const note = this.getNoteFromKey(button);
                // TODO: Check if already interacting with this element
                const id = this.getIdFromEvent(event);
                // noteName = button.getAttribute("data-note")
                // convert name into MIDI note number
                // const note = convertNoteNameToMIDINoteNumber(noteName)
                const starting = noteOn(note, pressure, id);
                this.activeNotes.set(id, note);
                this.activeId.set(id, true);
                this.activeElement.set(event.target, id);
                // console.log( id, event, starting, "START interaction",  this.#rollingIndex ) 
                document.addEventListener("pointerleave", onInterationComplete, {
                    signal: controller.signal,
                    passive: passive
                });
                document.addEventListener("pointerup", onInterationComplete, {
                    signal: controller.signal,
                    passive: passive
                });
                document.addEventListener("pointercancel", onInterationComplete, {
                    signal: controller.signal,
                    passive: passive
                });
                document.addEventListener("visibilitychange", onInterationComplete, {
                    signal: controller.signal,
                    passive: passive
                });
            };
            /**
             * 
             * @param {Event} event 
             * @returns 
             */ const onInterationComplete = (event)=>{
                // Keypresses other than Enter and Space should not trigger a command
                if (event instanceof KeyboardEvent && event.key !== "Enter" && event.key !== " ") return;
                if (!passive && event.preventDefault) event.preventDefault();
                if (event.pointerType === "mouse" || event.type === "pointerup" || event.type === "pointercancel") this.#mouseDown = false;
                document.removeEventListener("pointerleave", onInterationComplete);
                document.removeEventListener("pointerup", onInterationComplete);
                document.removeEventListener("pointercancel", onInterationComplete);
                document.removeEventListener("visibilitychange", onInterationComplete);
                const id = this.getIdFromEvent(event);
                const currentlyPlayingNote = this.activeNotes.get(id);
                if (currentlyPlayingNote) noteOff(currentlyPlayingNote, 1, id);
                // console.log(id, "STOP interaction" ) 
                this.activeNotes.delete(id);
                this.activeId.delete(id);
                this.activeElement.delete(event.target);
            // check for amount of touches...
            // const touches = event.changedTouches
            // this.isTouching = this.activeNotes.size > 0
            // document.querySelector(`.indicator[data-note="${noteName}"]`)?.classList?.toggle("active", false)
            };
            button.addEventListener("pointerdown", onInteractionStarting, {
                signal: controller.signal,
                passive: passive
            });
            // User leaves element - turns off note but updates id
            button.addEventListener("pointerleave", (event)=>{
                if (!passive && event.preventDefault) event.preventDefault();
                // Stop existing note playback
                const id = this.getIdFromEvent(event);
                const currentlyPlayingNote = this.activeNotes.get(id);
                // console.info(id, event.pointerType, "pointerleave", {event, id, currentlyPlayingNote} )
                if (currentlyPlayingNote) {
                    noteOff(currentlyPlayingNote, 1, id);
                    this.activeNotes.delete(id);
                    this.activeId.set(id, false);
                    this.activeElement.delete(event.target);
                // this will break it here!
                // this.#rollingIndex++
                }
            }, {
                signal: controller.signal,
                passive: passive
            });
            // if the user has finger down but they change keys...
            button.addEventListener("pointerenter", (event)=>{
                if (!passive && event.preventDefault) event.preventDefault();
                if (this.#mouseDown) this.#rollingIndex = (this.#rollingIndex + 1) % this.#maxTouchEvents;
                // this id will always be inactive due to fetching ids from targets
                const id = this.getIdFromEvent(event);
                const isActive = this.activeId.has(id);
                // console.info( id, event.pointerType , "pointerenter",{ event, id, isActive})
                // if we already playing, we change the note
                if (isActive || this.#mouseDown) {
                    const requestedNote = this.getNoteFromKey(button);
                    // document.querySelector(`.indicator[data-note="${previousNote}"]`)?.classList?.toggle("active", false)
                    // document.querySelector(`.indicator[data-note="${noteName}"]`)?.classList?.toggle("active", true)
                    this.glide;
                    // console.info("REQUEST CHANGE", {note, noteName,GENERAL_MIDI_INSTRUMENTS})
                    // const currentlyPlayingNote = this.activeNotes.get( id )
                    // if (currentlyPlayingNote)
                    // {
                    //     noteOff(currentlyPlayingNote, 1, id)
                    // } 
                    noteOn(requestedNote, 1, id);
                    // overwrite the pointer
                    this.activeNotes.set(id, requestedNote);
                    this.activeId.set(id, true);
                    this.activeElement.set(event.target, id);
                }
            }, {
                signal: controller.signal,
                passive: passive
            });
        });
        return ()=>{
            controller.abort();
        };
    }
}


const $d5f4fe8401977268$var$OCTAVE_NAMES = [
    "Bass",
    "Lead",
    "Treble"
];
const $d5f4fe8401977268$export$d207e7d00792110a = [
    3,
    5,
    7
];
class $d5f4fe8401977268$export$2e2bcd8739ae039 extends (0, $cc1d0ccf700154db$export$2e2bcd8739ae039) {
    noteLibrary = new Map();
    octave = 4;
    modeIndex = 0;
    scaleType = null;
    // text elements
    #timbreElement;
    #frequencyElement;
    #toneElement;
    #element;
    #titleElement;
    #emojiElement;
    #octaveSelectorElement;
    #keyElements;
    set happiness(value) {
        const emoji = (0, $4de8aad6661668d1$export$62dfd1132ee85baf)[Math.round(value * (0, $4de8aad6661668d1$export$62dfd1132ee85baf).length)];
        this.#emojiElement.textContent = emoji;
    }
    /**
     * Musical Scale Mode (eg. dorian) as Number
     */ set mode(value) {
        this.modeIndex = value;
        this.setEmoji();
    }
    get mode() {
        return this.modeIndex;
    }
    get modeName() {
        return (0, $96f413b39c3d1f22$export$d70b64e2bb71bb4e)[this.modeIndex];
    }
    /**
     * Musical Scale such as Major or Minor
     */ set scale(musicalScale) {
        this.scaleType = musicalScale;
        // lets also add an emoji at te end
        switch(musicalScale.toLowerCase()){
            case "major":
                this.#toneElement.textContent = musicalScale + " " + "happy";
            case "minor":
                this.#toneElement.textContent = musicalScale + " " + "sad";
            default:
                this.#toneElement.textContent = musicalScale;
        }
        this.#toneElement.setAttribute("startOffset", 35.5 - musicalScale.length * 0.5 + "%");
        // console.info("Scale", musicalScale )
        this.setEmoji();
    }
    get scale() {
        return this.scaleType;
    }
    /**
     * Timbre is a string value that is displayed in curved text
     */ set timbre(value) {
        this.#timbreElement.textContent = value // String(value).toUpperCase()
        ;
        this.#timbreElement.setAttribute("startOffset", 12.5 - value.length * 0.5 + "%");
    }
    get frequency() {
        return this.octave;
    }
    set frequency(value) {
        this.octave = typeof value === "number" ? value : $d5f4fe8401977268$var$OCTAVE_NAMES.indexOf(value);
        let octaveName = "All";
        if (this.octave <= $d5f4fe8401977268$export$d207e7d00792110a[0]) // BASS
        octaveName = $d5f4fe8401977268$var$OCTAVE_NAMES[0];
        else if (this.octave <= $d5f4fe8401977268$export$d207e7d00792110a[1]) // MID
        octaveName = $d5f4fe8401977268$var$OCTAVE_NAMES[1];
        else if (this.octave >= $d5f4fe8401977268$export$d207e7d00792110a[2]) // TREBLE
        octaveName = $d5f4fe8401977268$var$OCTAVE_NAMES[2];
        this.#frequencyElement.textContent = octaveName;
        this.#frequencyElement.setAttribute("startOffset", 75 - octaveName.length * 0.5 + "%");
    // this.frequencyElement.textContent = OCTAVE_NAMES[ this.octave ] 
    // console.info("FREQ", value, this.frequencyElement.textContent )
    }
    constructor(notes, noteOn, noteOff, setMode, setTimbre, mode = 0, octave = 4){
        super();
        const chordOn = (noteModel, velocity = 1, id = 0, idOffset = 0)=>{
            noteOn(noteModel, velocity, id, null, this.mode, idOffset);
        };
        const chordOff = (noteModel, velocity = 1, id = 0, idOffset = 0)=>{
            noteOff(noteModel, velocity, id, null, this.mode, idOffset);
        };
        // this.scaleType = sc ?? 0
        // only use the very first found one
        this.#element = document.querySelector(".circle-of-fifths");
        this.#titleElement = this.#element.querySelector("title");
        this.#emojiElement = this.#element.querySelector(".fifths-emotion-text");
        this.#timbreElement = this.#element.querySelector(".curved-text-timbre");
        this.#frequencyElement = this.#element.querySelector(".curved-text-frequency");
        this.#toneElement = this.#element.querySelector(".curved-text-tone");
        // console.error( "COF elements", this.timbreElement, this.frequencyElement, this.toneElement  )
        this.notes = notes;
        this.octave = octave ?? 4;
        this.modeIndex = mode ?? 0;
        this.#keyElements = this.createKeys(notes, ".circle-of-fifths-tonics path", 3);
        this.#keyElements.push(...this.createKeys(notes, ".circle-of-fifths-harmonies path"));
        this.addInteractivity(this.#keyElements, chordOn, chordOff);
        this.addControls(setMode, setTimbre);
        this.frequency = octave;
        this.#frequencyElement.addEventListener("click", (e)=>{
            const index = ($d5f4fe8401977268$export$d207e7d00792110a.indexOf(this.octave) + 1) % $d5f4fe8401977268$export$d207e7d00792110a.length;
            this.frequency = $d5f4fe8401977268$export$d207e7d00792110a[index];
        });
        // now update the face to match the mode
        this.setEmoji();
    }
    /**
     * set the emoji in the centre
     */ setEmoji() {
        const emoji = (0, $4de8aad6661668d1$export$4d99af9fe2d5a299)(this.scaleType, this.modeIndex);
        const modeString = this.modeName;
        this.#emojiElement.textContent = emoji;
        this.#toneElement.textContent = modeString;
        this.#toneElement.setAttribute("startOffset", 39.5 - modeString.length * 0.5 + "%");
    }
    /**
     * 
     * @param {*} setMode 
     * @param {*} setTimbre 
     */ addControls(setMode, setTimbre) {
        this.#octaveSelectorElement = this.#element.querySelectorAll("input[name=octave]");
        this.#octaveSelectorElement.forEach((radioButton)=>{
            radioButton.addEventListener("change", (e)=>{
                const input = e.target.value;
                input;
                this.octave = parseInt(input);
            });
        });
        // Allow the user to select a random emotion just
        // by clicking the text element
        // this.emoji.addEventListener("click", e =>{
        //     this.happiness = Math.random()
        //     setMode( this.modeIndex )
        // })
        const emojiHitArea = this.#element.querySelector(".fifths-emotion");
        emojiHitArea.addEventListener("click", (e)=>{
            const newMode = (this.modeIndex + 1) % (0, $96f413b39c3d1f22$export$d70b64e2bb71bb4e).length;
            this.mode = setMode((0, $96f413b39c3d1f22$export$d70b64e2bb71bb4e)[newMode]);
            // console.info("emoji pressed to mode", this.mode)
            e.preventDefault();
        });
        emojiHitArea.addEventListener("dblclick", (e)=>{
            // console.info("emoji double clicked to mode", this.mode)
            setTimbre();
            e.preventDefault();
        });
    }
    /**
     * 
     * @param {HTMLElement} button 
     * @returns 
     */ getNoteFromKey(button) {
        const noteNumber = parseInt(button.getAttribute("data-number"));
        const octaveOffset = this.octave * 12;
        const note = this.notes[noteNumber + octaveOffset];
        // console.info("noteNumber", noteNumber, note, this.notes )
        return note;
    }
    /**
     * Add the audio key buttons
     * @param {*} notes 
     * @param {String} query 
     * @param {Number} offset 
     * @returns 
     */ createKeys(notes, query = ".circle-of-fifths-tonics path", offset = 0) {
        const htmlElementKeys = Array.from(this.#element.querySelectorAll(query));
        const keys = htmlElementKeys.map((path, i)=>{
            i = (i + offset) % notes.length;
            const note = notes[i];
            path.setAttribute("data-key", note.noteKey);
            path.setAttribute("data-number", i) // note.noteNumber
            ;
            path.setAttribute("data-note", note.noteNumber);
            path.setAttribute("data-name", note.noteName);
            path.setAttribute("data-frequency", note.frequency);
            path.setAttribute("data-octave", note.octave);
            // make this into an accessible button
            path.setAttribute("role", "button");
            path.setAttribute("tabindex", "0");
            path.setAttribute("oncontextmenu", "return false;");
            path.setAttribute("aria-label", note.noteName);
            this.noteLibrary.set(path, notes[i]);
            return path;
        });
        return htmlElementKeys;
    }
}


class $183cd5d1ff396d87$var$ByteReader {
    constructor(dataView){
        this.dataView = dataView;
        this.pos = 0;
    }
    eof() {
        return this.pos >= this.dataView.byteLength;
    }
    // Returns the byte in the current position without advancing the position
    peek() {
        if (this.pos >= this.dataView.byteLength) throw new Error("Attempted to peek beyond the end of the DataView");
        return this.dataView.getUint8(this.pos);
    }
    readByte() {
        const byte = this.peek();
        this.pos++;
        return byte;
    }
    parseHeader() {
        // Header
        const b = this.readByte();
        if ((b & 0xc0) !== 0x80) throw new Error(`Invalid MIDI packet: expected header byte to start with 10, got ${b.toString(16)}`);
        return b & 0x3f;
    }
    parseTimestamp() {
        // Timestamp
        const b = this.readByte();
        if ((b & 0x80) !== 0x80) throw new Error(`Invalid MIDI packet: expected timestamp byte to start with 10, got ${b.toString(16)}`);
        return b & 0x7f;
    }
    parseChannelMessage() {
        const firstByte = this.dataView.getUint8(this.pos);
        const length = $183cd5d1ff396d87$var$getChannelMessageLength(firstByte);
        return this.read(length);
    }
    parseSystemMessage() {
        const firstByte = this.dataView.getUint8(this.pos);
        let length;
        if ((firstByte & 0xf0) === 0xf0) // System Common Message
        length = $183cd5d1ff396d87$var$getSystemCommonLength(firstByte);
        else // System Real-Time Message
        length = 1;
        return this.read(length);
    }
    read(length) {
        if (this.pos + length > this.dataView.byteLength) throw new Error(`Invalid read: requested ${length} bytes, but only ${this.dataView.byteLength - this.pos} bytes available`);
        const bytes = $183cd5d1ff396d87$var$extractUint8Range(this.dataView, this.pos, length);
        this.pos += length;
        return bytes;
    }
}
function $183cd5d1ff396d87$var$getChannelMessageLength(status) {
    const messageType = (status & 0xf0) >> 4;
    switch(messageType){
        case 0x8:
        case 0x9:
        case 0xa:
        case 0xb:
        case 0xe:
            return 3;
        default:
            return 2;
    }
}
function $183cd5d1ff396d87$var$getSystemCommonLength(status) {
    switch(status){
        case 0xf1:
        case 0xf3:
            return 2;
        case 0xf2:
            return 3;
        case 0xf6:
            return 1;
        default:
            return 1;
    }
}
function $183cd5d1ff396d87$var$extractUint8Range(view, start, length) {
    return new Uint8Array(view.buffer, view.byteOffset + start, length);
}
class $183cd5d1ff396d87$export$8cbea25bae40efe8 {
    constructor(callback){
        this.sysExContext = null;
        this.callback = callback;
    }
    push(dataView) {
        // BLE-MIDI packets are a repetition of [header][timestamp][data...][timestamp][data...] ...
        if (dataView.byteLength < 2) return;
        const reader = new $183cd5d1ff396d87$var$ByteReader(dataView);
        let state = this.sysExContext ? $183cd5d1ff396d87$var$sysExHeaderState(this.sysExContext.timestamp, this.sysExContext.partialSysExData) : $183cd5d1ff396d87$var$headerState;
        while(!reader.eof()){
            const [message, nextState] = state(reader);
            switch(message === null || message === void 0 ? void 0 : message.type){
                case "message":
                    // If we have a complete MIDI message, we call the callback
                    this.callback({
                        timestampMs: message.timestampMs,
                        message: message.message
                    });
                    // If the message is a SysEx message, we reset the SysEx buffer
                    if (message.message[0] === 0xf0) this.sysExContext = null;
                    break;
                case "incompleteSysEx":
                    // If we have an incomplete SysEx message, we store it in the context
                    this.sysExContext = {
                        timestamp: message.timestamp,
                        partialSysExData: message.data
                    };
                    break;
            }
            if (nextState === null) break;
            state = nextState;
        }
    }
}
const $183cd5d1ff396d87$var$headerState = (reader)=>{
    const timestampHigh = reader.parseHeader();
    return [
        null,
        $183cd5d1ff396d87$var$firstTimestampState(timestampHigh)
    ];
};
const $183cd5d1ff396d87$var$firstTimestampState = (timestampHigh)=>(reader)=>{
        const timestampLow = reader.parseTimestamp();
        const timestamp = timestampHigh << 7 | timestampLow;
        const nextByte = reader.peek();
        // Check if the next byte is a SysEx start (0xf0)
        if (nextByte === 0xf0) return [
            null,
            $183cd5d1ff396d87$var$sysExStartState(timestamp)
        ];
        return [
            null,
            $183cd5d1ff396d87$var$fullMessageState(timestamp)
        ];
    };
const $183cd5d1ff396d87$var$fullMessageState = (timestamp)=>(reader)=>{
        const messageBody = reader.parseChannelMessage();
        const message = {
            type: "message",
            timestampMs: timestamp,
            message: messageBody
        };
        if (reader.eof()) // If we reach the end of the stream, we return the message and null for the next state
        return [
            message,
            null
        ];
        const runningStatus = {
            statusByte: messageBody[0],
            length: messageBody.length
        };
        const nextByte = reader.peek();
        if ((nextByte & 0x80) === 0x80) // If the next byte is a timestamp, we return the timestamp state
        return [
            message,
            $183cd5d1ff396d87$var$timestampState(timestamp, runningStatus)
        ];
        else // If the next byte is not a timestamp, we assume it's a running status
        return [
            message,
            $183cd5d1ff396d87$var$runningStatusState(timestamp, runningStatus)
        ];
    };
const $183cd5d1ff396d87$var$sysExHeaderState = (timestamp, partialSysExData)=>(reader)=>{
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        reader.parseHeader(); // ignore the header byte
        // In a packet during SysEx reception, data comes immediately after the header
        const nextByte = reader.peek();
        if (nextByte === 0xf7) return [
            null,
            $183cd5d1ff396d87$var$sysExEndState(timestamp, partialSysExData)
        ];
        if (nextByte & 0x80) return [
            null,
            $183cd5d1ff396d87$var$sysExSystemMessageState(timestamp, partialSysExData)
        ];
        return [
            null,
            $183cd5d1ff396d87$var$sysExDataState(timestamp, partialSysExData)
        ];
    };
const $183cd5d1ff396d87$var$systemMessageState = (timestamp, runningStatus)=>(reader)=>{
        const messageBody = reader.parseSystemMessage();
        const message = {
            type: "message",
            timestampMs: timestamp,
            message: messageBody
        };
        if (reader.eof()) // If we reach the end of the stream, we return the message and null for the next state
        return [
            message,
            null
        ];
        // Verify if the next byte is a timestamp
        const nextByte = reader.peek();
        if ((nextByte & 0x80) !== 0x80) throw new Error(`Invalid MIDI packet: expected next byte to be a timestamp, got ${nextByte.toString(16)}`);
        return [
            message,
            $183cd5d1ff396d87$var$timestampState(timestamp, runningStatus)
        ];
    };
const $183cd5d1ff396d87$var$sysExDataState = (timestamp, partialSysExData)=>(reader)=>{
        // Read SysEx data that continues with 0-starting data
        const sysExData = [
            ...partialSysExData
        ];
        while(!reader.eof()){
            const nextByte = reader.peek();
            if ((nextByte & 0x80) === 0) // If the next byte is a data byte (0-127), we read it
            sysExData.push(reader.readByte());
            else if (nextByte === 0xf7) {
                // If the next byte is a SysEx end (0xf7), we return the SysEx data
                const message = {
                    type: "message",
                    timestampMs: timestamp,
                    message: new Uint8Array([
                        0xf0,
                        ...sysExData,
                        0xf7
                    ])
                };
                if (reader.eof()) // If we reach the end of the stream, we return the message and null for the next state
                return [
                    message,
                    null
                ];
                return [
                    message,
                    $183cd5d1ff396d87$var$firstTimestampState(timestamp >> 7)
                ];
            } else return [
                null,
                $183cd5d1ff396d87$var$sysExTimestampState(timestamp >> 7, sysExData)
            ];
        }
        // eof
        return [
            {
                type: "incompleteSysEx",
                timestamp: timestamp,
                data: sysExData
            },
            null
        ];
    };
// Handling when a system message arrives during SysEx reception
const $183cd5d1ff396d87$var$sysExSystemMessageState = (timestamp, partialSysExData)=>(reader)=>{
        const messageBody = reader.parseSystemMessage();
        const message = {
            type: "message",
            timestampMs: timestamp,
            message: messageBody
        };
        if (reader.eof()) // If we reach the end of the stream, we return the message and null for the next state
        return [
            message,
            null
        ];
        const nextByte = reader.peek();
        if ((nextByte & 0x80) === 0x80) return [
            message,
            $183cd5d1ff396d87$var$sysExTimestampState(timestamp, partialSysExData)
        ];
        return [
            message,
            $183cd5d1ff396d87$var$sysExDataState(timestamp, partialSysExData)
        ];
    };
// Handling when a timestamp arrives during SysEx reception
const $183cd5d1ff396d87$var$sysExTimestampState = (lastTimestamp, partialSysExData)=>(reader)=>{
        const timestampLow = reader.parseTimestamp();
        const timestamp = $183cd5d1ff396d87$var$getFixedTimestamp(lastTimestamp, timestampLow);
        const nextByte = reader.peek();
        if (nextByte === 0xf7) return [
            null,
            $183cd5d1ff396d87$var$sysExEndState(timestamp, partialSysExData)
        ];
        if (nextByte & 0x80) return [
            null,
            $183cd5d1ff396d87$var$sysExSystemMessageState(timestamp, partialSysExData)
        ];
        return [
            null,
            $183cd5d1ff396d87$var$sysExDataState(timestamp, partialSysExData)
        ];
    };
const $183cd5d1ff396d87$var$sysExStartState = (timestamp)=>(reader)=>{
        reader.readByte(); // Read the SysEx start byte (0xf0)
        return [
            null,
            $183cd5d1ff396d87$var$sysExDataState(timestamp, [])
        ];
    };
const $183cd5d1ff396d87$var$sysExEndState = (timestamp, partialSysExData)=>(reader)=>{
        reader.readByte(); // Read the SysEx end byte (0xf7)
        // If the next byte is a SysEx end (0xf7), we return the SysEx data
        const message = {
            type: "message",
            timestampMs: timestamp,
            message: new Uint8Array([
                0xf0,
                ...partialSysExData,
                0xf7
            ])
        };
        if (reader.eof()) // If we reach the end of the stream, we return the message and null for the next state
        return [
            message,
            null
        ];
        return [
            message,
            $183cd5d1ff396d87$var$firstTimestampState(timestamp >> 7)
        ];
    };
function $183cd5d1ff396d87$var$getFixedTimestamp(lastTimestamp, timestampLow) {
    const timestamp = lastTimestamp & 0x70 | timestampLow;
    if (timestamp < lastTimestamp) {
        // If the timestamp is less than the last timestamp, it indicates an overflow
        const timestampHigh = (lastTimestamp >> 7) + 1;
        return timestampHigh << 7 | timestampLow;
    }
    return timestamp;
}
const $183cd5d1ff396d87$var$timestampState = (lastTimestamp, runningStatus)=>(reader)=>{
        const timestampLow = reader.parseTimestamp();
        const timestamp = $183cd5d1ff396d87$var$getFixedTimestamp(lastTimestamp, timestampLow);
        const nextByte = reader.peek();
        if ((nextByte & 0xf0) === 0xf0) {
            // Check sysex start
            if (nextByte === 0xf0) return [
                null,
                $183cd5d1ff396d87$var$sysExStartState(timestamp)
            ];
            else if (nextByte === 0xf7) // If SysEx end (0xf7) is received without SysEx start (0xf0), it's an error
            throw new Error(`Invalid MIDI packet: SysEx end (0xf7) received without SysEx start (0xf0)`);
            else return [
                null,
                $183cd5d1ff396d87$var$systemMessageState(timestamp, runningStatus)
            ];
        } else if ((nextByte & 0x80) === 0x80) return [
            null,
            $183cd5d1ff396d87$var$fullMessageState(timestamp)
        ];
        else // If the next byte is not a timestamp, we assume it's a running status
        return [
            null,
            $183cd5d1ff396d87$var$runningStatusState(timestamp, runningStatus)
        ];
    };
const $183cd5d1ff396d87$var$runningStatusState = (timestamp, runningStatus)=>(reader)=>{
        const messageData = reader.read(runningStatus.length - 1);
        const messageBody = new Uint8Array([
            runningStatus.statusByte,
            ...Array.from(messageData)
        ]);
        const message = {
            type: "message",
            timestampMs: timestamp,
            message: messageBody
        };
        if (reader.eof()) // If we reach the end of the stream, we return the message and null for the next state
        return [
            message,
            null
        ];
        const nextByte = reader.peek();
        if ((nextByte & 0x80) === 0x80) // If the next byte is a timestamp, we return the timestamp state
        return [
            message,
            $183cd5d1ff396d87$var$timestampState(timestamp, runningStatus)
        ];
        else // If the next byte is not a timestamp, we assume it's a running status
        return [
            message,
            $183cd5d1ff396d87$var$runningStatusState(timestamp, runningStatus)
        ];
    };
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $183cd5d1ff396d87$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
/**
 * BLE MIDI Service UUID as defined by Bluetooth SIG
 * @see https://www.bluetooth.com/specifications/gatt/services/
 */ const $183cd5d1ff396d87$export$9928111d856f95a1 = "03b80e5a-ede8-4b33-a751-6ce34ec4c700".toLowerCase();
/**
 * BLE MIDI Characteristic UUID for I/O
 * @see https://www.bluetooth.com/specifications/gatt/characteristics/
 */ const $183cd5d1ff396d87$export$b027618ae06604e1 = "7772e5db-3868-4112-a1a9-f2669d106bf3".toLowerCase();
/**
 * Event types for BLE MIDI devices
 */ var $183cd5d1ff396d87$export$62d49a5cfb31233;
(function(MIDIEventType) {
    MIDIEventType["MIDIMessage"] = "midimessage";
    MIDIEventType["Disconnect"] = "disconnect";
})($183cd5d1ff396d87$export$62d49a5cfb31233 || ($183cd5d1ff396d87$export$62d49a5cfb31233 = {}));
/**
 * Custom event for MIDI messages
 */ class $183cd5d1ff396d87$export$a1aa5b8ae83fa080 extends CustomEvent {
    constructor(message){
        super($183cd5d1ff396d87$export$62d49a5cfb31233.MIDIMessage, {
            detail: message,
            bubbles: false,
            cancelable: false
        });
    }
    /**
     * Get the MIDI message
     */ get message() {
        return this.detail;
    }
}
/**
 * Custom event for disconnection
 */ class $183cd5d1ff396d87$export$16fd7097b8121b3a extends CustomEvent {
    constructor(){
        super($183cd5d1ff396d87$export$62d49a5cfb31233.Disconnect, {
            bubbles: false,
            cancelable: false
        });
    }
}
/**
 * Represents a BLE MIDI device
 */ class $183cd5d1ff396d87$export$52f1657fe1fab8cb extends EventTarget {
    /**
     * Creates a BLEMIDIDevice instance
     * @param device The underlying Web Bluetooth device
     */ constructor(device){
        super();
        this.characteristic = null;
        this.isConnecting = false;
        this.device = device;
        // Set up disconnect listener
        this.device.addEventListener("gattserverdisconnected", this.handleDisconnection.bind(this));
        // Create a single parser instance for this device
        this.parser = new $183cd5d1ff396d87$export$8cbea25bae40efe8((message)=>{
            // Forward MIDI messages as events
            this.dispatchEvent(new $183cd5d1ff396d87$export$a1aa5b8ae83fa080(message));
        });
    }
    /**
     * Get the device name
     * @returns The device name, or null if not available
     */ get name() {
        return this.device.name;
    }
    /**
     * Get the device ID
     * @returns The device ID
     */ get id() {
        return this.device.id;
    }
    /**
     * Connect to the MIDI device
     * @throws Error if connection fails
     */ connect() {
        var _a;
        return $183cd5d1ff396d87$var$__awaiter(this, void 0, void 0, function*() {
            if (this.isConnected()) return;
            if (this.isConnecting) throw new Error("Connection already in progress");
            this.isConnecting = true;
            try {
                // Connect to GATT server
                const server = yield (_a = this.device.gatt) === null || _a === void 0 ? void 0 : _a.connect();
                if (!server) throw new Error("Failed to connect to GATT server");
                // Get MIDI service
                const service = yield server.getPrimaryService($183cd5d1ff396d87$export$9928111d856f95a1);
                // Get MIDI characteristic
                this.characteristic = yield service.getCharacteristic($183cd5d1ff396d87$export$b027618ae06604e1);
                // Start notifications
                yield this.characteristic.startNotifications();
                // Add value change listener
                this.characteristic.addEventListener("characteristicvaluechanged", this.handleMIDICharacteristicValueChanged.bind(this));
            } catch (error) {
                this.characteristic = null;
                throw error;
            } finally{
                this.isConnecting = false;
            }
        });
    }
    /**
     * Disconnect from the MIDI device
     */ disconnect() {
        var _a, _b;
        if (this.characteristic) {
            try {
                this.characteristic.stopNotifications().catch((error)=>{
                    console.error("Error stopping notifications:", error);
                });
            } catch (error) {
                console.error("Error stopping notifications:", error);
            }
            this.characteristic = null;
        }
        if ((_b = (_a = this.device) === null || _a === void 0 ? void 0 : _a.gatt) === null || _b === void 0 ? void 0 : _b.connected) try {
            this.device.gatt.disconnect();
        } catch (error) {
            console.error("Error disconnecting device:", error);
        }
    }
    /**
     * Check if the device is connected
     * @returns True if connected, false otherwise
     */ isConnected() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.device) === null || _a === void 0 ? void 0 : _a.gatt) === null || _b === void 0 ? void 0 : _b.connected) !== null && _c !== void 0 ? _c : false;
    }
    /**
     * Handle MIDI characteristic value changes
     * @param event The characteristic value changed event
     * @private
     */ handleMIDICharacteristicValueChanged(event) {
        const value = event.target.value;
        if (value) this.parser.push(value);
    }
    /**
     * Handle disconnection events
     * @private
     */ handleDisconnection() {
        const wasConnected = this.characteristic !== null;
        this.characteristic = null;
        if (wasConnected) this.dispatchEvent(new $183cd5d1ff396d87$export$16fd7097b8121b3a());
    }
}
/**
 * BLEMIDI provides utility functions for working with Bluetooth MIDI devices
 */ const $183cd5d1ff396d87$export$506168a4130bff6b = {
    /**
     * Check if Web Bluetooth is supported in this browser
     * @returns True if supported, false otherwise
     */ isSupported () {
        return typeof navigator !== "undefined" && !!navigator.bluetooth;
    },
    /**
     * Scan for BLE MIDI devices
     * @param options Scan options to filter devices
     * @returns Promise that resolves with a BLEMIDIDevice, or rejects on error or if the user cancels
     */ scan (options = {}) {
        return $183cd5d1ff396d87$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isSupported()) throw new Error("Web Bluetooth is not supported in this browser");
            // Create filters based on options
            const filters = [
                {
                    services: [
                        $183cd5d1ff396d87$export$9928111d856f95a1
                    ]
                }
            ];
            if (options.name) filters.push({
                name: options.name
            });
            if (options.namePrefix) filters.push({
                namePrefix: options.namePrefix
            });
            // Request a device through the browser's UI
            const device = yield navigator.bluetooth.requestDevice({
                filters: filters
            });
            // Return a BLEMIDIDevice instance wrapping the selected device
            return new $183cd5d1ff396d87$export$52f1657fe1fab8cb(device);
        });
    }
};


const $b0bc596acda070ce$export$29d08668c517c982 = 'poweredOn';
const $b0bc596acda070ce$export$7b5342e338c29d = 'stateChange';
const $b0bc596acda070ce$export$ee4c2a119daa455d = 'characteristicvaluechanged';
const $b0bc596acda070ce$export$9481b6531b14b43a = 'discover';
const $b0bc596acda070ce$export$ab8303bf744a3b1e = 'gattserverdisconnected';
const $b0bc596acda070ce$export$d2f38afe20a8bf88 = 0x80;
const $b0bc596acda070ce$export$4c9675bf498b5ba8 = 0x90;
const $b0bc596acda070ce$export$740953c912a6941a = 0xA0;
const $b0bc596acda070ce$export$7d2eb38aeebc0302 = 0xB0;
const $b0bc596acda070ce$export$667d62e50c4110d0 = 0xC0;
const $b0bc596acda070ce$export$95d7a3752ecd13dd = 0xD0;
const $b0bc596acda070ce$export$a4ddce62bd7475d1 = 0xE0;
const $b0bc596acda070ce$export$6ce16743ac8c18f9 = 0xF0 // SYSEX!
;
const $b0bc596acda070ce$export$90c136ee07ee70dd = 0xF1;
const $b0bc596acda070ce$export$9d4a8af587b43918 = 0xF2;
const $b0bc596acda070ce$export$1c2fc43f8095cdaa = 0xF3;
const $b0bc596acda070ce$export$1c90fb8cdff3524e = 0xF6;
const $b0bc596acda070ce$export$962fb35cf1b79a6c = 0xF7;
const $b0bc596acda070ce$export$a95e1f4865192fad = 0xF8;
const $b0bc596acda070ce$export$1c9f5ec89553aed3 = 0xFA;
const $b0bc596acda070ce$export$d8283fd22be4426a = 0xFB;
const $b0bc596acda070ce$export$741971ccc181583e = 0xFC;
const $b0bc596acda070ce$export$8891b5703d3d89c1 = 0xFE;
const $b0bc596acda070ce$export$41e623913aa5d009 = 0xFF;
const $b0bc596acda070ce$export$5e3062daa704d192 = (channel = 1)=>Math.max(1, channel - 1) & 0x0f;
const $b0bc596acda070ce$export$b827b134be6fbf1c = (byte, channel)=>$b0bc596acda070ce$export$5e3062daa704d192(channel) | byte;




class $6af0da624ab416e2$export$2e2bcd8739ae039 {
    webMIDIDriver;
    bleMIDIDriver;
    webMIDIEnabled = false;
    bluetoothMIDIEnabled = false;
    webMIDIAccessGranted = false;
    bluetoothMIDICharacteristic = false;
    bluetoothPacketQueue = [];
    midiMap = new Map();
    activeInputDevices = [];
    activeOutputDevices = [];
    midiEventQueue = new Map();
    get isWebMIDISupported() {
        return navigator.requestMIDIAccess !== undefined;
    }
    get isWebMIDIAvailable() {
        return this.isWebMIDISupported && this.webMIDIDriver && this.webMIDIDriver.supported;
    }
    get isBluetoothMIDISupported() {
        return navigator.bluetooth !== undefined;
    }
    get isBluetoothMIDIAvailable() {
        return this.isBluetoothMIDISupported;
    }
    get isMIDIAvailable() {
        return this.isWebMIDIAvailable || this.isBluetoothMIDIAvailable;
    }
    get isMIDISupported() {
        return this.isWebMIDISupported || this.isBluetoothMIDISupported;
    }
    get enabled() {
        return this.webMIDIEnabled;
    }
    get hasInputDevices() {
        return this.inputs.length > 0;
    }
    get hasOutputDevices() {
        return this.outputs.length > 0;
    }
    get inputs() {
        return this.webMIDIDriver ? this.webMIDIDriver.inputs : [];
    }
    get outputs() {
        return this.webMIDIDriver ? this.webMIDIDriver.outputs : [];
    }
    constructor(){}
    /**
     * 
     * @returns 
     */ async loadWebMIDI() {
        try {
            const midi = await (parcelRequire("dBrz7"));
            return midi.WebMidi;
        } catch (error) {
            console.error("Couldn't load Web MIDI driver", error);
        }
    }
    /**
     * 
     * @returns 
     */ async loadBluetoothMIDI() {
        try {
            // const { BLEMIDI } = await import("web-ble-midi")
            // return BLEMIDI.isSupported() ? BLEMIDI : null
            const { DeviceConnector: DeviceConnector, MidiPacketParser: MidiPacketParser } = await (parcelRequire("iuYsy"));
            const bluetoothMIDIDataParser = new MidiPacketParser();
            return {
                bluetoothMIDIDataParser: bluetoothMIDIDataParser,
                DeviceConnector: DeviceConnector,
                MidiPacketParser: MidiPacketParser
            };
        } catch (error) {
            console.error("Couldn't load MIDI BLE driver", error);
        }
    }
    //  this.inputs.forEach((device, index) => this.monitorInput(device) )
    monitorInput(input, callback) {
        // `${index}: ${device.name}`
        // input.addListener("noteon", e => {
        //     // create a note object that matches
        //     // new Note(0)
        //     console.log("MIDI noteon", index, e,  e.note.identifier)
        //     callback && callback(e)
        // })
        // input.addListener("noteoff", e => {
        //     // create a note object that matches
        //     // new Note(0)
        //     console.log("MIDI noteoff", index, e,  e.note.identifier)
        //     callback && callback(e)
        // })
        input.addListener("midimessage", (e)=>{
            // { port: {…}, target: {…}, message: {…}, timestamp: 629940, type: "midimessage", data: (1) […], rawData: (1) […], statusByte: 248, dataBytes: [] }
            switch(e.message.type){
                case "clock":
                case "activesensing":
                case "start":
                case "stop":
                case "continue":
                    callback && callback(e);
                    break;
            }
        // create a note object that matches
        // new Note(0)
        // console.log("MIDI Message", e,  input )
        });
        input.addListener("noteon", (e)=>{
            // { port: {…}, target: {…}, message: {…}, timestamp: 629940, type: "midimessage", data: (1) […], rawData: (1) […], statusByte: 248, dataBytes: [] }
            // create a note object that matches
            // new Note(0)
            // console.log("MIDI Message", e,  input )
            callback && callback(e);
        });
        input.addListener("noteoff", (e)=>{
            // { port: {…}, target: {…}, message: {…}, timestamp: 629940, type: "midimessage", data: (1) […], rawData: (1) […], statusByte: 248, dataBytes: [] }
            // create a note object that matches
            // new Note(0)
            // console.log("MIDI Message", e,  input )
            callback && callback(e);
        });
    }
    // public method
    // take all devices connected to the computer and pipe their midi here
    monitorAllInputs(callback) {
        this.inputs.forEach((device, index)=>{
            this.monitorInput(device, callback);
        });
    }
    monitorActiveInputs(callback) {
        this.activeInputDevices.forEach((device, index)=>{
            this.monitorInput(device, callback);
        });
    }
    /**
     * 
     * @param {*} inputs 
     */ selectInputs(inputs) {
        this.activeInputDevices.push(...inputs);
    }
    /**
     * 
     * @param {*} outputs 
     */ selectOutputs(outputs) {
        this.activeOutputDevices.push(...outputs);
    }
    /**
     * Note ON for all connected MIDI devices
     */ async noteOn(note, velocity) {
        const options = {
            release: velocity
        };
        this.activeOutputDevices.forEach((output)=>{
            output.playNote(note, options);
        });
        if (this.bluetoothMIDICharacteristic) sendBLENoteOn(this.bluetoothMIDICharacteristic, selectedMIDIChannel, noteModel.noteNumber, 127, this.bluetoothPacketQueue);
        // also check the queue to see if there are any events waiting to be played
        this.midiEventQueue.forEach((midiEventQueue, index)=>{
            const latentEvent = midiEventQueue.shift();
            latentEvent;
        });
    }
    /**
     * Note OFF for all connected MIDI devices
     */ async noteOff(note, veolcity) {
        this.activeOutputDevices.forEach((output)=>{
        // output.playNote("C4", "acoustic_grand_piano", {duration: "4n"})
        });
    }
    /**
     * Enable all MIDI inputs
     * @returns 
     */ async enableWebMIDI() {
        if (this.webMIDIEnabled) return false;
        if (!this.webMIDIDriver) {
            this.webMIDIDriver = await this.loadWebMIDI();
            this.webMIDIDriver.addListener("error", this.onMIDIMessage);
            this.webMIDIDriver.addListener("connected", this.onMIDIMessage);
            this.webMIDIDriver.addListener("disconnected", this.onMIDIMessage);
            this.webMIDIDriver.addListener("portschanged", this.onMIDIMessage);
            this.webMIDIDriver.addListener("midiaccessgranted", this.onMIDIMessage);
        }
        try {
            await this.webMIDIDriver.enable();
            this.webMIDIEnabled = true;
        } catch (error) {
            console.error(error);
        }
        return true;
    }
    /**
     * Disable all MIDI output & input
     * @returns 
     */ async disableWebMIDI() {
        if (!this.webMIDIEnabled) return false;
        try {
            await this.webMIDIDriver.disable();
            this.webMIDIDriver.removeListener("error", this.onMIDIMessage);
            this.webMIDIDriver.removeListener("connected", this.onMIDIMessage);
            this.webMIDIDriver.removeListener("disconnected", this.onMIDIMessage);
            this.webMIDIDriver.removeListener("portschanged", this.onMIDIMessage);
            this.webMIDIDriver.removeListener("midiaccessgranted", this.onMIDIMessage);
            this.webMIDIEnabled = false;
        } catch (error) {
            console.error(error);
        }
        return true;
    }
    /**
     * Enable the WebMIDI if it is disabled,
     * disable it if it is enabled
     * @returns isEnabled
     */ async toggleWebMIDI() {
        if (!this.webMIDIEnabled) try {
            await this.enableWebMIDI();
            return true;
        } catch (error) {
            console.error(error);
        }
        else try {
            await this.disableWebMIDI();
            return false;
        } catch (error) {
            console.error(error);
        }
        return this.webMIDIEnabled;
    }
    /**
     * A WebMIDI Message was received
     * @param {Event} event 
     */ onMIDIMessage(event) {
        console.info("MIDI Event", event);
        switch(event){
            // per device!
            case "connected":
                console.info("MIDI Connected ", event, event.port);
                // this.midiMap[] = 
                this.midiEventQueue.set(event.port, []);
                break;
            case "disconnected":
                console.info("MIDI Disconnected ", event, event.port);
                // this.midiMap[] = 
                this.midiEventQueue.delete(event.port);
                break;
            case "portschanged":
                // this.availabilityMap[] = 
                console.info("New MIDI Device detected", event, event.port);
                break;
            case "midiaccessgranted":
                console.info("MIDI permission granted", event);
                this.webMIDIAccessGranted = true;
                break;
            case "error":
                console.error("MIDI FAIL", event);
                break;
        }
    }
    // --- BLE ------------------------------------------
    /**
     * Toggle Bluetooth MIDI (BLE)
     * @returns 
     */ async toggleBluetoothMIDI() {
        if (!this.bluetoothMIDIEnabled) try {
            await this.enableBLEMIDI();
            return true;
        } catch (error) {
            console.error(error);
        }
        else try {
            await this.disableBLEMIDI();
            return false;
        } catch (error) {
            console.error(error);
        }
        return this.bluetoothMIDIEnabled;
    }
    /**
     * Enable Bluetooth MIDI (BLE)
     * @returns boolean
     */ async enableBLEMIDI() {
        if (this.bluetoothMIDIEnabled) return false;
        if (!this.bleMIDIDriver) this.bleMIDIDriver = await this.loadBluetoothMIDI();
        const { bluetoothMIDIDataParser: bluetoothMIDIDataParser, DeviceConnector: DeviceConnector, MidiPacketParser: MidiPacketParser } = this.bleMIDIDriver;
        const device = await DeviceConnector.connect();
        device.addEventListener((0, $b0bc596acda070ce$export$ab8303bf744a3b1e), (event)=>{
            console.log("BLE Device disconnected");
        });
        const server = await device.gatt.connect();
        const service = await server.getPrimaryService((0, $183cd5d1ff396d87$export$9928111d856f95a1));
        const characteristic = await service.getCharacteristic((0, $183cd5d1ff396d87$export$b027618ae06604e1));
        await characteristic.startNotifications();
        characteristic.addEventListener((0, $b0bc596acda070ce$export$ee4c2a119daa455d), (event)=>{
            const value = event.target.value;
            const midiPackets = bluetoothMIDIDataParser.parse(value);
            console.log('MIDI Packets:', midiPackets, value);
        });
        this.bluetoothMIDICharacteristic = characteristic;
        this.bluetoothMIDIEnabled = true;
        startBLECharacteristicStream(characteristic);
        console.log('MIDI BLE:', {
            server: server,
            service: service,
            characteristic: characteristic
        }, this);
        return true;
    /*
        try {
            // Will prompt the user to select a device with a browser dialog
            // Optional: filter by name prefix
            const device = await BLEMIDI.scan()
            // const device = await BLEMIDI.scan({ namePrefix: "BLE-MIDI" })

            console.log("Selected device:", device.name)


            // Set up event listeners


            device.addEventListener(MIDIEventType.Disconnect, () => {
                console.log("BLE Device disconnected")
            })

            // Register event listeners
            device.addEventListener( MIDIEventType.MIDIMessage, (event) => {
                // MIDIMessageEvent has a message property with the MIDI data
                const message = event.message
                console.log("Received MIDI message:", message)

                // Access the raw MIDI data
                const statusByte = message.message[0]
                const channel = statusByte & 0x0f
                const midiCommand = statusByte & 0xf0

                switch (midiCommand) {

                    default:

                }


                // Handle note-on messages
                if ( midiCommand === MIDI_NOTE_ON && message.message[2] > 0) {
                    const noteNumber = message.message[1]
                    const velocity = message.message[2]
                    console.log(
                    `Note On - Channel: ${
                        channel + 1
                    }, Note: ${noteNumber}, Velocity: ${velocity}`
                    )
                }
            })

            

            // Connect to the device
            await device.connect()
            console.log("Connected to device:", device.name)

            // Later, when you want to disconnect:
            // device.disconnect();
        } catch (error) {
            if (error.name === "NotFoundError") {
               console.log("User cancelled the device selection")
            } else {
                console.error("Connection error:", error)
            }
        }
        */ }
    /**
     * Disable Bluetooth MIDI (BLE)
     * @returns boolean
     */ async disableBLEMIDI() {
        // this.bluetoothMIDICharacteristic
        // const { bluetoothMIDIDataParser, DeviceConnector, MidiPacketParser } = this.bleMIDIDriver
        // const device = await DeviceConnector.connect()
        if (!this.bluetoothMIDIEnabled) // already disabled
        return false;
        return true;
    }
}


//const OSCILLATORS = [ "sine", "triangle"]

/**
 * Tonic
 * Supertonic
 * Mediant
 * Subdominant
 * Dominant
 * Submediant
 * Leading Tone
 * Sub-Tonic
 * 
 * Charles Goes Dancing At Every Big Fun Celebration.
 * From G D A E B F C...
 * 
 */ 
var $5uK7V = parcelRequire("5uK7V");
const $7ec2567d1d301bb4$var$ROOT_FREQUENCY = 440 // frequency of A (common value is 440Hz)
;
const $7ec2567d1d301bb4$var$ROOT_F_BY_32 = $7ec2567d1d301bb4$var$ROOT_FREQUENCY / 32;
const $7ec2567d1d301bb4$export$696b7110bc0d8caf = (noteNumber)=>$7ec2567d1d301bb4$var$ROOT_F_BY_32 * 2 ** ((noteNumber - 9) / 12);
const $7ec2567d1d301bb4$var$KEY_NAMES = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
const $7ec2567d1d301bb4$var$SOUNDS_SOLFEGE = [
    "Do",
    "Do #",
    "Re",
    "Re #",
    "Mi",
    "Fa",
    "Fa #",
    "Sol",
    "Sol #",
    "La",
    "La #",
    "Si"
];
const $7ec2567d1d301bb4$var$CSS_VAR_COLOURS = [
    "--col-plum",
    "--col-plum",
    "--col-pink",
    "--col-pink",
    "--col-purple",
    "--col-blue",
    "--col-blue",
    "--col-green",
    "--col-green",
    "--col-orange",
    "--col-orange",
    "--col-red"
];
const $7ec2567d1d301bb4$var$COLOURS = [
    (0, $5uK7V.PALETTE).plum,
    (0, $5uK7V.PALETTE).plum,
    (0, $5uK7V.PALETTE).pink,
    (0, $5uK7V.PALETTE).pink,
    (0, $5uK7V.PALETTE).purple,
    (0, $5uK7V.PALETTE).blue,
    (0, $5uK7V.PALETTE).blue,
    (0, $5uK7V.PALETTE).green,
    (0, $5uK7V.PALETTE).green,
    (0, $5uK7V.PALETTE).orange,
    (0, $5uK7V.PALETTE).orange,
    (0, $5uK7V.PALETTE).red
];
// const SHARPS = [1,3,6,8,10]
const $7ec2567d1d301bb4$var$SHARPS = [
    false,
    true,
    false,
    true,
    false,
    false,
    true,
    false,
    true,
    false,
    true,
    false
];
const $7ec2567d1d301bb4$export$9cf3a421da1ab755 = $7ec2567d1d301bb4$var$KEY_NAMES.length;
const $7ec2567d1d301bb4$export$521fbba7d60d10ec = (noteNumber)=>$7ec2567d1d301bb4$var$KEY_NAMES[noteNumber % $7ec2567d1d301bb4$export$9cf3a421da1ab755];
const $7ec2567d1d301bb4$export$5afd7c472d863bbe = (noteNumber)=>Math.floor(noteNumber / $7ec2567d1d301bb4$export$9cf3a421da1ab755) - 1;
const $7ec2567d1d301bb4$export$8d7df602c031e767 = (noteNumber)=>$7ec2567d1d301bb4$var$SHARPS[noteNumber % $7ec2567d1d301bb4$export$9cf3a421da1ab755];
const $7ec2567d1d301bb4$export$5a20f49a17c681a1 = (noteNumber)=>$7ec2567d1d301bb4$export$8d7df602c031e767(noteNumber);
const $7ec2567d1d301bb4$export$fae73f5876775ac1 = (key, octave = 4, isAccidental = false)=>$7ec2567d1d301bb4$var$KEY_NAMES.indexOf(key) + octave * 12 + (isAccidental ? 1 : 0);
class $7ec2567d1d301bb4$export$2e2bcd8739ae039 {
    // noteName
    // noteNumber
    // noteKey 
    // frequency
    // octave
    // accidental
    // sound
    // alternate
    get hex() {
        return '';
    }
    get colour() {
        return $7ec2567d1d301bb4$var$COLOURS[this.sequenceIndex];
    }
    get asCSSVar() {
        return $7ec2567d1d301bb4$var$CSS_VAR_COLOURS[this.sequenceIndex];
    }
    set noteNumber(noteNumber) {
        this.number = noteNumber;
        this.sequenceIndex = noteNumber % $7ec2567d1d301bb4$export$9cf3a421da1ab755;
        this.noteKey = $7ec2567d1d301bb4$export$521fbba7d60d10ec(noteNumber);
        this.octave = $7ec2567d1d301bb4$export$5afd7c472d863bbe(noteNumber);
        this.noteName = this.noteKey + this.octave;
        this.frequency = $7ec2567d1d301bb4$export$696b7110bc0d8caf(noteNumber);
        this.accidental = $7ec2567d1d301bb4$export$8d7df602c031e767(noteNumber);
        this.sound = $7ec2567d1d301bb4$var$SOUNDS_SOLFEGE[noteNumber % $7ec2567d1d301bb4$var$SOUNDS_SOLFEGE.length];
        this.alternate = this.accidental ? $7ec2567d1d301bb4$export$521fbba7d60d10ec(noteNumber + 1) + " Flat" : this.noteName;
    }
    get noteNumber() {
        return this.number;
    }
    constructor(noteNumber){
        this.noteNumber = noteNumber;
    }
    toString() {
        return "[Note: " + this.noteNumber + " key:" + this.noteKey + "  octave:" + this.octave + " sound:" + this.sound + "  ] Freq:" + this.frequency;
    }
}


// import { WAVE_FORM_NAMES_GENERAL_MIDI, WAVE_TABLE_LOCATIONS_GENERAL_MIDI } from "./tables/wave-table-general-midi"
// import { WAVE_FORM_NAMES_GOOGLE, WAVE_TABLE_LOCATIONS_GOOGLE } from "./tables/wave-table-google"
// import { generateImageFromWaveTable, loadWaveTableFromImage } from "./wave-table-utils"

// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $907f3535d623acf9$var$ch2 = {};
var $907f3535d623acf9$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($907f3535d623acf9$var$ch2[id] || ($907f3535d623acf9$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $907f3535d623acf9$var$u8 = Uint8Array, $907f3535d623acf9$var$u16 = Uint16Array, $907f3535d623acf9$var$i32 = Int32Array;
// fixed length extra bits
var $907f3535d623acf9$var$fleb = new $907f3535d623acf9$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $907f3535d623acf9$var$fdeb = new $907f3535d623acf9$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $907f3535d623acf9$var$clim = new $907f3535d623acf9$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $907f3535d623acf9$var$freb = function(eb, start) {
    var b = new $907f3535d623acf9$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $907f3535d623acf9$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $907f3535d623acf9$var$_a = $907f3535d623acf9$var$freb($907f3535d623acf9$var$fleb, 2), $907f3535d623acf9$var$fl = $907f3535d623acf9$var$_a.b, $907f3535d623acf9$var$revfl = $907f3535d623acf9$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$907f3535d623acf9$var$fl[28] = 258, $907f3535d623acf9$var$revfl[258] = 28;
var $907f3535d623acf9$var$_b = $907f3535d623acf9$var$freb($907f3535d623acf9$var$fdeb, 0), $907f3535d623acf9$var$fd = $907f3535d623acf9$var$_b.b, $907f3535d623acf9$var$revfd = $907f3535d623acf9$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $907f3535d623acf9$var$rev = new $907f3535d623acf9$var$u16(32768);
for(var $907f3535d623acf9$var$i = 0; $907f3535d623acf9$var$i < 32768; ++$907f3535d623acf9$var$i){
    // reverse table algorithm from SO
    var $907f3535d623acf9$var$x = ($907f3535d623acf9$var$i & 0xAAAA) >> 1 | ($907f3535d623acf9$var$i & 0x5555) << 1;
    $907f3535d623acf9$var$x = ($907f3535d623acf9$var$x & 0xCCCC) >> 2 | ($907f3535d623acf9$var$x & 0x3333) << 2;
    $907f3535d623acf9$var$x = ($907f3535d623acf9$var$x & 0xF0F0) >> 4 | ($907f3535d623acf9$var$x & 0x0F0F) << 4;
    $907f3535d623acf9$var$rev[$907f3535d623acf9$var$i] = (($907f3535d623acf9$var$x & 0xFF00) >> 8 | ($907f3535d623acf9$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $907f3535d623acf9$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $907f3535d623acf9$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $907f3535d623acf9$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $907f3535d623acf9$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$907f3535d623acf9$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $907f3535d623acf9$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $907f3535d623acf9$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $907f3535d623acf9$var$flt = new $907f3535d623acf9$var$u8(288);
for(var $907f3535d623acf9$var$i = 0; $907f3535d623acf9$var$i < 144; ++$907f3535d623acf9$var$i)$907f3535d623acf9$var$flt[$907f3535d623acf9$var$i] = 8;
for(var $907f3535d623acf9$var$i = 144; $907f3535d623acf9$var$i < 256; ++$907f3535d623acf9$var$i)$907f3535d623acf9$var$flt[$907f3535d623acf9$var$i] = 9;
for(var $907f3535d623acf9$var$i = 256; $907f3535d623acf9$var$i < 280; ++$907f3535d623acf9$var$i)$907f3535d623acf9$var$flt[$907f3535d623acf9$var$i] = 7;
for(var $907f3535d623acf9$var$i = 280; $907f3535d623acf9$var$i < 288; ++$907f3535d623acf9$var$i)$907f3535d623acf9$var$flt[$907f3535d623acf9$var$i] = 8;
// fixed distance tree
var $907f3535d623acf9$var$fdt = new $907f3535d623acf9$var$u8(32);
for(var $907f3535d623acf9$var$i = 0; $907f3535d623acf9$var$i < 32; ++$907f3535d623acf9$var$i)$907f3535d623acf9$var$fdt[$907f3535d623acf9$var$i] = 5;
// fixed length map
var $907f3535d623acf9$var$flm = /*#__PURE__*/ $907f3535d623acf9$var$hMap($907f3535d623acf9$var$flt, 9, 0), $907f3535d623acf9$var$flrm = /*#__PURE__*/ $907f3535d623acf9$var$hMap($907f3535d623acf9$var$flt, 9, 1);
// fixed distance map
var $907f3535d623acf9$var$fdm = /*#__PURE__*/ $907f3535d623acf9$var$hMap($907f3535d623acf9$var$fdt, 5, 0), $907f3535d623acf9$var$fdrm = /*#__PURE__*/ $907f3535d623acf9$var$hMap($907f3535d623acf9$var$fdt, 5, 1);
// find max of array
var $907f3535d623acf9$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $907f3535d623acf9$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $907f3535d623acf9$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $907f3535d623acf9$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $907f3535d623acf9$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $907f3535d623acf9$var$u8(v.subarray(s, e));
};
var $907f3535d623acf9$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $907f3535d623acf9$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $907f3535d623acf9$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $907f3535d623acf9$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $907f3535d623acf9$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $907f3535d623acf9$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $907f3535d623acf9$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $907f3535d623acf9$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $907f3535d623acf9$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $907f3535d623acf9$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $907f3535d623acf9$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $907f3535d623acf9$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $907f3535d623acf9$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $907f3535d623acf9$var$flrm, dm = $907f3535d623acf9$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $907f3535d623acf9$var$bits(dat, pos, 31) + 257, hcLen = $907f3535d623acf9$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $907f3535d623acf9$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $907f3535d623acf9$var$u8(tl);
                // code length tree
                var clt = new $907f3535d623acf9$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$907f3535d623acf9$var$clim[i]] = $907f3535d623acf9$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $907f3535d623acf9$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $907f3535d623acf9$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$907f3535d623acf9$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $907f3535d623acf9$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $907f3535d623acf9$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $907f3535d623acf9$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $907f3535d623acf9$var$max(lt);
                // max dist bits
                dbt = $907f3535d623acf9$var$max(dt);
                lm = $907f3535d623acf9$var$hMap(lt, lbt, 1);
                dm = $907f3535d623acf9$var$hMap(dt, dbt, 1);
            } else $907f3535d623acf9$var$err(1);
            if (pos > tbts) {
                if (noSt) $907f3535d623acf9$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$907f3535d623acf9$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $907f3535d623acf9$var$err(0);
                break;
            }
            if (!c) $907f3535d623acf9$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $907f3535d623acf9$var$fleb[i];
                    add = $907f3535d623acf9$var$bits(dat, pos, (1 << b) - 1) + $907f3535d623acf9$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$907f3535d623acf9$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $907f3535d623acf9$var$err(3);
                pos += d & 15;
                var dt = $907f3535d623acf9$var$fd[dsym];
                if (dsym > 3) {
                    var b = $907f3535d623acf9$var$fdeb[dsym];
                    dt += $907f3535d623acf9$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $907f3535d623acf9$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $907f3535d623acf9$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $907f3535d623acf9$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $907f3535d623acf9$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $907f3535d623acf9$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $907f3535d623acf9$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $907f3535d623acf9$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $907f3535d623acf9$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $907f3535d623acf9$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $907f3535d623acf9$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $907f3535d623acf9$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $907f3535d623acf9$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($907f3535d623acf9$var$ln(n.l, l, d + 1), $907f3535d623acf9$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $907f3535d623acf9$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $907f3535d623acf9$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $907f3535d623acf9$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $907f3535d623acf9$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $907f3535d623acf9$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $907f3535d623acf9$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $907f3535d623acf9$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $907f3535d623acf9$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $907f3535d623acf9$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $907f3535d623acf9$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $907f3535d623acf9$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $907f3535d623acf9$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $907f3535d623acf9$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$907f3535d623acf9$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $907f3535d623acf9$var$clen(lf, $907f3535d623acf9$var$flt) + $907f3535d623acf9$var$clen(df, $907f3535d623acf9$var$fdt) + eb;
    var dtlen = $907f3535d623acf9$var$clen(lf, dlt) + $907f3535d623acf9$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $907f3535d623acf9$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $907f3535d623acf9$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $907f3535d623acf9$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $907f3535d623acf9$var$hMap(dlt, mlb, 0), ll = dlt, dm = $907f3535d623acf9$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $907f3535d623acf9$var$hMap(lct, mlcb, 0);
        $907f3535d623acf9$var$wbits(out, p, nlc - 257);
        $907f3535d623acf9$var$wbits(out, p + 5, ndc - 1);
        $907f3535d623acf9$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$907f3535d623acf9$var$wbits(out, p + 3 * i, lct[$907f3535d623acf9$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $907f3535d623acf9$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $907f3535d623acf9$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $907f3535d623acf9$var$flm, ll = $907f3535d623acf9$var$flt, dm = $907f3535d623acf9$var$fdm, dl = $907f3535d623acf9$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $907f3535d623acf9$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $907f3535d623acf9$var$wbits(out, p, sym >> 23 & 31), p += $907f3535d623acf9$var$fleb[len];
            var dst = sym & 31;
            $907f3535d623acf9$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $907f3535d623acf9$var$wbits16(out, p, sym >> 5 & 8191), p += $907f3535d623acf9$var$fdeb[dst];
        } else $907f3535d623acf9$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $907f3535d623acf9$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $907f3535d623acf9$var$deo = /*#__PURE__*/ new $907f3535d623acf9$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $907f3535d623acf9$var$et = /*#__PURE__*/ new $907f3535d623acf9$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $907f3535d623acf9$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $907f3535d623acf9$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $907f3535d623acf9$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $907f3535d623acf9$var$u16(32768), head = st.h || new $907f3535d623acf9$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $907f3535d623acf9$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $907f3535d623acf9$var$u16(288), df = new $907f3535d623acf9$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $907f3535d623acf9$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $907f3535d623acf9$var$revfl[l] << 18 | $907f3535d623acf9$var$revfd[d];
                    var lin = $907f3535d623acf9$var$revfl[l] & 31, din = $907f3535d623acf9$var$revfd[d] & 31;
                    eb += $907f3535d623acf9$var$fleb[lin] + $907f3535d623acf9$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $907f3535d623acf9$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $907f3535d623acf9$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $907f3535d623acf9$var$slc(o, 0, pre + $907f3535d623acf9$var$shft(pos) + post);
};
// CRC32 table
var $907f3535d623acf9$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $907f3535d623acf9$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $907f3535d623acf9$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $907f3535d623acf9$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $907f3535d623acf9$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $907f3535d623acf9$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $907f3535d623acf9$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $907f3535d623acf9$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $907f3535d623acf9$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $907f3535d623acf9$var$ch = [];
// clone bufs
var $907f3535d623acf9$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $907f3535d623acf9$var$wrkr = function(fns, init, id, cb) {
    if (!$907f3535d623acf9$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $907f3535d623acf9$var$wcln(fns[i], fnStr, td_1);
        $907f3535d623acf9$var$ch[id] = {
            c: $907f3535d623acf9$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $907f3535d623acf9$var$mrg({}, $907f3535d623acf9$var$ch[id].e);
    return $907f3535d623acf9$var$wk($907f3535d623acf9$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $907f3535d623acf9$var$cbfs(td), cb);
};
// base async inflate fn
var $907f3535d623acf9$var$bInflt = function() {
    return [
        $907f3535d623acf9$var$u8,
        $907f3535d623acf9$var$u16,
        $907f3535d623acf9$var$i32,
        $907f3535d623acf9$var$fleb,
        $907f3535d623acf9$var$fdeb,
        $907f3535d623acf9$var$clim,
        $907f3535d623acf9$var$fl,
        $907f3535d623acf9$var$fd,
        $907f3535d623acf9$var$flrm,
        $907f3535d623acf9$var$fdrm,
        $907f3535d623acf9$var$rev,
        $907f3535d623acf9$var$ec,
        $907f3535d623acf9$var$hMap,
        $907f3535d623acf9$var$max,
        $907f3535d623acf9$var$bits,
        $907f3535d623acf9$var$bits16,
        $907f3535d623acf9$var$shft,
        $907f3535d623acf9$var$slc,
        $907f3535d623acf9$var$err,
        $907f3535d623acf9$var$inflt,
        $907f3535d623acf9$export$90366d8b308ba94a,
        $907f3535d623acf9$var$pbf,
        $907f3535d623acf9$var$gopt
    ];
};
var $907f3535d623acf9$var$bDflt = function() {
    return [
        $907f3535d623acf9$var$u8,
        $907f3535d623acf9$var$u16,
        $907f3535d623acf9$var$i32,
        $907f3535d623acf9$var$fleb,
        $907f3535d623acf9$var$fdeb,
        $907f3535d623acf9$var$clim,
        $907f3535d623acf9$var$revfl,
        $907f3535d623acf9$var$revfd,
        $907f3535d623acf9$var$flm,
        $907f3535d623acf9$var$flt,
        $907f3535d623acf9$var$fdm,
        $907f3535d623acf9$var$fdt,
        $907f3535d623acf9$var$rev,
        $907f3535d623acf9$var$deo,
        $907f3535d623acf9$var$et,
        $907f3535d623acf9$var$hMap,
        $907f3535d623acf9$var$wbits,
        $907f3535d623acf9$var$wbits16,
        $907f3535d623acf9$var$hTree,
        $907f3535d623acf9$var$ln,
        $907f3535d623acf9$var$lc,
        $907f3535d623acf9$var$clen,
        $907f3535d623acf9$var$wfblk,
        $907f3535d623acf9$var$wblk,
        $907f3535d623acf9$var$shft,
        $907f3535d623acf9$var$slc,
        $907f3535d623acf9$var$dflt,
        $907f3535d623acf9$var$dopt,
        $907f3535d623acf9$export$21533ff51b8a0b4a,
        $907f3535d623acf9$var$pbf
    ];
};
// gzip extra
var $907f3535d623acf9$var$gze = function() {
    return [
        $907f3535d623acf9$var$gzh,
        $907f3535d623acf9$var$gzhl,
        $907f3535d623acf9$var$wbytes,
        $907f3535d623acf9$var$crc,
        $907f3535d623acf9$var$crct
    ];
};
// gunzip extra
var $907f3535d623acf9$var$guze = function() {
    return [
        $907f3535d623acf9$var$gzs,
        $907f3535d623acf9$var$gzl
    ];
};
// zlib extra
var $907f3535d623acf9$var$zle = function() {
    return [
        $907f3535d623acf9$var$zlh,
        $907f3535d623acf9$var$wbytes,
        $907f3535d623acf9$var$adler
    ];
};
// unzlib extra
var $907f3535d623acf9$var$zule = function() {
    return [
        $907f3535d623acf9$var$zls
    ];
};
// post buf
var $907f3535d623acf9$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $907f3535d623acf9$var$gopt = function(o) {
    return o && {
        out: o.size && new $907f3535d623acf9$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $907f3535d623acf9$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $907f3535d623acf9$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $907f3535d623acf9$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $907f3535d623acf9$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $907f3535d623acf9$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $907f3535d623acf9$var$err(5);
        if (t) strm.ondata($907f3535d623acf9$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $907f3535d623acf9$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $907f3535d623acf9$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $907f3535d623acf9$var$b8 = function(d, b) {
    return $907f3535d623acf9$var$b4(d, b) + $907f3535d623acf9$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $907f3535d623acf9$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $907f3535d623acf9$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $907f3535d623acf9$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $907f3535d623acf9$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $907f3535d623acf9$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $907f3535d623acf9$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $907f3535d623acf9$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $907f3535d623acf9$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $907f3535d623acf9$var$adler();
        h.p(o.dictionary);
        $907f3535d623acf9$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $907f3535d623acf9$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $907f3535d623acf9$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $907f3535d623acf9$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $907f3535d623acf9$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $907f3535d623acf9$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $907f3535d623acf9$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($907f3535d623acf9$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        if (this.s.l) $907f3535d623acf9$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $907f3535d623acf9$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        if (this.s.l) $907f3535d623acf9$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $907f3535d623acf9$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $907f3535d623acf9$var$astrmify([
            $907f3535d623acf9$var$bDflt,
            function() {
                return [
                    $907f3535d623acf9$var$astrm,
                    $907f3535d623acf9$export$ae157b6234afe138
                ];
            }
        ], this, $907f3535d623acf9$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $907f3535d623acf9$export$ae157b6234afe138(ev.data);
            onmessage = $907f3535d623acf9$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $907f3535d623acf9$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    return $907f3535d623acf9$var$cbify(data, opts, [
        $907f3535d623acf9$var$bDflt
    ], function(ev) {
        return $907f3535d623acf9$var$pbf($907f3535d623acf9$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $907f3535d623acf9$export$21533ff51b8a0b4a(data, opts) {
    return $907f3535d623acf9$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $907f3535d623acf9$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $907f3535d623acf9$var$u8(32768);
        this.p = new $907f3535d623acf9$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        if (this.d) $907f3535d623acf9$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $907f3535d623acf9$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $907f3535d623acf9$var$inflt(this.p, this.s, this.o);
        this.ondata($907f3535d623acf9$var$slc(dt, bts, this.s.b), this.d);
        this.o = $907f3535d623acf9$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $907f3535d623acf9$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $907f3535d623acf9$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $907f3535d623acf9$var$astrmify([
            $907f3535d623acf9$var$bInflt,
            function() {
                return [
                    $907f3535d623acf9$var$astrm,
                    $907f3535d623acf9$export$d1de70a877d6e43c
                ];
            }
        ], this, $907f3535d623acf9$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $907f3535d623acf9$export$d1de70a877d6e43c(ev.data);
            onmessage = $907f3535d623acf9$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $907f3535d623acf9$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    return $907f3535d623acf9$var$cbify(data, opts, [
        $907f3535d623acf9$var$bInflt
    ], function(ev) {
        return $907f3535d623acf9$var$pbf($907f3535d623acf9$export$90366d8b308ba94a(ev.data[0], $907f3535d623acf9$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $907f3535d623acf9$export$90366d8b308ba94a(data, opts) {
    return $907f3535d623acf9$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $907f3535d623acf9$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $907f3535d623acf9$var$crc();
        this.l = 0;
        this.v = 1;
        $907f3535d623acf9$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $907f3535d623acf9$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $907f3535d623acf9$var$dopt(c, this.o, this.v && $907f3535d623acf9$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $907f3535d623acf9$var$gzh(raw, this.o), this.v = 0;
        if (f) $907f3535d623acf9$var$wbytes(raw, raw.length - 8, this.c.d()), $907f3535d623acf9$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $907f3535d623acf9$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $907f3535d623acf9$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $907f3535d623acf9$var$astrmify([
            $907f3535d623acf9$var$bDflt,
            $907f3535d623acf9$var$gze,
            function() {
                return [
                    $907f3535d623acf9$var$astrm,
                    $907f3535d623acf9$export$ae157b6234afe138,
                    $907f3535d623acf9$export$8e4b66d280bf8342
                ];
            }
        ], this, $907f3535d623acf9$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $907f3535d623acf9$export$8e4b66d280bf8342(ev.data);
            onmessage = $907f3535d623acf9$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $907f3535d623acf9$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    return $907f3535d623acf9$var$cbify(data, opts, [
        $907f3535d623acf9$var$bDflt,
        $907f3535d623acf9$var$gze,
        function() {
            return [
                $907f3535d623acf9$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $907f3535d623acf9$var$pbf($907f3535d623acf9$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $907f3535d623acf9$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $907f3535d623acf9$var$crc(), l = data.length;
    c.p(data);
    var d = $907f3535d623acf9$var$dopt(data, opts, $907f3535d623acf9$var$gzhl(opts), 8), s = d.length;
    return $907f3535d623acf9$var$gzh(d, opts), $907f3535d623acf9$var$wbytes(d, s - 8, c.d()), $907f3535d623acf9$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $907f3535d623acf9$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $907f3535d623acf9$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $907f3535d623acf9$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $907f3535d623acf9$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $907f3535d623acf9$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $907f3535d623acf9$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $907f3535d623acf9$var$u8(0);
            this.push(new $907f3535d623acf9$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $907f3535d623acf9$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $907f3535d623acf9$var$astrmify([
            $907f3535d623acf9$var$bInflt,
            $907f3535d623acf9$var$guze,
            function() {
                return [
                    $907f3535d623acf9$var$astrm,
                    $907f3535d623acf9$export$d1de70a877d6e43c,
                    $907f3535d623acf9$export$4cb607de6db70415
                ];
            }
        ], this, $907f3535d623acf9$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $907f3535d623acf9$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $907f3535d623acf9$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $907f3535d623acf9$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    return $907f3535d623acf9$var$cbify(data, opts, [
        $907f3535d623acf9$var$bInflt,
        $907f3535d623acf9$var$guze,
        function() {
            return [
                $907f3535d623acf9$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $907f3535d623acf9$var$pbf($907f3535d623acf9$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $907f3535d623acf9$export$c80456f7aaba691c(data, opts) {
    var st = $907f3535d623acf9$var$gzs(data);
    if (st + 8 > data.length) $907f3535d623acf9$var$err(6, 'invalid gzip data');
    return $907f3535d623acf9$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $907f3535d623acf9$var$u8($907f3535d623acf9$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $907f3535d623acf9$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $907f3535d623acf9$var$adler();
        this.v = 1;
        $907f3535d623acf9$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $907f3535d623acf9$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $907f3535d623acf9$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $907f3535d623acf9$var$zlh(raw, this.o), this.v = 0;
        if (f) $907f3535d623acf9$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $907f3535d623acf9$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $907f3535d623acf9$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $907f3535d623acf9$var$astrmify([
            $907f3535d623acf9$var$bDflt,
            $907f3535d623acf9$var$zle,
            function() {
                return [
                    $907f3535d623acf9$var$astrm,
                    $907f3535d623acf9$export$ae157b6234afe138,
                    $907f3535d623acf9$export$4187ccf2467013b9
                ];
            }
        ], this, $907f3535d623acf9$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $907f3535d623acf9$export$4187ccf2467013b9(ev.data);
            onmessage = $907f3535d623acf9$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $907f3535d623acf9$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    return $907f3535d623acf9$var$cbify(data, opts, [
        $907f3535d623acf9$var$bDflt,
        $907f3535d623acf9$var$zle,
        function() {
            return [
                $907f3535d623acf9$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $907f3535d623acf9$var$pbf($907f3535d623acf9$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $907f3535d623acf9$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $907f3535d623acf9$var$adler();
    a.p(data);
    var d = $907f3535d623acf9$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $907f3535d623acf9$var$zlh(d, opts), $907f3535d623acf9$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $907f3535d623acf9$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $907f3535d623acf9$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $907f3535d623acf9$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($907f3535d623acf9$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $907f3535d623acf9$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $907f3535d623acf9$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $907f3535d623acf9$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $907f3535d623acf9$var$astrmify([
            $907f3535d623acf9$var$bInflt,
            $907f3535d623acf9$var$zule,
            function() {
                return [
                    $907f3535d623acf9$var$astrm,
                    $907f3535d623acf9$export$d1de70a877d6e43c,
                    $907f3535d623acf9$export$af2424f875ff1b17
                ];
            }
        ], this, $907f3535d623acf9$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $907f3535d623acf9$export$af2424f875ff1b17(ev.data);
            onmessage = $907f3535d623acf9$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $907f3535d623acf9$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    return $907f3535d623acf9$var$cbify(data, opts, [
        $907f3535d623acf9$var$bInflt,
        $907f3535d623acf9$var$zule,
        function() {
            return [
                $907f3535d623acf9$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $907f3535d623acf9$var$pbf($907f3535d623acf9$export$9ec8134f0f1b9fc6(ev.data[0], $907f3535d623acf9$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $907f3535d623acf9$export$9ec8134f0f1b9fc6(data, opts) {
    return $907f3535d623acf9$var$inflt(data.subarray($907f3535d623acf9$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $907f3535d623acf9$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $907f3535d623acf9$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $907f3535d623acf9$export$4cb607de6db70415;
        this.I = $907f3535d623acf9$export$d1de70a877d6e43c;
        this.Z = $907f3535d623acf9$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $907f3535d623acf9$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $907f3535d623acf9$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $907f3535d623acf9$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $907f3535d623acf9$export$d5adcdd968132151;
        this.I = $907f3535d623acf9$export$fff8358d6dbaa9cc;
        this.Z = $907f3535d623acf9$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $907f3535d623acf9$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $907f3535d623acf9$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $907f3535d623acf9$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $907f3535d623acf9$export$cae1ce83fe4a1782(data, opts, cb) : $907f3535d623acf9$export$ca7cbb494e731274(data, opts, cb);
}
function $907f3535d623acf9$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $907f3535d623acf9$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $907f3535d623acf9$export$90366d8b308ba94a(data, opts) : $907f3535d623acf9$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $907f3535d623acf9$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $907f3535d623acf9$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $907f3535d623acf9$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $907f3535d623acf9$var$u8(0),
                op
            ];
            $907f3535d623acf9$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $907f3535d623acf9$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $907f3535d623acf9$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $907f3535d623acf9$var$tds = 0;
try {
    $907f3535d623acf9$var$td.decode($907f3535d623acf9$var$et, {
        stream: true
    });
    $907f3535d623acf9$var$tds = 1;
} catch (e) {}
// decode UTF8
var $907f3535d623acf9$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $907f3535d623acf9$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $907f3535d623acf9$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($907f3535d623acf9$var$tds) this.t = new TextDecoder();
        else this.p = $907f3535d623acf9$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $907f3535d623acf9$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $907f3535d623acf9$var$err(4);
        var dat = new $907f3535d623acf9$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $907f3535d623acf9$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $907f3535d623acf9$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $907f3535d623acf9$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        if (this.d) $907f3535d623acf9$var$err(4);
        this.ondata($907f3535d623acf9$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $907f3535d623acf9$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $907f3535d623acf9$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($907f3535d623acf9$var$te) return $907f3535d623acf9$var$te.encode(str);
    var l = str.length;
    var ar = new $907f3535d623acf9$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $907f3535d623acf9$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $907f3535d623acf9$var$slc(ar, 0, ai);
}
function $907f3535d623acf9$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($907f3535d623acf9$var$td) return $907f3535d623acf9$var$td.decode(dat);
    else {
        var _a = $907f3535d623acf9$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $907f3535d623acf9$var$err(8);
        return s;
    }
}
// deflate bit flag
var $907f3535d623acf9$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $907f3535d623acf9$var$slzh = function(d, b) {
    return b + 30 + $907f3535d623acf9$var$b2(d, b + 26) + $907f3535d623acf9$var$b2(d, b + 28);
};
// read zip header
var $907f3535d623acf9$var$zh = function(d, b, z) {
    var fnl = $907f3535d623acf9$var$b2(d, b + 28), fn = $907f3535d623acf9$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($907f3535d623acf9$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $907f3535d623acf9$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $907f3535d623acf9$var$z64e(d, es) : [
        bs,
        $907f3535d623acf9$var$b4(d, b + 24),
        $907f3535d623acf9$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $907f3535d623acf9$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $907f3535d623acf9$var$b2(d, b + 30) + $907f3535d623acf9$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $907f3535d623acf9$var$z64e = function(d, b) {
    for(; $907f3535d623acf9$var$b2(d, b) != 1; b += 4 + $907f3535d623acf9$var$b2(d, b + 2));
    return [
        $907f3535d623acf9$var$b8(d, b + 12),
        $907f3535d623acf9$var$b8(d, b + 4),
        $907f3535d623acf9$var$b8(d, b + 20)
    ];
};
// extra field length
var $907f3535d623acf9$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $907f3535d623acf9$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $907f3535d623acf9$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $907f3535d623acf9$var$exfl(ex);
    $907f3535d623acf9$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $907f3535d623acf9$var$err(10);
    $907f3535d623acf9$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $907f3535d623acf9$var$wbytes(d, b, f.crc);
        $907f3535d623acf9$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $907f3535d623acf9$var$wbytes(d, b + 8, f.size);
    }
    $907f3535d623acf9$var$wbytes(d, b + 12, fl);
    $907f3535d623acf9$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $907f3535d623acf9$var$wbytes(d, b, col);
        $907f3535d623acf9$var$wbytes(d, b + 6, f.attrs);
        $907f3535d623acf9$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $907f3535d623acf9$var$wbytes(d, b, +k);
        $907f3535d623acf9$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $907f3535d623acf9$var$wzf = function(o, b, c, d, e) {
    $907f3535d623acf9$var$wbytes(o, b, 0x6054B50); // skip disk
    $907f3535d623acf9$var$wbytes(o, b + 8, c);
    $907f3535d623acf9$var$wbytes(o, b + 10, c);
    $907f3535d623acf9$var$wbytes(o, b + 12, d);
    $907f3535d623acf9$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $907f3535d623acf9$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $907f3535d623acf9$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $907f3535d623acf9$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $907f3535d623acf9$export$2b25194e1767ea06.call(this, filename);
        this.d = new $907f3535d623acf9$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $907f3535d623acf9$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $907f3535d623acf9$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $907f3535d623acf9$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $907f3535d623acf9$export$2b25194e1767ea06.call(this, filename);
        this.d = new $907f3535d623acf9$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $907f3535d623acf9$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $907f3535d623acf9$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $907f3535d623acf9$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $907f3535d623acf9$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($907f3535d623acf9$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $907f3535d623acf9$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $907f3535d623acf9$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $907f3535d623acf9$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($907f3535d623acf9$var$err(11, 0, 1), null, false);
            var header = new $907f3535d623acf9$var$u8(hl_1);
            $907f3535d623acf9$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $907f3535d623acf9$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $907f3535d623acf9$var$u8(16);
                        $907f3535d623acf9$var$wbytes(dd, 0, 0x8074B50);
                        $907f3535d623acf9$var$wbytes(dd, 4, file.crc);
                        $907f3535d623acf9$var$wbytes(dd, 8, cl_1);
                        $907f3535d623acf9$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($907f3535d623acf9$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $907f3535d623acf9$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $907f3535d623acf9$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $907f3535d623acf9$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $907f3535d623acf9$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $907f3535d623acf9$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $907f3535d623acf9$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    var r = {};
    $907f3535d623acf9$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $907f3535d623acf9$var$mt(function() {
            cb(a, b);
        });
    };
    $907f3535d623acf9$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $907f3535d623acf9$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $907f3535d623acf9$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $907f3535d623acf9$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $907f3535d623acf9$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $907f3535d623acf9$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $907f3535d623acf9$var$crc(), size = file.length;
        c.p(file);
        var f = $907f3535d623acf9$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $907f3535d623acf9$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $907f3535d623acf9$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $907f3535d623acf9$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($907f3535d623acf9$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $907f3535d623acf9$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($907f3535d623acf9$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $907f3535d623acf9$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $907f3535d623acf9$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $907f3535d623acf9$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $907f3535d623acf9$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $907f3535d623acf9$var$exfl(p.extra);
        if (s > 65535) $907f3535d623acf9$var$err(11);
        var d = compression ? $907f3535d623acf9$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $907f3535d623acf9$var$crc();
        c.p(file);
        files.push($907f3535d623acf9$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $907f3535d623acf9$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $907f3535d623acf9$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $907f3535d623acf9$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $907f3535d623acf9$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $907f3535d623acf9$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $907f3535d623acf9$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $907f3535d623acf9$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $907f3535d623acf9$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $907f3535d623acf9$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $907f3535d623acf9$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $907f3535d623acf9$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $907f3535d623acf9$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $907f3535d623acf9$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $907f3535d623acf9$export$93f81d5bbbb7c6bf
        };
        this.p = $907f3535d623acf9$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $907f3535d623acf9$var$err(5);
        if (!this.p) $907f3535d623acf9$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $907f3535d623acf9$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $907f3535d623acf9$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $907f3535d623acf9$var$b2(buf, i + 6), cmp_1 = $907f3535d623acf9$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $907f3535d623acf9$var$b2(buf, i + 26), es = $907f3535d623acf9$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $907f3535d623acf9$var$b4(buf, i + 18), su_1 = $907f3535d623acf9$var$b4(buf, i + 22);
                        var fn_1 = $907f3535d623acf9$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $907f3535d623acf9$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $907f3535d623acf9$var$err(5);
                                if (!sc_1) file_1.ondata(null, $907f3535d623acf9$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($907f3535d623acf9$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($907f3535d623acf9$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $907f3535d623acf9$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($907f3535d623acf9$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $907f3535d623acf9$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $907f3535d623acf9$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $907f3535d623acf9$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $907f3535d623acf9$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $907f3535d623acf9$var$mt(function() {
            cb(a, b);
        });
    };
    $907f3535d623acf9$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $907f3535d623acf9$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($907f3535d623acf9$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $907f3535d623acf9$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $907f3535d623acf9$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $907f3535d623acf9$var$b4(data, e - 12);
            z = $907f3535d623acf9$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $907f3535d623acf9$var$b4(data, ze + 32);
                o = $907f3535d623acf9$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $907f3535d623acf9$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $907f3535d623acf9$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $907f3535d623acf9$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $907f3535d623acf9$export$90366d8b308ba94a(infl, {
                            out: new $907f3535d623acf9$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($907f3535d623acf9$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($907f3535d623acf9$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $907f3535d623acf9$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $907f3535d623acf9$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $907f3535d623acf9$var$err(13);
    var c = $907f3535d623acf9$var$b2(data, e + 8);
    if (!c) return {};
    var o = $907f3535d623acf9$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $907f3535d623acf9$var$b4(data, e - 12);
        z = $907f3535d623acf9$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $907f3535d623acf9$var$b4(data, ze + 32);
            o = $907f3535d623acf9$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $907f3535d623acf9$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $907f3535d623acf9$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $907f3535d623acf9$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $907f3535d623acf9$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $907f3535d623acf9$var$u8(su)
            });
            else $907f3535d623acf9$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


const $ea1732c6f2e2ca42$var$waveTables = new Map();
const $ea1732c6f2e2ca42$var$waveTableFileNames = new Map();
const $ea1732c6f2e2ca42$var$ALL_WAVE_FORM_NAMES = [];
const $ea1732c6f2e2ca42$var$assignWaveTables = (locations, waves, waveMap)=>{
    // now try and create a relationship database...
    locations.forEach((waveTableName, index)=>{
        // waveTables.set(waveTableName, WAVE_FORM_NAMES[index])
        const noteName = waves[index];
        const nameExpanded = noteName.replaceAll("_", " ");
        waveMap.set(noteName, waveTableName);
        waveMap.set(noteName.toLowerCase(), waveTableName);
        waveMap.set(nameExpanded, waveTableName);
        waveMap.set(nameExpanded.toLowerCase(), waveTableName);
        $ea1732c6f2e2ca42$var$ALL_WAVE_FORM_NAMES.push(noteName);
    // console.info("waveTableName", waveTableName, WAVE_FORM_NAMES[index] ) 
    });
};
const $ea1732c6f2e2ca42$export$e0c962de4951ea0a = async (waveTableName = TB303)=>{
    console.info("Loading wavetable from file", waveTableName);
    const url = $ea1732c6f2e2ca42$var$waveTableFileNames.get(waveTableName);
    // we use the names from above...
    const request = await fetch(url);
    // const request = await fetch(`/wave-tables/${waveTableName}`)
    const response = await request.text();
    // firstly remove all new lines and carriage returns
    // and swap out the double quotes with single quotes
    const data = response.replaceAll(/(\s|\n|\r)/g, '').replaceAll(/"/g, "'");
    const delimA = /\{('|")real('|"):\[/;
    const delimB = /(,)?\],('|")imag('|"):\[/;
    const delimC = /(,)?\](,)?\}/ // ]}
    ;
    const parts = data.split(delimB);
    // now both real and imag are arrays of string numbers :(
    const part1 = parts[0].replace(delimA, "").split(",");
    // const part1 = parts[0].split(delimA)[1].trim().split(",")
    const part2 = parts[parts.length - 1].replace(delimC, "").split(",");
    // Ensure real/imag arrays are Float32Array for createPeriodicWave
    // convert all these strings into numbers
    const real = new Float32Array(part1.map(Number));
    const imag = new Float32Array(part2.map(Number));
    // create the object
    const waves = {
        real: real,
        imag: imag
    };
    // GAH, ensure that both arrays have the same length...
    if (real.length !== imag.length) {
        console.error(waveTableName + " Length mismatch real:" + real.length + " imaginary:" + imag.length, {
            waves: waves,
            parts: parts,
            part1: part1,
            part2: part2,
            data: data,
            real: real,
            imag: imag
        });
        // throw Error(waveTableName + " Length mismatch real:" + real.length + " imaginary:" + imag.length)
        // HACK: just make the arrays the same length
        real.length = imag.length;
    }
    console.info("Wave table available:loadWaveTableFromFile", waves);
    $ea1732c6f2e2ca42$var$waveTables.set(waveTableName, waves);
    return waves;
};
const $ea1732c6f2e2ca42$export$2d5332ffc4823279 = (colour = "white", numberOfHarmonics = 4096)=>{
    // Array length needs to be numberOfHarmonics + 1 to include the DC component (index 0)
    const arrayLength = numberOfHarmonics + 1;
    const real = new Float32Array(arrayLength);
    const imag = new Float32Array(arrayLength);
    // Generally, we don't want a DC offset in our noise signal.
    real[0] = 0;
    // The imaginary part for the DC component MUST be 0.
    imag[0] = 0;
    // Assign random values to the coefficients for harmonics 1 through N.
    // Math.random() gives [0, 1), so Math.random() * 2 - 1 gives [-1, 1)
    for(let i = 1; i < arrayLength; i++){
        // Generate random values for phase component (same as white noise)
        const randomReal = Math.random() * 2 - 1;
        const randomImag = Math.random() * 2 - 1;
        // PINK:Calculate the scaling factor for pink noise (Amplitude ~ 1/sqrt(f))
        // PINK: Since frequency is proportional to harmonic number 'i', scale by 1/sqrt(i)
        // BROWN: Calculate the scaling factor for Brown noise (Amplitude ~ 1/f)
        // BROWN: Since frequency is proportional to harmonic number 'i', scale by 1/i
        const scaleFactor = colour === "pink" ? 1 / Math.sqrt(i) : colour === "brown" ? 1 / i : 1;
        // Apply the scale factor to the random components
        real[i] = randomReal * scaleFactor;
        imag[i] = randomImag * scaleFactor;
    }
    // Note: We are *not* manually normalizing the coefficients here.
    // By default, audioContext.createPeriodicWave normalizes the resulting
    // waveform so that its peak amplitude is 1.0. Relying on this built-in
    // normalization is usually sufficient and simpler.
    // If you were to set `disableNormalization: true` in createPeriodicWave,
    // you would need to scale these random coefficients down significantly
    // to avoid generating a waveform that clips violently.
    const waveTable = {
        "name": colour + " Noise",
        "midi_number": -1,
        "description": colour + " Noise",
        real: real,
        imag: imag
    };
    return waveTable;
};
const $ea1732c6f2e2ca42$export$7db81bad684dcb08 = (waveTableURI, waveTableString)=>{
    // Ensure real/imag arrays are Float32Array for createPeriodicWave
    const real = new Float32Array(waveTableString.real);
    const imag = new Float32Array(waveTableString.imag);
    if (!waveTableString || !waveTableString.name) throw Error("No waveTableString @ " + waveTableURI);
    // --- Important Constraints ---
    // real[0] must be 0 (DC offset). We ensured this in generation.
    // imag[0] must be 0. We ensured this in generation.
    // The lengths of real and imag must be the same and >= 2.
    if (real.length !== imag.length || real.length < 2) {
        console.error(`Invalid wave data for GM ${waveTableString.gm_number}: ${waveTableString.name}`);
        return null;
    }
    // Optional: Explicitly set DC offset and imag[0] to zero just in case
    real[0] = 0;
    imag[0] = 0;
    const waveTable = {
        "name": waveTableString.name,
        "midi_number": waveTableString.gm_number ?? -1,
        "description": waveTableString.description,
        real: real,
        imag: imag
    };
    $ea1732c6f2e2ca42$var$waveTables.set(waveTableString.name, waveTable);
    // console.error("loading waves from JSON", waveTableURI, waveTables.entries(), {waveTable, waveTables} )
    return waveTable;
};
const $ea1732c6f2e2ca42$export$1dd6a85c759c0069 = async (waveTableURI)=>{
    try {
        const response = await fetch(waveTableURI);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        return $ea1732c6f2e2ca42$export$7db81bad684dcb08(waveTableURI, data);
    } catch (e) {
        console.error("Error loading wave table from", waveTableURI, e);
        return null;
    }
};
const $ea1732c6f2e2ca42$export$8180d634bf2e2c8f = async (waveTableName = TB303)=>{
    // Cache in static Map and load if registered
    if ($ea1732c6f2e2ca42$var$waveTables.has(waveTableName)) return $ea1732c6f2e2ca42$var$waveTables.get(waveTableName);
    else return $ea1732c6f2e2ca42$export$e0c962de4951ea0a(waveTableName);
};
const $ea1732c6f2e2ca42$export$7dd74eee9a2ffe92 = ()=>{
    const randomIndex = Math.floor(Math.random() * $ea1732c6f2e2ca42$var$waveTables.size);
    const allWaves = $ea1732c6f2e2ca42$export$315af10a7c3230d9();
    console.error("randomIndex", randomIndex, allWaves);
    return allWaves[randomIndex];
// return ALL_WAVE_FORM_NAMES[Math.floor(Math.random() * ALL_WAVE_FORM_NAMES.length)]
};
const $ea1732c6f2e2ca42$export$315af10a7c3230d9 = ()=>{
    const p = Array.from($ea1732c6f2e2ca42$var$waveTables.keys());
    p.unshift(...(0, $367c7c5f93c3b8e8$export$245ffa21a1602a56));
    return p;
} // ALL_WAVE_FORM_NAMES
;
const $ea1732c6f2e2ca42$export$ec5563a93b036d54 = async (timbre)=>{
    if ($ea1732c6f2e2ca42$var$waveTables.has(timbre)) {
        console.info("Found saved wavetable", timbre, $ea1732c6f2e2ca42$var$waveTables.get(timbre));
        return $ea1732c6f2e2ca42$var$waveTables.get(timbre);
    }
    // check if it is a string and if so, try to load it
    if (typeof timbre === 'string') return $ea1732c6f2e2ca42$export$8180d634bf2e2c8f(timbre);
    return timbre;
};
const $ea1732c6f2e2ca42$export$4779c0967580af98 = async ()=>{
    return $ea1732c6f2e2ca42$export$8180d634bf2e2c8f($ea1732c6f2e2ca42$export$7dd74eee9a2ffe92());
};
const $ea1732c6f2e2ca42$export$72cb279c6926e2fa = async (simultaneous = 3)=>{
    for(let i = 0, l = $ea1732c6f2e2ca42$var$ALL_WAVE_FORM_NAMES.length; i < l; i++){
        const group = [];
        for(let p = 0; p < simultaneous; p++){
            const name = $ea1732c6f2e2ca42$var$ALL_WAVE_FORM_NAMES[i];
            if (!name) break;
            group.push($ea1732c6f2e2ca42$export$8180d634bf2e2c8f(name));
            i++;
            console.info("prelaodwave", name, p, i);
        }
        await Promise.allSettled(group);
    }
};
const $ea1732c6f2e2ca42$export$ae9bca4752364733 = (manifest, folder = "/wave-tables/gm_periodic_waves_v5/")=>{
    // console.error("GM_MANIFEST", GM_MANIFEST)
    const keys = Object.keys(manifest);
    const waveDataToLoad = keys.map(async (noteName, index)=>{
        const noteURI = manifest[noteName];
        // first create the file name to load
        const waveTableFileName = noteName.replaceAll(" ", "");
        const path = folder + noteURI;
        const waveTableData = $ea1732c6f2e2ca42$export$1dd6a85c759c0069(path);
        $ea1732c6f2e2ca42$var$ALL_WAVE_FORM_NAMES.push(noteName);
        // console.info(noteNumber, "GM",path, {waveTableData, real, imag, noteName, noteName, noteURI, waveTableFileName} ) 
        if (index === keys.length - 1) console.error("waveTables", $ea1732c6f2e2ca42$var$waveTables);
        return waveTableData;
    });
    Promise.allSettled(waveDataToLoad).then((results)=>{
        waveDataToLoad.forEach((waveTableData, index)=>{
            const { real: real, imag: imag } = waveTableData;
            const noteNumber = index + 1;
            const noteName = keys[index];
            const nameExpanded = noteName.replaceAll("_", " ");
            $ea1732c6f2e2ca42$var$waveTables.set(noteNumber, waveTableData);
            // waveMap.set(waveTableData.name, waveTableData)
            // waveMap.set(waveTableData.name.toLowerCase(), waveTableData)
            $ea1732c6f2e2ca42$var$waveTables.set(nameExpanded, waveTableData);
            $ea1732c6f2e2ca42$var$waveTables.set(nameExpanded.toLowerCase(), waveTableData);
        });
        console.info("results", {
            results: results,
            waveTables: $ea1732c6f2e2ca42$var$waveTables
        });
    });
};
const $ea1732c6f2e2ca42$export$2ca57d018bbced6b = (waveTableArchiveURI, onProgress)=>new Promise(async (resolve, reject)=>{
        const fileBuffer = await fetch(waveTableArchiveURI);
        const arrayBuffer = await fileBuffer.arrayBuffer();
        const arrayBufferAsUint8Array = new Uint8Array(arrayBuffer);
        (0, $907f3535d623acf9$export$23c8d3f8757cab88)(arrayBufferAsUint8Array, (err, unzipped)=>{
            if (err) {
                reject(err);
                return;
            }
            const fileNames = Object.keys(unzipped);
            const waveTables = [];
            // TODO: multiple streams?
            fileNames.forEach((fileName, index)=>{
                if (fileName !== "manifest.json") {
                    // Conversion to string and then JSON
                    const progress = index / fileNames.length;
                    const file = unzipped[fileName];
                    try {
                        const waveTable = JSON.parse((0, $907f3535d623acf9$export$adb211f8cb999894)(file));
                        const waveTableData = $ea1732c6f2e2ca42$export$7db81bad684dcb08(fileName, waveTable);
                        onProgress && onProgress(progress, fileName, waveTable);
                        waveTables.push(waveTableData);
                    } catch (error) {
                        // likely a JSON parsing error
                        console.error("Error loading wave table", fileName, error);
                    }
                }
            });
            resolve(waveTables);
        });
    });
const $ea1732c6f2e2ca42$export$59da1b42c2e1d3db = ()=>{
    $ea1732c6f2e2ca42$var$waveTables.set("White Noise", $ea1732c6f2e2ca42$export$2d5332ffc4823279());
    $ea1732c6f2e2ca42$var$waveTables.set("Pink Noise", $ea1732c6f2e2ca42$export$2d5332ffc4823279("pink"));
    $ea1732c6f2e2ca42$var$waveTables.set("Brown Noise", $ea1732c6f2e2ca42$export$2d5332ffc4823279("brown"));
};


const $367c7c5f93c3b8e8$export$245ffa21a1602a56 = [
    "sine",
    "square",
    "sawtooth",
    "triangle"
];
const $367c7c5f93c3b8e8$var$SILENCE = 0.00000000009;
class $367c7c5f93c3b8e8$export$2e2bcd8739ae039 {
    options = {
        // default amplitude
        gain: 0.2,
        attack: 0.4,
        decay: 0.9,
        sustain: 0.95,
        release: 0.2,
        minDuration: .4,
        shape: $367c7c5f93c3b8e8$export$245ffa21a1602a56[0],
        arpeggioDuration: 0.2,
        slideDuration: 0.00006,
        fadeDuration: 0.2,
        filterGain: 0.7,
        filterCutOff: 2200,
        filterOverdrive: 2.5,
        filterResonance: 1.8,
        filterAttack: 0.2,
        filterDecay: 0.08,
        filterSustain: 0.8,
        filterRelease: 0.2,
        // don't destroy oscillators, just make them silent
        // at the end of their life
        reuseOscillators: true
    };
    // arpeggioIntervals = []
    customWave = null;
    #id = "SynthOscillator";
    #endsAt = -1;
    get id() {
        return this.#id;
    }
    set id(value) {
        this.#id = value;
    }
    get now() {
        return this.audioContext.currentTime;
    }
    get gain() {
        return this.options.gain;
    }
    get endsAt() {
        return this.#endsAt;
    }
    set gain(value) {
        this.options.gain = value;
    }
    get volume() {
        return this.gainNode.gain.value;
    }
    set volume(value) {
        const now = this.now;
        this.gainNode.gain.cancelScheduledValues(now);
        // this.gainNode.gain.value = value
        this.gainNode.gain.linearRampToValueAtTime(value, now + this.options.fadeDuration);
    }
    get frequency() {
        return this.oscillator.frequency.value;
    }
    set frequency(value) {
        if (!this.oscillator) {
            console.warn("No oscillator", this);
            return;
        }
        this.glide(value, this.options.slideDuration);
    }
    set shape(value) {
        this.setTimbre(value);
    }
    get shape() {
        return this.options.shape;
    }
    set Q(value) {
        // this.filter.Q.value = value
        this.filterNode.Q.cancelScheduledValues(this.now);
        this.filterNode.Q.linearRampToValueAtTime(value, this.now + this.options.slideDuration);
    }
    get Q() {
        return this.filterNode.Q.value;
    }
    set detune(value) {
        this.oscillator.detune.value = value;
    }
    get detune() {
        return this.oscillator.detune.value;
    }
    set filterCutOff(value) {
        this.filterNode.frequency.cancelScheduledValues(this.now);
        this.filterNode.frequency.linearRampToValueAtTime(value, this.now + this.options.slideDuration);
    }
    get filterCutOff() {
        return this.filterNode.frequency.value;
    }
    set filterType(value) {
        this.filterNode.type = value;
    }
    // set arpeggio( intervals ){
    //     this.arpeggioIntervals = intervals
    // }
    // get arpeggio(){
    //     return this.arpeggioIntervals
    // }
    get output() {
        return this.dcFilterNode;
    }
    get tremoloActive() {
        return !!this.tremoloGain;
    }
    constructor(audioContext, options = {}){
        this.audioContext = audioContext;
        this.options = Object.assign({}, this.options, options);
        // Add a highpass filter at 20Hz to remove DC offset
        this.dcFilterNode = new (0, $dd284deb2f465d95$export$f068340fbfd684eb)(audioContext, {
            type: 'highpass',
            frequency: 20,
            Q: 0.707
        });
        this.filterNode = new (0, $dd284deb2f465d95$export$f068340fbfd684eb)(audioContext, {
            type: 'lowpass',
            Q: this.options.filterResonance,
            frequency: this.options.filterCutOff,
            detune: 0,
            gain: 1
        });
        this.gainNode = audioContext.createGain();
        this.gainNode.gain.value = $367c7c5f93c3b8e8$var$SILENCE // start silently
        ;
        this.gainNode.gain.setValueAtTime($367c7c5f93c3b8e8$var$SILENCE, audioContext.currentTime);
        // Connect: filterNode -> gainNode -> dcFilterNode
        this.filterNode.connect(this.gainNode);
        this.gainNode.connect(this.dcFilterNode);
        if (options.shape) this.shape = options.shape;
        this.isNoteDown = false;
    }
    /**
     * 
     * @param {OscillatorNode} oscillator 
     */ destroyOscillator(oscillator) {
        oscillator.stop();
        oscillator.disconnect();
        oscillator = null;
        this.active = false;
    }
    /**
     * 
     * @param {Number} frequency 
     * @param {Number} startTime 
     */ createOscillator(frequency = 440, startTime = this.audioContext.currentTime) {
        this.oscillator = this.audioContext.createOscillator();
        // if (this.customWave)
        // {
        //     // this.oscillator.setPeriodicWave(this.customWave)
        //     // console.info("Setting periodic wave", this.customWave )
        // }else{
        //       // console.info("Setting oscilliator type", this.shape )
        // }
        this.shape = this.options.shape // OSCILLATORS[Math.floor(Math.random() * OSCILLATORS.length)]
        ;
        this.oscillator.frequency.value = frequency;
        this.oscillator.connect(this.gainNode);
        this.oscillator.start(startTime);
        if (this.tremoloActive) {
            this.tremoloOscillator.frequency.cancelScheduledValues(startTime);
            this.tremoloOscillator.frequency.setValueAtTime(frequency, startTime);
            this.tremoloGain.connect(this.oscillator.frequency);
        // console.info("tremoloActive", this.shape )   
        }
        this.active = true;
    }
    /**
     * Set a random oscillator timbre from the collection
     */ setRandomTimbre() {
        this.shape = $367c7c5f93c3b8e8$export$245ffa21a1602a56[Math.floor(Math.random() * $367c7c5f93c3b8e8$export$245ffa21a1602a56.length)];
    }
    /**
     * 
     * @param {String} value 
     */ setTimbre(value) {
        // there are 3 different sources of shapes :
        switch(typeof value){
            case 'string':
                if ($367c7c5f93c3b8e8$export$245ffa21a1602a56.includes(value)) {
                    // 1. the oscillator type
                    // console.info("SynthOscillator::STANDARD"+ this.options, value)
                    if (this.oscillator) this.oscillator.type = value;
                    this.customWave = null;
                } else // 2. attempt to load in customWave JSON data from a URI
                this.loadWaveTable(value).then((waves)=>{
                    this.setWaveTable(waves);
                // console.info("SynthOscillator::CUSTOM URI"+this.options, value, {waves} )
                });
                break;
            case 'object':
                // 3. customWave data with real and imag arrays
                this.setWaveTable(value);
                break;
            default:
                console.warn("SynthOscillator::UNKNOWN TYPE", value);
        }
        this.options.shape = value;
    }
    /**
     * 
     * @param {Number} tonic 
     * @param {Array<Number>} intervals 
     * @param {Number} repetitions 
     */ addArpeggioAtIntervals(tonic, intervals = [], repetitions = 24) {
        const now = this.now;
        let startTime = now;
        let frequency = tonic.noteNumber;
        const frequencies = intervals.map((note)=>(0, $7ec2567d1d301bb4$export$696b7110bc0d8caf)(frequency + note));
        for(let i = 0; i < repetitions; ++i)intervals.forEach((interval, index)=>{
            this.oscillator.frequency.setValueAtTime(frequencies[index], startTime);
            startTime += this.options.arpeggioDuration;
        // console.info("start time", startTime )
        // this.oscillator.frequency.linearRampToValueAtTime( frequency + interval, startTime )
        });
    }
    /**
     * Adds a constant tremolo effect
     * @param {Number} depth 
     */ addTremolo(depth = 0.5) {
        const now = this.now;
        this.tremoloGain = this.audioContext.createGain();
        this.tremoloGain.gain.value = depth;
        this.tremoloOscillator = this.audioContext.createOscillator();
        this.tremoloOscillator.type = 'sine';
        this.tremoloOscillator.connect(this.tremoloGain);
        this.tremoloOscillator.start(now);
    }
    /**
     * Note ON
     * @param {Note} note - Model data
     * @param {Number} velocity - strength of the note
     * @param {Array<Number>} arp - intervals
     * @param {Number} delay - number to pause before playing
     */ noteOn(note, velocity = 1, arp = null, delay = 0) {
        const frequency = note.frequency;
        const startTime = this.now + delay;
        const filterPeak = this.options.filterCutOff * this.options.filterOverdrive;
        const filterSustain = this.options.filterCutOff + (filterPeak - this.options.filterCutOff) * this.options.filterSustain;
        // fade in envelope ADsr
        const amplitude = velocity * this.options.gain;
        const amplitudeSustain = amplitude * this.options.sustain;
        clearInterval(this.timerInterval);
        this.gainNode.gain.cancelScheduledValues(startTime);
        // FORCE Silence to prevent stacking
        // this.gainNode.gain.setValueAtTime( this.gainNode.gain.minValue, startTime )
        this.gainNode.gain.setValueAtTime($367c7c5f93c3b8e8$var$SILENCE, startTime);
        this.gainNode.gain.linearRampToValueAtTime($367c7c5f93c3b8e8$var$SILENCE, startTime + 4);
        // Attack
        this.gainNode.gain.linearRampToValueAtTime(amplitude, startTime + this.options.attack);
        // Decay to Sustain
        this.gainNode.gain.linearRampToValueAtTime(amplitudeSustain, startTime + this.options.attack + this.options.decay);
        console.error("Note on", this.gainNode.gain.value, this.gainNode.gain);
        // by resetting the shape, the phase should restart
        this.setTimbre(this.shape);
        // Shape the note
        this.filterNode.frequency.cancelScheduledValues(startTime);
        this.filterNode.frequency.setValueAtTime(this.options.filterCutOff, startTime);
        this.filterNode.frequency.linearRampToValueAtTime(filterPeak, startTime + this.options.filterAttack);
        this.filterNode.frequency.linearRampToValueAtTime(filterSustain, startTime + this.options.filterAttack + this.options.filterDecay);
        if (!this.isNoteDown) {
            if (this.options.reuseOscillators) {
                if (!this.oscillator) this.createOscillator(frequency, startTime);
                else // reuse existing, no glide
                this.glide(frequency, 0.03);
            } else {
                if (this.oscillator) this.destroyOscillator(this.oscillator);
                this.createOscillator(frequency, startTime);
            }
        } else // reuse existing and glide
        this.frequency = frequency;
        if (arp) this.addArpeggioAtIntervals(note, arp);
        this.isNoteDown = true;
        this.startedAt = startTime;
        return this;
    }
    /**
     * Note OFF
     * This starts the process of stopping the note
     * by creating a smooth transition to silence from 
     * the current amplitude via release time.
     * @param {Note} note - Model data
     * @returns 
     */ noteOff(note) {
        if (!this.isNoteDown) {
            console.warn("noteOff IGNORED - note NOT playing", note, this);
            return;
        }
        const releaseDuration = Math.max(this.options.release, this.options.filterRelease);
        const now = this.now;
        const elapsed = now - this.startedAt;
        // const timeAddition = 
        // Ensure minimum duration - elapsed 
        const extendNow = elapsed < this.options.minDuration ? now + this.options.minDuration : now;
        // Use a longer minimum release time (e.g. 400ms)
        this.#endsAt = extendNow + releaseDuration;
        //    console.warn("noteOff - note too short?",  elapsed < this.options.minDuration, {now, extendNow, stopTime, elapsed} )
        // Cancel any scheduled gain changes and start from current value
        // const currentAmplitude = this.gainNode.gain.value
        this.gainNode.gain.cancelScheduledValues(extendNow);
        // this.gainNode.gain.setValueAtTime(currentAmplitude, now)
        // only setting this up as a var to multiply it later - you can hardcode.
        // initial value is 1 millisecond - experiment with this value if it's not fading
        // quickly enough.
        const timeConstant = 0.01 // 0.001
        ;
        this.gainNode.gain.setTargetAtTime(0, extendNow, timeConstant) // ( SILENCE, extendNow + this.options.release )
        ;
        // Use linear ramp for fade out
        // NB. this may POP due to the way zero can doesnt exist
        // this.gainNode.gain.linearRampToValueAtTime( SILENCE, extendNow + this.options.release )
        // this.gainNode.gain.setValueAtTime(currentAmplitude, now)
        // Apply filter fade out
        // this.filterNode.frequency.cancelScheduledValues(extendNow)
        // this.filterNode.frequency.linearRampToValueAtTime(this.options.filterCutOff, extendNow + this.options.filterRelease )
        // Schedule the oscillator to stop and disconnect after the envelope has completed
        !this.options.reuseOscillators && this.oscillator;
        // this.isNoteDown = false
        this.timerInterval = setTimeout(()=>this.isNoteDown = false, this.options.release + 4);
        this.startedAt = -1;
        return this;
    }
    glide(value, duration = 0) {
        const now = this.now;
        this.oscillator.frequency.cancelScheduledValues(now);
        this.oscillator.frequency.linearRampToValueAtTime(value, now + duration);
    }
    async loadWaveTable(waveTableName = TB303_Square) {
        return await (0, $ea1732c6f2e2ca42$export$8180d634bf2e2c8f)(waveTableName);
    }
    setWaveTable(waveTable) {
        const { real: real, imag: imag } = waveTable;
        const waveData = this.audioContext.createPeriodicWave(real, imag, {
            disableNormalization: true
        });
        // reshape any playing oscillators
        if (this.oscillator) this.oscillator.setPeriodicWave(waveData);
        this.customWave = waveData;
        return waveData;
    }
}




/**
 * Simple song sequence of Note models
 */ 
class $060898502bebeba7$export$2e2bcd8739ae039 {
    notes;
    index = 0;
    constructor(noteString){
        // this.noteString = noteString
        // remove line breaks & ensure that there are no empty holes
        const data = noteString.replaceAll("\n", "").split(" ").filter((note)=>note.length);
        // now convert that into a series of Note object
        this.notes = this.createNotes(data);
    // test
    // this.notes.forEach( (note, index)  => {
    //     console.info(index, note.noteKey === data[index], "NOTE", note, data[index] )
    // })
    }
    // convert the note name to the midi number
    // 69 is middle G4
    // convert a letter and an octave to a noteNumber
    // A4, G4 -> 69
    convertNoteLetterToNoteNumber(noteLetter, octave = 4) {
        const key = noteLetter.charAt(0).toUpperCase();
        const isAccidental = noteLetter.charCodeAt(1) === 35 // #
        ;
        const noteName = noteLetter.toUpperCase() + octave;
        const noteNumber = (0, $7ec2567d1d301bb4$export$fae73f5876775ac1)(key, octave, isAccidental);
        // console.info("note", noteNumber, {isAccidental, key, noteLetter, octave, noteName })
        return noteNumber;
    }
    // turn the string into a noteNumber...
    createNotes(notes) {
        return notes.map((note)=>new (0, $7ec2567d1d301bb4$export$2e2bcd8739ae039)(this.convertNoteLetterToNoteNumber(note)));
    }
    getNextNote() {
        this.index = (this.index + 1) % this.notes.length;
        // console.info( this.index, this.notes[this.index], this.notes )
        return this.notes[this.index];
    }
}



class $d24753f95a0da964$export$2e2bcd8739ae039 extends (0, $cc1d0ccf700154db$export$2e2bcd8739ae039) {
    notesPlaying = [];
    noteIndex = 0;
    constructor(notes, noteOn, noteOff, noteQuantity = 20){
        super();
        this.hero = document.getElementById("hero");
        if (!this.hero) // we are on a page that doesn't have
        // the elements required so we leave early
        return;
        this.figure = document.getElementById("hero-figure");
        // this.mask = document.getElementById("introduction")
        this.mask = document.getElementById("main-content");
        this.notes = notes;
        this.keyElements = this.addNotesToDOM(this.mask, noteQuantity);
        this.addInteractivity(this.keyElements, noteOn, noteOff);
    }
    // Add X notes to the DOM in the specific element
    // NB. THESE RUIN GPU PERFORMANCE
    addNotesToDOM(parent, quantity) {
        const elements = [];
        const fragment = document.createDocumentFragment();
        const group = document.createElement("div");
        for(let index = 0; index < quantity; ++index){
            const i = document.createElement("i");
            i.className = "note-animated";
            i.setAttribute("aria-hidden", "true");
            group.appendChild(i);
            elements.push(i);
        }
        group.className = "overlaid-notes";
        group.setAttribute("aria-hidden", true);
        group.setAttribute("inert", true);
        fragment.appendChild(group);
        parent.appendChild(fragment);
        return elements;
    }
    /**
     * Note ON
     * @param {Note} note 
     * @param {Number} velocity 
     * @param {String} id 
     */ noteOn(note, velocity = 1, id = 0) {
        const noteElement = this.keyElements[this.noteIndex];
        if (noteElement) {
            // change note to the correct colour
            noteElement.style.setProperty("--col-accent", "var(" + this.notes[note.noteNumber].asCSSVar + ")");
            // noteElement.style.setProperty( "--path", "var("+this.notes[note.noteNumber].asCSSVar+")" )
            // this.hero.style.setProperty( "--col-accent", "var("+this.notes[note.noteNumber].asCSSVar+")" )
            noteElement.classList.remove("active", "inactive");
            // this.hero.classList.remove("active")
            // this.figure.classList.remove("active")
            this.noteIndex = (this.noteIndex + 1) % this.keyElements.length;
            // i.textContent = this.notes[note.noteNumber].noteName
            requestAnimationFrame(()=>{
                noteElement.classList.toggle("active", true);
            // this.hero.classList.add("active")
            // this.figure.classList.add("active")
            });
        }
    }
    /**
     * 
     * @param {Note} note 
     * @param {Number} velocity 
     * @param {String} id 
     */ noteOff(note, velocity = 1, id = 0) {
        // this.hero.classList.remove("active")
        // this.figure.classList.remove("active")
        const noteElement = this.keyElements[this.noteIndex - 1];
        if (noteElement) {
            const n = this.notes[note.noteNumber];
            // change note to the correct colour
            n && noteElement.style.setProperty("--col-accent", "var(" + n.asCSSVar + ")");
            // noteElement.style.setProperty( "--path", "var("+this.notes[note.noteNumber].asCSSVar+")" )
            // this.hero.style.setProperty( "--col-accent", "var("+this.notes[note.noteNumber].asCSSVar+")" )
            noteElement.classList.toggle("inactive", true);
        }
    }
}


/**
 * Scrolling note on / off visualisation
 */ var $22435a4bfdb3729c$exports = {};
$22435a4bfdb3729c$exports = $parcel$resolve("jbhUk");


// We may want a maximim size
// that then get's scaled up proportiaonatly
// so for example, rather than 1000 it may double 500 instead
// so here we specify the max size... if the screen
// grows bigger than the max size then we simply
// divide the screen size by 2 or 3 accordingly
const $7d9a12bcf883220d$var$DEFAULT_PERFORMANCE_BOUNDARY_SIZE = 1080;
class $7d9a12bcf883220d$export$f84539d7782ebdfd {
    element;
    worker;
    optional;
    /**
     * 
     * @param {HTMLElement} canvas 
     * @param {String} workerURI 
     * @param {Object} optional 
     */ constructor(canvas, workerURI, optional = {}){
        // there is no canvas to work with
        if (!canvas) return;
        this.element = canvas;
        this.optional = {
            screenBoundary: $7d9a12bcf883220d$var$DEFAULT_PERFORMANCE_BOUNDARY_SIZE,
            ...optional
        };
        this.onResize = this.onResize.bind(this);
        const canvasWorker = canvas.transferControlToOffscreen();
        const payload = {
            canvas: canvasWorker,
            ...this.optional
        };
        this.worker = new Worker(workerURI);
        this.worker.postMessage(payload, [
            canvasWorker
        ]);
        // Add error listeners for the worker
        this.worker.onerror = (error)=>{
            console.error("NoteVisualiser Worker Error:", error.message, error.filename, error.lineno, error);
        // You might want to add logic here to try and recover or display a message
        };
        this.worker.onmessageerror = (event)=>{
            console.error("NoteVisualiser Worker Message Error:", event);
        };
        const resizeObserver = new ResizeObserver(this.onResize);
        resizeObserver.observe(canvas, {
            box: 'content-box'
        });
    }
    /**
     * Prevents Overgrowth and small sizes too
     * @param {Number} displayWidth 
     * @param {Number} displayHeight 
     * @returns 
     */ resizeCanvasToDisplaySize(width, height, dpr) {
        // do we ignore the DPR too???
        let displayWidth = Math.round(width * dpr);
        let displayHeight = Math.round(height * dpr);
        let scaleFactor = 1;
        // HALVE if over size, and keep halving it till it is smaller
        // the CSS should automatically scale it up
        while(displayWidth > this.optional.screenBoundary || displayHeight > this.optional.screenBoundary){
            displayWidth /= 2;
            displayHeight /= 2;
            scaleFactor++;
        }
        // console.info( "size",{ displayWidth, displayHeight, dpr, width, height })
        // Get the size the browser is displaying the canvas in device pixels.
        // Check if the canvas is not the same size.
        const needResize = this.element.width !== displayWidth || this.element.height !== displayHeight;
        if (needResize) {
            this.started = true;
            this.width = displayWidth;
            this.height = displayHeight;
            // NB. Make the canvas the same size via OffscreenCanvas
            //      this.canvas.width  = displayWidth
            //      this.canvas.height = displayHeight
            const payload = {
                type: "resize",
                displayWidth: displayWidth,
                displayHeight: displayHeight,
                scaleFactor: scaleFactor,
                ...this.optional
            };
            this.worker.postMessage(payload);
        }
        return needResize;
    }
    /**
     * EVENT
     * @param {Array} entries 
     */ onResize(entries) {
        for (const entry of entries){
            let width;
            let height;
            let dpr = window.devicePixelRatio;
            // let dprSupport = false
            if (entry.devicePixelContentBoxSize) {
                // NOTE: Only this path gives the correct answer
                // The other paths are an imperfect fallback
                // for browsers that don't provide anyway to do this
                width = entry.devicePixelContentBoxSize[0].inlineSize;
                height = entry.devicePixelContentBoxSize[0].blockSize;
                dpr = 1 // it's already in width and height
                ;
            // dprSupport = true
            } else if (entry.contentBoxSize) {
                if (entry.contentBoxSize[0]) {
                    width = entry.contentBoxSize[0].inlineSize;
                    height = entry.contentBoxSize[0].blockSize;
                } else {
                    // legacy
                    width = entry.contentBoxSize.inlineSize;
                    height = entry.contentBoxSize.blockSize;
                }
            } else {
                // legacy
                width = entry.contentRect.width;
                height = entry.contentRect.height;
            }
            this.resizeCanvasToDisplaySize(width, height, dpr);
        }
    }
}


class $170794a91e951f39$export$2e2bcd8739ae039 extends (0, $7d9a12bcf883220d$export$f84539d7782ebdfd) {
    notes;
    canvas;
    context;
    height;
    counter = 0;
    notesOn = 0;
    started = false;
    mouseDown = false;
    mouseX = 0;
    mouseY = 0;
    #blendMode = 23;
    set blendMode(value) {
        this.#blendMode = value;
    // console.error("Blendmode requested", value)
    }
    get blendMode() {
        return this.#blendMode;
    }
    get backgroundColour() {
        return getComputedStyle(this.canvas).getPropertyValue("background-color");
    }
    constructor(notes, canvas, vertical = false, wave = 0){
        super(canvas, (0, (/*@__PURE__*/$parcel$interopDefault($22435a4bfdb3729c$exports))), {
            vertical: vertical,
            notes: notes
        });
        this.notes = notes;
        this.canvas = canvas;
        this.wave = wave;
        this.vertical = vertical;
    }
    /**
     * Note On
     * @param {Note} note 
     * @param {number} velocity 
     */ noteOn(note, velocity = 1) {
        const payload = {
            type: "noteOn",
            note: note.number,
            colour: note.colour,
            velocity: velocity
        };
        // console.info("NOTEVIZ noteOn", {note, velocity, payload} )
        this.notesOn++;
        this.worker.postMessage(payload);
    }
    /**
     * Note Off
     * @param {Note} note 
     * @param {Number} velocity 
     */ noteOff(note, velocity = 1) {
        this.notesOn--;
        this.worker.postMessage({
            type: "noteOff",
            note: note.number,
            colour: note.colour,
            velocity: velocity
        });
    }
}


/**
 * Classic audio waveform visualiser
 */ const $b1c4638f08a18298$var$DEFAULT_OPTIONS = {
    backgroundColour: false,
    lineColour: false,
    lineWidth: 3,
    fftSize: 512 // 2048
};
class $b1c4638f08a18298$export$2e2bcd8739ae039 {
    options;
    ctx;
    canvas;
    width;
    height;
    analyser;
    bufferLength;
    dataArray;
    count = 0;
    alpha = 256;
    isTimeDomain = false;
    set colour(value) {
        this.options.lineColour = value;
        this.count = 0;
    }
    constructor(canvasContext, audioContext, inputAudioNode, options = $b1c4638f08a18298$var$DEFAULT_OPTIONS){
        this.options = {
            ...$b1c4638f08a18298$var$DEFAULT_OPTIONS,
            ...options
        };
        this.ctx = canvasContext;
        this.canvas = canvasContext.canvas;
        this.width = canvasContext.canvas.width;
        this.height = canvasContext.canvas.height;
        this.verticalCentre = this.height / 2;
        this.analyser = audioContext.createAnalyser();
        this.analyser.fftSize = this.options.fftSize;
        // frequencyBinCount = fftSize / 2
        this.bufferLength = this.analyser.frequencyBinCount;
        // startIndex = startFrequency / frequencyPerBin
        // endIndex = endFrequency / frequencyPerBin
        // frequencyPerBin = 44100 / 2 * 1024 = 44100 / 2048 ≈ 21.53 Hz per bin
        this.dataArray = new Uint8Array(this.bufferLength);
        // data for drawing to screen
        // this.path = new Path2D()
        // connect input to analyser
        inputAudioNode.connect(this.analyser);
        this.analyser.connect(audioContext.destination);
    }
    /**
     * For bar charts
     * @returns Array<UInt8>
     */ fetchFrequencyData() {
        this.analyser.getByteFrequencyData(this.dataArray);
        return this.dataArray;
    }
    /**
     * For waveforms
     * @returns Array<UInt8>
     */ fetchByteTimeDomainData() {
        this.analyser.getByteTimeDomainData(this.dataArray);
        return this.dataArray;
    }
    /**
     * clear the canvas of all data
     * @param {Number|Boolean} backgroundColour 
     */ clear(backgroundColour = "rgb(0,0,0)") {
        if (backgroundColour) {
            this.ctx.fillStyle = backgroundColour;
            this.ctx.fillRect(0, 0, this.width, this.height);
        } else this.ctx.clearRect(0, 0, this.width, this.height);
    }
    /**
     * Call every frame to show an animated waveform!
     */ drawWaveform() {
        const sliceWidth = this.width / this.bufferLength;
        this.path = new Path2D();
        let x = 0;
        // const h = (this.height / 2)
        this.fetchByteTimeDomainData();
        this.count = (this.count + 1) % 4096;
        let volume = 0;
        // console.info("updating visualiser", this.dataArray)
        for(let i = 0; i < this.bufferLength; ++i){
            const band = this.dataArray[i];
            // Remap 0 -> 128 to 0 -> 1
            const ratio = band / 128;
            const y = ratio * this.verticalCentre // this is just a factor to reduce for clipping
            ;
            if (i === 0) this.path.moveTo(x, y);
            else this.path.lineTo(x, y);
            x += sliceWidth;
            volume += ratio;
        }
        // console.log(volume)
        // close
        // this.path.lineTo(this.width, this.height)
        // paint
        this.clear(this.options.backgroundColour);
        // choose colour and size
        this.ctx.lineWidth = this.options.lineWidth;
        // SILENCE?
        if (volume === 256) {
            // cycle colours
            this.ctx.strokeStyle = `hsla(${this.count % 256}, 90%, 20%, ${Math.max(0, this.alpha / 256)})`;
            this.alpha -= 32;
        } else {
            this.alpha = 256;
            this.ctx.strokeStyle = this.options.lineColour;
        }
        this.ctx.stroke(this.path);
    }
    /**
     * 
     */ drawBarChart() {
        this.fetchFrequencyData();
    }
    /**
     * Handy public method
     */ draw() {
        if (this.isTimeDomain) this.drawBarChart();
        else this.drawWaveform();
    }
}



const $99822b96e55280e1$export$eea8d61eedbcfaa7 = (name)=>NOTE_NAME_MAP[name];
const $99822b96e55280e1$var$DEFAULT_TITLE = "Piano Keyboard with 12 keys";
class $99822b96e55280e1$export$2e2bcd8739ae039 extends (0, $cc1d0ccf700154db$export$2e2bcd8739ae039) {
    static uniqueID = 0;
    isTouching = false;
    keyElements = [];
    htmlElement;
    titleElement;
    firstNoteNumber = 0;
    notes = [];
    get svg() {
        return this.svgString;
    }
    get asElement() {
        return this.htmlElement;
    }
    set title(value) {
        this.titleElement.textContent = value;
    }
    constructor(notes, noteOn, noteOff){
        super(false, true);
        const unique = `keyboard-${$99822b96e55280e1$export$2e2bcd8739ae039.uniqueID++}`;
        this.titleID = `${unique}-title`;
        this.descriptionID = `${unique}-desc`;
        const { svg: svg, whiteKeyElements: whiteKeyElements, blackKeyElements: blackKeyElements } = this.createKeyboard(notes);
        this.htmlElement = document.createElement("div");
        this.htmlElement.className = "piano";
        this.htmlElement.setAttribute("data-piano", true);
        this.htmlElement.innerHTML = svg;
        this.titleElement = this.htmlElement.querySelector("title");
        this.keyElements = Array.from(this.htmlElement.querySelectorAll(".piano-key"));
        this.keyMap = new Map();
        this.keyElements.forEach((value, index)=>{
            // const key = this.htmlElement.querySelector('[data-number="'+noteNumber+'"]')
            this.keyMap.set(parseInt(value.dataset.number), value);
        });
        // console.error( this.keyElements  )
        // console.error( this.keyMap )
        // debugger
        this.firstNoteNumber = notes[0].noteNumber;
        this.svgString = svg;
        this.addInteractivity(this.keyElements, noteOn, noteOff);
    }
    getNoteFromKey(button) {
        const noteNumber = parseInt(button.getAttribute("data-number"));
        const note = this.notes[noteNumber - this.firstNoteNumber];
        // console.info("noteNumber", noteNumber, note, this.notes )
        return note;
    }
    createKeyName(key, x, y, width = 23, height = 120) {
        const textYPosition = y + height;
        return `<text x="${x}" y="${textYPosition}" class="piano-key-name">${key.noteName}</text>`;
    }
    createBlackKey(key, x, y, r = 1.5, width = 13, height = 80) {
        return `<rect 
					x="${x}" 
					y="${y}" 
					rx="${r}" 
					role="button"
					tabindex="0"
                    oncontextmenu="return false;"
					class="piano-key piano-key-black" 
					width="${width}" height="${height}" 
					title="${key.noteName}" 
					aria-label="${key.noteName}"
                    data-key="${key.noteKey}" 
					data-note="${key.noteName}" 
					data-number="${key.noteNumber}" 
					data-frequency="${key.frequency}"
					data-key="${key.noteKey}"
					data-octave="${key.octave}"
				>
				</rect>`;
    }
    createWhiteKey(key, x, y, r = 1.5, width = 23, height = 120) {
        return `<rect 
					x="${x}" 
					y="${y}" 
					rx="${r}" 
					role="button"
                    tabindex="0"
                    oncontextmenu="return false;"
					class="piano-key piano-key-white" 
					width="${width}" height="${height}" 
					title="${key.noteName}" 
					aria-label="${key.noteName}"
					data-key="${key.noteKey}" 
					data-note="${key.noteName}" 
					data-number="${key.noteNumber}" 
					data-frequency="${key.frequency}"
					data-octave="${key.octave}"
				>
				</rect>`;
    }
    /**
	 * 
	 * @param {Object} key 
	 * @param {Number} x 
	 * @param {Number} y 
	 * @param {Number} r 
	 * @returns 
	 */ createIndicator(key, x, y, r = 5) {
        return `<circle 
					cx="${x}" 
					cy="${y}" 
					r="${r}" 
					class="piano-note-indicator" 
					data-note="${key.noteName}" 
					data-number="${key.noteNumber}" 
					data-frequency="${key.frequency}"
					data-octave="${key.octave}"
				>
				</circle>`;
    }
    /**
	 * Create an SVG keyboard
	 * @param {Array} keys 
	 * @param {Number} blackKeyWidth 
	 * @param {Number} whiteKeyWidth 
	 * @returns {SVG}
	 */ createKeyboard(keys, blackKeyWidth = 13, whiteKeyWidth = 23, indicatorWidth = 8, blackKeyScale = 0.5, whiteKeyHeight = 140, x = 0, y = 20) {
        const curvedRadius = 6;
        const halfBlackKeyWidth = blackKeyWidth / 2;
        const halfIndicatorWidth = indicatorWidth / 2;
        const indicatorRadius = halfIndicatorWidth;
        const spaceBetweenIndicators = whiteKeyWidth - indicatorWidth;
        const blackKeyHeight = whiteKeyHeight * blackKeyScale;
        const totalHeight = whiteKeyHeight;
        // rescaled by SVG - just for proportion
        let totalWidth = 0 // 1197.8
        ;
        // Keys as strings
        const whiteKeyElements = [];
        const blackKeyElements = [];
        const keyElements = keys.map((key, index)=>{
            // FIXME: 
            const isBlack = key.accidental ?? false;
            // if the key is a black key, we move back
            x -= isBlack ? halfBlackKeyWidth : 0;
            const keyElement = isBlack ? this.createBlackKey(key, x, y, curvedRadius, blackKeyWidth, blackKeyHeight) : this.createWhiteKey(key, x, y, curvedRadius, whiteKeyWidth, whiteKeyHeight);
            const keyQuantity = isBlack ? blackKeyElements.push(keyElement) : whiteKeyElements.push(keyElement);
            this.createKeyName(key, x, y, blackKeyWidth, blackKeyHeight);
            x += isBlack ? halfBlackKeyWidth : whiteKeyWidth;
            // x += isBlack ? -halfBlackKeyWidth  : whiteKeyWidth
            // only white keys affect total width
            totalWidth += isBlack ? 0 : whiteKeyWidth;
            this.notes.push(key);
            return keyElement;
        });
        // Indicators
        x = 0 // spaceBetweenIndicators / 2
        ;
        y = 0;
        const indicatorElements = keys.map((key, index)=>{
            const indicator = this.createIndicator(key, x, y, indicatorRadius);
            x += spaceBetweenIndicators;
            return indicator;
        });
        const keyboard = `<g class="piano-key-notes piano-keys-white">${whiteKeyElements.join("")}</g>
							<g class="piano-key-notes piano-keys-black">${blackKeyElements.join("")}</g>`;
        const indicators = `<g class="piano-key-indicators">${indicatorElements.join("")}</g>`;
        const svg = `<svg 
					xmlns="http://www.w3.org/2000/svg" 
					class="piano-keys" 
					viewBox="0 0 ${totalWidth} ${totalHeight}" 
					aria-labelledby="${this.titleID} ${this.descriptionID}"
					draggable="false">
					<title id="${this.titleID}">Piano Keyboard with ${keys.length} keys</title>
					<desc id="${this.descriptionID}">Interactive Piano Keyboard with ${keys.length} keys</desc>
					${keyboard}
					${indicators}
				</svg>`;
        return {
            svg: svg,
            keyElements: keyElements,
            whiteKeyElements: whiteKeyElements,
            blackKeyElements: blackKeyElements
        };
    }
    /**
	 * 
	 * @param {Number} noteNumber 
	 */ setKeyAsActive(noteModel) {
        const noteNumber = noteModel.noteNumber;
        const key = this.keyMap.get(noteNumber) ?? this.htmlElement.querySelector('[data-number="' + noteNumber + '"]');
        // const key = this.keyElements[noteNumber - this.firstNoteNumber]
        if (key) {
            key.classList.toggle("active", true);
            this.title = noteModel.toString();
        }
    }
    /**
	 * 
	 * @param {Number} noteNumber 
	 */ setKeyAsInactive(noteModel) {
        const noteNumber = noteModel.noteNumber;
        const key = this.keyMap.get(noteNumber) ?? this.htmlElement.querySelector('[data-number="' + noteNumber + '"]');
        // const key = this.keyElements[noteNumber - this.firstNoteNumber]
        if (key) key.classList.toggle("active", false);
    }
}



var $aq50Z = parcelRequire("aq50Z");
// https://www.chromestatus.com/features/5687444770914304
const $8940dd7f2be14fa1$var$TIME_OUT = 10000;
const $8940dd7f2be14fa1$export$93a0b76ba9b3e540 = ()=>{
    return "speechSynthesis" in window;
};
// we have to loop this with a settimout until voices are available...
const $8940dd7f2be14fa1$var$getVoices = async ()=>new Promise((resolve, reject)=>{
        let voices;
        const startTime = Date.now();
        const waitForVoices = ()=>{
            voices = window.speechSynthesis.getVoices();
            if (voices.length > 0) resolve(voices);
            else {
                // check to see we aren't wasting too much time
                const elapsed = Date.now() - startTime;
                if (elapsed < $8940dd7f2be14fa1$var$TIME_OUT) // in some ways this is a fudge factor as the voices
                // aren't always known about on DOM available : LOOP
                setTimeout(waitForVoices, 0);
                else reject("No voices found");
            }
        };
        waitForVoices();
    });
const $8940dd7f2be14fa1$var$getSpecificVoice = async (lang = "en-US", name = "Zira")=>{
    const voices = $8940dd7f2be14fa1$var$getVoices();
    const filtered = voices.filter((voice)=>{
        // first we check to see if the language is the same...
        return voice.lang === lang && voice.name.indexOf(name) > -1;
    });
    return filtered.length < 1 ? voices : filtered;
};
const $8940dd7f2be14fa1$export$91d88f71a134afea = async (text, interupt = true, volume = 1, rate = 1, pitch = 1, lang = 'en-US', name)=>{
    return new Promise((resolve, reject)=>{
        try {
            if (!$8940dd7f2be14fa1$export$93a0b76ba9b3e540) reject("Speech tech not available");
            else {
                // now pause whilst we attempt to list...
                const talk = async ()=>{
                    const voices = lang && name ? await $8940dd7f2be14fa1$var$getSpecificVoice(lang, name) : await $8940dd7f2be14fa1$var$getVoices();
                    const person = voices[0];
                    let speech = new SpeechSynthesisUtterance();
                    speech.lang = lang;
                    // set voice if specified
                    // Note: some voices don't support altering params
                    speech.voice = person;
                    speech.voiceURI = 'native';
                    speech.onboundary = (event)=>{
                        console.info("onboundary", event);
                    };
                    speech.onmark = (event)=>{
                        console.info("onmark", event);
                    };
                    speech.onstart = (event)=>{
                        console.info("onstart", event);
                    };
                    speech.onpause = (event)=>{
                        console.info("onpause", event);
                    };
                    speech.onresume = (event)=>{
                        console.info("onresume", event);
                    };
                    // watch for ending...
                    speech.onend = (event)=>{
                        //console.log('Finished in ' + event.elapsedTime + ' seconds.')
                        speech.onend = null;
                        speech = null;
                        resolve(event);
                    };
                    speech.onerror = (event)=>{
                        reject();
                    };
                    // 0 to 1
                    speech.volume = volume;
                    // 0.1 to 10
                    speech.rate = rate;
                    //0 to 2
                    speech.pitch = pitch;
                    speech.text = text;
                    // console.error("specific voices", {
                    //   speech, lang,
                    //   name,
                    //   voices
                    // });
                    // kill any pending!
                    if (interupt & window.speechSynthesis.pending) window.speechSynthesis.cancel();
                    window.speechSynthesis.speak(speech);
                };
                talk();
            }
        } catch (error) {
            reject(error);
        }
    });
};
const $8940dd7f2be14fa1$export$7036ebc395e43d3f = ()=>{
    return window.speechSynthesis.cancel();
};
const $8940dd7f2be14fa1$export$b248aae96be5c23d = ()=>{
    return window.speechSynthesis.pending;
};


const $7e3eccf8d0185cbf$export$f06f8b3003f18927 = (word)=>word.charAt(0).toUpperCase() + word.slice(1);
const $7e3eccf8d0185cbf$export$17ae96553a71db1b = (attribute, value)=>document.documentElement.setAttribute(attribute, value);
const $7e3eccf8d0185cbf$export$abf4923cac76073b = (query, value)=>{
    document.querySelectorAll(query).forEach((element)=>element.textContent = value);
};
const $7e3eccf8d0185cbf$export$c6150438b1a5ab7c = (value)=>{
    document.querySelectorAll(`input[value="${value}"]`).forEach((element)=>{
        if (!element.checked) element.checked = true;
    });
};
/**
 * update text field on UI
 * @param {String} timbre 
 */ let $7e3eccf8d0185cbf$var$elementTimbreSelector;
const $7e3eccf8d0185cbf$export$dd02f9126dfaec8f = (timbre)=>{
    $7e3eccf8d0185cbf$export$abf4923cac76073b("[data-timbre]", $7e3eccf8d0185cbf$export$f06f8b3003f18927(timbre));
    if (!$7e3eccf8d0185cbf$var$elementTimbreSelector) $7e3eccf8d0185cbf$var$elementTimbreSelector = document.getElementById("song-timbre-select");
    if ($7e3eccf8d0185cbf$var$elementTimbreSelector.value !== timbre) $7e3eccf8d0185cbf$var$elementTimbreSelector.value = timbre;
};
const $7e3eccf8d0185cbf$export$20abb0e1f3e2be92 = (scaleType)=>{
    // remove old scale and add new one...
    $7e3eccf8d0185cbf$export$17ae96553a71db1b("data-scale", scaleType.toLowerCase());
    // ensure the input radio is selected
    $7e3eccf8d0185cbf$export$c6150438b1a5ab7c(scaleType);
    $7e3eccf8d0185cbf$export$abf4923cac76073b("[data-musical-scale]", scaleType);
};
const $7e3eccf8d0185cbf$export$a98762472d9dfc6a = ()=>{
    const currentYear = new Date().getFullYear();
    const yearElement = document.querySelector(".current-year");
    if (yearElement) {
        yearElement.textContent = currentYear;
        return true;
    }
    return false;
};
const $7e3eccf8d0185cbf$export$20a00301834a6f4d = (searchParams, correctPassword = "", onSubmitted = null)=>{
    // in future we will disable the password protection
    const hasPasswordScreen = pass || !pass.hidden;
    if (!hasPasswordScreen) return false;
    const timesVisited = parseInt(searchParams.get("visited") ?? 0);
    const hasPreviousUserSession = timesVisited > 0;
    pass.addEventListener("submit", (event)=>{
        event.preventDefault();
        const isPasswordCorrect = password.value === correctPassword;
        if (isPasswordCorrect) {
            pass.hidden = true;
            searchParams.set("visited", timesVisited + 1);
            console.info('Password correct ' + isPasswordCorrect, password, password.value);
            onSubmitted && onSubmitted();
        }
        return false;
    });
    if (hasPreviousUserSession) pass.hidden = true;
    // console.error({pass:pass, hidden:pass.hidden, showingPasswordScreen, timesVisited})
    return hasPreviousUserSession;
};
const $7e3eccf8d0185cbf$export$d34ae9cf8bb7186a = ()=>{
    const hasVoice = (0, $8940dd7f2be14fa1$export$93a0b76ba9b3e540)();
    if (!hasVoice) return false;
    const readableElements = document.querySelectorAll("[data-readable]");
    readableElements.forEach((element)=>{
        element.innerHTML = `
        <label class="label-button-read" >
        <div class="sticky-content-wrapper">   
        Voice-over :
            <button class="button-read" type="button" data-button-speak>
                Read out this section
            </button>
            </div>
        </label>` + element.innerHTML;
    });
    const speakOutLoudButtons = document.querySelectorAll('[data-button-speak]');
    speakOutLoudButtons.forEach((button)=>{
        if (hasVoice) button.addEventListener("click", async (e)=>{
            (0, $8940dd7f2be14fa1$export$7036ebc395e43d3f)();
            if (button.hasAttribute("data-speaking")) {
                button.removeAttribute("data-speaking");
                return;
            }
            const article = button.closest("[data-readable]");
            const text = article.textContent.replace(button.innerText, "");
            // We do not want to read out the button text we just pressed...
            button.setAttribute("data-speaking", true);
            await (0, $8940dd7f2be14fa1$export$91d88f71a134afea)(text);
            button.removeAttribute("data-speaking");
        });
        else button.hidden = true;
    });
    return true;
};



var $5uK7V = parcelRequire("5uK7V");
const $1a845b6315e83cc8$export$61fc7d43ac8f84b0 = (callback, wait = 100)=>{
    let timeoutId = null;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>callback.apply(null, args), wait);
    };
};
const $1a845b6315e83cc8$export$7ac3a88d34a76e7 = (array)=>{
    const clone = array.slice(0);
    for(let i = clone.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1)) // random index from 0 to i
        ;
        // swap elements array[i] and array[j]
        const t = clone[i];
        clone[i] = clone[j];
        clone[j] = t;
    // same can be written as:
    // [clone[i], clone[j]] = [clone[j], clone[i]]
    }
    return clone;
};


const $d2bdd7a7bcbc68ef$export$ec8de47e92e93d9c = `
    g a a# a# C a g f
    g g a a# g f F F C
    g g a a# g a# C a g f
    g g a a# g f C C C D C

    a# C D a# C C C D C f
    f g a# g C D C

    f g a# g D D C
    f g a f C C a# a g
    f g a f a# C a g f f C a#
    f g a# g D D C
    f g a f F a a# a g
    f g a f a# C a g f f C a#
    `;
const $d2bdd7a7bcbc68ef$export$c25e6e3096d30d11 = `C# B A E C# G# A E G# A E B G# A E B F# C# E B F# C# E B C# G# A E C# G# A E G# A E B G# A E B F# C# E B F# C# E B F# C# E B F# C# E B G# A E B F# C# E B F# C# E B F# C# E B`;
const $d2bdd7a7bcbc68ef$export$17f667b7b4f93e11 = `
    D E G G G G G G G 
    D E G G G G G G G 
    D E G G G G G G G
    G G F#`;
const $d2bdd7a7bcbc68ef$export$a84dea26c0720dae = `e e G e d`;
const $d2bdd7a7bcbc68ef$export$7a0220cea1898448 = `c g g# g f`;
const $d2bdd7a7bcbc68ef$export$7969338a888437a6 = `g a# C g a# d# C`;
const $d2bdd7a7bcbc68ef$export$7eaa155e7c08255c = `F# F# D E F# B A G# F#`;
const $d2bdd7a7bcbc68ef$export$9ef3880d4c046cdd = `e e e b A G E`;
const $d2bdd7a7bcbc68ef$export$cf18516c3063a9b = `f# f# f# e d# c# b`;
const $d2bdd7a7bcbc68ef$export$972f99d69dde69f0 = `f f f f f f d#`;
const $d2bdd7a7bcbc68ef$export$b4e02685400d92f7 = `a b C# C# C# b a`;
const $d2bdd7a7bcbc68ef$export$2ee71139328c2993 = `c c c a# c c g# c c a# c c c`;
const $d2bdd7a7bcbc68ef$export$617af65d771637bd = `a a C a g c g g# g f g a# C`;
const $d2bdd7a7bcbc68ef$export$403e939e0cea02d8 = `c d D f g D F d f`;
const $d2bdd7a7bcbc68ef$export$31e0613f17d976db = `g f e d c `;
const $d2bdd7a7bcbc68ef$var$repeatSong = (song, repetitions = 1)=>{
    const output = new Array(repetitions);
    return output.map((p)=>song).join(" ");
};
const $d2bdd7a7bcbc68ef$export$303bd80a05b59501 = [
    $d2bdd7a7bcbc68ef$export$ec8de47e92e93d9c,
    $d2bdd7a7bcbc68ef$export$c25e6e3096d30d11,
    $d2bdd7a7bcbc68ef$export$17f667b7b4f93e11,
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$31e0613f17d976db, 3),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$403e939e0cea02d8, 3),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$7eaa155e7c08255c, 3),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$cf18516c3063a9b, 3),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$972f99d69dde69f0, 4),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$9ef3880d4c046cdd, 2),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$2ee71139328c2993, 2),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$a84dea26c0720dae, 5),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$617af65d771637bd, 3),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$7a0220cea1898448, 4),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$b4e02685400d92f7, 4),
    $d2bdd7a7bcbc68ef$var$repeatSong($d2bdd7a7bcbc68ef$export$7969338a888437a6, 4)
];
const $d2bdd7a7bcbc68ef$export$c2bdb834f9cd11fd = ()=>{
    const index = Math.floor(Math.random() * $d2bdd7a7bcbc68ef$export$303bd80a05b59501.length);
    return $d2bdd7a7bcbc68ef$export$303bd80a05b59501[index];
};
const $d2bdd7a7bcbc68ef$export$d8599d66c7d09a18 = ()=>(0, $1a845b6315e83cc8$export$7ac3a88d34a76e7)($d2bdd7a7bcbc68ef$export$303bd80a05b59501).join(" ") + " " + (0, $1a845b6315e83cc8$export$7ac3a88d34a76e7)($d2bdd7a7bcbc68ef$export$303bd80a05b59501).join(" ") + " " + (0, $1a845b6315e83cc8$export$7ac3a88d34a76e7)($d2bdd7a7bcbc68ef$export$303bd80a05b59501).join(" ") + " " + (0, $1a845b6315e83cc8$export$7ac3a88d34a76e7)($d2bdd7a7bcbc68ef$export$303bd80a05b59501).join(" ") + " " + (0, $1a845b6315e83cc8$export$7ac3a88d34a76e7)($d2bdd7a7bcbc68ef$export$303bd80a05b59501).join(" ") + " " + (0, $1a845b6315e83cc8$export$7ac3a88d34a76e7)($d2bdd7a7bcbc68ef$export$303bd80a05b59501).join(" ") + " " + (0, $1a845b6315e83cc8$export$7ac3a88d34a76e7)($d2bdd7a7bcbc68ef$export$303bd80a05b59501).join(" ");


// AKA "Sequences"
const $d8410092f691f4cc$export$b5c48ef765714183 = [
    [
        255,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        255,
        0,
        0,
        0
    ],
    [
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0
    ],
    [
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        255
    ],
    [
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255,
        0,
        255
    ],
    [
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        5,
        50,
        150,
        200
    ],
    [
        255,
        155,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        155,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        255,
        155,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        155,
        0,
        0,
        0,
        0,
        0
    ]
];
const $d8410092f691f4cc$export$6c10b212d4753e84 = [
    [
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0
    ],
    [
        0,
        255,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        255,
        0,
        0
    ],
    [
        0,
        255,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        255,
        205,
        205,
        255,
        205,
        205,
        255
    ],
    [
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        255,
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        255
    ],
    [
        0,
        0,
        0,
        0,
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100,
        110
    ],
    [
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        0
    ]
];
const $d8410092f691f4cc$export$ca2528a22cc908c9 = [
    [
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0
    ]
];
const $d8410092f691f4cc$export$5d446d193e435993 = new Array(16).map((i)=>i * 255 / 16);
const $d8410092f691f4cc$export$95075ead6ad865e2 = [
    [
        255,
        0,
        170,
        0,
        200,
        0,
        170,
        0,
        255,
        0,
        170,
        0,
        200,
        0,
        170,
        0
    ],
    [
        0,
        100,
        0,
        100,
        0,
        100,
        0,
        100,
        0,
        100,
        0,
        100,
        0,
        100,
        0,
        100
    ],
    [
        255,
        0,
        170,
        0,
        200,
        0,
        170,
        0,
        255,
        0,
        170,
        0,
        200,
        0,
        170,
        188
    ],
    [
        170,
        0,
        0,
        0,
        170,
        0,
        0,
        0,
        170,
        0,
        0,
        0,
        170,
        0,
        0,
        0
    ],
    [
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50,
        50
    ],
    [
        20,
        50,
        20,
        50,
        20,
        50,
        20,
        50,
        20,
        50,
        20,
        50,
        20,
        50,
        20,
        50
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]
];


// Just a simple factory for creating random repetitive beats
const $208c0312f9334a36$var$subdivisions = 4;
const $208c0312f9334a36$export$e9008f2713103c6c = (bars = 16)=>{
    // each bar has 4 sub divisions
    const gaps = bars * $208c0312f9334a36$var$subdivisions;
    const sequence = new Array(gaps).fill(0);
    // const sequence = []
    // for (let i=0; i<gaps; ++i)
    // {
    // 	const playNote = false
    // 	sequence.push(playNote)
    // }
    return sequence;
};
const $208c0312f9334a36$export$24f82734ea047e6f = (sequence, offset = 0)=>{
    let index = offset;
    if (!sequence) throw Error("No sequence provided to pattern");
    let length = sequence.length;
    if (length === 0) throw Error("No sequences provided in the array");
    // accessors
    return {
        reset: ()=>{
            index = 0;
            return sequence[index];
        },
        current: ()=>sequence[index],
        previous: ()=>{
            const newIndex = index - 1;
            index = newIndex < 0 ? length - 1 : newIndex;
            return sequence[index];
        },
        next: ()=>{
            const newIndex = index + 1;
            index = newIndex >= length ? 0 : newIndex;
            return sequence[index];
        },
        setVelocityAtStep: (step, velocity)=>sequence[step] = velocity,
        getVelocityAtStep: (step)=>sequence[step],
        setStep: (step)=>index = step,
        getStep: ()=>index,
        getLength: ()=>length,
        setLength: (l)=>length = Math.min(l, sequence.length),
        setSequence: (s)=>sequence = s
    };
};
const $208c0312f9334a36$export$c3291a83c801590 = $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$b5c48ef765714183)[0]);
const $208c0312f9334a36$export$1910341275cefb6f = $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$6c10b212d4753e84)[0]);
const $208c0312f9334a36$export$d47aca4eac4502ba = $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$95075ead6ad865e2)[0]);
const $208c0312f9334a36$export$cde6c35c7278a93 = $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$ca2528a22cc908c9)[0]);
const $208c0312f9334a36$export$de4eb2f714ccf215 = (kitIndex = 0)=>{
    return {
        kick: $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$b5c48ef765714183)[kitIndex % (0, $d8410092f691f4cc$export$b5c48ef765714183).length]),
        hat: $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$95075ead6ad865e2)[kitIndex % (0, $d8410092f691f4cc$export$95075ead6ad865e2).length]),
        snare: $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$6c10b212d4753e84)[kitIndex % (0, $d8410092f691f4cc$export$6c10b212d4753e84).length]),
        clap: $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$ca2528a22cc908c9)[kitIndex % (0, $d8410092f691f4cc$export$ca2528a22cc908c9).length]),
        roll: $208c0312f9334a36$export$24f82734ea047e6f((0, $d8410092f691f4cc$export$5d446d193e435993))
    };
};
const $208c0312f9334a36$export$767daa1b24654839 = (pattern, instrument)=>{};
const $208c0312f9334a36$export$988bb0e77ce90466 = (pattern, instrument, options)=>{
    const velocity = pattern.next();
    if (velocity > 0) {
        instrument({
            ...options,
            velocity: velocity / 255
        }) // velocity
        ;
        return true;
    } else // no note but noteOff?
    return false;
};
const $208c0312f9334a36$export$f0893aa361c31009 = ()=>{
    return $208c0312f9334a36$export$de4eb2f714ccf215(Math.floor(17 + Math.random() * 23));
};


const $eceed7e1d30e9bcd$var$now = ()=>performance ? performance.now() : Date.now();
const $eceed7e1d30e9bcd$export$7cd2e3acd307c9c3 = ()=>navigator.getGamepads() || navigator.webkitGetGamepads();
const $eceed7e1d30e9bcd$export$921e1622b80aef1d = ()=>{
    const gamepads = $eceed7e1d30e9bcd$export$7cd2e3acd307c9c3();
    for(let i = 0; i < gamepads.length; i++){
        console.log("Gamepad " + i + ":");
        if (gamepads[i] === null) {
            console.log("[null]");
            continue;
        }
        if (!gamepads[i].connected) {
            console.log("[disconnected]");
            continue;
        }
        console.log("    Index: " + gamepads[i].index);
        console.log("    ID: " + gamepads[i].id);
        console.log("    Axes: " + gamepads[i].axes.length);
        console.log("    Buttons: " + gamepads[i].buttons.length);
        console.log("    Mapping: " + gamepads[i].mapping);
    }
    return gamepads;
};
const $eceed7e1d30e9bcd$export$4c443f41c554eab3 = "game-pad-available";
const $eceed7e1d30e9bcd$export$780986f0e15d18b6 = "game-pad-unplugged";
const $eceed7e1d30e9bcd$export$cf0f8f2cb256084 = "p1";
const $eceed7e1d30e9bcd$export$e9af151cf00046ef = "p2";
const $eceed7e1d30e9bcd$export$401aad026d8ca26c = "a";
const $eceed7e1d30e9bcd$export$1af87d6f98981eec = "b";
const $eceed7e1d30e9bcd$export$8f66230ebae17096 = "x";
const $eceed7e1d30e9bcd$export$5670e9378e511489 = "y";
const $eceed7e1d30e9bcd$export$35330282dfd6e866 = "lb";
const $eceed7e1d30e9bcd$export$4d24a57ad001cad3 = "rb";
const $eceed7e1d30e9bcd$export$b9132d272e7d98cc = "lt";
const $eceed7e1d30e9bcd$export$caf8cedd88214940 = "rt";
const $eceed7e1d30e9bcd$export$bee483b2ddb10de6 = "select";
const $eceed7e1d30e9bcd$export$d54ea57a6ab7737f = "start";
const $eceed7e1d30e9bcd$export$dc4feb096d3d021a = "ls";
const $eceed7e1d30e9bcd$export$87a0297004ebb962 = "rs";
const $eceed7e1d30e9bcd$export$b5ad9376033e98b2 = "dup";
const $eceed7e1d30e9bcd$export$28a694fb106a7f62 = "ddown";
const $eceed7e1d30e9bcd$export$4f1506fa80c37e6f = "dleft";
const $eceed7e1d30e9bcd$export$a34043b88230a335 = "dright";
const $eceed7e1d30e9bcd$export$bd5a07ac75315a4f = "leftstickY";
const $eceed7e1d30e9bcd$export$d2d1fe960400d1c4 = "leftstickX";
const $eceed7e1d30e9bcd$export$db6b6f3b030b8a82 = "rightstickY";
const $eceed7e1d30e9bcd$export$219bdfbfc971c174 = "rightstickX";
const $eceed7e1d30e9bcd$export$a16e4b9ce9019fe8 = {
    P1: $eceed7e1d30e9bcd$export$cf0f8f2cb256084,
    P2: $eceed7e1d30e9bcd$export$e9af151cf00046ef,
    A: $eceed7e1d30e9bcd$export$401aad026d8ca26c,
    B: $eceed7e1d30e9bcd$export$1af87d6f98981eec,
    X: $eceed7e1d30e9bcd$export$8f66230ebae17096,
    Y: $eceed7e1d30e9bcd$export$5670e9378e511489,
    LB: $eceed7e1d30e9bcd$export$35330282dfd6e866,
    RB: $eceed7e1d30e9bcd$export$4d24a57ad001cad3,
    LT: $eceed7e1d30e9bcd$export$b9132d272e7d98cc,
    RT: $eceed7e1d30e9bcd$export$caf8cedd88214940,
    SELECT: $eceed7e1d30e9bcd$export$bee483b2ddb10de6,
    START: $eceed7e1d30e9bcd$export$d54ea57a6ab7737f,
    LEFT_SHOULDER: $eceed7e1d30e9bcd$export$dc4feb096d3d021a,
    RIGHT_SHOULDER: $eceed7e1d30e9bcd$export$87a0297004ebb962,
    UP: $eceed7e1d30e9bcd$export$b5ad9376033e98b2,
    DOWN: $eceed7e1d30e9bcd$export$28a694fb106a7f62,
    LEFT: $eceed7e1d30e9bcd$export$4f1506fa80c37e6f,
    RIGHT: $eceed7e1d30e9bcd$export$a34043b88230a335,
    LEFT_STICK_Y: $eceed7e1d30e9bcd$export$bd5a07ac75315a4f,
    LEFT_STICK_X: $eceed7e1d30e9bcd$export$d2d1fe960400d1c4,
    RIGHT_STICK_Y: $eceed7e1d30e9bcd$export$db6b6f3b030b8a82,
    RIGHT_STICK_X: $eceed7e1d30e9bcd$export$219bdfbfc971c174
};
// Gamepad reference IDs
const $eceed7e1d30e9bcd$var$BUTTON_NAMES = [
    $eceed7e1d30e9bcd$export$cf0f8f2cb256084,
    $eceed7e1d30e9bcd$export$e9af151cf00046ef,
    $eceed7e1d30e9bcd$export$401aad026d8ca26c,
    $eceed7e1d30e9bcd$export$1af87d6f98981eec,
    $eceed7e1d30e9bcd$export$8f66230ebae17096,
    $eceed7e1d30e9bcd$export$5670e9378e511489,
    $eceed7e1d30e9bcd$export$35330282dfd6e866,
    $eceed7e1d30e9bcd$export$4d24a57ad001cad3,
    $eceed7e1d30e9bcd$export$b9132d272e7d98cc,
    $eceed7e1d30e9bcd$export$caf8cedd88214940,
    $eceed7e1d30e9bcd$export$bee483b2ddb10de6,
    $eceed7e1d30e9bcd$export$d54ea57a6ab7737f,
    $eceed7e1d30e9bcd$export$dc4feb096d3d021a,
    $eceed7e1d30e9bcd$export$87a0297004ebb962,
    $eceed7e1d30e9bcd$export$b5ad9376033e98b2,
    $eceed7e1d30e9bcd$export$28a694fb106a7f62,
    $eceed7e1d30e9bcd$export$4f1506fa80c37e6f,
    $eceed7e1d30e9bcd$export$a34043b88230a335
];
// Gamepad reference IDs
// const BUTTON_NAMES = [
// 	"a",
// 	"b",
// 	"x",
// 	"y",
// 	"lb",
// 	"rb",
// 	"lt",
// 	"rt",
// 	"select",
// 	"start", 
// 	"ls", 
// 	"rs", 
// 	"dup", 
// 	"ddown", 
// 	"dleft", 
// 	"dright"
// ]
const $eceed7e1d30e9bcd$var$BUTTON_QUANTITY = $eceed7e1d30e9bcd$var$BUTTON_NAMES.length;
class $eceed7e1d30e9bcd$export$2e2bcd8739ae039 {
    index = -1;
    connectionIndex = -1;
    gamePadIndex = -1;
    gamepad = null // just a cache of the last state
    ;
    available = false;
    // joystick angle
    leftstickX = 0;
    leftstickY = 0;
    rightstickX = 0;
    rightstickY = 0;
    // button states
    p1 = false;
    p2 = false;
    a = false;
    b = false;
    x = false;
    y = false;
    rb = false;
    lb = false;
    rt = false;
    lt = false;
    rs = false;
    ls = false;
    start = false;
    select = false;
    dup = false;
    ddown = false;
    dleft = false;
    dright = false;
    standardMapping = false;
    watcher = null;
    pressedAt = new Map();
    constructor(gamePadId = 0, connectionIndex = -1){
        this.connected = false;
        this.gamePadIndex = gamePadId;
        this.connectionIndex = connectionIndex;
    }
    // getButton(name){
    // 	return this.buttonLibrary.get(name)
    // }
    on(callback) {
        this.watcher = callback;
    }
    dispatch(key, value) {
        this.watcher && this.watcher(key, value);
    }
    /**
	 * Connect to this gamepad
	 * @param {Event} event 
	 */ connect(event) {
        const gamepad = event.originalEvent ? event.originalEvent.gamepad : event.gamepad;
        this.connected = true;
        this.gamepad = gamepad;
        this.index = gamepad.index;
        this.standardMapping = gamepad.mapping === "standard";
        // BUTTON_NAMES.forEach( (button,index) => {
        // 	this.buttonLibrary.set( button, this.buttons[index] )
        // })
        // this.update()
        this.dispatch($eceed7e1d30e9bcd$export$4c443f41c554eab3, this.toString());
    }
    /**
	 * Disconnect from this gamepad
	 * @param {Event} event 
	 */ disconnect(event) {
        // const gamepad = event.originalEvent ? event.originalEvent.gamepad : event.gamepad
        this.connected = false;
        this.available = false;
        this.gamepad = null;
        this.dispatch($eceed7e1d30e9bcd$export$780986f0e15d18b6, this.toString());
    }
    /**
	 * Make the gamepad vibrate!
	 * 
	 * @param {Number} value 
	 * @param {Number} duration 
	 * @param {Number} hapticIndex 
	 */ vibrate(value = 1, duration = 200, hapticIndex = 0) {
        if (this.gamepad) this.gamepad.hapticActuators[hapticIndex].pulse(value, duration);
    }
    /**
	 * 
	 * @param {String} type 
	 * @param {Number} startDelay 
	 * @param {Number} duration 
	 * @param {Number} weakMagnitude 
	 * @param {Number} strongMagnitude 
	 */ playEffect(type = "dual-rumble", startDelay = 0, duration = 1000, weakMagnitude = 1.0, strongMagnitude = 1.0) {
        if (this.gamepad) this.gamepad.vibrationActuator.playEffect(type, {
            startDelay: startDelay,
            duration: duration,
            weakMagnitude: weakMagnitude,
            strongMagnitude: strongMagnitude
        });
    }
    /**
	 * Check if changed and send out event if so
	 * 
	 * @param {Class} gamepad 
	 * @param {} button 
	 * @param {Number} buttonIndex 
	 */ setBoolean(newValue, button, dispatchEvent = true) {
        const oldValue = this[button];
        let elapsed = -1;
        if (oldValue === false && newValue === true) // ON
        this.pressedAt.set(button, $eceed7e1d30e9bcd$var$now());
        else if (oldValue === true && newValue === false) {
            // OFF
            elapsed = $eceed7e1d30e9bcd$var$now() - this.pressedAt.get(button);
            this.pressedAt.delete(button);
        }
        // TOGGLE
        if (oldValue !== newValue) {
            this[button] = newValue;
            if (dispatchEvent) this.dispatch(button, newValue, elapsed);
        // }else{
        // not changed
        // console.log( buttonIndex, "unchanged gamepad data", gamepad, button, this[button], newValue )
        }
    }
    /**
	 * 
	 * @param {String} key 
	 * @param {String|Number} value 
	 */ setStickPosition(key, value) {
        if (!this.available) {
            // dont't dispatch if first grep
            this[key] = value;
            this.available = true;
        } else if (this[key] !== value) {
            this[key] = value;
            this.dispatch(key, value);
        }
    }
    /**
	 * Set all joystick positions
	 */ setAllStickPositions() {
        this.setStickPosition("leftstickX", this.gamepad.axes[0]);
        this.setStickPosition("leftstickY", this.gamepad.axes[1]);
        this.setStickPosition("rightstickX", this.gamepad.axes[2]);
        this.setStickPosition("rightstickY", this.gamepad.axes[3]);
    // this.leftstickX = this.gamepad.axes[0]
    // this.leftstickY = this.gamepad.axes[1]
    // this.rightstickX = this.gamepad.axes[2]
    // this.rightstickY = this.gamepad.axes[3]
    }
    /**
	 * Update the gamepad state
	 */ update() {
        // NB. *always* fetch the pads to get their latest state
        const gamepads = $eceed7e1d30e9bcd$export$7cd2e3acd307c9c3();
        if (this.available && this.connected) {
            // console.log( "Updating gamepad data",this.gamepad, this)
            this.setAllStickPositions();
            const gamepad = gamepads[this.index];
            for(let i = 0; i < $eceed7e1d30e9bcd$var$BUTTON_QUANTITY; ++i){
                // const gamepadButton = this.gamepad.buttons[i]
                const gamepadButton = gamepad.buttons[i];
                const newValue = gamepadButton.pressed;
                // if (newValue){
                // 	console.error("gamepadButton",  this.gamepad.buttons[i].pressed,  getGamePads()[this.index].buttons[i].pressed, this.index )
                // 	// console.info("gamepadButton", gamepadButton, this.gamepad, navigator.getGamepads()[this.buttonIndex] )
                // } 
                this.setBoolean(newValue, $eceed7e1d30e9bcd$var$BUTTON_NAMES[i]);
            }
        //BUTTON_NAMES.forEach( (button, i) => this.setBoolean( this.gamepad, button, i) )
        // this.setBoolean( gamepad, "a", 0)
        // this.setBoolean( gamepad, "b", 1)
        // this.setBoolean( gamepad, "x", 2)
        // this.setBoolean( gamepad, "y", 3)
        // this.setBoolean( gamepad, "lb", 4)
        // this.setBoolean( gamepad, "rb", 5)
        // this.setBoolean( gamepad, "lt", 6)
        // this.setBoolean( gamepad, "rt", 7)
        // this.setBoolean( gamepad, "select", 8)
        // this.setBoolean( gamepad, "start", 9)
        // this.setBoolean( gamepad, "ls", 10)
        // this.setBoolean( gamepad, "rs", 11)
        // this.setBoolean( gamepad, "dup", 12)
        // this.setBoolean( gamepad, "ddown", 13)
        // this.setBoolean( gamepad, "dleft", 14)
        // this.setBoolean( gamepad, "dright", 15)
        // this.a = !!gamepad.buttons[0].value
        // this.b = !!gamepad.buttons[1].value
        // this.x = !!gamepad.buttons[2].value
        // this.y = !!gamepad.buttons[3].value
        // this.lb = !!gamepad.buttons[4].value
        // this.rb = !!gamepad.buttons[5].value
        // this. lt = !!gamepad.buttons[6].value
        // this.rt = !!gamepad.buttons[7].value
        // this.select = !!gamepad.buttons[8].value
        // this.start = !!gamepad.buttons[9].value
        // this.ls = !!gamepad.buttons[10].value
        // this.rs = !!gamepad.buttons[11].value
        // this.dup = !!gamepad.buttons[12].value
        // this.ddown = !!gamepad.buttons[13].value
        // this.dleft = !!gamepad.buttons[14].value
        // this.dright = !!gamepad.buttons[15].value
        }
    // kill any references remaining...
    // this.gamepad = null
    }
    toStringState() {
        return $eceed7e1d30e9bcd$var$BUTTON_NAMES.map((button)=>this[button]).join(" / ");
    }
    toString() {
        return `Gamepad #${this.index} : ${this.gamePadId} -> ${this.toStringState()}`;
    }
}
const $eceed7e1d30e9bcd$export$8ae012ae7817d18a = "game-pad-connected";
const $eceed7e1d30e9bcd$export$e2f984af7518f4c4 = "game-pad-disconnected";
class $eceed7e1d30e9bcd$export$ccf4b26eab2de2e6 {
    controllers = new Map();
    callbacks = new Set();
    held = new Map();
    get isAnyButtonHeld() {
        return this.held.size > 0;
    }
    get heldButtons() {
        return this.held;
    }
    constructor(){
        // fetch any previously registered game pads
        let pads = $eceed7e1d30e9bcd$export$921e1622b80aef1d();
        let quantity = 0;
        const eventLoop = ()=>{
            //console.info("checking buttons for pads", quantity)
            this.controllers.forEach((gamePad)=>gamePad.update());
            if (quantity > 0) requestAnimationFrame(eventLoop);
        };
        //pads.forEach( pad => pad && this.controllers.set(pad.index, new GamePad(pad.index)) )
        console.info("Existing Gamepads", {
            pads: pads
        }, this);
        window.addEventListener("gamepadconnected", (e)=>{
            const event = e.originalEvent ? e.originalEvent.gamepad : e.gamepad;
            const gamePad = new $eceed7e1d30e9bcd$export$2e2bcd8739ae039(e.index, quantity++);
            gamePad.connect(e);
            gamePad.on((buttonName, value, heldFor)=>{
                switch(buttonName){
                    // ignore caching these
                    case $eceed7e1d30e9bcd$export$8ae012ae7817d18a:
                    case $eceed7e1d30e9bcd$export$e2f984af7518f4c4:
                    case $eceed7e1d30e9bcd$export$a16e4b9ce9019fe8.LEFT_STICK_Y:
                    case $eceed7e1d30e9bcd$export$a16e4b9ce9019fe8.LEFT_STICK_X:
                    case $eceed7e1d30e9bcd$export$a16e4b9ce9019fe8.RIGHT_STICK_Y:
                    case $eceed7e1d30e9bcd$export$a16e4b9ce9019fe8.RIGHT_STICK_X:
                        break;
                    default:
                        if (value) this.held.set(buttonName, value);
                        else this.held.delete(buttonName);
                }
                this.dispatchEvent(buttonName, value, gamePad, heldFor);
            });
            pads = $eceed7e1d30e9bcd$export$921e1622b80aef1d();
            this.controllers.set(event.index, gamePad);
            console.info("Gamepad connected at index %d: %s. %d buttons, %d axes.", event.index, event.id, event.buttons.length, event.axes.length, {
                gamePad: gamePad,
                e: e,
                event: event
            }, this.controllers, pads);
            this.dispatchEvent($eceed7e1d30e9bcd$export$8ae012ae7817d18a, gamePad);
            // start loop if not started already
            eventLoop();
        });
        window.addEventListener("gamepaddisconnected", (e)=>{
            const gamePad = this.controllers.get(e.gamepad.connectionIndex);
            gamePad.disconnect();
            this.controllers.delete(e.gamepad.connectionIndex);
            gamePad = null;
            quantity--;
            this.dispatchEvent($eceed7e1d30e9bcd$export$e2f984af7518f4c4, gamePad);
            console.info("Gamepad disconnected", {
                gamePad: gamePad,
                e: e
            }, this.controllers);
        });
    }
    isHeld(buttonName) {
        return this.held.has(buttonName);
    }
    /**
	 * 
	 * @param {String} key 
	 * @param {Boolean|String|Object} value 
	 */ dispatchEvent(key, value, gamePad) {
        if (this.callbacks.size) this.callbacks.forEach((callback)=>callback(key, value, gamePad));
    }
    addEventListener(callback) {
        this.callbacks.add(callback);
    }
    removeEventListener(callback) {
        this.callbacks.delete(callback);
    }
}
const $eceed7e1d30e9bcd$var$establishGamePadController = ()=>{
// pads = fetchGamePads()
// if (pads.length > 0 && pads[0])
// {
// 	console.info("Gamepads", { pads } )
// 	addGamePad(0)
// 	addGamePad(1)
// 	addGamePad(2)
// 	addGamePad(3)
// }else{
// 	console.info("No Gamepads", { pads } )
// 	requestAnimationFrame( establishGamePadController )
// }
};


var $6c6a611dd94833d5$exports = {};
$6c6a611dd94833d5$exports = $parcel$resolve("b9Bte");



class $836fbe64aaecf064$export$17282cf69930b62e extends (0, $7d9a12bcf883220d$export$f84539d7782ebdfd) {
    timeout;
    mouseDown = false;
    hoveredElement = null;
    mouseX = 0;
    mouseY = 0;
    rect;
    constructor(canvas){
        super(canvas, (0, (/*@__PURE__*/$parcel$interopDefault($6c6a611dd94833d5$exports))));
        this.rect = canvas.getBoundingClientRect();
        const elementToObserve = window ?? document;
        // elementToObserve.addEventListener("mousemove", e => {
        elementToObserve.addEventListener("pointermove", (e)=>{
            const details = e.target // can e.something return what element the mouse cursor is over?
            ;
            const coords = this.getMouseCoords(canvas, e);
            this.mouseX = coords.x // ?? e.offsetX ?? e.layerX ?? e.clientX
            ;
            this.mouseY = coords.y // e.offsetY ?? e.layerY ?? e.clientY
            ;
            this.hoveredElement = details ? details.nodeName : null;
            this.sendMessage(1);
        // console.log("onmousemove", {details, coords})
        });
        elementToObserve.addEventListener("pointerdown", (e)=>{
            this.mouseDown = true;
            this.sendMessage();
        });
        elementToObserve.addEventListener("pointerup", (e)=>{
            this.mouseDown = false;
            this.sendMessage();
        });
    }
    /**
     * 
     * @param {Number} delay (only used in debounce mode)
     */ sendMessage(delay = 0) {
        if (delay === 0) // direct
        this.worker.postMessage(this.getPayload());
        else if (delay === 1) // on next available video frame 
        requestAnimationFrame((e)=>this.worker.postMessage(this.getPayload()));
        else {
            // debounced
            clearTimeout(this.timeout);
            this.timeout = setTimeout(()=>this.worker.postMessage(this.getPayload()), delay);
        }
    }
    /**
     * update the size of the canvas & rect
     * @param {Number} width 
     * @param {Number} height 
     * @param {Number} dpr 
     */ resizeCanvasToDisplaySize(width, height, dpr) {
        this.rect = this.element.getBoundingClientRect();
        super.resizeCanvasToDisplaySize(width, height, dpr);
    }
    /**
     * get the current mouse coordinates
     * @param {HTMLElement} canvas 
     * @param {MouseEvent} event 
     * @returns 
     */ getMouseCoords(canvas, event) {
        // this.rect = canvas.getBoundingClientRect()
        const x = (event.clientX - this.rect.left) / (this.rect.right - this.rect.left) * canvas.width;
        const y = (event.clientY - this.rect.top) / (this.rect.bottom - this.rect.top) * canvas.height;
        // *always* round to integers!
        return {
            x: 0.5 + x | 0,
            y: 0.5 + y | 0
        };
    }
    /**
     * 
     * @returns {Object}
     */ getPayload() {
        // console.info("MOUSEMOVE", {type:"mouse", x:this.mouseX , y:this.mouseY, pressed:this.mouseDown})
        return {
            type: "pointer",
            x: this.mouseX,
            y: this.mouseY,
            pressed: this.mouseDown,
            target: this.hoveredElement
        };
    }
    /**
     * Note On
     * @param {Note} note 
     * @param {number} velocity 
     */ noteOn(note, velocity = 1) {
        const payload = {
            type: "noteOn",
            colour: note.colour,
            velocity: velocity,
            playing: this.mouseDown
        };
        this.worker.postMessage(payload);
    }
    /**
     * Note Off
     * @param {Note} note 
     * @param {Number} velocity 
     */ noteOff(note, velocity = 1) {
        const payload = {
            type: "noteOff",
            colour: note.colour,
            velocity: velocity,
            playing: this.mouseDown
        };
        this.worker.postMessage(payload);
    }
}


class $2f6f7b2476ebbf7f$export$a12b5e8ce44e7a30 {
    #melodyRecorder = new Map();
    constructor(){
        this.#melodyRecorder = new Set();
    }
    /**
     * 
     * @param {Note} note 
     * @param {Number} velocity 
     */ noteOn(note, velocity = 1, time = 0) {
        this.#melodyRecorder.add({
            time: time,
            note: note,
            velocity: velocity,
            playing: true
        });
    }
    /**
     * 
     * @param {Number} velocity 
     */ noteOff(note, velocity = 1, time = 0) {
        this.#melodyRecorder.add({
            time: time,
            note: note,
            velocity: velocity,
            playing: false
        });
    }
    getRecording() {
        return Array.from(this.#melodyRecorder);
    }
    loadFromLocalStorage(key) {
        const arrayDataString = localStorage.getItem(key);
        if (arrayDataString) {
            const arrayData = JSON.parse(arrayDataString);
            // console.error({arrayData, arrayDataString}, this.getRecording())
            arrayData.forEach((item)=>{
                //  console.error({item})
                this.#melodyRecorder.add(item);
            });
            return this.#melodyRecorder;
        }
        return false;
    }
    sveToLocalStorage(key) {
        localStorage.setItem(key, JSON.stringify(this.getRecording()));
        return this.#melodyRecorder;
    }
}



/**
 * Instance based version of timing
 * To allow hybrid timing events and for multiple
 * clocks to run at different rates
 */ 
var $avNAW = parcelRequire("avNAW");
var $584e3729eaac6766$exports = {};
$584e3729eaac6766$exports = $parcel$resolve("56mx0");


var $8335d1956070bc00$exports = {};
$8335d1956070bc00$exports = $parcel$resolve("QLqDO");


var $4866fb8b94d0d5eb$exports = {};
$4866fb8b94d0d5eb$exports = $parcel$resolve("kWVsy");


const $8a65375c1c8b72e2$export$85528aa76ee23af8 = 32;
const $8a65375c1c8b72e2$var$DEFAULT_TIMER_OPTIONS = {
    bars: 16,
    // keep this at 24 to match MIDI1.0 spec
    // where there are 24 ticks per quarternote
    divisions: 24,
    bpm: 90,
    contexts: null,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($584e3729eaac6766$exports))),
    // type:AUDIOTIMER_WORKLET_URI,
    // processor:AUDIOTIMER_PROCESSOR_URI,
    callback: null
};
const $8a65375c1c8b72e2$export$8a8ea1acd162824 = (bpm)=>60000 / parseFloat(bpm);
const $8a65375c1c8b72e2$export$b6db2578a5b75f87 = (period)=>60000 / parseFloat(period);
const $8a65375c1c8b72e2$export$36f510e08ea61006 = (millisecondsPerClockEvent, pulsesPerQuarterNote = 24)=>{
    // Calculate the time for one quarter note in milliseconds
    // If 1 clock event takes `millisecondsPerClockEvent` ms,
    // then 24 clock events (1 quarter note) take `24 * millisecondsPerClockEvent` ms.
    const millisecondsPerQuarterNote = millisecondsPerClockEvent * pulsesPerQuarterNote;
    // Convert milliseconds per quarter note to BPM
    // BPM = (milliseconds in a minute) / (milliseconds per beat)
    // 1 minute = 60,000 milliseconds
    return $8a65375c1c8b72e2$export$b6db2578a5b75f87(millisecondsPerQuarterNote);
};
/**
 * TODO: Implement lienar regression like nayuki
 * https://www.nayuki.io/page/tap-to-measure-tempo-javascript
 * Converts a series of method calls into a tempo estimate.
 * @param {Boolean} autoReset Start a new estimation session if timeout reached
 * @param {Number} timeOut Time frame before ignoring the event and starting a fresh estimation session
 * @param {Number} minimumTaps Requires at least x taps before estimate set
 * @returns {Number} New Period
 */ let $8a65375c1c8b72e2$var$beatTimes = [];
const $8a65375c1c8b72e2$var$TAP_TIMEOUT = 10000;
const $8a65375c1c8b72e2$var$MINIMUM_TEMPOS = 2;
const $8a65375c1c8b72e2$export$db1c0995e6d36014 = (autoReset = true, timeOut = $8a65375c1c8b72e2$var$TAP_TIMEOUT, minimumTaps = $8a65375c1c8b72e2$var$MINIMUM_TEMPOS)=>{
    const currentTime = performance ? performance.now() : Date.now();
    if (autoReset && $8a65375c1c8b72e2$var$beatTimes.length > 0 && currentTime - $8a65375c1c8b72e2$var$beatTimes[$8a65375c1c8b72e2$var$beatTimes.length - 1] > timeOut) $8a65375c1c8b72e2$var$beatTimes = [];
    $8a65375c1c8b72e2$var$beatTimes.push(currentTime);
    const quantity = $8a65375c1c8b72e2$var$beatTimes.length;
    const x = quantity - 1;
    const y = $8a65375c1c8b72e2$var$beatTimes[x] - $8a65375c1c8b72e2$var$beatTimes[0];
    // const time = (y / 1000).toFixed(3)
    if (quantity >= minimumTaps) {
        // const tempo = 60000 * x / y
        const period = y / x;
        return period;
    }
    return -1;
};

class $8a65375c1c8b72e2$export$2e2bcd8739ae039 {
    startTime = -1;
    period = 100;
    // for time formatting...
    currentBar = 0;
    divisions = 24 // 24 quarter notes in a bar
    ;
    bars = 16 // 16 bars in a measure
    ;
    swingOffset = 0 // from 0 -> divisions
    ;
    divisionsElapsed = 0;
    totalBarsElapsed = 0;
    lastRecordedTime = 0;
    isRunning = false;
    isCompatible = false;
    isBypassed = false;
    isActive = false;
    timingWorker;
    loaded = new Promise(this.onAvailable, this.onUnavailable);
    callback;
    // we overwrite this with an audioContext if available
    getNow = ()=>performance.timeOrigin + performance.now();
    /**
	 * Can we use this timing method on this device?
	 * @returns {Boolean} is the worker available and compatable
	 */ get available() {
        return this.isCompatible;
    }
    /**
	 * Can we use this timing method on this device?
	 * @returns {Boolean} is the worker available and compatable
	 */ get running() {
        return this.isRunning;
    }
    /**
	 * Accurate time in milliseconds
	 * @returns {Number} The current time as of now
	 */ get now() {
        return this.getNow();
    }
    /**
	 * Fetch current bar length in milliseconds
	 * @returns {Number} bar length in milliseconds
	 */ get timeBetween() {
        return this.period;
    }
    /**
	 * Amount of time elapsed since startTimer() in seconds
	 * @returns {Number} in seconds
	 */ get timeElapsed() {
        // How long has elapsed according to audio context
        return this.now - this.startTime // * 0.001 
        ;
    }
    /**
	 * Fetch whole loop length in milliseconds
	 * @returns {Number} length in milliseconds
	 */ get totalTime() {
        return this.timePerBar * this.bars;
    }
    /**
	 * Fetch current bar
	 * @returns {Number} current bar
	 */ get bar() {
        return this.currentBar;
    }
    /**
	 * Fetch total bars completed
	 * @returns {Number} total bars
	 */ get barsElapsed() {
        return this.totalBarsElapsed;
    }
    /**
	 * Fetch total bar quantity
	 * @returns {Number} total bars
	 */ get totalBars() {
        return this.bars;
    }
    get totalDivisions() {
        return this.divisions;
    }
    /**
	 * Percentage duration of bar progress 0->1
	 * @returns {Number} percentage elapsed
	 */ get barProgress() {
        return this.currentBar / this.bars;
    }
    /**
	 * Percentage duration of beat progress 0->1
	 * @returns {Number} percentage elapsed
	 */ get beatProgress() {
        return this.divisionsElapsed / this.totalDivisions;
    }
    // Bar times
    /**
	 * Fetch current bar length in milliseconds
	 * @returns {Number} bar length in milliseconds
	 */ get timePerBar() {
        return this.period * this.divisions;
    }
    /**
	 * Get the current timing as Beats per minute
	 * BPM = 60,000,000 / MicroTempo
	 * @returns {Number} BPM
	 */ get BPM() {
        return 60000 / this.timePerBar;
    }
    get bpm() {
        return this.BPM;
    }
    /**
	 * Get the current timing as a Microtempo 
	 * @returns {Number} Microtempo
	 */ get microTempo() {
        return this.timePerBar * 0.001;
    }
    /**
	 * Get the current timing in Micros per MIDI clock
	 * MicrosPerMIDIClock = MicroTempo / 24 
	 * @returns {Number} Microtempo
	 */ get microsPerMIDIClock() {
        return this.microTempo / 24;
    }
    get isAtStartOfBar() {
        return this.barProgress === 0;
    }
    get isStartBar() {
        return this.currentBar === 0;
    }
    get isAtStart() {
        return this.divisionsElapsed === 0;
    }
    get isAtMiddleOfBar() {
        return this.barProgress === 0.5;
    }
    get isQuarterNote() {
        return this.beatProgress % 0.25 === 0;
    }
    get isHalfNote() {
        return this.beatProgress % 0.5 === 0;
    }
    get isSwungBeat() {
        return this.divisionsElapsed % this.swingOffset === 0;
    }
    get swing() {
        return this.swingOffset / this.divisions;
    }
    // Setters
    /**
	 * Fetch current bar
	 * @returns {Number} current bar
	 */ set bar(value) {
        this.currentBar = parseInt(value);
    }
    /**
	 * Allows a user to set the total number of bars
	 * @param {Number} value How many bars to have in a measure
	 * @returns {Number} total bars
	 */ set totalBars(value) {
        this.bars = value < 1 ? 1 : value > $8a65375c1c8b72e2$export$85528aa76ee23af8 ? $8a65375c1c8b72e2$export$85528aa76ee23af8 : value;
    }
    /**
	 *  Set the current timing using a BPM where 
	 *  one beat in milliseconds =  60,000 / BPM
	 * @param {Number} bpm Beats per minute
	 * @returns {Number} period
	 */ set BPM(value) {
        this.timeBetween = 60000 / parseFloat(value);
    }
    set bpm(value) {
        this.BPM = value;
    }
    /**
	 * Using a time in milliseconds, set the amount of time between tick and tock
	 * @param {Number} time Amount of millieconds between ticks
	 * @returns {Number} period
	 */ set timeBetween(time) {
        const interval = time / this.divisions;
        // we want 16 notes
        this.period = interval;
        // TODO
        // FIXME
        // if it is running, stop and restart it?
        //interval = newInterval
        this.postMessage({
            command: (0, $avNAW.CMD_UPDATE),
            interval: interval,
            time: this.now
        });
    }
    /**
	 * Passed in the onBeat callback as a variant
	 * to determine when the "beat" should occur
	 */ set swing(value) {
        this.swingOffset = value * this.divisions;
    }
    constructor(options = $8a65375c1c8b72e2$var$DEFAULT_TIMER_OPTIONS){
        options = {
            ...$8a65375c1c8b72e2$var$DEFAULT_TIMER_OPTIONS,
            ...options
        };
        const optionKeys = Object.keys(options);
        // const { contexts, type=AUDIOTIMER_WORKLET_URI, divisions=DIVISIONS, processor=AUDIOTIMER_PROCESSOR_URI} = options
        for (let key of optionKeys)switch(key){
            case "audioContext":
                this.audioContext = options.audioContext;
                this.getNow = ()=>this.audioContext.currentTime * 1000;
                break;
            case "contexts":
                for(let context in options.contexts)this[context] = options.contexts[context];
                this.getNow = ()=>this.audioContext.currentTime * 1000;
                break;
            default:
                this[key] = options[key];
                console.warn("Timer option", key, options[key]);
        }
        // 
        const isWorklet = options.type.indexOf("orklet") > -1 && this.audioContext;
        if (isWorklet) // TODO:Check if there is a processor
        this.loaded = this.setTimingWorklet(options.type, options.processor, this.audioContext);
        else this.loaded = this.setTimingWorker(options.type);
    }
    /**
	 * 
	 * @param {Function} callback Method to call when the timer ticks
	 */ setCallback(callback) {
        this.callback = callback;
    }
    /**
	 * Allows us to disable the existing route to send our own
	 * or to inject them into here 
	 * 
	 * @param {Boolean} useExternalClock 
	 * @returns 
	 */ bypass(useExternalClock = true) {
        if (useExternalClock) {
            // we want to bypass the worker's work
            this.isBypassed = true;
            if (this.isRunning) {
                // disconnect but don't destroy
                this.disconnectWorker(this.timingWorker, false);
                console.info("timer runinng, bypassing... ");
            } else console.info("bypassing... ignored");
        } else {
            this.isBypassed = false;
            if (this.isRunning) {
                this.startTimer();
                console.info("restarting timer... ");
            } else console.info("undoing bypass... ignored");
        }
        const trigger = (timePassed, expected, drift, level, intervals, lag)=>{
            // call callback
            this.onTick(timePassed, expected, drift, level, intervals, lag);
        };
        return trigger;
    }
    // WORKLET ------------------------------------------------------------------------------------
    /**
	 * Set the worklet as the main timing mechanism
	 * @param {String} type 
	 * @param {String} processor 
	 * @param {AudioContext} audioContext 
	 */ async setTimingWorklet(type, processor, audioContext) {
        let wasRunning = this.isRunning;
        // destroy any existing worklet
        if (this.timingWorker) await this.unsetTimingWorker();
        try {
            await audioContext.audioWorklet.addModule(processor);
        } catch (error) {
            console.error("AudioWorklet processor cannot be added", error);
            throw Error("Timing Worklet failed to load processor:" + processor + " type:" + type);
        }
        // console.error(type, "timer.processor loaded", { type, processor} ) 
        // const wrklet = await import(type) 
        const wrklet = await (parcelRequire("hyPs1"));
        // set worker in global space
        this.timingWorker = new wrklet.default(audioContext);
        // console.error(type, "timer.audioworklet", wrklet, this.timingWorker ) 
        //const timing = module.createTimingProcessor( audioContext )
        // this.timingWorker = timing
        // console.error(type, "timer.audioworklet", {module, audioContext}, this.timingWorker ) 
        if (wasRunning) this.startTimer();
        return this.timingWorker;
    }
    // WORKER ------------------------------------------------------------------------------------
    /**
	 * Load in the Worker URI
	 * @param {String} type or URi 
	 * @returns 
	 */ async loadTimingWorker(type) {
        return new Worker(new URL(type), {
            type: 'module'
        });
    }
    /**
	 * In the future, we may be able to pass offlineAudioContext to a worker
	 * and at that point, we can finally tie in the actual timing by using the 
	 * context as the global clock!
	 * NB. We NOW CAN! User the setTimingWorklet instead :)
	 * @param {String} type 
	 * @returns 
	 */ async setTimingWorker(type) {
        try {
            let wasRunning = this.isRunning;
            // destroy any existing worker
            if (this.timingWorker) await this.unsetTimingWorker();
            this.timingWorker = await this.loadTimingWorker(type);
            if (!this.timingWorker) throw Error("Timing Worker failed to load url:" + url + " type:" + type);
            console.info("Setting timer worker", type, this.timingWorker);
            if (wasRunning) this.startTimer();
            return this.timingWorker;
        } catch (error) {
            this.isCompatible = false;
            console.error("Timing WORKER FAILED TO LOAD", type, error);
        }
        return null;
    }
    // SHARED WORKER / WORKLET CDE ------------------------------------------------------------------------------------
    /**
	 * 
	 * @param {String} type 
	 * @returns {Boolean}
	 */ async unsetTimingWorker(type) {
        // timer.onmessage = this.timingWorker.onmessage 
        // timer.onerror = this.timingWorker.onerror 
        // // TODO: clone the methods into new worker
        // this.timingWorker.onmessage = (e) => {}
        // this.timingWorker.onerror = (e) => {}
        this.stopTimer();
        this.timingWorker.terminate();
        this.timingWorker = null;
        return true;
    }
    /**
	 * Add a worker or worklet into the pipeline
	 * and monitor it's events and messages
	 * @param {Worker} worker 
	 */ connectWorker(worker) {
        if (!worker) throw new Error("Timing Worker was not defined - please check paths " + worker);
        // now hook into our worker bee and watch for timing changes
        worker.onmessage = (e)=>{
            const time = this.now;
            const data = e.data;
            switch(data.event){
                case 0, $avNAW.EVENT_READY:
                    break;
                case 0, $avNAW.EVENT_STARTING:
                    // save start time
                    this.startTime = time;
                    this.isRunning = true;
                    this.resetTimer();
                    break;
                case 0, $avNAW.EVENT_TICK:
                    const timeBetweenPeriod = this.timeBetween * 0.001;
                    // How many ticks have occured yet
                    const intervals = data.intervals;
                    // Expected time stamp
                    const expected = intervals * timeBetweenPeriod;
                    // How long has elapsed according to our worker
                    const timePassed = data.time;
                    // how much spill over the expected timestamp is there
                    const lag = timePassed % timeBetweenPeriod;
                    // should be 0 if the timer is working...
                    const drift = timePassed - this.timeElapsed;
                    // deterministic intervals not neccessary
                    const level = Math.floor(timePassed / this.timeBetween);
                    // elapsed should === time
                    this.onTick(timePassed, expected, drift, level, intervals, lag);
                    break;
                default:
                    console.log("message: ", e, time);
            }
        };
        // Error!
        worker.onerror = (error)=>{
            console.error("error...", {
                error: error
            });
            worker.postMessage({
                error: error,
                time: this.audioContext.currentTime
            });
        };
    }
    postMessage(payload) {
        this.timingWorker && this.timingWorker.postMessage(payload);
    }
    /**
	 * Disconnect the worker from the timer
	 * @param {Worker} worker 
	 */ disconnectWorker(worker, setStopped = true) {
        worker.onmessage = (e)=>{
            switch(e.event){
                // Clean up
                case 0, $avNAW.EVENT_STOPPING:
                    // destroy contexts and unsubscribe from events
                    if (setStopped) this.isRunning = false;
                    break;
            }
        };
        worker.postMessage({
            command: (0, $avNAW.CMD_STOP),
            time: this.now
        });
    }
    /**
	 * Reset the timer and start from the beginning
	 */ resetTimer() {
        this.totalBarsElapsed = 0;
        this.divisionsElapsed = 0;
        this.flipped = false;
    }
    /**
	 * Starts the timer and begins events being dispatched
	 * 
	 * @returns {Object} current time and timingWorker
	 */ async startTimer(callback, options = {}) {
        await this.loaded;
        const currentTime = this.now;
        if (!this.isRunning) {
            // FIXME: Alter this behaviour for rolling count
            this.totalBarsElapsed = 0;
            this.flipped = false;
        }
        if (callback) this.setCallback(callback);
        // if we are using an external clock
        // we try and determine the tempo ourselves
        if (this.isBypassed) {
            this.isRunning = true;
            return {
                time: currentTime,
                interval: -1,
                worker: null
            };
        }
        this.connectWorker(this.timingWorker);
        // send command to worker... options
        this.postMessage({
            command: (0, $avNAW.CMD_START),
            time: currentTime,
            interval: this.period,
            // FIXME:
            accurateTiming: false
        });
        // console.log("Starting...", { interval:timeBetween, timingWorker} )
        return {
            time: currentTime,
            interval: this.period,
            worker: this.timingWorker
        };
    }
    /**
	 * Stops the timer and prevents events being dispatched
	 * @returns {Object} current time and timingWorker
	 */ async stopTimer() {
        await this.loaded;
        const currentTime = this.now;
        // cancel the thing thrugh the workers first
        // cancel any scheduled quie noises
        this.disconnectWorker(this.timingWorker);
        return {
            currentTime: currentTime,
            worker: this.timingWorker
        };
    }
    /**
	 * start the timer if it is paused...
	 * or stop the timer if it is running
	 * @returns {Boolean} is the timer running
	 */ async toggleTimer() {
        if (this.isBypassed) // we are using an external timer!
        return this.isRunning;
        if (!this.isRunning) await this.startTimer();
        else await this.stopTimer();
        return this.isRunning;
    }
    /**
	 * Use an external device to send clock signals to and through this timer
	 * @param {Number} timePassed 
	 * @param {Number} expected 
	 * @param {Number} drift 
	 * @param {Number} level 
	 * @param {Number} intervals 
	 * @param {Number} lag 
	 */ externalTrigger(timePassed, expected, drift = 0, level = 0, intervals = 0, lag = 0) {
        if (this.isRunning && this.isBypassed) this.onTick(timePassed, expected, drift, level, intervals, lag);
    }
    /**
	 * EVENT: Timer is available
	 */ onAvailable() {
        console.info("Timer is available");
    }
    /**
	 * EVENT: Timer is unavailable
	 */ onUnavailable() {
        console.error("Timer is unavailable");
    }
    /**
	 * Occurs 24 times per beat
	 * Call the callback with internal flags
	 * @param {Number} timePassed 
	 * @param {Number} expected 
	 * @param {Number} drift 
	 * @param {Number} level 
	 * @param {Number} intervals 
	 * @param {Number} lag 
	 */ onTick(timePassed, expected, drift = 0, level = 0, intervals = 0, lag = 0) {
        // console.info("Timer:onTick", {timePassed, expected, drift, level, intervals, lag} )
        this.lastRecordedTime = timePassed;
        // check if bar has completed
        if (++this.divisionsElapsed >= this.divisions) {
            ++this.totalBarsElapsed;
            this.currentBar = (this.currentBar + 1) % this.bars;
            this.divisionsElapsed = 0;
        }
        // let us determine if we are on a swung beat
        const swung = this.divisionsElapsed % this.swingOffset === 0;
        this.callback && this.callback({
            bar: this.currentBar,
            bars: this.totalBars,
            divisionsElapsed: this.divisionsElapsed,
            barsElapsed: this.barsElapsed,
            elapsed: this.timeElapsed,
            timePassed: //performance
            timePassed,
            expected: expected,
            drift: drift,
            level: level,
            intervals: intervals,
            lag: lag
        });
    }
}


class $33f2e6c2e07fb954$export$6025dfc8c34171bc {
    canvas;
    context;
    melodyRecorder;
    quantized = true;
    index = 0;
    lastNoteTime = 0;
    constructor(canvas, melodyRecorder){
        this.canvas = canvas;
        this.context = canvas.getContext("2d");
        this.melodyRecorder = melodyRecorder;
        const resizeObserver = new ResizeObserver((e)=>this.onResize(e));
        resizeObserver.observe(canvas, {
            box: 'content-box'
        });
    }
    /**
     * Note On
     * @param {Note} note 
     * @param {number} velocity 
     */ noteOn(note, velocity = 1, time = 0) {
        let hasAdvancedThroughTime = false;
        if (this.lastNoteTime < time) {
            this.lastNoteTime = time;
            hasAdvancedThroughTime = true;
            this.index++;
        }
        this.drawNote(note, this.quantized ? this.index : time);
    }
    /**
     * Note Off
     * @param {Note} note 
     * @param {Number} velocity 
     */ noteOff(note, velocity = 1, time = 0) {}
    drawNote(note, time) {
        this.context.fillStyle = note.colour;
        this.context.fillRect(time, note.number, 1, 1);
    // console.info("note", note, time)
    }
    redraw() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        const t = this.melodyRecorder.getRecording();
        if (this.canvas.width < t.size) this.canvas.width = t.size;
        this.index = 0;
        t.forEach((data)=>{
            this.drawNote(data.note, this.quantized ? this.index : data.time);
            this.index++;
        });
    }
    resizeCanvasToDisplaySize(width, height, dpr) {
        const displayWidth = Math.round(width * dpr);
        if (this.canvas.width !== displayWidth) this.canvas.width = displayWidth;
        this.redraw();
    }
    /**
     * EVENT
     * @param {Array} entries 
     */ onResize(entries) {
        for (const entry of entries){
            let width;
            let height;
            let dpr = window.devicePixelRatio;
            // let dprSupport = false
            if (entry.devicePixelContentBoxSize) {
                // NOTE: Only this path gives the correct answer
                // The other paths are an imperfect fallback
                // for browsers that don't provide anyway to do this
                width = entry.devicePixelContentBoxSize[0].inlineSize;
                height = entry.devicePixelContentBoxSize[0].blockSize;
                dpr = 1 // it's already in width and height
                ;
            // dprSupport = true
            } else if (entry.contentBoxSize) {
                if (entry.contentBoxSize[0]) {
                    width = entry.contentBoxSize[0].inlineSize;
                    height = entry.contentBoxSize[0].blockSize;
                } else {
                    // legacy
                    width = entry.contentBoxSize.inlineSize;
                    height = entry.contentBoxSize.blockSize;
                }
            } else {
                // legacy
                width = entry.contentRect.width;
                height = entry.contentRect.height;
            }
            this.resizeCanvasToDisplaySize(width, height, dpr);
        }
    }
}


const $ca2546b3e0c3d36c$var$COUNTDOWN_TYPES = [
    "day",
    "hour",
    "minute",
    "second"
];
const $ca2546b3e0c3d36c$export$f52e29715bba3529 = (element, completedText = "This event is in the past", period = 1000)=>{
    // grab all the time elements
    const timeElements = element.querySelectorAll("time");
    if (!timeElements || timeElements.length === 0) return;
    const counter = document.createElement("p");
    counter.classList.add("countdown");
    let date;
    let times;
    let interval;
    const getRemaining = (date)=>{
        const now = new Date();
        return Math.max(0, date.getTime() - now.getTime());
    };
    const getTime = (remainingMs)=>{
        const totalSeconds = Math.floor(remainingMs / 1000);
        const totalMinutes = Math.floor(totalSeconds / 60);
        const totalHours = Math.floor(totalMinutes / 60);
        const totalDays = Math.floor(totalHours / 24);
        const displaySeconds = totalSeconds % 60;
        const displayMinutes = totalMinutes % 60;
        const displayHours = totalHours % 24;
        const times = [
            totalDays,
            displayHours,
            displayMinutes,
            displaySeconds
        ];
        return times;
    };
    const countElements = [];
    timeElements.forEach((timeElement)=>{
        const time = timeElement.getAttribute("datetime");
        date = new Date(time);
        times = getTime(date) // [ totalDays, displayHours, displayMinutes, displaySeconds ]
        ;
        times.forEach((value, i)=>{
            const isLast = i === times.length - 1;
            const type = $ca2546b3e0c3d36c$var$COUNTDOWN_TYPES[i] + (value > 1 ? "s" : "");
            const span = document.createElement("span");
            span.classList.add("countdown-" + type);
            span.textContent = "" + value + " " + type + (isLast ? "." : ", ");
            counter.appendChild(span);
            countElements.push(span);
        });
        timeElement.hidden = true;
    });
    element.appendChild(counter);
    const update = ()=>{
        const remainingMS = getRemaining(date);
        if (remainingMS > 0) {
            const newTimes = getTime(remainingMS);
            countElements.forEach((countElement, i)=>{
                const newValue = newTimes[i];
                const oldValue = times[i];
                if (oldValue !== newValue) {
                    const isLast = i === newTimes.length - 1;
                    const type = $ca2546b3e0c3d36c$var$COUNTDOWN_TYPES[i] + (newValue > 1 ? "s" : "");
                    countElement.textContent = "" + newValue + " " + type + (isLast ? "." : ", ");
                }
            });
            interval = setTimeout(update, period);
        } else {
            // finished
            clearInterval(interval);
            counter.textContent = completedText;
            element.classList.add("in-the-past");
        }
    };
    update();
};


var $ac3d96ed21a53251$exports = {};
$ac3d96ed21a53251$exports = $parcel$resolve("abJQM");


var $6667a1daf649183e$exports = {};
$6667a1daf649183e$exports = $parcel$resolve("j77Aa");


var $d652174115640530$exports = {};
$d652174115640530$exports = $parcel$resolve("enQih");


const $3b51a335dfa13a39$var$SPELLS = [
    (0, (/*@__PURE__*/$parcel$interopDefault($ac3d96ed21a53251$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6667a1daf649183e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($d652174115640530$exports)))
];
const $3b51a335dfa13a39$export$f39a892ec03dae3b = ()=>{
    return $3b51a335dfa13a39$var$SPELLS[Math.floor(Math.random() * $3b51a335dfa13a39$var$SPELLS.length)];
};


const $cd9f07ae59996643$export$50f5c8c4b7cc55df = [
    "source-over",
    "source-in",
    "source-out",
    "source-atop",
    "destination-over",
    "destination-in",
    "destination-out",
    "destination-atop",
    "lighter",
    "copy",
    "xor",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
].reverse();
const $cd9f07ae59996643$export$188c64432b18968a = [
    "This is the default setting and draws new shapes on top of the existing canvas content.",
    "The new shape is drawn only where both the new shape and the destination canvas overlap. Everything else is made transparent.",
    "The new shape is drawn where it doesn't overlap the existing canvas content.",
    "The new shape is only drawn where it overlaps the existing canvas content.",
    "New shapes are drawn behind the existing canvas content.",
    "The existing canvas content is kept where both the new shape and existing canvas content overlap. Everything else is made transparent.",
    "The existing content is kept where it doesn't overlap the new shape.",
    "The existing canvas is only kept where it overlaps the new shape. The new shape is drawn behind the canvas content.",
    "Where both shapes overlap the color is determined by adding color values.",
    "Only the new shape is shown.",
    "Shapes are made transparent where both overlap and drawn normal everywhere else.",
    "The pixels of the top layer are multiplied with the corresponding pixel of the bottom layer. A darker picture is the result.",
    "The pixels are inverted, multiplied, and inverted again. A lighter picture is the result (opposite of multiply)",
    "A combination of multiply and screen. Dark parts on the base layer become darker, and light parts become lighter.",
    "Retains the darkest pixels of both layers.",
    "Retains the lightest pixels of both layers.",
    "Divides the bottom layer by the inverted top layer.",
    "Divides the inverted bottom layer by the top layer, and then inverts the result.",
    "A combination of multiply and screen like overlay, but with top and bottom layer swapped.",
    "A softer version of hard-light. Pure black or white does not result in pure black or white.",
    "Subtracts the bottom layer from the top layer or the other way round to always get a positive value.",
    "Like difference, but with lower contrast.",
    "Preserves the luma and chroma of the bottom layer, while adopting the hue of the top layer.",
    "Preserves the luma and hue of the bottom layer, while adopting the chroma of the top layer.",
    "Preserves the luma of the bottom layer, while adopting the hue and chroma of the top layer.",
    "Preserves the hue and chroma of the bottom layer, while adopting the luma of the top layer."
].reverse();


var $b19681a3b51d0c6c$exports = {};
$b19681a3b51d0c6c$exports = $parcel$resolve("eY1iU");


var $b2ef9d6141f2e5ac$exports = {};
$b2ef9d6141f2e5ac$exports = $parcel$resolve("lA4jq");



class $6492a35c65bfd61a$export$dbc2a52036a3723c extends HTMLElement {
    constructor(){
        super();
        this.isIframeLoaded = false;
        this.isPlaylistThumbnailLoaded = false;
        this.setupDom();
    }
    static get observedAttributes() {
        return [
            'videoid',
            'playlistid',
            'videoplay',
            'videotitle'
        ];
    }
    connectedCallback() {
        this.addEventListener('pointerover', ()=>$6492a35c65bfd61a$export$dbc2a52036a3723c.warmConnections(this), {
            once: true
        });
        this.addEventListener('click', ()=>this.addIframe());
    }
    get videoId() {
        return encodeURIComponent(this.getAttribute('videoid') || '');
    }
    set videoId(id) {
        this.setAttribute('videoid', id);
    }
    get playlistId() {
        return encodeURIComponent(this.getAttribute('playlistid') || '');
    }
    set playlistId(id) {
        this.setAttribute('playlistid', id);
    }
    get videoTitle() {
        return this.getAttribute('videotitle') || 'Video';
    }
    set videoTitle(title) {
        this.setAttribute('videotitle', title);
    }
    get videoPlay() {
        return this.getAttribute('videoplay') || 'Play';
    }
    set videoPlay(name) {
        this.setAttribute('videoplay', name);
    }
    get videoStartAt() {
        return this.getAttribute('videoStartAt') || '0';
    }
    get autoLoad() {
        return this.hasAttribute('autoload');
    }
    get autoPause() {
        return this.hasAttribute('autopause');
    }
    get noCookie() {
        return this.hasAttribute('nocookie');
    }
    get posterQuality() {
        return this.getAttribute('posterquality') || 'hqdefault';
    }
    get posterLoading() {
        return this.getAttribute('posterloading') || 'lazy';
    }
    get params() {
        return `start=${this.videoStartAt}&${this.getAttribute('params')}`;
    }
    set params(opts) {
        this.setAttribute('params', opts);
    }
    set posterQuality(opts) {
        this.setAttribute('posterquality', opts);
    }
    get disableNoscript() {
        return this.hasAttribute('disablenoscript');
    }
    setupDom() {
        const shadowDom = this.attachShadow({
            mode: 'open'
        });
        let nonce = '';
        if (window.liteYouTubeNonce) nonce = `nonce="${window.liteYouTubeNonce}"`;
        shadowDom.innerHTML = `
      <style ${nonce}>
        :host {
          --aspect-ratio: var(--lite-youtube-aspect-ratio, 16 / 9);
          --aspect-ratio-short: var(--lite-youtube-aspect-ratio-short, 9 / 16);
          --frame-shadow-visible: var(--lite-youtube-frame-shadow-visible, yes);
          contain: content;
          display: block;
          position: relative;
          width: 100%;
          aspect-ratio: var(--aspect-ratio);
        }

        @media (max-width: 40em) {
          :host([short]) {
            aspect-ratio: var(--aspect-ratio-short);
          }
        }

        #frame, #fallbackPlaceholder, iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }

        #frame {
          cursor: pointer;
        }

        #fallbackPlaceholder, slot[name=image]::slotted(*) {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }

        @container style(--frame-shadow-visible: yes) {
          #frame::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            background-image: linear-gradient(180deg, #111 -20%, transparent 90%);
            height: 60px;
            width: 100%;
            z-index: 1;
          }
        }

        #playButton {
          width: 68px;
          height: 48px;
          background-color: transparent;
          background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/><path d="M45 24 27 14v20" fill="white"/></svg>');
          z-index: 1;
          border: 0;
          border-radius: inherit;
        }

        #playButton:before {
          content: '';
          border-style: solid;
          border-width: 11px 0 11px 19px;
          border-color: transparent transparent transparent #fff;
        }

        #playButton,
        #playButton:before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          cursor: inherit;
        }

        /* Post-click styles */
        .activated {
          cursor: unset;
        }

        #frame.activated::before,
        #frame.activated > #playButton {
          display: none;
        }
      </style>
      <div id="frame">
        <picture>
          <slot name="image">
            <source id="webpPlaceholder" type="image/webp">
            <source id="jpegPlaceholder" type="image/jpeg">
            <img id="fallbackPlaceholder" referrerpolicy="origin" loading="lazy">
          </slot>
        </picture>
        <button id="playButton" part="playButton"></button>
      </div>
    `;
        this.domRefFrame = shadowDom.querySelector('#frame');
        this.domRefImg = {
            fallback: shadowDom.querySelector('#fallbackPlaceholder'),
            webp: shadowDom.querySelector('#webpPlaceholder'),
            jpeg: shadowDom.querySelector('#jpegPlaceholder')
        };
        this.domRefPlayButton = shadowDom.querySelector('#playButton');
    }
    setupComponent() {
        const hasImgSlot = this.shadowRoot.querySelector('slot[name=image]');
        if (hasImgSlot.assignedNodes().length === 0) this.initImagePlaceholder();
        this.domRefPlayButton.setAttribute('aria-label', `${this.videoPlay}: ${this.videoTitle}`);
        this.setAttribute('title', `${this.videoPlay}: ${this.videoTitle}`);
        if (this.autoLoad || this.isYouTubeShort() || this.autoPause) this.initIntersectionObserver();
        if (!this.disableNoscript) this.injectSearchNoScript();
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (oldVal !== newVal) {
            if (name === 'playlistid' && oldVal !== null && oldVal !== newVal) this.isPlaylistThumbnailLoaded = false;
            this.setupComponent();
            if (this.domRefFrame.classList.contains('activated')) {
                this.domRefFrame.classList.remove('activated');
                this.shadowRoot.querySelector('iframe').remove();
                this.isIframeLoaded = false;
            }
        }
    }
    injectSearchNoScript() {
        const eleNoScript = document.createElement('noscript');
        this.prepend(eleNoScript);
        eleNoScript.innerHTML = this.generateIframe();
    }
    generateIframe(isIntersectionObserver = false) {
        let autoplay = isIntersectionObserver ? 0 : 1;
        let autoPause = this.autoPause ? '&enablejsapi=1' : '';
        const wantsNoCookie = this.noCookie ? '-nocookie' : '';
        let embedTarget;
        if (this.playlistId) embedTarget = `?listType=playlist&list=${this.playlistId}&`;
        else embedTarget = `${this.videoId}?`;
        if (this.isYouTubeShort()) {
            this.params = `loop=1&mute=1&modestbranding=1&playsinline=1&rel=0&enablejsapi=1&playlist=${this.videoId}`;
            autoplay = 1;
        }
        return `
<iframe credentialless frameborder="0" title="${this.videoTitle}"
  referrerpolicy="strict-origin-when-cross-origin"
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
  src="https://www.youtube${wantsNoCookie}.com/embed/${embedTarget}autoplay=${autoplay}${autoPause}&${this.params}"
></iframe>`;
    }
    addIframe(isIntersectionObserver = false) {
        if (!this.isIframeLoaded) {
            const iframeHTML = this.generateIframe(isIntersectionObserver);
            this.domRefFrame.insertAdjacentHTML('beforeend', iframeHTML);
            this.domRefFrame.classList.add('activated');
            this.isIframeLoaded = true;
            this.attemptShortAutoPlay();
            this.dispatchEvent(new CustomEvent('liteYoutubeIframeLoaded', {
                detail: {
                    videoId: this.videoId
                },
                bubbles: true,
                cancelable: true
            }));
        }
    }
    initImagePlaceholder() {
        if (this.playlistId && !this.videoId) this.loadPlaylistThumbnail();
        else this.testPosterImage();
        this.domRefImg.fallback.setAttribute('aria-label', `${this.videoPlay}: ${this.videoTitle}`);
        this.domRefImg?.fallback?.setAttribute('alt', `${this.videoPlay}: ${this.videoTitle}`);
    }
    async loadPlaylistThumbnail() {
        if (this.isPlaylistThumbnailLoaded) return;
        this.isPlaylistThumbnailLoaded = true;
        try {
            const oEmbedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/playlist?list=${this.playlistId}&format=json`;
            const response = await fetch(oEmbedUrl);
            if (!response.ok) throw new Error(`Failed to fetch playlist thumbnail: ${response.status}`);
            const data = await response.json();
            if (data.thumbnail_url) {
                const thumbnailUrl = data.thumbnail_url;
                const videoIdMatch = thumbnailUrl.match(/\/vi\/([^\/]+)\//);
                if (videoIdMatch) {
                    const extractedVideoId = videoIdMatch[1];
                    this.loadThumbnailImages(extractedVideoId);
                } else {
                    this.domRefImg.fallback.src = thumbnailUrl;
                    this.domRefImg.fallback.loading = this.posterLoading;
                }
            }
        } catch (error) {
            console.warn('Failed to load playlist thumbnail:', error);
        }
    }
    loadThumbnailImages(videoId) {
        const posterUrlWebp = `https://i.ytimg.com/vi_webp/${videoId}/${this.posterQuality}.webp`;
        this.domRefImg.webp.srcset = posterUrlWebp;
        const posterUrlJpeg = `https://i.ytimg.com/vi/${videoId}/${this.posterQuality}.jpg`;
        this.domRefImg.jpeg.srcset = posterUrlJpeg;
        this.domRefImg.fallback.src = posterUrlJpeg;
        this.domRefImg.fallback.loading = this.posterLoading;
    }
    async testPosterImage() {
        setTimeout(()=>{
            const webpUrl = `https://i.ytimg.com/vi_webp/${this.videoId}/${this.posterQuality}.webp`;
            const img = new Image();
            img.fetchPriority = 'low';
            img.referrerPolicy = 'origin';
            img.src = webpUrl;
            img.onload = async (e)=>{
                const target = e.target;
                const noPoster = target?.naturalHeight == 90 && target?.naturalWidth == 120;
                if (noPoster) this.posterQuality = 'hqdefault';
                this.loadThumbnailImages(this.videoId);
            };
        }, 100);
    }
    initIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };
        const observer = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !this.isIframeLoaded) {
                    $6492a35c65bfd61a$export$dbc2a52036a3723c.warmConnections(this);
                    this.addIframe(true);
                    observer.unobserve(this);
                }
            });
        }, options);
        observer.observe(this);
        if (this.autoPause) {
            const windowPause = new IntersectionObserver((e, o)=>{
                e.forEach((entry)=>{
                    if (entry.intersectionRatio !== 1) this.shadowRoot.querySelector('iframe')?.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                });
            }, {
                threshold: 1
            });
            windowPause.observe(this);
        }
    }
    attemptShortAutoPlay() {
        if (this.isYouTubeShort()) setTimeout(()=>{
            this.shadowRoot.querySelector('iframe')?.contentWindow?.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 2000);
    }
    isYouTubeShort() {
        return this.getAttribute('short') === '' && window.matchMedia('(max-width: 40em)').matches;
    }
    static addPrefetch(kind, url) {
        const linkElem = document.createElement('link');
        linkElem.rel = kind;
        linkElem.href = url;
        linkElem.crossOrigin = 'true';
        document.head.append(linkElem);
    }
    static warmConnections(context) {
        if ($6492a35c65bfd61a$export$dbc2a52036a3723c.isPreconnected || window.liteYouTubeIsPreconnected) return;
        $6492a35c65bfd61a$export$dbc2a52036a3723c.addPrefetch('preconnect', 'https://i.ytimg.com/');
        $6492a35c65bfd61a$export$dbc2a52036a3723c.addPrefetch('preconnect', 'https://s.ytimg.com');
        if (!context.noCookie) {
            $6492a35c65bfd61a$export$dbc2a52036a3723c.addPrefetch('preconnect', 'https://www.youtube.com');
            $6492a35c65bfd61a$export$dbc2a52036a3723c.addPrefetch('preconnect', 'https://www.google.com');
            $6492a35c65bfd61a$export$dbc2a52036a3723c.addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
            $6492a35c65bfd61a$export$dbc2a52036a3723c.addPrefetch('preconnect', 'https://static.doubleclick.net');
        } else $6492a35c65bfd61a$export$dbc2a52036a3723c.addPrefetch('preconnect', 'https://www.youtube-nocookie.com');
        $6492a35c65bfd61a$export$dbc2a52036a3723c.isPreconnected = true;
        window.liteYouTubeIsPreconnected = true;
    }
}
$6492a35c65bfd61a$export$dbc2a52036a3723c.isPreconnected = false;
customElements.define('lite-youtube', $6492a35c65bfd61a$export$dbc2a52036a3723c);


const $e6718a831229ead6$var$SETTINGS = (0, $5uK7V.getSettings)();
// audio requires a user gesture to start...
// so we hook into each musical event to check if the user has engaged
let $e6718a831229ead6$var$hasUserEngaged = false;
let $e6718a831229ead6$var$drumsPlaying = false;
let $e6718a831229ead6$var$isHappy = true // is Major or Minor?
;
// read any saved themes from the URL ONLY (not from cookies so no overlay required :)
const $e6718a831229ead6$var$searchParams = new URLSearchParams(location.search);
// create a synth for every finger!
// lazily create a new one is requested
const $e6718a831229ead6$var$fingerSynths = new Map();
// audio context requires a user gesture to start...
let $e6718a831229ead6$var$audioContext = null;
let $e6718a831229ead6$var$limiter = null;
let $e6718a831229ead6$var$mixer = null;
let $e6718a831229ead6$var$timer = null;
let $e6718a831229ead6$var$stats;
const $e6718a831229ead6$var$midiManager = new (0, $6af0da624ab416e2$export$2e2bcd8739ae039)();
let $e6718a831229ead6$var$midiDeviceInput;
let $e6718a831229ead6$var$midiDeviceOutput;
// Pointers to Shared DOM elements
let $e6718a831229ead6$var$hero;
let $e6718a831229ead6$var$noteVisualiser;
let $e6718a831229ead6$var$shapeVisualiser;
let $e6718a831229ead6$var$mouseVisualiser;
let $e6718a831229ead6$var$wallpaperCanvas;
let $e6718a831229ead6$var$miniNotation;
let $e6718a831229ead6$var$circles;
let $e6718a831229ead6$var$keyboard;
let $e6718a831229ead6$var$recorder;
let $e6718a831229ead6$var$timeKeeper;
// a map of all active notes currently playing
const $e6718a831229ead6$var$notesPlaying = new Map();
const $e6718a831229ead6$var$keyboardKeys = new Array(128).fill("");
// Full keyboard with all notes including those we do not want the user to play
const $e6718a831229ead6$var$ALL_KEYBOARD_NOTES = $e6718a831229ead6$var$keyboardKeys.map((keyboardKeys, index)=>new (0, $7ec2567d1d301bb4$export$2e2bcd8739ae039)(index));
// Grab a good sounding part (not too bassy, not to trebly)
const $e6718a831229ead6$var$KEYBOARD_NOTES = $e6718a831229ead6$var$ALL_KEYBOARD_NOTES.slice(41, 94);
// KEYBOARD_NOTES.forEach( (n,index) => console.info( n.toString(), index ) )
const $e6718a831229ead6$var$SCALES = [
    "Major",
    "Minor"
];
let $e6718a831229ead6$var$scale = $e6718a831229ead6$var$SCALES[0] // scale (eg. Major, Minor... etc)
;
let $e6718a831229ead6$var$mode = 0 // scale mode (eg. Dorian, Mixolydian... etc)
;
let $e6718a831229ead6$var$octave = 0 // octave (bass / mid / treble )
;
let $e6718a831229ead6$var$shape = "sine" // oscillator shape or periodic wave id (eg. sine, square, sawtooth, triangle)
;
let $e6718a831229ead6$var$song = null;
let $e6718a831229ead6$var$playingNote = null;
let $e6718a831229ead6$var$playingChord = null;
let $e6718a831229ead6$var$volume = 1;
const $e6718a831229ead6$var$isIOS = navigator.platform.startsWith("iP") || navigator.platform.startsWith("Mac") && navigator.maxTouchPoints > 4;
const $e6718a831229ead6$var$CHORDS = [
    (0, $96f413b39c3d1f22$export$7a8d537a00aa0876),
    (0, $96f413b39c3d1f22$export$6b86be061ac2dfd6),
    (0, $96f413b39c3d1f22$export$a6f744ead6b37562),
    (0, $96f413b39c3d1f22$export$3e070e48e768ef6f)
];
/**
 * Load all of the PeriodicWave Table Data from the local
 * file system via a zip that is created on build
 * @param {String} zipURL 
 * @returns 
 */ const $e6718a831229ead6$var$preloadWaveTablesFromZip = async (zipURL)=>{
    const meter = document.getElementById("load-progress");
    const data = await (0, $ea1732c6f2e2ca42$export$2ca57d018bbced6b)(zipURL, (progress, fileName, file)=>{
        // console.info("zip", {progress, fileName, file })
        meter.value = progress;
    });
    // console.info( data.length, "ZIPPED WAVE data",zipURL, {data}, getAllWaveTables() )
    return data;
};
// UI ==============================================================
/**
 * Replace the existing URL with a specific one without refreshing the page
 * This query string can then be used to restore the state of the page
 * on reload
 */ const $e6718a831229ead6$var$updateURL = (0, $1a845b6315e83cc8$export$61fc7d43ac8f84b0)(()=>{
    const newURL = `${window.location.pathname}?${$e6718a831229ead6$var$searchParams.toString()}`;
    window.history.pushState({
        path: newURL
    }, '', newURL);
});
const $e6718a831229ead6$var$setURLParameter = (0, $1a845b6315e83cc8$export$61fc7d43ac8f84b0)((name, value)=>{
    $e6718a831229ead6$var$searchParams.set(name, value);
});
// AUDIO ==============================================================
/**
 * Lazy load a SynthOscillator instrument for the specified index
 * @param {Number} finger 
 * @returns 
 */ const $e6718a831229ead6$var$getSynthForFinger = (finger)=>{
    let fingerSynth = $e6718a831229ead6$var$fingerSynths.get(finger);
    if (fingerSynth) return fingerSynth;
    // const shape = getRandomWaveTableName()
    fingerSynth = new (0, $367c7c5f93c3b8e8$export$2e2bcd8739ae039)($e6718a831229ead6$var$audioContext, {
        shape: $e6718a831229ead6$var$shape
    });
    // fingerSynth.loadWaveTable(shape)
    // fingerSynth.shape = "Piano"
    // console.info("shape loading",shape, "into", fingerSynth)
    fingerSynth.id = finger + "-synth";
    fingerSynth.output.connect($e6718a831229ead6$var$limiter);
    $e6718a831229ead6$var$fingerSynths.set(finger, fingerSynth);
    // console.error("getSynthForFinger", finger, fingerSynth)
    return fingerSynth;
};
/**
 * Create a time keeper and call this method
 * callback on every tick
 * @param {Function} callback 
 * @returns {Timer}
 */ const $e6718a831229ead6$var$createMetronome = (callback)=>{
    let beats = 0;
    // const timing = await import("./timing/timer.js")
    // await timingContext.audioWorklet.addModule(AUDIOTIMER_PROCESSOR_URI)
    // const TimingAudioWorklet = await import("./timing/timing.audioworklet.js")
    // const timing = new TimingAudioWorklet.default(timingContext)
    // const timing = createTimingProcessor( timingContext )
    const timingContext = new AudioContext();
    $e6718a831229ead6$var$timer = new (0, $8a65375c1c8b72e2$export$2e2bcd8739ae039)({
        contexts: {
            audioContext: timingContext
        },
        bpm: 32
    });
    // await timer.loaded
    $e6718a831229ead6$var$timer.swing = 0 //.5
    ;
    $e6718a831229ead6$var$timer.startTimer((e)=>{
        const oddBeat = beats++ % 2 !== 0;
        callback && callback(oddBeat, e, $e6718a831229ead6$var$timer);
    });
    return $e6718a831229ead6$var$timer;
};
/**
 * Adds a menu specifically for accessibility
 * that includes text sizing / font selection
 * audio controls and theme selection
 */ const $e6718a831229ead6$var$addAccessibilityFunctionality = ()=>{
    // As the menu only works with JS, we hide it by default
    const accessibilityMenu = document.getElementById("menu-accessibility");
    if (!accessibilityMenu) return false;
    accessibilityMenu.hidden = false;
    // THEME ------------------------------------------------
    // set theme from query string if provided
    if ($e6718a831229ead6$var$searchParams.has("theme")) (0, $8781acd752900d31$export$2e49b867b7a0847c)($e6718a831229ead6$var$searchParams.get("theme"));
    (0, $8781acd752900d31$export$542a581047271686)((themeName)=>{
        $e6718a831229ead6$var$searchParams.set("theme", themeName);
        $e6718a831229ead6$var$updateURL();
        // now also ensure that the note visualiser has the correct
        // background colour by checking the canvas's 
        const bgCol = $e6718a831229ead6$var$noteVisualiser.backgroundColour;
        bgCol;
    });
    // AUDIO ------------------------------------------------
    const volumeSlider = document.getElementById("volume");
    volumeSlider.addEventListener("input", (e)=>{
        $e6718a831229ead6$var$setVolume(e.target.value / 100);
    });
    const muteCheckbox = document.getElementById("toggle-mute");
    muteCheckbox.addEventListener("change", (e)=>{
        $e6718a831229ead6$var$toggleMute(e.target.checked, volumeSlider);
    });
    // TEXT ------------------------------------------------
    // connect the menu to the theme selection options
    const initialFontSize = $e6718a831229ead6$var$searchParams.get("font-size") ?? 1;
    (0, $95de1c9d486109cf$export$51a8f1c0de4f8090)(initialFontSize, (scaleMode)=>{
        // due to floating points, this may be irrational
        // so we ensure that it is a good number
        $e6718a831229ead6$var$searchParams.set("font-size", scaleMode);
        $e6718a831229ead6$var$updateURL();
    });
    // FONTS ------------------------------------------------
    const fontRadioButtons = document.querySelectorAll('input[name="font"]');
    fontRadioButtons.forEach((radioButton)=>{
        radioButton.addEventListener("change", (e)=>{
            const font = (0, $d0a2447e4623647d$export$69e9bdef456a9c46)(e.target.value);
            $e6718a831229ead6$var$searchParams.set("font", font);
            $e6718a831229ead6$var$updateURL();
        });
    });
    // Set user font preference from previous session
    if ($e6718a831229ead6$var$searchParams.has("font")) (0, $d0a2447e4623647d$export$69e9bdef456a9c46)($e6718a831229ead6$var$searchParams.get("font"));
    return true;
};
/**
 * Play a NOTE
 * @param {Object} noteModel 
 * @param {Number} velocity 
 * @param {Number} id 
 */ const $e6718a831229ead6$var$noteOn = (noteModel, velocity = 1, id = (0, $cc1d0ccf700154db$export$582afac2cd0d1cc9), isMidi = false)=>{
    // console.info(id, "NOTE ON for FINGER", {noteModel, velocity} )
    // as user click is required to start the audio contextin
    if (!$e6718a831229ead6$var$hasUserEngaged) $e6718a831229ead6$var$createAudioContext();
    if (!noteModel) {
        console.warn("No noteModel provided to noteOn", noteModel);
        return;
    }
    // already playing
    if ($e6718a831229ead6$var$notesPlaying.has(noteModel)) // console.warn("NoteOn Already playing", noteModel)
    return;
    // if we had a pointer event fired from a mouse we need to ensure that
    // it increments ovtherwise the oscillators get overwritten before thhey are clear to be stopped
    const synth = $e6718a831229ead6$var$getSynthForFinger(id);
    if (!synth) {
        console.warn("No Synths available for " + id);
        return;
    }
    const isAlreadyPlaying = synth.noteOn(noteModel, velocity);
    $e6718a831229ead6$var$notesPlaying.set(noteModel);
    $e6718a831229ead6$var$keyboard && $e6718a831229ead6$var$keyboard.setKeyAsActive(noteModel) // highlight the keys on the keyboard!    
    ;
    $e6718a831229ead6$var$hero && $e6718a831229ead6$var$hero.noteOn(noteModel);
    $e6718a831229ead6$var$noteVisualiser && $e6718a831229ead6$var$noteVisualiser.noteOn(noteModel, velocity);
    $e6718a831229ead6$var$mouseVisualiser && $e6718a831229ead6$var$mouseVisualiser.noteOn(noteModel, velocity);
    $e6718a831229ead6$var$recorder && $e6718a831229ead6$var$recorder.noteOn(noteModel, velocity);
    $e6718a831229ead6$var$miniNotation && $e6718a831229ead6$var$miniNotation.noteOn(noteModel, velocity, $e6718a831229ead6$var$audioContext.currentTime);
    console.log("Note On", id, synth, isAlreadyPlaying ? "repress" : "fresh");
    // this should change the visualiser line colour
    if ($e6718a831229ead6$var$shapeVisualiser) $e6718a831229ead6$var$shapeVisualiser.colour = noteModel.colour;
    // NB. To prevent endless looping...
    if (!isMidi && $e6718a831229ead6$var$midiManager.enabled && $e6718a831229ead6$var$midiDeviceOutput) $e6718a831229ead6$var$midiDeviceOutput.playNote(noteModel.noteName, {
        attack: velocity
    });
    if ($e6718a831229ead6$var$midiManager.bluetoothMIDIEnabled) console.info("BLE MIDI Note ON", noteModel.noteNumber, velocity);
    return isAlreadyPlaying;
};
/**
 * Stop playing a specific NOTE
 * @param {Object} noteModel 
 * @param {Number} velocity 
 * @param {Number} id 
 */ const $e6718a831229ead6$var$noteOff = (noteModel, velocity = 1, id = 0, isMidi = false)=>{
    // console.info( id, "NOTE OFF",{ noteModel, velocity } )
    // as user click is required to start the audio context
    if (!$e6718a831229ead6$var$hasUserEngaged) $e6718a831229ead6$var$createAudioContext();
    if (!noteModel) // console.warn("No noteModel provided to noteOff", noteModel)
    return;
    const synth = $e6718a831229ead6$var$getSynthForFinger(id);
    if (!synth) {
        console.warn("No Synths available for " + id);
        return;
    }
    $e6718a831229ead6$var$notesPlaying.delete(noteModel);
    const isPlaying = synth.noteOff(noteModel, velocity);
    $e6718a831229ead6$var$keyboard && $e6718a831229ead6$var$keyboard.setKeyAsInactive(noteModel) // unhighlight the keys on the keyboard
    ;
    $e6718a831229ead6$var$hero && $e6718a831229ead6$var$hero.noteOff(noteModel);
    $e6718a831229ead6$var$noteVisualiser && $e6718a831229ead6$var$noteVisualiser.noteOff(noteModel, velocity);
    $e6718a831229ead6$var$mouseVisualiser && $e6718a831229ead6$var$mouseVisualiser.noteOff(noteModel, velocity);
    $e6718a831229ead6$var$recorder && $e6718a831229ead6$var$recorder.noteOff(noteModel, velocity);
    $e6718a831229ead6$var$miniNotation && $e6718a831229ead6$var$miniNotation.noteOff(noteModel, velocity, $e6718a831229ead6$var$audioContext.currentTime);
    if ($e6718a831229ead6$var$shapeVisualiser) $e6718a831229ead6$var$shapeVisualiser.colour = false;
    if (!isMidi && $e6718a831229ead6$var$midiManager.enabled && $e6718a831229ead6$var$midiDeviceOutput) $e6718a831229ead6$var$midiDeviceOutput.stopNote(noteModel.noteName);
    if ($e6718a831229ead6$var$midiManager.bluetoothMIDIEnabled) console.info("BLE MIDI Note OFF", noteModel.noteNumber, velocity);
    return isPlaying;
};
/**
 * Play a chord with the specified intervals
 * @param {Note} noteModel 
 * @param {Number} velocity 
 * @param {Array<Number>} intervals 
 * @param {Number} mode 
 * @param {Number|String} idOffset 
 */ const $e6718a831229ead6$var$chordOn = (noteModel, velocity = 1, id = 0, intervals = null, mode = 0, idOffset = 0)=>{
    // console.info("Creating chord ON", intervals ?? MAJOR_CHORD_INTERVALS, noteModel, mode, "cutoff", "acculumate" )
    const chord = (0, $96f413b39c3d1f22$export$23934e34e39daf40)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, intervals ?? (0, $96f413b39c3d1f22$export$11a614999be145f9), noteModel.noteNumber, mode, true, true);
    const velocityReduction = velocity / chord.length * 0.8;
    const length = chord.length + idOffset;
    //console.info(idOffset, "chordOn", chord, velocityReduction  )
    for(let i = idOffset; i < length; i++)$e6718a831229ead6$var$noteOn(chord[i], velocityReduction, id + i);
};
/**
 * Turn off a series of chords
 * @param {Note} noteModel 
 * @param {Number} velocity 
 * @param {Array<Number>} intervals 
 * @param {Number} mode 
 */ const $e6718a831229ead6$var$chordOff = (noteModel, velocity = 1, id = 0, intervals = null, mode = 0)=>{
    // console.info("Creating chord OFF", noteModel, mode, "cutoff", "acculumate" )
    if (!noteModel) // console.warn("No noteModel provided to chordOff", noteModel)
    return;
    const chord = (0, $96f413b39c3d1f22$export$23934e34e39daf40)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, intervals ?? (0, $96f413b39c3d1f22$export$11a614999be145f9), noteModel.noteNumber, mode, true, true);
    for(let i = 0; i < chord.length; i++)$e6718a831229ead6$var$noteOff(chord[i], velocity, id + i);
};
/**
 * Load in our rick roll...
 * @param {String} track as text
 * @returns 
 */ const $e6718a831229ead6$var$loadSong = (track = (0, $d2bdd7a7bcbc68ef$export$ec8de47e92e93d9c))=>{
    const song = new (0, $060898502bebeba7$export$2e2bcd8739ae039)(track);
    // const note = song.getNextNote()
    // console.info("note", note, {song} )
    return song;
};
/**
 * As we already loaded in a song, we can
 * use this method to fetch the next note
 * in the sequence
 * 
 * @param {Array<Note>} songSequence 
 * @param {Array<Number>} chordIntervals 
 * @param {Number} scaleMode 
 */ const $e6718a831229ead6$var$playNextNoteInSong = (songSequence, chordIntervals = (0, $96f413b39c3d1f22$export$11a614999be145f9), scaleMode = 0)=>{
    const note = songSequence.getNextNote();
    const isChord = chordIntervals && chordIntervals.length > 1;
    // stop any currently playing notes
    if ($e6718a831229ead6$var$playingNote) // console.info("Killing note", note, {songSequence, playingNote} )
    isChord ? $e6718a831229ead6$var$chordOff($e6718a831229ead6$var$playingNote, 1, $e6718a831229ead6$var$playingChord ?? chordIntervals, scaleMode) : $e6718a831229ead6$var$noteOff($e6718a831229ead6$var$playingNote, 1);
    isChord ? $e6718a831229ead6$var$chordOn(note, 1, 0, chordIntervals, scaleMode) : $e6718a831229ead6$var$noteOn(note, 1);
    $e6718a831229ead6$var$playingNote = note;
    $e6718a831229ead6$var$playingChord = chordIntervals;
    return note;
};
/**
 * 
 * @param {HTMLElement} button 
 * @param {Array<Number>} chord 
 * @param {Number} musicalMode 
 */ const $e6718a831229ead6$var$addMusicalMouseEventsToElement = (button, chord = null, musicalMode = null, onActive = null)=>{
    let notePlaying = null;
    button.addEventListener("mousedown", (e)=>{
        const scaleMode = musicalMode ?? $e6718a831229ead6$var$mode;
        onActive && onActive();
        notePlaying = $e6718a831229ead6$var$playNextNoteInSong($e6718a831229ead6$var$song, chord, scaleMode);
        document.addEventListener("mouseup", (e)=>{
            if (notePlaying) {
                $e6718a831229ead6$var$chordOff(notePlaying, 1, 0, chord, scaleMode);
                $e6718a831229ead6$var$playingNote = null;
            }
        }, {
            once: true
        });
    });
};
/**
 * Waveform visualiser
 * @param {AudioContext} audioContext 
 * @param {AudioNode} source 
 */ const $e6718a831229ead6$var$createAudioVisualiser = (visualiserCanvas, audioContext, source, song, visualiserOptions = (0, $5uK7V.VISUALISER_OPTIONS))=>{
    const visualiserContext = visualiserCanvas.getContext('2d');
    $e6718a831229ead6$var$shapeVisualiser = new (0, $b1c4638f08a18298$export$2e2bcd8739ae039)(visualiserContext, audioContext, source, visualiserOptions);
    const updateVis = ()=>{
        $e6718a831229ead6$var$shapeVisualiser.drawWaveform();
        requestAnimationFrame(updateVis);
    };
    updateVis();
    const pickSongButtons = document.querySelectorAll("[data-control-next-song]");
    pickSongButtons.forEach((pickSongButton)=>{
        // random song!
        (0, $d2bdd7a7bcbc68ef$export$c2bdb834f9cd11fd)();
    });
    // allow the user to click the visualiser to play a song...
    const playButtons = document.querySelectorAll('[data-control-play]');
    playButtons.forEach((playButton)=>{
        $e6718a831229ead6$var$addMusicalMouseEventsToElement(playButton) // visualiserCanvas
        ;
    });
    // const randomWaveButton = document.querySelector('#timbre-random')
    const randomWaveButtons = document.querySelectorAll('input[value="random"]');
    randomWaveButtons.forEach((randomWaveButton)=>{
        const radioButtons = randomWaveButton.closest("fieldset").querySelectorAll('input[type="radio"]');
        const initialRandomTableName = (0, $ea1732c6f2e2ca42$export$7dd74eee9a2ffe92)();
        randomWaveButton.value = initialRandomTableName;
        // randomWaveButton.textContent = initialRandomTableName 
        randomWaveButton.addEventListener("click", (e)=>{
            //console.info("randomWaveButton", randomWave)
            $e6718a831229ead6$var$shape = $e6718a831229ead6$var$setTimbre(randomWaveButton.value);
            randomWaveButton.value = (0, $ea1732c6f2e2ca42$export$7dd74eee9a2ffe92)();
            // clear all the nearby radio buttons
            radioButtons.forEach((radioButton)=>radioButton.checked = false);
        });
    });
    const buttonSelectRandomTimbre = document.getElementById("song-timbre-random");
    buttonSelectRandomTimbre.addEventListener("click", (e)=>{
        $e6718a831229ead6$var$shape = $e6718a831229ead6$var$setTimbre((0, $ea1732c6f2e2ca42$export$7dd74eee9a2ffe92)());
    // clear all the nearby radio buttons
    // buttonSelectRandomTimbre.innerText = shape
    });
    // drum sequencer
    // percussion
    const detailsPercussion = document.querySelector("#percussion");
    detailsPercussion.addEventListener("toggle", (event)=>{
        detailsPercussion.open;
    });
};
// AUDIO ==============================================================
/**
 * Set the musical scale to Major / Minor
 * @param {Boolean|String|Number} scaleType 
 */ const $e6718a831229ead6$var$setScale = (scaleType)=>{
    // if it is a boolean or a number we act accordingly
    switch(typeof scaleType){
        case "boolean":
            scaleType = $e6718a831229ead6$var$SCALES[scaleType ? 0 : 1];
            $e6718a831229ead6$var$isHappy = scaleType;
            break;
        case "number":
            scaleType = $e6718a831229ead6$var$SCALES[scaleType % $e6718a831229ead6$var$SCALES.length];
            break;
    }
    if (typeof scaleType === "string") $e6718a831229ead6$var$isHappy = scaleType === $e6718a831229ead6$var$SCALES[0];
    (0, $7e3eccf8d0185cbf$export$20abb0e1f3e2be92)(scaleType);
    $e6718a831229ead6$var$scale = scaleType;
    $e6718a831229ead6$var$circles && ($e6718a831229ead6$var$circles.scale = scaleType);
// console.info("Scale set to", scaleType )
};
/**
 * Set the musical mode for the scale (eg. Dorian, Mixolydian, etc)
 * @param {Number|String} musicalMode 
 * @returns {Number}
 */ const $e6718a831229ead6$var$setMode = (musicalMode)=>{
    $e6718a831229ead6$var$mode = isNaN(musicalMode) ? (0, $96f413b39c3d1f22$export$6a4d1dd9fd40a1d0)(musicalMode) : musicalMode % (0, $96f413b39c3d1f22$export$d70b64e2bb71bb4e).length;
    const modeName = (0, $96f413b39c3d1f22$export$73ad9fe2ff31b7b6)($e6718a831229ead6$var$mode);
    $e6718a831229ead6$var$mode;
    if (!modeName) throw new Error("No modeName found for mode " + musicalMode);
    (0, $7e3eccf8d0185cbf$export$c6150438b1a5ab7c)(modeName);
    return $e6718a831229ead6$var$mode;
};
/**
 * Set the shape of this sound
 * (or select a random one if not specified)
 * @param {String|Number} timbre 
 */ const $e6718a831229ead6$var$setTimbre = (timbre)=>{
    if (!timbre) // choose a random timbre
    timbre = (0, $ea1732c6f2e2ca42$export$7dd74eee9a2ffe92)();
    if (!(0, $367c7c5f93c3b8e8$export$245ffa21a1602a56).includes(timbre)) // const timbreSanitised = " " + timbre.replaceAll("_","") 
    // const lowerCaseTimbre = timbre.toLowerCase()
    (0, $ea1732c6f2e2ca42$export$ec5563a93b036d54)(timbre).then((waveTable)=>{
        $e6718a831229ead6$var$fingerSynths.forEach((synth)=>synth.shape = waveTable);
    });
    else $e6718a831229ead6$var$fingerSynths.forEach((synth)=>synth.shape = timbre);
    (0, $7e3eccf8d0185cbf$export$dd02f9126dfaec8f)(timbre);
    $e6718a831229ead6$var$circles && ($e6718a831229ead6$var$circles.timbre = timbre);
    return timbre;
};
/**
 * 
 * @param {Array} timbres - array of all timbres
 * @param {String} timbre - the timbre to fetch
 * @param {Number} offset 
 * @returns {String} timbre name
 */ const $e6718a831229ead6$var$getTimbre = (timbres, timbre, offset = 0)=>{
    const index = timbres.indexOf(timbre);
    // if ( index < 0)
    // {
    //     console.error( index, "NO TIMBRE", timbres, timbre, offset)
    // }else{
    //     console.log( index, "getTimbre", timbres, timbre, offset)
    // }
    return timbres[(index + offset) % timbres.length];
};
const $e6718a831229ead6$var$saveVolume = (0, $1a845b6315e83cc8$export$61fc7d43ac8f84b0)((value)=>{
    $e6718a831229ead6$var$setURLParameter("volume", value);
    $e6718a831229ead6$var$updateURL();
}, 50);
/**
 * Set the Master Volume
 * @param {Number} value 0->1
 */ const $e6718a831229ead6$var$setVolume = (value)=>{
    $e6718a831229ead6$var$mixer.gain.value = value * 0.8;
    $e6718a831229ead6$var$volume = value;
    $e6718a831229ead6$var$saveVolume($e6718a831229ead6$var$volume);
};
/**
 * Mute / Unmute the Master Volume
 * @param {Number} value 
 * @param {HTMLElement} volumeSlider 
 */ const $e6718a831229ead6$var$toggleMute = (value, volumeSlider = null)=>{
    if (value) {
        $e6718a831229ead6$var$mixer.disconnect();
        volumeSlider.setAttribute("disabled", true);
    } else {
        $e6718a831229ead6$var$mixer.connect($e6718a831229ead6$var$audioContext.destination);
        volumeSlider.removeAttribute("disabled");
    }
};
// STATE ==============================================================
/**
 * Fetch the state from the radio buttons   
 */ const $e6718a831229ead6$var$fetchStateFromRadioButtons = ()=>{
    const CHECKED_RADIO_BUTTON = 'input[type="radio"]:checked';
    const queries = [
        '.emotion-selector ' + CHECKED_RADIO_BUTTON,
        '#emotion ' + CHECKED_RADIO_BUTTON
    ];
    const checkedInputRadioButtons = [];
    queries.forEach((query)=>{
        const radioButtons = document.querySelectorAll(query);
        radioButtons.forEach((radioButton)=>checkedInputRadioButtons.push(radioButton));
    });
    // console.info("checked", { checkedInputRadioButtons} )
    // now set each state by calling the relevant selection function   
    checkedInputRadioButtons.forEach((radioButton)=>{
        console.info("checked radio button", radioButton);
        switch(radioButton.name){
            case "emotion":
                console.warn("fetchStateFromRadioButtons:emotion", radioButton.value);
                $e6718a831229ead6$var$setMode(radioButton.value);
                break;
            case "octave":
                console.warn("fetchStateFromRadioButtons:octave", radioButton.value);
                $e6718a831229ead6$var$octave = parseInt(radioButton.value);
                break;
            case "timbre":
                console.warn("fetchStateFromRadioButtons:timbre", radioButton.value);
                $e6718a831229ead6$var$shape = radioButton.value;
                break;
            case "chord":
                console.warn("fetchStateFromRadioButtons:chord", radioButton.value);
                $e6718a831229ead6$var$setScale(radioButton.value);
                break;
            default:
                console.warn("No case for", radioButton.value);
        }
    });
    // ensure MIDI is always set to checked OFF
    const midiToggle = document.getElementById("toggle-midi");
    if (midiToggle) midiToggle.checked = false;
};

// USER INTERFACE ==============================================================
/**
 * Load the share menu and make the button visible
 */ const $e6718a831229ead6$var$loadShareMenu = ()=>{
    const shareMenu = document.getElementById("share-menu");
    if (shareMenu) (parcelRequire("25NTg")).then((lib)=>{
        shareMenu.hidden = false;
    // console.info("Menu for sharing is available", shareMenu, lib )
    });
};
/**
 * Show the MIDI toggle button (ensure that MIDI is enabled first!)
 */ const $e6718a831229ead6$var$showMIDIToggle = ()=>{
    const MIDIStatus = document.getElementById("midi-status");
    const sectionMIDIToggle = document.getElementById("midi-equipment");
    const buttonWebMIDIToggle = document.getElementById("toggle-web-midi");
    const labelWebMIDIToggle = buttonWebMIDIToggle.parentNode //  sectionMIDIToggle.querySelector("label[for='toggle-web-midi']")
    ;
    let isWebMIDIAvailable = true;
    buttonWebMIDIToggle.addEventListener("click", async (e)=>{
        if (!isWebMIDIAvailable) return false;
        await $e6718a831229ead6$var$midiManager.toggleWebMIDI();
        if (!$e6718a831229ead6$var$midiManager.isMIDIAvailable) {
            buttonWebMIDIToggle.hidden = true;
            isWebMIDIAvailable = false;
            console.error("No midi support");
            return;
        }
        // TODO: play a connection theme to show MIDI is controlled
        // INSPECTOR_GADGET
        // let midiDriver = await toggleMIDI()
        if ($e6718a831229ead6$var$midiManager.enabled) MIDIStatus.textContent = "MIDI Enabled. ";
        else MIDIStatus.textContent = "MIDI Available! ";
        // await midiManager.load()
        // just use the first instument?
        if ($e6718a831229ead6$var$midiManager.hasInputDevices) {
            // previous clock time
            let lastClockTimestamp = -1;
            // How many ticks have occured yet
            let intervals = 0;
            let midiNoteIndex = 0;
            let midiNoteIndeces = new Map();
            $e6718a831229ead6$var$midiManager.monitorAllInputs((event)=>{
                switch(event.message.type){
                    case "clock":
                        if ($e6718a831229ead6$var$timer) {
                            const trigger = $e6718a831229ead6$var$timer.bypass(true);
                            // How long has elapsed according to our clock
                            const timestamp = event.timestamp;
                            const elapsedSinceLastClock = timestamp - lastClockTimestamp;
                            lastClockTimestamp = timestamp;
                            // work out the BPOM from the clock...
                            // const BPM = convertPeriodToBPM( period * 24 )
                            // console.log("MIDI CLOCK", BPM, period, elapsedSinceLastClock, timestamp )
                            // calculated
                            const period = (0, $8a65375c1c8b72e2$export$db1c0995e6d36014)(true, 10000, 3);
                            const timeBetweenPeriod = elapsedSinceLastClock;
                            // Expected time stamp
                            const expected = intervals++ * timeBetweenPeriod;
                            // how much spill over the expected timestamp is there
                            const lag = timestamp % timeBetweenPeriod;
                            // should be 0 if the timer is working...
                            const drift = timestamp - expected;
                            // deterministic intervals not neccessary
                            const level = Math.floor(timestamp / timeBetweenPeriod);
                            trigger(timestamp, expected, drift, level, intervals, lag);
                        }
                        break;
                    case "noteon":
                        midiNoteIndex = (midiNoteIndex + 1) % 10;
                        midiNoteIndeces.set(event.note.number, midiNoteIndex);
                        // console.log("MIDI noteon", event )
                        $e6718a831229ead6$var$noteOn(new (0, $7ec2567d1d301bb4$export$2e2bcd8739ae039)(event.note.number), event.value, midiNoteIndex, true);
                        break;
                    case "noteoff":
                        // console.log("MIDI noteoff", event )  
                        midiNoteIndex = midiNoteIndeces.get(event.note.number);
                        $e6718a831229ead6$var$noteOff(new (0, $7ec2567d1d301bb4$export$2e2bcd8739ae039)(event.note.number), event.value, midiNoteIndex, true);
                        break;
                    default:
                        console.info("MIDI Message " + event.message.type, event);
                }
                event.type;
            });
            const midiDevice = $e6718a831229ead6$var$midiManager.inputs[0];
            MIDIStatus.textContent += "Connected to input device " + midiDevice.name + " - play some notes to hear them. ";
            // console.info("MIDI Input found " + midiDevice.name, midiDevice )
            $e6718a831229ead6$var$midiDeviceInput = midiDevice;
        // midiDriver.inputs.forEach((device, index) => {
        //     // `${index}: ${device.name}`
        //     device.addListener("noteon", e => {
        //         // create a note object that matches
        //         new Note(0)
        //         console.log("MIDI Message", index, e,  e.note.identifier)
        //     })
        //     console.log("MIDI Device", device, {midiDeviceInput} )
        // })
        } else {
            MIDIStatus.textContent = "No Wired MIDI devices were detected. Connect one via USB or MIDI cable and try again.";
            isWebMIDIAvailable = false;
            buttonWebMIDIToggle.hidden = false;
        }
        if ($e6718a831229ead6$var$midiManager.hasOutputDevices) {
            const midiDevice = $e6718a831229ead6$var$midiManager.outputs[0];
            MIDIStatus.textContent += "Connected to output device " + midiDevice.name;
            $e6718a831229ead6$var$midiDeviceOutput = midiDevice;
        // console.info("MIDI Output found " + midiDevice.name, midiDevice )
        }
        buttonWebMIDIToggle.checked = isWebMIDIAvailable;
    });
    // chcek for web midi support
    labelWebMIDIToggle.hidden = !$e6718a831229ead6$var$midiManager.isWebMIDISupported;
    // BLUETOOTH MIDI ---------------------------------------------------
    const buttonBluetoothMIDIToggle = document.getElementById("toggle-ble-midi");
    const labelBluetoothMIDIToggle = buttonBluetoothMIDIToggle.parentNode // sectionMIDIToggle.querySelector("label[for='toggle-ble-midi']")
    ;
    buttonBluetoothMIDIToggle.addEventListener("click", async (e)=>{
        const isBLEEnabled = await $e6718a831229ead6$var$midiManager.toggleBluetoothMIDI();
        console.info("Bluetooth MIDI toggle", {
            isBLEEnabled: isBLEEnabled
        });
    // MIDIStatus.textContent += "Connected to output device " + midiDevice.name
    });
    labelBluetoothMIDIToggle.hidden = !$e6718a831229ead6$var$midiManager.isBluetoothMIDISupported;
    // show whole section if the user has MIDI access!
    sectionMIDIToggle.hidden = !$e6718a831229ead6$var$midiManager.isMIDISupported;
};
/**
 * Add to DOM the Circle of Fifths Synthesizer and populate with
 * historic input data (octave and musical mode)
 */ const $e6718a831229ead6$var$createCircularSynth = (musicalMode, musicalOctave)=>{
    // const circleIntervals = CICRLE_INTERVALS
    const circleIntervals = (0, $96f413b39c3d1f22$export$a6f744ead6b37562)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, 41, musicalMode).reverse();
    const fifthIndexes = circleIntervals.map((note, index)=>note.sequenceIndex);
    const fifthData = $e6718a831229ead6$var$ALL_KEYBOARD_NOTES.map((key, i)=>{
        const oneOctave = Math.floor(i / 12);
        return $e6718a831229ead6$var$ALL_KEYBOARD_NOTES[oneOctave * 12 + fifthIndexes[i % fifthIndexes.length]];
    });
    // console.error("Creating Circular Synth", { circleIntervals, fifthIndexes, fifthData } )
    // const svgCircle = Array.from(document.querySelectorAll(".circle-of-fifths-tonics > path"))
    // const keys = svgCircle.map((path, i)=>{
    //     path.setAttribute("data-key", fifthData[i].noteKey)
    //     path.setAttribute("data-number", fifthData[i].noteNumber)
    //     path.setAttribute("data-name", fifthData[i].noteName)
    //     return path
    // })
    const circularSynth = new (0, $d5f4fe8401977268$export$2e2bcd8739ae039)(fifthData, $e6718a831229ead6$var$chordOn, $e6718a831229ead6$var$chordOff, $e6718a831229ead6$var$setMode, $e6718a831229ead6$var$setTimbre, musicalMode, musicalOctave);
    // const f5 = createChord( fifthData, circleIntervals.major, 0, mode, false, true )
    //console.info("COF", {f5, fifthData, fifthIndexes }) 
    return circularSynth;
};
/**
 * Setup the radio toggle buttons and give their actions commands
 */ const $e6718a831229ead6$var$setupRadioButtons = ()=>{
    const emotionRadioButtons = document.querySelectorAll("input[name='emotion'], input[name='octave'], input[name='chord'], input[name='timbre']");
    emotionRadioButtons.forEach((radioButton)=>{
        radioButton.addEventListener("change", (e)=>{
            const input = e.target.value;
            const name = e.target.name;
            switch(name){
                case "timbre":
                    $e6718a831229ead6$var$shape = $e6718a831229ead6$var$setTimbre(input);
                    break;
                // 
                case "octave":
                    $e6718a831229ead6$var$circles.frequency = parseInt(input);
                    break;
                case "emotion":
                    $e6718a831229ead6$var$setMode(input);
                    // circles.happiness = mode / 7
                    $e6718a831229ead6$var$circles.mode = $e6718a831229ead6$var$mode;
                    break;
            }
            switch(input.toLowerCase()){
                case "happy":
                case "major":
                    $e6718a831229ead6$var$setScale(true);
                    break;
                case "sad":
                case "minor":
                    $e6718a831229ead6$var$setScale(false);
                    break;
            }
        // console.info("RadioButton", {name, input} )
        // emotionPanel.querySelector("output").textContent = input
        });
    });
};
/**
 * Timbre selector and shape creator
 * @param {Array<String>} instrumentNames 
 */ const $e6718a831229ead6$var$setupTimbreSelector = (instrumentNames)=>{
    const timbreSongButtons = document.querySelectorAll("[data-play-timbre]");
    timbreSongButtons.forEach((button)=>{
        const timbre = button.dataset.playTimbre;
        // we can specify the chord and mode or infer them... MAJOR_CHORD_INTERVALS
        $e6718a831229ead6$var$addMusicalMouseEventsToElement(button, null, null, ()=>{
            $e6718a831229ead6$var$setTimbre(timbre);
        });
    });
    const timbreSelect = document.getElementById("song-timbre-select");
    const timbrePrevious = document.getElementById("song-timbre-previous");
    const timbreNext = document.getElementById("song-timbre-next");
    const chordHappy = document.getElementById("button-happy");
    const chordSad = document.getElementById("button-sad");
    instrumentNames.forEach((name)=>{
        timbreSelect.add(new Option(name, name));
    });
    timbreSelect.addEventListener("change", (e)=>{
        $e6718a831229ead6$var$shape = $e6718a831229ead6$var$setTimbre(e.target.value);
    });
    timbrePrevious.addEventListener("click", (e)=>{
        $e6718a831229ead6$var$shape = $e6718a831229ead6$var$setTimbre($e6718a831229ead6$var$getTimbre(instrumentNames, $e6718a831229ead6$var$shape, -1));
    });
    timbreNext.addEventListener("click", (e)=>{
        $e6718a831229ead6$var$shape = $e6718a831229ead6$var$setTimbre($e6718a831229ead6$var$getTimbre(instrumentNames, $e6718a831229ead6$var$shape, 1));
    });
    $e6718a831229ead6$var$addMusicalMouseEventsToElement(chordHappy, (0, $96f413b39c3d1f22$export$11a614999be145f9));
    $e6718a831229ead6$var$addMusicalMouseEventsToElement(chordSad, (0, $96f413b39c3d1f22$export$47ab18dfff75fa45));
};
/**
 * Read entire article!
 */ const $e6718a831229ead6$var$readOutLoud = ()=>{
    let e = "Hello there, welcome to the Summer Science Exhibition 2025";
    const speakSources = document.querySelectorAll("[data-speak]");
    speakSources.forEach((speakSource)=>{
        e += speakSource.textContent;
    });
    say(e);
};
// Connect to any gamepads that might be available
const $e6718a831229ead6$var$addGamePads = (drumSamples)=>{
    const kickDrum = drumSamples[0];
    const snareDrum = drumSamples[1];
    const hihat = drumSamples[2];
    const shaker = drumSamples[3];
    const gamepadHeld = new Map();
    const gamePadManager = new (0, $eceed7e1d30e9bcd$export$ccf4b26eab2de2e6)();
    gamePadManager.addEventListener((button, value, gamePad, heldFor)=>{
        switch(button){
            // ignore caching these
            case GAME_PAD_CONNECTED:
            case GAME_PAD_DISCONNECTED:
            case COMMANDS.LEFT_STICK_Y:
            case COMMANDS.LEFT_STICK_X:
            case COMMANDS.RIGHT_STICK_Y:
            case COMMANDS.RIGHT_STICK_X:
                break;
            default:
                value;
        }
        switch(button){
            case GAME_PAD_CONNECTED:
                console.info("Gamepad connected", button, value, gamePad);
                break;
            case GAME_PAD_DISCONNECTED:
                console.info("Gamepad disconnected", button, value, gamePad);
                break;
            // open sidebar
            case COMMANDS.START:
                // if select is also being held....
                gamePad.select;
                console.info("Gamepad start", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld
                });
                break;
            case COMMANDS.SELECT:
                // check to see if another key is held down...
                gamePad.start;
                console.info("Gamepad select", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                break;
            case COMMANDS.A:
                console.info("Gamepad A", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                kickDrum.click();
                break;
            case COMMANDS.B:
                console.info("Gamepad B", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                snareDrum.click();
                break;
            case COMMANDS.X:
                console.info("Gamepad X", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                hihat.click();
                break;
            case COMMANDS.Y:
                console.info("Gamepad Y", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                shaker.click();
                break;
            // If we are in a certain mode...
            // adapt 
            case COMMANDS.LB:
                console.info("Gamepad LB", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                break;
            case COMMANDS.LB:
                console.info("Gamepad LB", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                break;
            case COMMANDS.RB:
                console.info("Gamepad RB", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                break;
            case COMMANDS.LT:
                console.info("Gamepad LT", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                break;
            case COMMANDS.RT:
                console.info("Gamepad RT", value, {
                    gamePad: gamePad,
                    gamepadHeld: gamepadHeld,
                    heldFor: heldFor
                });
                break;
            default:
                console.info("Gamepad", {
                    gamePadManager: gamePadManager,
                    button: button,
                    value: value,
                    gamePad: gamePad,
                    heldFor: heldFor
                });
        }
    });
};
// LOGIC ==============================================================
/**
 * Requires a user-gesture before initiation...
 */ const $e6718a831229ead6$var$createAudioContext = async (event)=>{
    // only ever perform this once!
    if ($e6718a831229ead6$var$hasUserEngaged || $e6718a831229ead6$var$audioContext) return $e6718a831229ead6$var$audioContext;
    $e6718a831229ead6$var$hasUserEngaged = true;
    // polyfilled see : https://github.com/chrisguttandin/standardized-audio-context
    $e6718a831229ead6$var$audioContext = new (0, $dd284deb2f465d95$export$fcbc63750ec2a81f)();
    $e6718a831229ead6$var$limiter = $e6718a831229ead6$var$audioContext.createDynamicsCompressor();
    $e6718a831229ead6$var$limiter.threshold.value = 0;
    $e6718a831229ead6$var$limiter.ratio.value = 2 // 20
    ;
    $e6718a831229ead6$var$mixer = $e6718a831229ead6$var$audioContext.createGain();
    $e6718a831229ead6$var$mixer.gain.value = parseFloat($e6718a831229ead6$var$searchParams.get("volume") ?? 1) * 0.8;
    $e6718a831229ead6$var$limiter.connect($e6718a831229ead6$var$mixer);
    $e6718a831229ead6$var$mixer.connect($e6718a831229ead6$var$audioContext.destination);
    const visualiserCanvas = document.getElementById("visualiser");
    if ($e6718a831229ead6$var$SETTINGS.showAudioVisualiser && visualiserCanvas) $e6718a831229ead6$var$createAudioVisualiser(visualiserCanvas, $e6718a831229ead6$var$audioContext, $e6718a831229ead6$var$mixer, $e6718a831229ead6$var$song, {
        ...(0, $5uK7V.VISUALISER_OPTIONS),
        backgroundColour: false
    });
    (0, $b5907fdf43994cd6$export$7789d9e7785a9b7e)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, $e6718a831229ead6$var$chordOn, $e6718a831229ead6$var$chordOff, (noteModel, previousNoteModel, p)=>{
        // show the mouse visualiser primed to play note
        if ($e6718a831229ead6$var$mouseVisualiser) {
            if (previousNoteModel) {
                const previousChord = (0, $96f413b39c3d1f22$export$23934e34e39daf40)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, (0, $96f413b39c3d1f22$export$11a614999be145f9), previousNoteModel.noteNumber, $e6718a831229ead6$var$mode, true, true);
                previousChord.forEach((note)=>$e6718a831229ead6$var$mouseVisualiser.noteOff(note, 1));
                $e6718a831229ead6$var$mouseVisualiser.noteOff(previousNoteModel, 1);
            }
            // mouseVisualiser.chordOn( noteModel, 1, 0 )
            const chord = (0, $96f413b39c3d1f22$export$23934e34e39daf40)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, (0, $96f413b39c3d1f22$export$11a614999be145f9), noteModel.noteNumber, $e6718a831229ead6$var$mode, true, true);
            chord.forEach((note)=>$e6718a831229ead6$var$mouseVisualiser.noteOn(note, 1));
        // console.info("NOTE OPTIONS", {noteModel, chord, previousNoteModel, mouseVisualiser})
        }
    });
    if ($e6718a831229ead6$var$SETTINGS.saveNotesInMiniNotation) $e6718a831229ead6$var$miniNotation = new (0, $33f2e6c2e07fb954$export$6025dfc8c34171bc)(document.getElementById("song-in-pixels"), $e6718a831229ead6$var$recorder);
    const mixerRouting = new Map();
    const audioSources = document.querySelectorAll("audio");
    audioSources.forEach((audioElement)=>{
        const audioSource = $e6718a831229ead6$var$audioContext.createMediaElementSource(audioElement);
        const gainNode = $e6718a831229ead6$var$audioContext.createGain();
        gainNode.gain.value = 1;
        audioSource.connect(gainNode);
        gainNode.connect($e6718a831229ead6$var$limiter);
        mixerRouting.set(audioSource, gainNode);
    });
    const audioSpellSources = document.querySelectorAll("[data-audio-spell]");
    const audioSpell = document.getElementById("audio-spell");
    audioSpellSources.forEach((audioElement)=>{
        audioElement.addEventListener("click", (e)=>audioSpell.click());
    });
    const drumSequencer = document.querySelector("#drum-sequencer > li > ol");
    const drumSamples = document.querySelectorAll("#drums button audio");
    const kickDrum = drumSamples[0];
    const snareDrum = drumSamples[1];
    const hihat = drumSamples[2];
    const shaker = drumSamples[3];
    // add control devices
    if ($e6718a831229ead6$var$SETTINGS.useGamepads) $e6718a831229ead6$var$addGamePads(drumSamples);
    // let patterns = kitSequence()
    let patterns = (0, $208c0312f9334a36$export$f0893aa361c31009)();
    const setRandomDrumPattern = ()=>{
        patterns = (0, $208c0312f9334a36$export$f0893aa361c31009)();
    };
    // display the pattern using the checkboxes
    const drumSequnceBaseElements = [
        "kick",
        "snare",
        "hat",
        // "shaker"
        "clap"
    ];
    drumSequnceBaseElements.forEach((drumType)=>{
        const sourceCheckbox = document.getElementById("drum-sequence-" + drumType);
        const fragment = document.createDocumentFragment();
        const active = patterns[drumType];
        for(let i = 0; i < 16; i++){
            const velocity = active.getVelocityAtStep(i);
            // console.warn("Step", i, velocity)
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.name = "kick-sequence-" + i;
            checkbox.value = i;
            checkbox.checked = velocity === 0 ? false : true;
            checkbox.addEventListener("change", (e)=>{
                const pattern = parseInt(e.target.value);
                active.setVelocityAtStep(pattern, e.target.checked ? 255 : 0);
            // console.info(velocity, "drum-sequence", {pattern, drumType, velocity, active}) 
            // setRandomDrumPattern()
            });
            const label = document.createElement("label");
            label.textContent = drumType;
            const li = document.createElement("li");
            label.appendChild(checkbox);
            li.appendChild(label);
            fragment.appendChild(li);
        }
        // swap them out
        sourceCheckbox.closest("ol").replaceChild(fragment, sourceCheckbox.parentNode.parentNode);
    });
    let count = 0;
    const playMetronomeBeat = (oddBeat, timerEvent, timer)=>{
        if (!$e6718a831229ead6$var$drumsPlaying || !timer.isStartBar) return;
        // const index = oddBeat ? Math.floor(Math.random() * drumSamples.length) : 0
        // const newBeat = drumSamples[ index ]
        drumSequencer.style.setProperty('--i', 9);
        const kickVelocity = patterns.kick.next() / 255;
        const snareVelocity = patterns.snare.next() / 255;
        const hatVelocity = patterns.hat.next() / 255;
        // console.info("Velocities", timerEvent, {kickVelocity, snareVelocity, hatVelocity})
        const kickVolume = mixerRouting.get(kickDrum);
        kickVolume.gain.value = kickVelocity;
        if (kickVelocity > 0) {
            kickDrum.pause();
            kickDrum.play(0);
        }
        const snareVolume = mixerRouting.get(kickDrum);
        snareVolume.gain.value = snareVelocity;
        if (snareVelocity > 0) {
            snareDrum.pause();
            snareDrum.play(0);
        }
        const hatVolume = mixerRouting.get(kickDrum);
        hatVolume.gain.value = hatVelocity;
        if (hatVelocity > 0) {
            hihat.pause();
            hihat.play(0);
        }
        // console.info("playMetronomeBeat", !oddBeat ? "even" : "odd",  {patterns} )
        count++;
        if (count > 10) {
            count = 0;
            setRandomDrumPattern();
        }
        return;
    // hihat.pause()
    // hihat.play(0)
    };
    if ($e6718a831229ead6$var$SETTINGS.useTimer) $e6718a831229ead6$var$timeKeeper = $e6718a831229ead6$var$createMetronome(playMetronomeBeat);
    const toggleDrums = document.getElementById("toggle-drums");
    toggleDrums.addEventListener("change", (e)=>{
        $e6718a831229ead6$var$drumsPlaying = toggleDrums.checked;
    });
};
const $e6718a831229ead6$var$monitorViewportEntries = ()=>{
    // watch for when an element arrives in the window
    let observations = new Map();
    const monitoredElements = (0, $aq50Z.monitorIntersections)({}, (entry, inViewport)=>{
        observations.set(entry.target, inViewport);
    // console.info(entry,inViewport ? "in viewport" : "exit", {observations} )
    });
    monitoredElements.forEach((element, index)=>{
        if (!observations.has(element)) observations.set(element, false);
    });
};

/**
 * Preload all of the wave tables and things that can be
 * loaded in the background without choking anything
 */ const $e6718a831229ead6$var$backgroundLoad = async ()=>{
    if ($e6718a831229ead6$var$SETTINGS.showCountdown) {
        const timeElement = document.querySelector("[data-countdown]");
        timeElement && (0, $ca2546b3e0c3d36c$export$f52e29715bba3529)(timeElement);
    }
    // add white pink brown noise to the timbres
    // await preloadAllWaveTables()
    (0, $ea1732c6f2e2ca42$export$59da1b42c2e1d3db)();
    // Load periodic wavetable data
    try {
        if ($e6718a831229ead6$var$SETTINGS.loadFromZips) await $e6718a831229ead6$var$preloadWaveTablesFromZip((0, (/*@__PURE__*/$parcel$interopDefault($b19681a3b51d0c6c$exports))));
        else {
            const request = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($b2ef9d6141f2e5ac$exports))));
            const manifest = await request.json();
            (0, $ea1732c6f2e2ca42$export$ae9bca4752364733)(manifest);
        }
    } catch (error) {
        throw Error("Couldn't load custom periodic wave data");
    }
    // update the UI with these new data sets...
    // NB. This is the full list that may not be loaded yet?
    // all possible data files for instrument sounds
    const instrumentNames = (0, $ea1732c6f2e2ca42$export$315af10a7c3230d9)();
    // load saved instrument if not the default
    $e6718a831229ead6$var$setTimbre($e6718a831229ead6$var$shape);
    // waveform visualiser
    $e6718a831229ead6$var$setupTimbreSelector(instrumentNames);
    // now add the share button and share overlay
    await $e6718a831229ead6$var$loadShareMenu();
    if ($e6718a831229ead6$var$SETTINGS.showStats) {
        try {
            const Stats = await (parcelRequire("1PKpj"));
            // const Stats = (await import('stats-gl')).default
            const statsOptions = {
                trackGPU: false,
                trackHz: true,
                trackCPT: false,
                logsPerSecond: 2,
                graphsPerSecond: 3,
                samplesLog: 4,
                samplesGraph: 10,
                precision: 2,
                horizontal: true,
                minimal: true,
                mode: 0
            };
            $e6718a831229ead6$var$stats = new Stats(statsOptions);
        } catch (error) {
            console.error(error);
        }
        document.body.appendChild($e6718a831229ead6$var$stats.dom);
        const updateStats = ()=>{
            $e6718a831229ead6$var$stats.begin();
            $e6718a831229ead6$var$stats.end();
            // stats.update()
            requestAnimationFrame(updateStats);
        };
        updateStats();
    }
    if ($e6718a831229ead6$var$SETTINGS.debug) console.log("PhotoSYNTH.LOL ALL loaded : ", {
        stats: $e6718a831229ead6$var$stats,
        instrumentNames: instrumentNames
    });
};
/**
 * DOM is ready...
 */ const $e6718a831229ead6$var$start = async ()=>{
    // record each user note
    // NB. This saves to local storage!
    if ($e6718a831229ead6$var$SETTINGS.recordNotes) {
        $e6718a831229ead6$var$recorder = new (0, $2f6f7b2476ebbf7f$export$a12b5e8ce44e7a30)();
        $e6718a831229ead6$var$recorder.loadFromLocalStorage($e6718a831229ead6$var$SETTINGS.storage);
    }
    // load in our note sequences
    $e6718a831229ead6$var$song = $e6718a831229ead6$var$loadSong((0, $d2bdd7a7bcbc68ef$export$d8599d66c7d09a18)());
    // show password protection
    // if (DEFAULT_PASSWORD)
    // {
    //     handlePasswordProtection( searchParams, DEFAULT_PASSWORD, updateURL )
    // }
    // ensure that the mouse visualiser is not shown on ios
    document.body.classList.toggle("platform-ios", $e6718a831229ead6$var$isIOS);
    // change the copyright year to this year
    (0, $7e3eccf8d0185cbf$export$a98762472d9dfc6a)();
    // add accessibility functionality menu to header
    $e6718a831229ead6$var$addAccessibilityFunctionality();
    // reinstate the state recalled from the previous session
    // and use as the basis for initialising the synths
    $e6718a831229ead6$var$fetchStateFromRadioButtons();
    // add gallery interactions to dialog
    (0, $a0j6m.createGallery)();
    // FIXME: Quit here if the resources are not available
    // top interactive smiling graphic
    $e6718a831229ead6$var$hero = new (0, $d24753f95a0da964$export$2e2bcd8739ae039)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, $e6718a831229ead6$var$noteOn, $e6718a831229ead6$var$noteOff, $e6718a831229ead6$var$SETTINGS.showNotes ? $e6718a831229ead6$var$SETTINGS.notes : 0);
    if ($e6718a831229ead6$var$SETTINGS.showNoteVisualiser) {
        // sequencer style note visualiser (2 varieties)
        $e6718a831229ead6$var$wallpaperCanvas = document.getElementById("wallpaper");
        if (!$e6718a831229ead6$var$wallpaperCanvas) return false;
        $e6718a831229ead6$var$noteVisualiser = new (0, $170794a91e951f39$export$2e2bcd8739ae039)($e6718a831229ead6$var$ALL_KEYBOARD_NOTES, $e6718a831229ead6$var$wallpaperCanvas, false, 0) // ALL_KEYBOARD_NOTES
        ;
        // noteVisualiser = new NoteVisualiser( KEYBOARD_NOTES, wallpaperCanvas, false, 0 ) // ALL_KEYBOARD_NOTES
        $e6718a831229ead6$var$wallpaperCanvas.addEventListener("dblclick", (e)=>$e6718a831229ead6$var$scale === $e6718a831229ead6$var$SCALES[($e6718a831229ead6$var$SCALES.indexOf($e6718a831229ead6$var$scale) + 1) % $e6718a831229ead6$var$SCALES.length]);
        let b = 23;
        const setNoteVisualiserBlendMode = (value)=>{
            $e6718a831229ead6$var$noteVisualiser.blendMode = (0, $cd9f07ae59996643$export$50f5c8c4b7cc55df)[b % (0, $cd9f07ae59996643$export$50f5c8c4b7cc55df).length];
        // console.info(b, "BLENDMODE",  noteVisualiser.blendMode, CANVAS_BLEND_MODE_DESCRIPTIONS[b] )
        };
    // setNoteVisualiserBlendMode(b++)
    // setInterval( setNoteVisualiserBlendMode, 30000 )
    }
    // bottom interactive piano
    if ($e6718a831229ead6$var$SETTINGS.showKeyboard) {
        $e6718a831229ead6$var$keyboard = new (0, $99822b96e55280e1$export$2e2bcd8739ae039)($e6718a831229ead6$var$SETTINGS.showAllKeys ? $e6718a831229ead6$var$ALL_KEYBOARD_NOTES : $e6718a831229ead6$var$KEYBOARD_NOTES, $e6718a831229ead6$var$noteOn, $e6718a831229ead6$var$noteOff);
        const keyboardElement = document.body.appendChild($e6718a831229ead6$var$keyboard.asElement);
        keyboardElement.addEventListener("dblclick", (e)=>$e6718a831229ead6$var$setTimbre((0, $ea1732c6f2e2ca42$export$7dd74eee9a2ffe92)()));
    }
    if ($e6718a831229ead6$var$SETTINGS.useKeyboard) (0, $f398903761015229$export$9d83d59ca66b5647)($e6718a831229ead6$var$wallpaperCanvas, (e)=>{
        console.info("key event:", e);
    });
    // we can turn the mouse cursor into a note indicator  
    const mouseCanvas = document.getElementById("mouse-visualiser");
    if ($e6718a831229ead6$var$SETTINGS.showMouseNotes && !$e6718a831229ead6$var$isIOS) $e6718a831229ead6$var$mouseVisualiser = new (0, $836fbe64aaecf064$export$17282cf69930b62e)(mouseCanvas);
    else mouseCanvas.hiden = true;
    // circular fifths synth
    $e6718a831229ead6$var$circles = $e6718a831229ead6$var$createCircularSynth($e6718a831229ead6$var$mode, $e6718a831229ead6$var$octave);
    // wire up the radio buttons
    $e6718a831229ead6$var$setupRadioButtons();
    // setGalleryImage()
    if ($e6718a831229ead6$var$midiManager.isMIDISupported) $e6718a831229ead6$var$showMIDIToggle();
    if ($e6718a831229ead6$var$SETTINGS.monitorIntersections) $e6718a831229ead6$var$monitorViewportEntries();
    else document.body.classList.add("no-intersections");
    if ($e6718a831229ead6$var$SETTINGS.showVoiceOver) (0, $7e3eccf8d0185cbf$export$d34ae9cf8bb7186a)();
    const audioSamplesInButtons = document.querySelectorAll('button > audio');
    audioSamplesInButtons.forEach((audioSample)=>{
        const button = audioSample.parentNode;
        button.addEventListener("click", (e)=>{
            audioSample.play();
        });
    });
    // console.error('audioSamplesInButtons', audioSamplesInButtons)
    // finally update the URL with the state
    $e6718a831229ead6$var$updateURL();
    // try and load in some instrument data sets in the background...
    requestAnimationFrame($e6718a831229ead6$var$backgroundLoad);
    if ($e6718a831229ead6$var$SETTINGS.debug) {
        console.log("PhotoSYNTH.LOL PART loaded : ");
        $e6718a831229ead6$var$hero && console.log("hero", {
            hero: $e6718a831229ead6$var$hero
        });
        $e6718a831229ead6$var$keyboard && console.log("keyboard", {
            keyboard: $e6718a831229ead6$var$keyboard
        });
        $e6718a831229ead6$var$mouseVisualiser && console.log("mouseVisualiser", {
            mouseVisualiser: $e6718a831229ead6$var$mouseVisualiser
        });
        $e6718a831229ead6$var$noteVisualiser && console.log("noteVisualiser", {
            noteVisualiser: $e6718a831229ead6$var$noteVisualiser
        });
        $e6718a831229ead6$var$recorder && console.log("recorder", {
            recorder: $e6718a831229ead6$var$recorder
        });
        $e6718a831229ead6$var$song && console.log("song", {
            song: $e6718a831229ead6$var$song
        });
    }
    window.addEventListener("unload", (e)=>$e6718a831229ead6$var$recorder.sveToLocalStorage($e6718a831229ead6$var$SETTINGS.storage));
};
/**
 * DOM reporting for action!
 */ document.addEventListener("DOMContentLoaded", $e6718a831229ead6$var$start, {
    once: true
});
document.addEventListener("touchstart", $e6718a831229ead6$var$createAudioContext, {
    once: true
});
document.addEventListener("mousedown", $e6718a831229ead6$var$createAudioContext, {
    once: true
});


//# sourceMappingURL=newham-citizen-science-fair.a08073f9.js.map
